var _KRP0008 = (function() {
    var isMobile = window.innerWidth < 768;

    var additionalItemTemplate = '<li data-id="{{id}}" data-quantity="1" data-price="{{price}}">' +
        '<dl class="price-info">' +
        '<dt class="text">{{title}}</dt>' +
        '<dd class="content">' +
        '<div class="quantity-wrap">' +
        '<div class="select-quantity"><div class="inner">' +
        '<button type="button" class="minus" disabled><span class="blind">빼기</span></button>' +
        '<input type="number" class="quantity" title="수량 입력" value="1" readonly>' +
        '<button type="button" class="plus"><span class="blind">더하기</span></button>' +
        '</div></div>' +
        '</div><span class="price"><em class="blind">판매가</em>{{priceString}}</span>' +
        '</dd>' +
        '</dl>' +
        '<button type="button" class="btn-delete"><span class="blind">삭제</span></button>' +
        '</li>';

    var awardPopupItemTemplate = '<li>' +
        '<a href="#" class="award-item">' +
        '<span class="image"><img src="{{storyPdpThumbnailPath}}{{storyPdpThumbnailServerName}}" alt="{{storyPdpThumbnailAltText}}" onError="lgkorUI.addImgErrorEvent(this);"></span>' +
        '<span class="text">{{storyTitle}}</span>' +
        '</a>' +
        '</li>';

    // 20210722 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
    // BTOCSITE-78119
    var trTemplate =  '{{#each (item, idx) in list}}'+
        '<tr>' +
        '{{#if idx == Object.keys(list).length  && idx > 5 && item.categoryName != "정수기" }}'+
        '<td>{{idx}}년차 이후({{(idx-1)*12+1}}회차~)</td>' +
        '{{#else}}'+
        '<td>{{idx}}년차 ({{(idx-1)*12+1}}~{{(idx*12)}}회차)</td>' +
        '{{/if}}'+
        '<td>{{item.price}}</td>' +
        '<td>{{item.free}}</td>' +
        '</tr>'+
        '{{/each}}';

    // var siblingTemplate =
    //     '<div class="{{#if itemList[0].siblingType=="COLOR"}}sibling-color {{#else}}sibling-select{{/if}}">' +
    //         '{{#if itemList[0].siblingType=="COLOR"}}' +
    //             '<div class="sibling-colorHead">' +
    //                 '<div class="text">{{pdpTitle}}</div>' +
    //                 '<div class="color-text"><span>{{colorValue}}</span></div>' +
    //             '</div>' +
    //             '{{#else}}' +
    //             '<div class="text">{{pdpTitle}}</div>' +
    //         '{{/if}}' +
    //         '<div class="select-option radio {{#if itemList[0].siblingType=="COLOR"}}color{{#else}}select{{/if}}">' +
    //             '<div class="option-list" role="radiogroup">' +
    //             '{{#each (item, index) in itemList}}'+
    //                 '{{#if item.siblingType=="COLOR"}}' +
    //                     '<div role="radio" class="chk-wrap-colorchip {{item.siblingCode}}" title="{{item.siblingValue}}">' +
    //                     '{{#else}}' +
    //                     '<div role="radio" class="rdo-wrap btn-type2" title="{{item.siblingValue}}">' +
    //                 '{{/if}}' +

    //                         '{{#if index === currentCheckIndex}}' +
    //                         '<input type="radio" id="rdo-option-{{optionIndex}}-{{index}}" name="rdo-option-{{optionIndex}}" data-sibling-code="{{item.siblingCode}}" data-sibling-group-code="{{item.siblingGroup_code}}" checked>' +
    //                         '{{#else}}' +
    //                         '<input type="radio" id="rdo-option-{{optionIndex}}-{{index}}" name="rdo-option-{{optionIndex}}" data-sibling-code="{{item.siblingCode}}" data-sibling-group-code="{{item.siblingGroup_code}}">' +
    //                         '{{/if}}' +
    //                         '{{#if item.siblingType=="COLOR"}}' +
    //                             '<label for="rdo-option-{{optionIndex}}-{{index}}"><span class="blind">{{item.siblingValue}}</span></label>' +
    //                             '{{#else}}' +
    //                             '<label for="rdo-option-{{optionIndex}}-{{index}}">{{item.siblingValue}}</label>' +
    //                         '{{/if}}' +
    //                     '</div>' +
    //             '{{/each}}'
    //         '</div>' +
    //     '</div>' +
    // '</div>';

    //$(window).ready(function(){
    //if(!document.querySelector('.KRP0008')) return false;

    //$('.KRP0008').buildCommonUI();
    
    // BTOCSITE-26021 옵션팝업
    var optionStartTemplate =
        '<div class="{{_itemClass }} {{optItemId}}-div" data-opt-item-nm="{{optItemNm}}" data-opt-item-buy-chk-flag="{{optItemBuyChkFlag}}">'+
            '<div class="text">{{optItemNm }}{{#if desc !== null }}<button type="button" class="icon-info" data-control="modal" data-href="#specTermsPopup" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm}}"><span class="blind">{{optItemNm }} 정보설명 팝업열기</span></button>{{/if}}<span class="option-change"></span>{{#if optItemAttrCode==="03"}}<button type="button" class="btn-change-unit is-cm">인치로 보기</button>{{/if}}'+
            '</div>' +
        '<div class="select-option radio {{#if optItemAttrCode==="02"}}color{{#else}}select{{/if}}">' +
            '<div class="option-list" role="radiogroup">'+
                '{{#if optItemAttrCode==="02"}}'+
                    '<div role="radio" class="chk-wrap-colorchip {{optItemValueExtra}}" title="{{optItemNm }}">'+
                    '<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-sibling-group-code="OBJ453_color"{{#if _valueChchked==="Y"}}checked="true"{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
                '{{#else}}'+
                    '<div role="radio" class="rdo-wrap" title="{{optItemNm }}">'+
                    '<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-opt-item-value-extra="{{optItemValueExtra}}" data-sibling-group-code="OLED-B-type" {{#if _valueChchked==="Y"}}checked{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
                '{{/if}}'+
                        '<label for="{{optItemValueId}}"><span class="opt-value-nm">{{optItemValueDispNm }}</span>'+
                            '{{#if bestOptYn==="Y"}}<span class="best-badge">{{#if percent===100 || percent==="100" || percent==="100%"}}BEST{{#else}}{{percent}} 선택{{/if}}</span>{{/if}}'+
                        '</label>'+
                    '</div>';
    var optionValueTemplate =
        '{{#if optItemAttrCode==="02"}}'+
            '<div role="radio" class="chk-wrap-colorchip {{optItemValueExtra}}" title="{{optItemNm }}">'+
                '<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-sibling-group-code="OBJ453_color" {{#if _valueChchked==="Y"}}checked="true"{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
        '{{#else}}'+
                '<div role="radio" class="rdo-wrap" title="{{optItemNm }}">'+
                '<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-opt-item-value-extra="{{optItemValueExtra}}" data-sibling-group-code="OLED-B-type" {{#if _valueChchked==="Y"}}checked{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
        '{{/if}}'+
                    '<label for="{{optItemValueId}}"><span class="opt-value-nm">{{optItemValueDispNm }}</span>'+
                    '{{#if bestOptYn==="Y"}}<span class="best-badge">{{#if percent===100 || percent==="100" || percent==="100%"}}BEST{{#else}}{{percent}} 선택{{/if}}</span>{{/if}}'+
                    '</label>'+
                '</div>';
    var optionNextTemplate =
                    '</div>'+
                '</div>'+
            '</div>'+
        '</div>'+
        '<div class="{{_itemClass }} {{#if optItemAttrCode==="02"}}sibling-select{{/if}} {{optItemId}}-div" data-opt-item-nm="{{optItemNm}}" data-opt-item-buy-chk-flag="{{optItemBuyChkFlag}}">'+
            '<div class="text">{{optItemNm }}{{#if desc !== null }}<button type="button" class="icon-info" data-control="modal" data-href="#specTermsPopup" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm}}"><span class="blind">{{optItemNm }} 정보설명 팝업열기</span></button>{{/if}}<span class="option-change"></span>{{#if optItemAttrCode==="03"}}<button type="button" class="btn-change-unit is-cm">인치로 보기</button>{{/if}}' +
            '</div>' +
        '<div class="select-option radio {{#if optItemAttrCode==="02"}}color{{#else}}select{{/if}}">' +
            '<div class="option-list" role="radiogroup">'+
                '{{#if optItemAttrCode==="02"}}'+
                    '<div role="radio" class="chk-wrap-colorchip {{optItemValueExtra}}"title="{{optItemNm }}">'+
                        '<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-sibling-group-code="OBJ453_color" {{#if _valueChchked==="Y"}}checked="true"{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
                        '{{#else}}'+
                        '<div role="radio" class="rdo-wrap" title="{{optItemNm }}">'+
                            '<input type="radio" id="{{optItemValueId}}" name="rdo-{{optItemId}}" data-opt-item-id="{{optItemId}}" data-opt-item-nm="{{optItemNm }}" data-opt-item-value-nm="{{optItemValueDispNm }}" data-opt-item-value-extra="{{optItemValueExtra}}" data-sibling-group-code="OLED-B-type" {{#if _valueChchked==="Y"}}checked{{/if}} data-contents="옵션선택 / {{optItemNm }} / {{optItemDispOder}}단">'+
                        '{{/if}}'+
                            '<label for="{{optItemValueId}}"><span class="opt-value-nm">{{optItemValueDispNm }}</span>'+
                        '{{#if bestOptYn==="Y"}}<span class="best-badge">{{#if percent===100 || percent==="100" || percent==="100%"}}BEST{{#else}}{{percent}} 선택{{/if}}</span>{{/if}}'+
                            '</label>'+
                        '</div>';
    var optHeaderTemplate = 
    	'<div data-opt-model-id="{{MODEL_ID}}" class="header-prd" style="display:{{#if _display==="N"}}none{{/if}}">' +
		    '<div class="prd-left">' +
		        '<img src="{{IMAGE_ADDR}}" alt="" >' +
		    '</div>' +
		    '<div class="{{_statusClass}}">' +
		        '<p>{{MODEL_DISPLAY_NAME}}</p>' +
		        '<h4>{{modelOptInfoStr}}</h4>' +
		        '{{#if _modelStatusOrder===1 && _mixProductFlag ==="N"}}'+
		        	'<h5>{{#if _rentalPrice != ""}}<span>월 {{_rentalPrice}}원</span><b>{{_visitPer}}</b>{{#else}}{{#if _price != ""}}{{_memberPriceTxt}}<span>{{_price}}원</span>{{/if}}{{/if}}</h5>' +
    			'{{/if}}'+
		        '{{#if _modelStatusOrder===2 && _mixProductFlag ==="N"}}'+
		        	'{{#if _rentalPrice != ""}}<h5><span>월 {{_rentalPrice}}원</span><b>{{_visitPer}}</b></h5>{{#else}}{{#if _price != ""}}<h5>{{_memberPriceTxt}}<span>{{_price}}원</span></h5>{{/if}}{{/if}}' +
			        '<h6>판매 예정{{#if _modelSalePlannedDate != "" }}({{_modelSalePlannedDate}}){{/if}}</h6>'+
		        '{{/if}}'+
			    '{{#if _modelStatusOrder===3 && _mixProductFlag ==="N"}}'+
			        '<h5>{{#if _rentalPrice != ""}}<span>월 {{_rentalPrice}}원</span><b>{{_visitPer}}</b>{{#else}}{{#if _price != ""}}{{_memberPriceTxt}}<span>{{_price}}원</span>{{/if}}{{/if}}</h5>' +
			        '<h6>일시품절</h6>'+
	    		'{{/if}}'+
			    '{{#if _modelStatusOrder===4 && _obsFlag==="Y" && _mixProductFlag ==="N"}}'+
			        '<h6>LGE.COM에서는<br>제품 정보만 제공하고 있습니다.</h6>'+
    			'{{/if}}'+
			    '{{#if _modelStatusOrder===5 && _mixProductFlag ==="N"}}'+
			        '<h6>단종제품입니다.</h6>'+
		        '{{/if}}'+
                '{{#if _mixProductFlag ==="Y"}}'+
                '<h6>LGE.COM에서는<br>제품 정보만 제공하고 있습니다.</h6>'+
                '{{/if}}'+
		    '</div>' +
		 '</div>';
    // 스펙기반의 선호도 (BTOCSITE-93074)
    var optSpecTemplate =
        '<button type="button" class="sheet-close ui_modal_close"><span class="blind">닫기</span></button>' +
            '<header class="pop-header">' +
                '<h4 class="tit">{{optItemNm}}</h4>' +
            '</header>' +
            '<section class="pop-conts common-pop">' +
                '<div class="section__content">' +
                    '<div class="tooltip-bottom__content">' +
                        '<div class="item__inner">' +
                            '<div class="item__image">' +
                            '{{#if details.length > 0}}' +
                                '<div class="specTerms-banner slide-wrap ui_wide_slider">' +
                                    '<div class="slide-content ui_carousel_list">' +
                                        '<ul class="slide-track ui_carousel_track">' +
                                            '<!-- slide -->' +
                                                '{{#each (item, idx) in details}}' +
                                                    '<li class="slide-conts ui_carousel_slide">' +
                                                        '<div class="slide-img">' +
                                                            '<img src="{{item.contents}}" data-pc-src="{{item.contents}}" data-m-src="{{item.contents}}" alt="{{item.imageAltText}}">' +
                                                        '</div>' +
                                                    '</li>' +
                                                '{{/each}}' +
                                            '<!-- // slide -->' +
                                        '</ul>' +
                                    '</div>' +
                                    '<div class="custom-indi-wrap">' +
                                        '<div class="slide-controls">' +
                                            '<div class="controls">' +
                                                '<button type="button" class="btn-arrow ico-prev ui_carousel_prev">이전</button>' +
                                                '<span class="slide-page"><span class="current"></span><em class="count"></em></span>' +
                                                '<button type="button" class="btn-arrow ico-next ui_carousel_next">다음</button>' +
                                            '</div>' +
                                        '</div>' +
                                        '<button type="button" class="indi-control ui_carousel_play play">' +
                                            '<span class="blind" data-bind-text="{&quot;play&quot;:&quot;재생&quot;, &quot;stop&quot;:&quot;정지&quot;}">정지</span>' +
                                        '</button>' +
                                    '</div>' +
                                '</div>' +
                            '{{/if}}' +
                                '<div class="item__infos">' +
                                    '{{#raw description}}' +
                                '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</section>' +
        '<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>' ;
    // 장바구니 담기 다품목 추천 상품 (BTOCSITE-37933)
    var cartRecommendTemplate =
        '<div class="slide-conts swiper-slide">' +
            '<div class="cart-item-wrap" data-ec-product="{{ecProduct}}">' +
                '<a href="javascript:_KRP0008.setTail(\'{{tail}}\');" class="cart-item" data-url="{{modelUrlPath}}" data-url-target="{{_target}}" data-contents="/{{modelDisplayNameConvert}}/{{modelName}}/{{subtitle}}">' +
                    '<div class="item-image" >' +
                        '<div class="image-wrap" >' +
                            '<img src="{{mediumImageAddr}}" alt="">' +
                        '</div>' +
                    '</div>' +
                    '<div class="item-infos">' +
                        '{{#if multipleItemsFlag == "Y"}}<span class="disc-badge new">다품목할인</span>{{/if}}' +
                        '<div class="item-name">{{#raw modelDisplayName}}</div>' +
                        '<div class="item-num">{{modelName}}</div>' +
                        '<div class="item-price-wrap">' +
                            '<em class="blind">회원가격</em>' +
                            '<span class="item-price">{{#if _discountRate != "0"}}<span class="item-disc"><em class="blind">할인율</em>{{_discountRate}}%</span>{{/if}}{{_obsSellingPrice}}<em>원</em></span>' +
                        '</div>' +
                    '</div>' +
                '</a>' +
            '</div>' +
        '</div>';

    // BTOCSITE-36570 [개인맞춤서비스] 일반제품/소모품 제품추천 영역 추가
    let recommendationTemplate =
        '<div class="req-top-main-title" data-label="{{eventLabel}}">'+
            '{{#if scenarioNo === "s2_3" || scenarioNo === "s2_3_1" || scenarioNo === "s2_3_2"}}'+
                '<h4><span class="req-top-item-name">{{categoryName}}</span> 제품과 <br />함께 많이 구매하는 제품</h4>'+
            '{{#elsif scenarioNo === "s2_4" || scenarioNo === "s2_4_1" || scenarioNo === "s2_4_2" ' +
                    '|| scenarioNo === "s2_6" || scenarioNo === "s2_6_1" || scenarioNo === "s2_6_2" || scenarioNo === "s2_7" || scenarioNo === "s2_8" }}'+
                '<h4><span class="req-top-item-name">{{categoryName}}</span> 카테고리에서 <br />가장 많이 관심받은 제품</h4>'+
            '{{#elsif scenarioNo === "s2_1" || scenarioNo === "s2_1_1" || scenarioNo === "s2_1_2"}}'+
                '<h4><span class="req-top-item-name">가지고 계신 <em class="req-product-name">{{categoryName}}</em></span>에 <br />사용할 수 있는 다른 소모품</h4>'+
            '{{#elsif scenarioNo === "s9_9_9"}}'+
                '<h4><span class="req-top-item-name">{{categoryName}}</span>와 어울리는 사운드바 제품</h4>'+
            '{{/if}}'+
        '</div>'+
        '<ul>'+
            '{{#each (item, idx) in recommendModels}}'+
                '<li>'+
                    '<a href="{{item.modelUrlPath}}" data-contents="{{item.sku}}/{{item.modelName}}/{{scenarioNo}}/{{idx + 1}}/{{recommendLen}}">'+
                        '<span class="req-img-area">'+
                            '<img src="{{item.imageAddr}}" alt="">'+
                        '</span>'+
                        '<span class="req-text-area">'+
                            '<span class="req-title-inner">'+
                                '<span class="req-main-title">{{#raw item.modelDisplayName}}</span>'+
                                '<span class="req-sub-title">{{item.modelName}}</span>'+
                            '</span>'+
                            '<span class="req-product-info">'+
                                '<em class="product-price">{{item.obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>'+
                                '<em class="product-unit">원</em>'+
                            '</span>'+
                        '</span>'+
                    '</a>'+
                '</li>'+
            '{{/each}}'+
        '</ul>'
    ;

    // BTOCSITE-49751 [상품] 딜 플랫폼
    const timeDealInnerTemplate =
        '<span class="icon"><span>타임딜</span></span>'+
        '{{#if isTimeDealSoldOut}}'+
            '<span class="txt">SOLD OUT</span>'+
        '{{#else}}'+
            '<span class="time">{{remainingDay}}</span>'+
            '<span class="remain-count">{{remainingCount}}</span>'+
        '{{/if}}'
    ;

    // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
    var rentalDirectTemplate =
        '<div class="text">' +
            '<span>이 제품, 초기 비용 부담 없이</span>' +
            '<p><strong>사업자회원가</strong>로 구독해 보세요.</p>' +
        '</div>' +
        '<span class="btn-text">구독하기</span>';

    // BTOCSITE-102051 임직원몰 / 계열사/ 복지몰 쿠폰
    var rentalRepresentTemplate =
        '<div class="text">' +
            '<span>이 제품, 초기 비용 부담 없이</span>' +
            '<p><strong>월 {{years1TotAmt}}원</strong>으로 구독해 보세요.</p>' +
            '<span class="sub-text">({{contractTerm}}년 계약 기준)</span>' +
        '</div>' +
        '<span class="btn-text">구독하기</span>';

    var rentalRepresentTemplate2 =
        '<div class="text">' +
            '<span>이 제품, 초기 비용 부담 없이</span>' +
            '<p><strong>월 {{years1TotAmt}}원</strong>로 구독해 보세요.</p>' +
            '<span class="sub-text">({{contractTerm}}년 계약 기준)</span>' +
        '</div>' +
        '<span class="btn-text">구독하기</span>';    

    var rentalRepresentPromTemplate =
     '<div class="text">' +
            '<span>이 제품, 초기 비용 부담 없이</span>' +
            '<p><strong>월 {{years1TotAmt}}원</strong>으로 구독해 보세요.</p>' +
            '<span class="sub-text">({{contractTerm}}년 계약 · 2년차 부터 월 {{years2TotAmt}}원)</span>' +
        '</div>' +
        '<span class="btn-text">구독하기</span>';

    var rentalRepresentPromTemplate2 =
     '<div class="text">' +
            '<span>이 제품, 초기 비용 부담 없이</span>' +
            '<p><strong>월 {{years1TotAmt}}원</strong>로 구독해 보세요.</p>' +
            '<span class="sub-text">({{contractTerm}}년 계약 · 2년차 부터 월 {{years2TotAmt}}원)</span>' +
        '</div>' +
        '<span class="btn-text">구독하기</span>';    

    var timeDealTimer; // BTOCSITE-49751 타임딜 타이머
    var headerMutationObserver; // BTOCSITE-62058 스마트홈 경험 솔루션

    const KR_TIME_DIFF = 9 * 60 * 60 * 1000;
    const _SECOND	= 1000;
    const _MINUTE	= _SECOND * 60;
    const _HOUR	= _MINUTE * 60;
    const _DAY	= _HOUR * 24;

    // 옵션 팝업 관련 변수
    var checkedOpt = [];
    var orgCheckedOpt = []; //리셋시 필요
    var optList = [];
    var optModelList = [];
    var bestOptInfo = ""; //스펙 기반 선호도 추가
    var optBizType = "PRODUCT";
    // BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
    var purchaseButtonDisplay ="Y";
    var purchaseButtonMassage ="";
    var emplCk = "N"; //BTOCSITE-96476

    //BTOCSITE-93074 스펙 기반 선호도
    var isUpdating = false; //BTOCSITE-93074  업데이트 상태 플래그
    var optDescList = []; //BTOCSITE-93074 스펙 기반 선호도
    var orgModelOptValInfoStr =''; //BTOCSITE-93074 스펙 기반 선호도 옵션 초기화 시 필요

    //S:BTOCSITE-109002 상품 이벤트PDP 개발
    var modelInfoJson = [];

    let globalFnCallback = null;
    let timeId = null;

    var KRP0008 = {
        isGetRewardExcuted : false,
        isSetTimeDealExcuted : false,
        rewardInfoData : null, // API 응답 데이터 저장 (additionModel에서 재사용)

        // alert나 모달이 표시되어 있는지 확인하는 헬퍼 함수
        isModalVisible: function() {
            // ui_modal_container가 표시되어 있는지 확인
            var $modalContainer = $('.ui_modal_container');
            if ($modalContainer.length > 0 && $modalContainer.is(':visible')) {
                return true;
            }
            // html에 dim 클래스가 있으면 모달이 표시된 것으로 간주
            return $('html').hasClass('dim');
        },

        init: function(up20Flag) {
            var self = this;

            return new Promise(function(resolve){
                // LGECOMVIO-20 PDP내 앱 하단 바 비노출
				if( isApp() ){
					lgkorUI.showAppBottomMenu(false);
					lgkorUI.setEnableAppScrollBottomMenu(false);
					if(vcui.detect.isIOS){
						 lgkorUI.showAppBottomMenuOver(false)
					}else if(vcui.detect.isAndroid){
						$(window).on('mo_total_menu_acc',function(){
						   if($('.mobile-nav-button').hasClass('active')){
                                //전체메뉴 열기시
                                lgkorUI.setEnableAppScrollBottomMenu(true);
                                lgkorUI.showAppBottomMenuOver(false)
                                lgkorUI.showAppBottomMenu(true);
						   }else{
                                //전체메뉴 닫기시
                                lgkorUI.setEnableAppScrollBottomMenu(false);
                                lgkorUI.showAppBottomMenuOver(true)
                                lgkorUI.showAppBottomMenu(false);
						   }
						})
					}
				}

                // AR 체험하기 APP 호출시 실행
                var url = lgkorUI.parseUrl(location.href);
                var params = url.searchParams.getAll();
                if( isApp() && params.openAR) {
                    lgkorUI.openAR(params.openAR);
                    delete params.openAR;
                    window.history.replaceState('', '', url.pathname + (Object.keys(params).length > 0 ? '?'+$.param(params) : ''))
                }

                // 20211014 BTOCSITE-6768 사전예약 버튼클릭 시 로그인 체크
                loginFlag = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";

                // BTOCSITE-90808
                if (location.pathname.indexOf(lgkorUI.B2B_PATH_URL + "/") > -1) {
                    lgkorUI.DEFAULT_URL = lgkorUI.B2B_PATH_URL;
                    lgkorUI.COMPARE_KEY = "prod_compare_b2b";
                }

                // 옵션 선택 이벤트 발생 여부를 추적하는 변수
                self.isEventTriggered = false;

                //처음 로그인 체크를 하는 ajax 호출 여부
                self.processProductBuy = null;
                self.loginCheckEnd = false;

                // BTOCSITE-48463 B2B 복지몰(제휴사) 상품 구축
                self.default_partner_grp = "B2C";  // 일반
                self.emp_partner_grp = "LGE,AFF";   // LG 계열사
                self.memberPartnerGrp = "";
                self.partnerPrice = 0;
                self.bsnsMbrStat = ""; //BTOCSITE-48266
                self.bsnsMbrUpdStat = "";       //BTOCSITE-85521
                self.bsnsPstnCd = "";           //BTOCSITE-85521 사업자 직위/직책
                self.rprsnNm = "";              //BTOCSITE-85521 사업자 대표 명
                self.mbrName = "";              //BTOCSITE-85521 회원 명
                self.bsnsType = "";             //BTOCSITE-85521 사업자 타입
                self.obsOriginalPrice =0;
                self.partnerBoldBadgesArr = "";
                self.partnerRentalDirectInfoArr = "";
                self.partnerRentalRepresentInfoArr = "";
                self.sellPointCom = "";
                self.selYnCom = "";

                self.checkIntervalTimer;
                self.checkIntervalCount = 0;

                self.isScrollDown = true; // setIsScrollDown() 통해 변경
                self.isDragging = false;
                self.cartRecommendStorageName = "cartRecommend";

                // 키오스크 여부
                var kiosk = lgkorUI.getParameterByName("kiosk");
                self.kiosk = lgkorUI.stringToBool(kiosk);
                // BTOCSITE-100866 START
                var checkSmartViewBestRanking = function() {
                    var categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
                    var fromBestRanking = sessionStorage.getItem("smart_view_from_best_ranking");
                    if (fromBestRanking === 'Y') {
                        sessionStorage.removeItem("smart_view_from_best_ranking");
                        var smartViewCategorySessionData = {};
                        var smartViewCategorySessionDataStr = sessionStorage.getItem("smart_view_category_best_ranking");
                        
                        if (smartViewCategorySessionDataStr) {
                            smartViewCategorySessionData = JSON.parse(smartViewCategorySessionDataStr);
                        }
                        
                        var isExposed = false;
                        var viewCnt = 1;
                        
                        // Check if there is an existing entry for the given categoryId
                        if (smartViewCategorySessionData[categoryId]) {
                            // Safely retrieve and update viewCnt
                            viewCnt = smartViewCategorySessionData[categoryId].viewCnt != null ? smartViewCategorySessionData[categoryId].viewCnt + 1 : 1;
                            // Update isExposed
                            isExposed = smartViewCategorySessionData[categoryId].isExposed || isExposed;
                        }
                        
                        // Create or update the entry for the given categoryId
                        smartViewCategorySessionData[categoryId] = {
                            isExposed: isExposed,
                            viewCnt: viewCnt
                        };
                        
                        // Save the updated smartViewCategorySessionData back to sessionStorage
                        sessionStorage.setItem("smart_view_category_best_ranking", JSON.stringify(smartViewCategorySessionData));
                    }
                }
                checkSmartViewBestRanking();
                // BTOCSITE-100866 START
                self.setting();
                self.popUpDataSetting();
                self.contentLoadingScrollEvent();

                // [정리] 사업자몰 제품은 최근본 제품 적재 제외(B2C 전용 로직, b2cYN==='Y'는 이 파일에서 항상 false)

                if(lgkorUI.getHiddenInputData().bizType === 'DISPOSABLE'){
                    self.initDisposable();
                }

                // [정리] B2C 전용 타임딜(setTimeDeal) 제거: b2cYN==='Y'는 이 파일에서 항상 false

                /* BTOCSITE-112460 : 임직원/제휴사 타임딜 적용 */
                if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail !== "CARETAB" && lgkorUI.parseUrl(location.href).searchParams.get("kiosk") != 'y') {
                    self.setTimeDealB2b();
                }

                if(self.$component.data('consumables')) {
                    //BTOCSITE-68092 호출 순서에 의하여 가격 먼저 설정하도록 수정
                    if(loginFlag == 'Y' && loginFlag != null){
                        self.getRewardInfo();
                    }
                    vcui.require(['support/consumables-2.0.0.min'], function (consumables) {
                        self.prepare(up20Flag);
                        self.consumables = consumables;
                    });
                } else if(self.$component.data('notification')) { // BTOCSITE-29838 일반 제품 알림 신청
                    vcui.require(['support/notification-2.0.0.min'], function (notification) {
                        self.prepare(up20Flag);
                        self.notification = notification;
                    });
                } else {
                    self.prepare(up20Flag);
                }

                //BTOCSITE-841 페이지 로드시 활성화탭의 model-name으로 브레드크럼 & sku 변경
                //var activeTabIndex = $('.option-tabs .tabs li.on').index()

                //BTOCSITE-2551 PDP > 매장상담 예약 > 코드에 따른 분기처리 스크립트 추가
                $(document).on('click', '[data-app-link]', function(e){
                    if( isApp()) {
                        e.preventDefault();
                        var appUrl = $(this).attr('data-app-link');
                        if(vcui.detect.isIOS){
                            var jsonString = JSON.stringify({'command':'openInAppBrowser', 'url': appUrl, 'titlebar_show': 'Y'});
                            webkit.messageHandlers.callbackHandler.postMessage(jsonString);
                        } else {
                            void android.openLinkOut(appUrl);
                        }
                    }
                })
                //BTOCSITE-2551 PDP > 매장상담 예약 > 코드에 따른 분기처리
                self.bindRentalPopupEvents();

                // BTOCSITE-55284 // KRP0009 init 전 탭 클릭에 대한 대응
                self.disableKRP0009Tab();

                // BTOCSITE-659
                self.addAWSPdpUp();
                // BTOCSITE-8312 프로젝터>시네빔과 프로빔 스펙비교 예외처리 요청
                self.compareBtnStatus();

                // S : BTOCSITE-15587
                if(self.$view360.length) {
                    vcui.require([
                        '/lg5-common/front/360view/js/View360.js'
                    ], function () {
                        self.open360(); // BTOCSITE-19022
                    });
                }
                // E : BTOCSITE-15587

                $(window).off('.KRP0008-2');

                // visual sticky - only pc
                // window.addEventListener('load', self.pdpVisualSticky);
                // window.addEventListener('resize', self.pdpVisualSticky);
                // window.addEventListener('scroll', self.pdpVisualSticky);
                window.addEventListener('pageshow', self.pageshowEvent);

                $(window).on('resizeend.KRP0008-2', self.resizeEnd.bind(self));
                $(window).on('breakpointchange.KRP0008-2', self.breakpointChange.bind(self));

                // 비교하기 레이어 열림 시 bottom, z-index 수치 변경
                var $KRP0015 = $('.KRP0015');
                var $compareOpenEl = $KRP0015.find('.more-arrow');

                var  compareLayerBuffer = function(el) {
                    if($(el).hasClass('open')){
                        $KRP0015.removeClass('is-buffer--open');
                    } else {
                        $KRP0015.addClass('is-buffer--open');
                    }
                }

                if(self.$actionSheet.length) {
                    $KRP0015.addClass('is-buffer');
                    $compareOpenEl.on('click', function () {
                        compareLayerBuffer(this);
                    })
                } else {
                    $('body').addClass('is-only-compare');
                    $KRP0015.addClass('is-only-compare');
                }

                $(window).on("changeStorageData", function (e) {
                    if (e.key == lgkorUI.COMPARE_KEY) {
                        compareLayerBuffer($compareOpenEl);
                        setTimeout(function(){
                            compareLayerBuffer($compareOpenEl);
                        }, 2000);
                    }
                });

                $('.wrap, .iw_viewport-wrapper').on('click', function(e){
                    if($(e.target).parents('.KRP0015').length < 1 && $(e.target).parents('.product-compare').length < 1) {
                        $KRP0015.removeClass('is-buffer--open');
                    }
                });

                // 최대 할인가 로그인 전 노출 영역 처리
                //var $beforeLoginArea = $('.price-detail-item .before-login');

                // 보유제품 로그인 관련 노출 처리 및 보유 제품 팝업 목록 API 호출
                var $myProduct = $('.pdp-my-product');
                var $myProductList = $('#popupMyProductList .my-product-list');
                var isMyProduct = false;
                var myProductTemplate =
                    '{{#each (item, idx) in list}}'+
                    '<div class="my-product-list__item">'+
                    '<span class="my-product-list__image">'+
                    '<img src="{{item.smallImageUrl}}" alt="{{item.modelDisplayName}}">'+
                    '</span>'+
                    '<div class="my-product-list__info">'+
                    '<p class="my-product-list__category">{{item.categoryName}}</p>'+
                    '<p class="my-product-list__name">{{item.modelDisplayName}}</p>'+
                    '<p class="my-product-list__model">{{item.modelName}}</p>'+
                    '</div>'+
                    '</div>'+
                    '{{/each}}';

                if(!lgkorUI.stringToBool(loginFlag)){
                    //$beforeLoginArea.closest('li').show();
                    $myProduct.filter('.is-before-login').addClass('is-active');
                } else {
                    var param = {
                        "modelId": lgePdpSendData.modelId,
                        "modelGubun": modelGubun
                    }

                    const myProductUrl = self.$pdpInfo.data('myProductUrl');
                    myProductUrl && lgkorUI.requestAjaxDataPost(myProductUrl, param,function(result){

                        var data = result.data;

                        if(data.length) {
                            isMyProduct = true;
                            /* BTOCSITE-32756 모델명 내 <br> , <sup> 태그 치환 Start */
                            var replaceMyProductTemplate = vcui.template(myProductTemplate, {list : data});
                            replaceMyProductTemplate = vcui.string.replaceAll(replaceMyProductTemplate, "&lt;br&gt;","<br>",false);
                            replaceMyProductTemplate = vcui.string.replaceAll(replaceMyProductTemplate, "&lt;sup&gt;","<sup>",false);
                            replaceMyProductTemplate = vcui.string.replaceAll(replaceMyProductTemplate, "&lt;/sup&gt;","</sup>",false);
                            $myProductList.append(replaceMyProductTemplate);
                            /* BTOCSITE-32756 End */
                        } else {
                            isMyProduct = false;
                        }

                        if(typeof isMyProduct !== 'undefined' && isMyProduct) {
                            $myProduct.filter('.is-after-login').addClass('is-active');
                            if(data.length == 1){
                                $myProduct.filter('.is-after-login').find('.block-arrow').html('<span>'+data[0].modelDisplayName+'</span> ('+ data[0].modelName +')');
                            } else {
                                $myProduct.filter('.is-after-login').find('.block-arrow').html('<span>'+data[0].modelDisplayName+'</span> ('+ data[0].modelName +') 외 '+Number(result.dataCount-1)+'개');
                            }
                        } else {
                            $myProduct.filter('.is-not-my-product').addClass('is-active');
                        }
                    });
                }

                // action sheets 스펙변경 modal 노출
                var $btnActionSheetsSpec = $('.action-sheet .sibling-spec');
                $btnActionSheetsSpec.on('click', function (e){
                    e.preventDefault();
                    $('#specInfoPopup').vcModal({opener: this}); // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                });

                // LGECOMVIO-20 : 핵심스펙 옵션 비노출/비활성 관련 변수 추가
                self.enableOptionList = [];
                self.disableOptionList = [];

                // LGECOMVIO-20 : pc keyvisual 첫 visual animation 영역일 시 정지/재생 컨트롤러 이벤트 실행
                if(self.$pdpVisualAnimation.length && self.$pdpVisualAnimation.hasClass('is-active')) {
                    var $video = self.$pdpVisualAnimation.find('video');
                    var $controller = self.$pdpVisualAnimation.find('.video-controller');
                    var $pause = $controller.find('.btn-pause');
                    var $play = $controller.find('.btn-play');

                    $video.on('click', function () {
                        $controller.addClass('is-active');
                    })

                    $pause.on('click', function () {
                        $video[0].pause();
                        $(this).removeClass('is-active');
                        $play.addClass('is-active');
                    });

                    $play.on('click', function () {
                        $video[0].play();
                        $controller.removeClass('is-active');
                        $(this).removeClass('is-active');
                        $pause.addClass('is-active');
                    });
                }
                if(typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr) {
                    //옵션팝업 BTOCSITE-26021
                    self.optionPopupSet();
                    //옵션팝업 토스트 닫기 이벤트
                    $('.toast-message2').on('click', '.btn-area', function(e) {
                        e.preventDefault();
                        self.optPopToastClose();
                    });
                }else{
                    // BTOCSITE-93074 스펙 기반 선호도
                    if (!KRP0008.$pdpInfo.find('li').hasClass('laptap-opt')) {
                        KRP0008.bestOptCheckUrl(null);
                    }
                }

                // BTOCSITE-37933 다품목 활성화
                self.cartSwiper();
                $('.basket-btn').on('click', function() {
                    $('#actionSheetCart').vcModal({opener: this}); // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    $('#actionSheetPopup').removeClass('active');
                    setTimeout(function(){
                        $('#actionSheetCart').addClass('active');
                    }, 300);

                    setTimeout(function(){
                        KRP0008.recommandActionSheet();
                    }, 100);
                });

                $('.cart-action-sheet').find('.ui_modal_close').on('click', function() {
                    $('#actionSheetCart').removeClass('active')
                    $('html, body').css('overflow','initial');
                });

                $(document).on('click', '.ui_modal_dim', function(e) {
                    // actionSheet가 열려있고 알럿이 표시되어 있으면 actionSheet를 닫지 않음
                    if (KRP0008.isModalVisible() && $('#actionSheetPopup').hasClass('active')) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    $('.cart-action-sheet').find('.ui_modal_close').trigger('click');
                    // BTOCSITE-85293 START
                    // requested by BTOCSITE-85293
                    // var isActionSheetConsentModalOpen = $('#actionSheetConsent').hasClass('ui_modal_container')
                    // if (isActionSheetConsentModalOpen) { // check 5 terms popup was actived
                    //     $('#actionSheetConsent .sheet-close').click();
                    // }
                    // BTOCSITE-85293 END
                });

                // BTOCSITE-51366 PDP 렌탈이동 경로 개선
                self.rentalSwiper();

                //BTOCSITE-35421 가격 bold 정책 적용
                self.benefitPriceDisplayInit();

                //BTOCSITE-48266 [상품] B2B OBS 구축
                self.b2bClickEventLoad();

                self.defaultValueInit();

                // [정리] B2C 전용 온라인상담 레이어 이동(onlineLinkMove) 제거: #b2cLayerOnlineCounsel는 B2B 화면에 없음
                //BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
                if(lgkorUI.getHiddenInputData().bizType === 'DISPOSABLE'){
                    self.disposablePaymentButtonInit('disposable_prod_purchase_button_display', 'disposable_prod_purchase_button_massage');

                    // BTOCSITE-83042 PDP 소모품 회원가 노출로직 수정
                    if ($("#employeeDisposableTab").is(':visible') == false) {
                        $('#priceArea').css('display', 'block');
                    }
                }

                /* BTOCSITE-80498 */
                if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
                    KRP0008.csContentViewRecordEvent();
                }

                /* BTOCSITE-60454 START */
                KRP0008.contentViewRecordEvent();
                /* BTOCSITE-60454 END */

                // Event after loading vcui library
                document.addEventListener('vcLoaded', _vcLoaded_1);
                function _vcLoaded_1() {
                    // 구매하기 버튼 영역
                    self.setPaymentBtnArea();
                    self.refresh();
                    document.removeEventListener("vcLoaded", _vcLoaded_1); // 한 번만 실행

                };

                //로그인,찜하기 관련 데이타 가져오기
                if(lgePdpSendData.bizTypeDetail != 'DISPOSABLE'){
                    self.getRewardInfo();
                }

                //$(document).on("click", )
                // <!-- BTOCSITE-85525 다이렉트 청약 서비스 도입 -->
            	$("a.one-time-link.direct").on('click',function(e){
            		e.preventDefault();
            		const categoryId = $(this).data("category-id");
            		let cstmParam = {categoryId:categoryId};
            		var ajaxUrl = '/care-solutions/cstmSubItemSaveCheck.lgajax';

                	lgkorUI.requestAjaxDataPost(ajaxUrl, cstmParam, function(result){
                		if (result.status === "success" && !vcui.isEmpty(result.data)) {
            				var data = result.data;
            				if(data.isSave){
            					$('#cstmSubItemModal').vcModal({opener: document.activeElement}); // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
            					$('#chkSaveHistory').off('click').on('click',function(e){
            						window.location.href = "/care-solutions/cstmSubItem?isSave=Y&categoryId="+categoryId;
                                });
                                $('#newCstmSubItem').off('click').on('click',function(e){
                                	window.location.href = "/care-solutions/cstmSubItemIntro?categoryId="+categoryId;
                                });
            				}else{
            					location.href = "/care-solutions/cstmSubItemIntro?categoryId="+categoryId;
            				}
            			}
                    }, true);
            	});

                // [S] BTOCSITE-83434 [EPIC] 구독 다품목 적용
                self.setBannerSwiper();
                // [E] BTOCSITE-83434 [EPIC] 구독 다품목 적용
                
                // BTOCSITE-88928 3D 공간 (구 미리집 : 3D 홈뷰) 인입페이지 버튼 애니메이션
                self.setButtonAnimate();
                
                // BTOCSITE-98607 3D 공간 뱃지
                if(isApp()){
                    $('#btn-3dSpace').show();
                    self.setButtonAnimate();
                }else{
                    $('#btn-3dSpace').hide();
                    self.setButtonAnimate();
                }
				
                resolve();

            });
        },

        prepare: function(up20Flag) {
            var self = this;

            // BTOCSITE-15360 KRP0008 컴포넌트 수정
            if(!Array.prototype.indexOf){
                Array.prototype.indexOf = function(obj){
                    for(var i=0; i<this.length; i++){
                        if(this[i]==obj){
                            return i;
                        }
                    }
                    return -1;
                }
            };

            //핀치줌
            vcui.require(['ui/pinchZoom'], function (PinchZoom) {
                self.pinchZoom = new PinchZoom('#pop-pdp-visual .zoom-area'); // BTOCSITE-54289 PDP 오른쪽 영역 컴포넌트화 작업하며 이곳 선택자 왼쪽영역으로 한정합니다.

                self.$popPdpVisual.find('div.zoom-btn-area a.zoom-plus').on('click', function(e){
                    e.preventDefault();
                    var zoom =self. pinchZoom.getZoomFactor();
                    if(Math.round(zoom) >= 4) zoom = 0;
                    self.pinchZoom.runZoom(zoom+1, true);
                });

                self.$popPdpVisual.find('div.zoom-btn-area a.zoom-minus').on('click', function(e){
                    e.preventDefault();
                    var zoom =self.pinchZoom.getZoomFactor();
                    self.pinchZoom.runZoom(zoom-1, true);
                });

                self.$popPdpVisualImage.mousedown(function() {
                    self.isDragging = false;
                })
                    .mousemove(function() {
                        self.isDragging = true;
                    })
                    .mouseup(function() {
                        var wasDragging = self.isDragging;
                        self.isDragging = false;
                        if (!wasDragging) {
                            self.$popPdpVisual.find('div.zoom-btn-area a.zoom-plus').trigger('click');
                        }
                    });

                //pinchZoom.update(true);

                self.bindProductEvents();
                self.bindPopupEvents();
                if(up20Flag == 'Y') {
                    self.up20OptionBindSideEvents();            
                } else {
                    self.bindSideEvents();
                }
            });



            //비교하기 체크
            self.setCompares();
            self.setNotifications(); // BTOCSITE-29838 알림 신청
            // BTOCSITE-62058
            if (!self.kiosk && digitalData.productInfo.smart_home_flag ==='N') self.setPersonalRecommendation(); // BTOCSITE-36570 개인맞춤서비스

            self.setDirectRentalChange(); // BTOCSITE-51366 PDP 렌탈이동 경로 개선

            // BTOCSITE-62058
            if (typeof smartHome !== 'undefined') {
                const pkgNo = lgkorUI.parseUrl(location.href).searchParams.get("pkgNo");
                if (pkgNo) {
                    const packageLink = document.querySelector('.package-product-link a');
                    if (packageLink) {
                        packageLink.setAttribute('href', `/aihome/extension/bridgePage/${pkgNo}`);
                    }
                }
                if (smartHome) {
                    smartHome.setSmartHomeRentalRecommand();
                }
            }

            //찜하기 체크
            var ajaxUrl = self.$pdpInfo.attr('data-wish-url');
            lgkorUI.checkWishItem(ajaxUrl);

            //전달받은 리뷰카운트를 krp0009 컴퍼넌트에 넘김
            if(typeof reviewsCount !== 'undefined' && reviewsCount != "") {
                if(parseInt(reviewsCount) > 0) {
                    $(window).trigger("changeCategory.KRP0009",{"title":"리뷰(" + reviewsCount + ")","linkName":"review"});
                }
            }
        },

        setting: function() {
            var self = this;
            //pdp데이타
            self.$pdpData = $('#pdp-data');

            //콤포넌트
            self.$component = $('section.component.KRP0008');

            //데스크탑용 갤러리
            self.$pdpVisual = $('#desktop_summary_gallery div.pdp-visual');
            //데스크탑용 갤러리 - '※소비자의 이해를 돕기 위해 연출된 이미지입니다.' - BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다.
            self.$pdpVisualNotice = $('#pdp_visual_click2');
            //데스크탑용 pdp visual 하위 전체
            self.$pdpVisualList = self.$pdpVisual.find('[class*="pdp-visual-"]');
            //데스크탑용 갤러리 이미지
            self.$pdpImage = self.$pdpVisual.find('div.pdp-visual-image');
            //데스크탑용 video
            self.$pdpVisualVideo = self.$pdpVisual.find('div.pdp-visual-video');
            //데스크탑용 animation
            self.$pdpVisualAnimation = self.$pdpVisual.find('div.pdp-visual-animation');
            //데스크탑용 갤러리 썸네일리스트
            self.$pdpThumbnail = self.$pdpVisual.find('div.pdp-thumbnail-nav div.inner div.pdp-thumbnail-list ul.thumbnail-list');
            self.$pdpThumbnail.find('li > a').append('<span class="blind">선택안됨</span>');
            //선택된 데스크탑 썸네일
            self.$selectItemTarget = self.$pdpThumbnail.find('li.active');
            self.$selectItemTarget.find('.blind').text("선택됨");
            //데스크탑용 갤러리 디스클레이머
            self.$pdpVisualNotices = self.$pdpVisual.find('span.pdp-visual-notice');

            //모바일용 갤러리
            self.$pdpMobileVisual = $('#mobile_summary_gallery');
            //self.$pdpMobileVisual.hide();
            //모바일용 갤러리 슬라이더
            self.$pdpMobileSlider = self.$pdpMobileVisual.find('div.ui_carousel_slider');
            //모바일용 갤러리 썸네일 슬라이더
            self.$pdpMobileSliderTrack = self.$pdpMobileSlider.find('div.slide-content ul.slide-track');
            //모바일용 갤러리 인덱스
            self.$slideNumber = self.$pdpMobileVisual.find('div.slide-number .current');

            //PDP 더보기
            self.$pdpMoreInfo = $('div.pdp-more-info');

            //PDP모달
            self.$popPdpVisual = $('#pop-pdp-visual');
            //PDP모달 360
            self.$popPdpVisual360 = self.$popPdpVisual.find('#modal_detail_target div.item.r360');
            //PDP모달 이미지타입
            self.$popPdpVisualImage = self.$popPdpVisual.find('#modal_detail_target div.item.image');
            //PDP모달 비디오타입
            self.$popPdpVisualVideo = self.$popPdpVisual.find('#modal_detail_target div.item.video');
            //PDP모달 애니메이션타입
            self.$popPdpVisualAnimation = self.$popPdpVisual.find('#modal_detail_target div.item.animation');
            //PDP모달 썸네일 리스트
            self.$popPdpThumbnail = self.$popPdpVisual.find('div.pop-pdp-thumbnail-nav ul.pop-thumbnail-list');
            self.$popPdpThumbnail.find("li a").attr("aria-selected","false");
            //선택된 PDP모달 썸네일
            self.$selectModalItemTarget = self.$popPdpThumbnail.find('li.active');
            //PDP모달 확대축소 버튼영역
            self.$popPdpZoomArea = self.$popPdpVisual.find('div.zoom-btn-area');
            //PDP모달 item-number
            self.$itemNumber = self.$popPdpVisual.find('div.item-number .current');
            self.$view360 = $('#view360'); // BTOCSITE-15587
            //PDP모달 갤러리 디스클레이머
            self.$pdpVisualNoticePopup = self.$popPdpVisual.find('span.pdp-visual-notice-popup');
            self.$popPdpDisclaimer = $('div.pop-pdp-disclaimer');

            //PDP 인포
            self.$pdpInfo = $('div.pdp-info-area');
            self.$mobilePdpInfo = $('div.mobile-pdp-info');
            self.$pdpInfoProductDetailInfo = self.$pdpInfo.find('.product-detail-info');
            self.$productBuyOptionTab = self.$pdpInfoProductDetailInfo.find('.ui_tab:eq(0)');
            //self.$pdpInfoSiblingOption = self.$pdpInfo.find('.sibling-option');
            self.$specInfoPopup = $('#specInfoPopup'); //20210607 스펙선택 추가
            self.$pdpInfoSiblingOption = self.$specInfoPopup.find('.sibling-option'); //20210607 스펙선택 추가
            self.$pdpInfoSiblingColorText = $('.chk-wrap-colorchip'); //20210607 스펙선택 추가

            //BTOCSITE-2551 PDP > 매장상담 예약 > 코드에 따른 분기처리
            self.$pdpInfoWrap = $('div.pdp-wrap .pdp-info-area');
            self.$pdpInfoProductDetailInfo = self.$pdpInfoWrap.find('.product-detail-info');
            self.$packageButton = self.$pdpInfoProductDetailInfo.find('.info-bottom .link-area ul rental-counsel a');

            // 20210923 BTOCSITE-3534 [퍼블] [사용자행태분석 개선사항] PDP 제품명/리뷰 링크 개선
            self.$copy =  self.$component.find('.copy');

            //LGECOMVIO-20
            self.$actionSheetCallBtn = $('.action-sheet-call');
            self.$actionSheet = $('.action-sheet');
            self.$actionSheetCart = $('#actionSheetCart');

            self.$serviceOptPopup1 = $('#pop_subs_common'); //BTOCSITE-22701 add :: 선택옵션 팝업

            self.$bannerLink = $('.scrb-option-banners');   // BTOCSITE-22701 add :: 결합할인 배너
            self.$compositionInfoPopup = $('#compositionInfoPopup');// BTOCSITE-22701 add :: 구성상품 팝업
            //가격정보
            self.$pdpInfoPaymentAmount = self.$pdpInfo.find('.payment-amount');
            self.$pdpInfoPaymentAmount.data('quantity',1); //기본수량 1 세팅
            
            // BTOCSITE-30700 이용요금, 셀렉트박스 영역 노출 처리
            self.$pdpInfoProductDetailInfo.find('.info-accordion-wrap.detail-option-box').css('display', 'block');
            
            if(typeof productPrice !== 'undefined' && productPrice != "") {
                self.$pdpInfoPaymentAmount.data('price',productPrice);
            } else {
                self.$pdpInfoPaymentAmount.data('price',0);
            }

            var $paymentInput = self.$pdpInfoPaymentAmount.find('input.quantity');
            $paymentInput.each(function(index, item){
                var $paymentAmount = $(item).parents('.payment-amount');
                $paymentAmount.data('quantity',item.value);
            });

            // BTOCSITE-70412 START
            if ($('div.pdp-info-area .payment-amount input.quantity').length > 0) {
               if ($('div.pdp-info-area .payment-amount input.quantity').val() > 1) {
                  self.$pdpInfoPaymentAmount.data('quantity', parseInt($('div.pdp-info-area .payment-amount input.quantity').val()));
               }
            }
            // BTOCSITE-70412 END
            self.$pdpInfoPaymentAmount.each(function(index,item){
                self.updatePaymentAmountPrice($(item));
            });

            //
            self.$pdpInfoAdditionalPurchase = self.$pdpInfo.find('.additional-purchase');
            //
            //self.$pdpInfoAllCareshipService = self.$pdpInfo.find('.careship-service');
            self.$pdpInfoCareshipService = self.$pdpInfo.find('div.careship-service');

            self.$pdpInfoCareSiblingOption = self.$pdpInfo.find('div.care-sibling-option');


            //LGECOMVIO-20 렌탈 옵션 체크
            self.rentalAllSelect = true;


            // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용 start
            if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                self.rentalSetting();
            }else{
            	//BTOCSITE-111313
                const dpTypeMatch = location.href.match(/[?&]dpType=([^&#]*)/);
                const firstDpType = dpTypeMatch ? decodeURIComponent(dpTypeMatch[1]):'';
                if(firstDpType == "careTab"){
                	self.rentalSetting();
                }
            }
            // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용 end

            // [정리] B2C 전용 재구독 할인가(reSubDisCount) 호출 제거: b2cYN==='Y'는 이 파일에서 항상 false

            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성 START
            var careSelectBoxIndex1 = 0;
            var careSelectBoxIndex2 = 0;

            var selectCareRtModelSeq = null;
            var selectCareVisitTerm = null;
            var selectCareSvcTypeDesc = null;

            var oCareShipInfoData = {};

            careShipInfo.forEach(function(item, index) {

                // 1. 방문주기
                var visitPerTxt = (!item.visitPer || parseInt(item.visitPer) === 0) ? '방문없음/자가관리' : '1회 / '+item.visitPer+'개월'; //BTOCSITE-7447
                var visitPerKey  = visitPerTxt;

                // 2. 서비스타입
                var svcTypeDesc = (item.svcTypeUseYn === "Y") ? ("" + item.svcTypeDesc) : ""; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성

                // 데이터 재정렬
                var dataBySvcTypeDesc = oCareShipInfoData[visitPerKey] || [];

                dataBySvcTypeDesc.push(item);

                oCareShipInfoData[visitPerKey] = dataBySvcTypeDesc; // 첫번째값

                if(item.representChargeFlag == "Y") {
                    selectCareRtModelSeq = item.rtModelSeq;
                    selectCareVisitTerm =  visitPerTxt;
                    selectCareSvcTypeDesc = svcTypeDesc; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성
                }
            });
            self.careshipInfoData = oCareShipInfoData;

            //최초 기본값 찾기
            if(selectCareRtModelSeq) {
                // 방문주기 찾기
                var array = Object.keys(self.careshipInfoData);
                for (var i = 0, len = array.length; i < len; i++) {
                    if(array[i] == selectCareVisitTerm) {
                        careSelectBoxIndex1 = i;
                        break;
                    }
                }

                // 서비스타입 찾기
                var dataBySvcTypeDesc = self.careshipInfoData[selectCareVisitTerm];
                for (var i = 0, len = dataBySvcTypeDesc.length; i < len; i++) {
                    if(dataBySvcTypeDesc[i].representChargeFlag == "Y") {
                        careSelectBoxIndex2 = i;
                        break;
                    }
                }
            }
            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성 END


            //케어십 계약기간
            self.$careshipInfoSelectBox = self.$pdpInfoCareshipService.find('.ui_selectbox:eq(0)');
            self.$careshipInfoSelectBox2 = self.$pdpInfoCareshipService.find('.ui_selectbox:eq(1)');
            if(self.careshipInfoData && self.$careshipInfoSelectBox.length > 0) {
                // self.updateCareshipInfoPrice(self.careshipInfoData[careSelectIndex]);
                self.careshipInfoSelectBoxUpdate(self.$careshipInfoSelectBox,self.careshipInfoData,careSelectBoxIndex1,true);

                //서비스타입
                var key = Object.keys(self.careshipInfoData)[careSelectBoxIndex1];
                var svcTypeDescData = self.careshipInfoData[key];

                if(svcTypeDescData) {
                    self.updateCareshipInfoPrice(svcTypeDescData[careSelectBoxIndex2]);
                    self.careshipInfoSelectBoxUpdate(self.$careshipInfoSelectBox2,svcTypeDescData,careSelectBoxIndex2,true);
                } else { // 서비스타입 데이터가 없을때
                    self.updateCareshipInfoPrice(svcTypeDescData[0]);
                    self.careshipInfoSelectBoxUpdate(self.$careshipInfoSelectBox2,svcTypeDescData,0,true);
                }
            }

            // 케어십 서비스타입



            //렌탈 케어솔루션 제휴카드 리스트 정리
            //var isTab = false;

            self.rentalCardList = [];
            if(typeof rentalAssociatedCardList !== 'undefined' && rentalAssociatedCardList.length > 0) {
                self.rentalCardList = self.makeAssociatedCardListData(rentalAssociatedCardList);
            }

            self.$rentalCardList = self.$pdpInfoCareSiblingOption.find('.rental-card-list'); //BTOCSITE-3523 선택자 수정
            if(self.$rentalCardList.length > 0) {
                //isTab = true;
                self.updateAssociatedCardList(self.$rentalCardList, self.rentalCardList);
            }

            //케어십 제휴카드 리스트 정리
            self.careCardList = [];
            if(typeof careshipAssociatedCardList !== 'undefined' && careshipAssociatedCardList.length > 0) {
                self.careCardList = self.makeAssociatedCardListData(careshipAssociatedCardList);
            }

            self.$careshipCardList = self.$pdpInfoCareshipService.find('.select-box:eq(1)');
            if(self.$careshipCardList.length > 0) {
                //isTab = true;
                self.updateAssociatedCardList(self.$careshipCardList, self.careCardList);
            }

            if($("#typeRental").length) {
                var $paymentAmount = self.$pdpInfoProductDetailInfo.find('.payment-amount');
                var $cardList = self.$pdpInfoProductDetailInfo.find('div.care-sibling-option > .select-box');
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    //케어쉽 선택 버튼이 있으므로 케어타입
                    self.updateAssociatedCardList($cardList, self.careCardList);
                } else {
                    //렌탈타입
                    self.updateAssociatedCardList($cardList, self.rentalCardList);
                }
            }

            //최초 케어쉽 체크 여부
            var checkinput = self.$pdpInfoCareshipService.find('input[type=radio]:checked');
            if(checkinput.length > 0) {
                var check = lgkorUI.stringToBool(checkinput.val());
                var $paymentAmount = self.$pdpInfo.find('.payment-amount'); //LGECOMVIO-20
                self.updatePaymentAmountState($paymentAmount, check);
            }

            //리뷰 클릭하기 // BTOCSITE-59618 탭 로드전에 클릭 방지 및 개선된 스크롤 이동 함수인 KRP0009-2.0.0.js > exactScrollMove() 호출로 대체
            self.$pdpInfoProductDetailInfo.on('click', '.star-rating-wrap a', function(e) {
                e.preventDefault();
                var href = $(this).attr('href');

                if (href && href.match(/^\#\w/i)) $('.pdp-tab .tab-menu > a').filter('[href="'+href+'"]').trigger('click');
            });

            // Event after loading vcui library
            document.addEventListener('vcLoaded', _vcLoaded_2);
            function _vcLoaded_2() {
                self.$pdpMobileSlider.vcCarousel({
                    infinite: true,
                    autoplay: false,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    prevArrow:'.btn-arrow.prev',
                    nextArrow:'.btn-arrow.next',
                    focusOnSelect: false,
                    focusOnChange: false,
                    dots: false,
                    buildDots: false,
                    cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    speed: 150,
                    touchThreshold: 100
                });
                document.removeEventListener("vcLoaded", _vcLoaded_2); // 한 번만 실행
            };

            //BTOCSITE-44 시블링레이어
            self.defaultSiblingDataFlag = true;
            self.codesSortArry = [];
            self.pdpUniqTitle = [];
            self.receivedSiblingData = [];
            self.$specInfoPopup = $('#specInfoPopup'); /* 20210607 스펙선택 추가 */
            self.$siblingCont = self.$specInfoPopup.find('.sibling-cont');
            self.$siblingBtnComp = self.$specInfoPopup.find('.btn-sibling-select');
            self.siblingCurrentModel = "";

            //LGECOMVIO-20
            self.actionSheetCallEvent();
            self.settingAppByArPopup();
            self.laptapSelectColor(); // BTOCSITE-47671 노트북 색상 선택
            self.laptabPopupCarousel(); // BTOCSITE-47671 Popup Carousel 
            self.laptabPopupClose(); // BTOCSITE-47671 노트북 옵션 팝업 닫기
            self.laptapOptionUrlSet(); // BTOCSITE-93074 스펙 기반 선호도
            self.modelOptionPopupCarousel(); // BTOCSITE-93074 스펙 기반 선호도
            self.modelOptionPopupClose(); // BTOCSITE-93074 스펙 기반 선호도
            self.setInfoDisclaimer(); // BTOCSITE-102082

            //옵션 선택 BTOCSITE-26021
            self.$optHeader = self.$specInfoPopup.find('.pop-header');
            // 옵션 리뉴얼
            self.$laptapOpt = self.$pdpInfo.find('li.laptap-opt');

            // BTOCSITE-62058스마트홈 경험 솔루션
            var smartWrap = $('.component-wrap .smart-home-wrap')
            var smartItems = smartWrap.find('.smart-home-area > div').last().prop('className');
            if( smartItems == 'smart-banner-area' ){
                smartWrap.addClass('lastBanner');
            }
            //BTOCSITE-90632
            $('.product-share .tooltip-wrap.share .ui_tooltip-target').on('click',function(e){
				var $tooltipBox = $('.product-share .tooltip-wrap.share .tooltip-box');
				$tooltipBox.css({'top':34 });
                if(window.innerWidth < 768 && $('.subRenewPdpWrap').length == 1 && $('#paymentButtonArea').length == 1){
                    var yMax = $tooltipBox.outerHeight() + $(this).offset().top + $(this).outerHeight() - 12;
                    if( $('#paymentButtonArea').offset().top < yMax){
                        yMax = $('#paymentButtonArea').offset().top - yMax;
                        $tooltipBox.css({'top':yMax });
                    }
                }
            });
			//BTOCSITE-83472
			var isResizeScroll = false;
			var resizeObserver = new ResizeObserver(function(entries){
				if(isResizeScroll && window.innerWidth < 768){
					var $id = $(window.pdpTabId)
					if($id.length > 0 && $id.offset().top != $(window).scrollTop()){
						console.log('resizeMoveTop')
						$(window).trigger('resizeMoveTop',window.pdpTabId);
					}
				}
			});
			resizeObserver.observe($('body')[0]);
			$(window).on('startResizeObserver',function(e,obj){
				isResizeScroll = true;
			})
			$(window).on('wheel.stopResizeObserver', function(e) {
				isResizeScroll = false;
			});
			$(document).on('touchstart.stopResizeObserver', function(e) {
				isResizeScroll = false;
			});

            let bannerCnt = $('div.banner-slide').find('div.swiper-container').find("div.swiper-wrapper").children('div.swiper-slide').length;
            if(bannerCnt == 1){
                $("div.banner-slide").find('div.banner-slide-box').addClass('one-bn');
            }else{
                $("div.banner-slide").find('div.banner-slide-box').removeClass('one-bn');
            }
        },
        
        refresh: function () {
            var self = this;

            // BTOCSITE-62058스마트홈 경험 솔루션
            self.smartProdSticky();
            self.smartPackageSwiper();
            self.packageScrollLeft();
        },

        resizeEnd: function () {
            var self = this;

            // BTOCSITE-62058스마트홈 경험 솔루션
            self.packageScrollLeft();
        },

        breakpointChange: function (e, data) {
            var self = this;
            
            isMobile = data.isMobile;

            self.refresh();
        },

        disableKRP0009Tab: function () { // BTOCSITE-55284 // KRP0009 init 전 탭 클릭에 대한 대응
            $('.subRenewPdpWrap').on('click', '.KRP0009 .pdp-tab .tab-menu > a', function (e) {
                if (!$(this).closest('.KRP0009').data('inited')) {
                    e.preventDefault();
                    document.querySelector(e.currentTarget.getAttribute('href')).scrollIntoView();

					//BTOCSITE-83472
                    if(window.innerWidth < 768){
						var id = e.currentTarget.getAttribute('href');
						window.pdpTabId = id;
					}
                }
            });
        },

        //BTOCSITE-2551 PDP > 매장상담 예약 > 코드에 따른 분기처리
        bindRentalPopupEvents: function() {
            var self = this;
            self.$packageButton.on('click', function(e){
                var $this = $(this);
                if( $this.hasClass('package')) {
                    e.preventDefault();
                    var popupId = $this.attr('href');
                    $(popupId).vcModal({opener: this});
                }
            })

            $('.popup-package-model').find('.pop-footer .btn').on('click', function(e){
                var _self = this;
                var $targetPopup = $(this).closest('.popup-package-model')
                self.packageSelect(_self, $targetPopup)
            })
        },
        packageSelect: function(alertTarget, $targetPopup){
            var $radio = $targetPopup.find('.model-list input:radio');
            if( !$radio.filter(':checked').length ) {
                var msgTxt = '제품을 선택해주세요';
                lgkorUI.alert("", {title: msgTxt}, alertTarget);
            } else {
                location.href = $radio.filter(':checked').data('model-path');
            }
        },

        popUpDataSetting: function() {
            var self = this;
            self.$awardPopup = $('#awardPopup');
            self.$saleInfoPopup = $('#saleInfoPopup'); // BTOCSITE-5781
            self.$benefitInfoPopup = $('#benefitInfoPopup'); //추후 삭제 buyBenefitInfoPopup로 대체 처리
            self.$buybenefitInfoPopup = $('#buyBenefitInfoPopup'); //LGECOMVIO-20 추가
            self.$buybenefitInfoPopupNew = $('#buyBenefitInfoPopupNew'); // BTOCSITE-66272 구매 혜택 안내 팝업 신규 디자인
            self.benefitCardPopup = $('#benefitCardPopup'); //LGECOMVIO-20 추가
            self.$caresolutionInfoPopup = $('#caresolutionInfoPopup');

            self.$mainInitPopup = $('#main-init-popup'); //BTOCSITE-1025 : add 20210802
            self.$maxBenefitPopup = $('#maxBenefitPopup'); //최대혜택가 popup
            self.$maxBenefitPopup2 = $('#maxBenefitPopup2'); //최대혜택가2 popup
            self.$memberPricePopup = $('#memberPricePopup'); //회원할인가 popup
            self.$couponPricePopup = $('#couponPricePopup'); //쿠폰할인가 popup
            self.$employeeTabCouponPricePopup = $('#employeeTabCouponPricePopup'); //쿠폰할인가(임직원/복지몰) popup
            self.$employeeTabMaxBenefitPopup = $('#employeeTabMaxBenefitPopup'); //최대혜택가(임직원/복지몰) popup
            // self.$staffPricePopup = $('#staffPricePopup');
            // BTOCSITE-85293 START
            self.$actionSheetConsentPopup     = $('#actionSheetConsent');
            self.$sheetConsent1Popup          = $('#sheetConsent01');
            self.$sheetConsent2Popup          = $('#sheetConsent02');
            self.$sheetConsent3Popup          = $('#sheetConsent03');
            self.$sheetConsent4Popup          = $('#sheetConsent04');
            //self.$sheetConsent5Popup          = $('#sheetConsent05'); // BTOCSITE-85293 V0.8
            // BTOCSITE-85293 END
        },

        bindProductEvents: function() {
            var self = this;

            // 20210923 BTOCSITE-3534 [퍼블] [사용자행태분석 개선사항] PDP 제품명/리뷰 링크 개선
            self.$copy.on('click',function() {
                var $this = $(this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 모델명 복사 팝업 close 시 포커스 이동
                var txt = $(this).clone().find('.blind').remove().end().text().trim();// BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 모델명 복사 시 숨김텍스트 제거
                vcui.dom.copyToClipboard(txt, {
                    container:this,
                    onSuccess: function () {
                        // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 모델명 복사 팝업 close 시 포커스 이동
                        $(window).off('toastopen.productNameCopy').on('toastopen.productNameCopy', function() {
                            setTimeout(function() {
                                $('.toast-text').focus();
                            }, 300);
                            $(window).off('toastopen.productNameCopy');
                        });
                        $(window).trigger("toastshow",{text:"모델명을 복사했습니다.", opener:$this});
                        // [E] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 모델명 복사 팝업 close 시 포커스 이동
                    }
                });
            });

            //데스크탑용 갤러리 이미지 클릭
            self.$pdpImage.find('a').first().on('click',function(e){
                e.preventDefault();
                var index = $(this).attr("data-idx");
                self.openVisualModal(index, this);
            });
            self.$pdpVisualNotice.on('click',function(e){ // BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다.
                e.preventDefault();
                var index = $(this).attr("data-idx");
                self.openVisualModal(index, this);
            });

            //데스크탑용 썸네일리스트 클릭
            self.$pdpThumbnail.on('click','li a',function(e) {
                e.preventDefault();
                var $li = $(this).parent();
                var index = $(this).parents('li').index();
                if($li.hasClass('more')) {
                    //더보기 버튼은 바로 pdp모달 뛰움
                    self.openVisualModal(index, this);
                } else {
                    //썸네일 클릭
                    self.clickThumbnailSlide(index, this);
                }
            });

            self.$pdpMobileSlider.on('click', 'a', function(e){
                e.preventDefault();
                var index = $(this).parents(".ui_carousel_current").attr("data-ui_carousel_index");
                // BTOCSITE-100135 Start
                if(vcui.detect.isMobileDevice){
                   const only = $('div.sr-only');
                   if(only){
                      only.first().attr('aria-hidden', 'true');
                   }
                   const viewPort = $('div.iw_viewport-wrapper.subRenewPdpWrap');
                   if(viewPort){
                      viewPort.first().attr('aria-hidden', 'true');
                   }
                   const toastMessage = $('div.toast-message');
                   if(toastMessage){
                      toastMessage.first().attr('aria-hidden', 'true');
                   }
                }
                // BTOCSITE-100135 End
                self.openVisualModal(index, this);
            });

            //모바일용 갤러리 클릭 //BTOCSITE-19922
            self.$pdpMobileVisual.on('click', '.pdp-visual-animation .video-controller button', function(e){
                var $video = $(this).parents('.pdp-visual-animation').find('video');
                var $parent = $video.parent('.pdp-visual-animation');
                var $controller = $parent.find('.video-controller');
                var $pause = $controller.find('.btn-pause');
                var $play = $controller.find('.btn-play');

                $parent.addClass('is-active');
                $controller.addClass('is-active');

                if( $(this).hasClass('btn-pause') ){
                    $video[0].pause();
                    $(this).removeClass('is-active');
                    $play.addClass('is-active');
                } else {
                    $video[0].play();
                    $controller.removeClass('is-active');
                    $(this).removeClass('is-active');
                    $pause.addClass('is-active');
                }
            });

            //pdp모달 썸네일 리스트 클릭
            self.$popPdpThumbnail.on('click','li a',function(e) {
                e.preventDefault();
                var index = $(this).parents('li').index();

                self.$popPdpThumbnail.find('li a').attr("aria-selected","false");
                $(this).attr("aria-selected","true");

                self.clickModalThumbnail(index);
            });

            //모바일 갤러리 슬라이드시 인덱스 넘버 표시
            self.$pdpMobileSlider.on('carouselafterchange', function(e,target,index){
                self.$slideNumber.text(index + 1);
            });

            //AR체험하기 클릭
            self.$component.on('click','div.pdp-ar-area a.btn-ar', function (e){
                e.preventDefault();
                var modelId = this.dataset.arModelId;
                if(!lgkorUI.openAR(modelId)) {
                    $('#arPopup').vcModal({opener: this});
                }
            });

            //360 view
            self.$component.on('click','div.pdp-ar-area a.btn-360', function (e){
                e.preventDefault();
                self.clickThumbnailSlide($(this).data('index'));
            });

            // $(window).on('appNotInstall', function(e){
            //     $('#arPlayPop').vcModal({opener: e.currentTarget});
            // });

            // 리뉴얼 옵션 클릭
            $(document).off('click', 'li.laptap-opt .opt-area input').on('click', 'li.laptap-opt .opt-area input', function (e) {
                e.preventDefault();

                var modelUrlPath = $(this).attr("data-model-url-path");
                if (!modelUrlPath) {
                    return false;
                }

                if (modelUrlPath == location.pathname) {
                    return false;
                }

                var changeOptionList = [];
                var tempChangeOptionList = $(this).attr("data-change-option-list").slice(1, -1).replaceAll(" ", "");
                if (tempChangeOptionList) {
                    changeOptionList = tempChangeOptionList.split(',');
                }

                var param = {
                    pickOptionId: $(this).attr("id").replaceAll("opt-", ""),
                    changedOptionIds: changeOptionList,
					top : $(window).scrollTop()
                };

				//location.href = lgkorUI.DEFAULT_URL+modelUrlPath; //BTOCSITE-48266 b2b url 추가
				try {
                    // lgkorUI.showLoading();
                    $('body').promise().then(function () {
                        /* BTOCSITE-100866 START */
                        // TBT 개선을 위한 비동기 처리
                        if (window.requestIdleCallback) {
                            requestIdleCallback(function() {
                                try {
                                    SmartViewController.clearPdpHistory(lgeSmartView_category, lgeSmartView_modelId);
                                } catch (e) {
                                    console.log(e);
                                }
                            }, { timeout: 3000 });
                        } else {
                            // requestIdleCallback 미지원 브라우저를 위한 fallback
                            requestAnimationFrame(function() {
                                try {
                                    SmartViewController.clearPdpHistory(lgeSmartView_category, lgeSmartView_modelId);
                                } catch (e) {
                                    console.log(e);
                                }
                            });
                        }
                        /* BTOCSITE-100866 END */
                        __PDP_DOM_MNG__.load(lgkorUI.DEFAULT_URL+modelUrlPath, param);
                        KRP0008.isEventTriggered = true;
                    });
                } catch(e) {
                    lgkorUI.hideLoading();
                    KRP0008.isEventTriggered = false;
                }
				
            });

            // [S] BTOCSITE-91373 [QC][AOS] 구독 계약기간별 상품 이동 영역 내 특정 구독 건 선택 시 페이지 이동되지 않음
            // BTOCSITE-51366 PDP 렌탈이동 경로 개선 85521 문제
            $('ul.rental-new-list li.rental-new-item a').on('click', function(e) {
                e.preventDefault();

                if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "PRODUCT"){
                    let callbackVal = KRP0008.b2bLoginCheck(e);
                    if(!callbackVal) return;
                }

                let url  = $(this).closest('div.rental-new').children('a').prop('href');
                if (url) {
                    lgkorUI.setStorage("dispRtModelSeq", $(this).data('rt-model-seq'));
                    location.href = url;
                }
            });
            // [E] BTOCSITE-91373 [QC][AOS] 구독 계약기간별 상품 이동 영역 내 특정 구독 건 선택 시 페이지 이동되지 않음
        },

        contentLoadingScrollEvent: function() {

            $(window).scroll(function(){

                if (KRP0008.isEventTriggered) {
                    try {
                        // 이벤트 대상
                        var $targetElement = $('.lists.member');
                        // 대상 요소의 페이지 상단으로부터의 거리
                        var targetOffset = $targetElement.offset().top;
                        // 현재 스크롤 위치
                        var scrollPosition = $(window).scrollTop();
                        // 윈도우 높이
                        var windowHeight = $(window).height();
                        // 문서 전체 높이
                        var documentHeight = $(document).height();

                        if (scrollPosition > targetOffset || scrollPosition + windowHeight >= documentHeight) {
                            KRP0008.isEventTriggered = false; 	// 이벤트 발생 처리 표시

                            $(window).trigger('contentLoad');	// 컨텐츠 로딩
                        }

                    } catch(error2) {
                        KRP0008.isEventTriggered = true; // 이벤트 발생 처리 표시 (스크롤 이벤트 발생 가능 상태로 변경)

                        console.error('컨텐츠 스크롤 이벤트 실패: ', error2);
                    }
                }

            });

            // 컨텐츠 로딩 이벤트 등록
            $(window).off('contentLoad').on('contentLoad', function(e){

                $('#contentLoading').show();

                var _promise = __PDP_DOM_MNG__.loadContent(window.location.pathname);

                Promise.all([_promise]).then((result) => {
                    __PDP_DOM_MNG__.execComponentsJs('content');
                    $(window).trigger('load');
                }).catch((error) => {
                    console.error('컨텐츠 로드 실패: ', error);
                });

            });

        },

        setGiftPopup: function (e, data) {  //66272 모달 팝업 내에 들어가는 스와이프 함수
            var $popup = $(e.target);
            var $carousels = $popup.find(".gift-swiper");
            var eventNS = '.buy-benefit';

            // 페이징 변경
            var changePagination = function (carousel) {
                var $indicator = carousel.$el.find(".custom-indi-wrap");
                var $slideCurrent = $indicator.find(".current");
                var $totalCount = $indicator.find(".count");

                var idx = carousel.getCurrent();
                var dotlen = carousel.getDotCount(); // slide 1개면 0

                $slideCurrent.text(idx + 1);
                $totalCount.text(dotlen + 1);

                $indicator.toggle(!!dotlen);
            }

            // 캐러셀
            $carousels.each(function (idx, elm) {
                var $carousel = $(elm);
                
                // 중복 방지
                if ($carousel.vcCarousel('instance', false)) return;

                // 초기화
                $carousel
                .on("carouselafterchange", function (e, carousel, index) {
                    changePagination(carousel);
                }).on("carouselinit", function (e, carousel, index) {
                    changePagination(carousel);
                })
                .vcCarousel({
                    infinite: true,
                    autoplay:false,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: '.btn-arrow.ico-prev',
                    nextArrow: '.btn-arrow.ico-next'
                });
            });

            /**
             * 아코디언 확장 함수
             * @param {jQueryElement} target .ui_accordion 대상
             * @param {number} index 활성화 넘버
             */
            var expandAccordion = function (target, index) {
                if (!target.length) return;
                    
                var accordion = target.vcAccordion('instance', false);
                if (accordion && index >= 0) accordion.expand(index , false);
            }

            // 탭 버튼
            var $tab = $popup.find('.ui_tab'); // 팝업 내부 탭 elm
            var tab = $tab.vcTab('instance', false);

            var targetId = $(data.opener).data("active-target"); // 팝업 오픈한 버튼 dataset
            var matchTabIdx = $popup.find('ul.tabs > li[data-active-target^="'+ targetId.slice(0, -1) +'"]').index(); // 열어둘 아코디언 item index

            if (tab && targetId) {
                // 탭 변경
                $tab
                .off(eventNS)
                .on(tab.$statics.ON_CHANGED + eventNS, function (e, data) {
                    var x = data.button.get(0).offsetLeft;

                    // 탭 버튼 활성화 가로 스크롤 이동
                    data.button.closest('.tabs').get(0).scrollTo({ left: x, behavior: "smooth" });

                    if (!!data.content.find('.ui_accordion').length) {
                        // 아코디언 컨텐츠 존재 시 전부 닫기
                        data.content.find('.ui_accordion').vcAccordion('collapseAll');
                    }
                });

                if (matchTabIdx > -1) tab.select(matchTabIdx); // 해당 탭버튼 활성화

                var $currenTabCont = tab.$contents.eq(matchTabIdx); // 해당 탭 컨텐츠
                var $accordion = $currenTabCont.find('.ui_accordion'); // 탭 컨텐츠 내부 아코디언
                var chooseIndex = $currenTabCont.find('li#' + targetId).index(); // 탭 컨텐츠 내부 아코디언 ui와 targetId와 맞는 element index
                
                expandAccordion($accordion, chooseIndex);
            }

            // 아코디언 토글 시
            $popup.find('.ui_accordion').each(function (idx, elm) {
                var $accordion = $(elm);
                var accordion = $accordion.vcAccordion('instance', false);

                if (!accordion) return;

                $accordion
                .off(eventNS)
                .on(accordion.$statics.ON_START_EXPAND + eventNS, function (e, data) {
                    // 아코디언 열리기 직전 내부 carousel setPosition 으로 ui 갱신
                    data.content.find('.ui_carousel_initialized').vcCarousel('setPosition', true); 
                })
                .on(accordion.$statics.ON_EXPAND + eventNS, function (e, data) {
                    // 아코디언 컨텐츠 열린 후
                    var $popCont = $(e.target).closest('.pop-conts');

                    if (!$popCont.length) return;

                    // 팝업 내에 스크롤이 생겼다면
                    if ($popCont.get(0).clientHeight !== $popCont.get(0).scrollHeight) {
                        // 아코디언에 의해 팝업 스크롤이 생겼다면 아코디언 컨텐츠 내부 carousel width 변경되었으니 setPosition 으로 ui 갱신
                        data.content.find('.ui_carousel_initialized').vcCarousel('setPosition');
                    }
                });
            })

            // 팝업 열리면 내부 초기화된 carousel refresh 1회 실행
            $popup.find('.ui_carousel_initialized').vcCarousel('setPosition', true);
        },

        bindSideEvents: function() {
            var self = this;
            var checkCompareClick = false;

            // LGECOMVIO-20 TAB 제외로 수정
            if(self.$pdpInfo.find('.option-contents').length) {
                if ($('#typeOrder').length) {
                    self.$pdpInfo.attr('data-type-cart', 'P');
                } else {
                    self.$pdpInfo.attr('data-type-cart', 'C');
                }
            }

            //모바일 수상내역 버튼
            self.$mobilePdpInfo.on('click','div.inner a.btn-link.popup', function (e) {
                e.preventDefault();
                self.$pdpMoreInfo.find('a.btn-link.popup').trigger('click');
            });

            //비교하기
            self.$pdpInfo.find('.product-compare button').off('click').on('click', function(e) {
                e.preventDefault();
                // BTOCSITE-30428 : 빠른 클릭시 레이아웃이 안뜨는 형상 발생
                if(checkCompareClick) {
                    return;
                }
                checkCompareClick = true;

                var checked = !$(this).hasClass('compare-select');
                var pdpDataId = self.$pdpInfo.attr('data-id'); //BTOCSITE-5856 비교하기 버튼 토글기능 오류

                if(checked) {
                    $(this).addClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
                    $(this).find('span.blind').text('선택됨');
                } else {
                    $(this).removeClass('compare-select');
                    $(this).find('span.blind').text('선택안됨');
                    // BTOCSITE-30428 : $('.sticy-compare .list-inner li') 이벤트 발생되어 비교하기 삭제시에서도 세션캐시 2번 호출로 인한 에러 발생
                    // $('.item-inner[data-id=' + pdpDataId + ']').siblings('.btn-close').trigger('click'); //BTOCSITE-5856 비교하기 버튼 토글기능 오류
                }
                //$(this).prop('checked',!checked);
                //self.requestCompareItem(lgePdpSendData, checked, $(this));
                var categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
                var categoryNm = lgkorUI.getHiddenInputData().defaultCategoryName;

                var compareId = lgePdpSendData.sku.split(".");
                if(typeof modelName !== 'undefined') {
                    compareId = modelName;
                }

                if(checked){
                    var compareObj = {
                        "id": lgePdpSendData.id,
                        "b2bcatemapping":lgePdpSendData.b2bCateMapping,
                        "productName": lgePdpSendData.productName,
                        "productID": compareId,
                        "productImg": lgePdpSendData.productImg,
                        "productAlt": lgePdpSendData.productAlt,
                        "careType": lgePdpSendData.careType,
                        "path": modelUrlPath,
                        "lgecomOnlyFlag" : lgePdpSendData.lgecomOnlyFlag,
                        "b2cYN": lgkorUI.getHiddenInputData().b2cYN
                    }
                    var isAdd = lgkorUI.addCompareProd(categoryId, compareObj, categoryNm);
                    if(!isAdd) {
                        $(this).prop('checked', false);
                        $(this).removeClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
                        $(this).find('span.blind').text('선택안됨');
                    }
                } else{
                    lgkorUI.removeCompareProd(categoryId, lgePdpSendData.id);
                }

                setTimeout(function(){
                    checkCompareClick = false;
                }, 500);
            });

            //비교하기 컴포넌트 변화 체크
            $(window).on("changeStorageData", function(){
                self.setCompares();
            });

            // 장바구니 담기 성공 리턴(BTOCSITE-37933)
            $(window).on("addCartReturn", function(e){
                self.cartRecommend(false);
            });

            //찜하기
            self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').off().on('click', function(e) {
                self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').attr('disabled', true); // BTOCSITE-61135
            	var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                var $this = $(this);
                var _id = lgePdpSendData.modelId;
                var sku = (productInfo.model_sku ? productInfo.model_sku : lgePdpSendData.sku);
                var categoryId = lgePdpSendData.categoryId;
                var wishListId = $this.data("wishListId");
                var wishItemId = $this.data("wishItemId");
                var wish = $this.is(':checked');
                var param = {
                    "id":_id,
                    "sku":sku,
                    "categoryId": categoryId,
                    "wishListId": wishListId,
                    "wishItemId": wishItemId
                }
                if(wish){
                    param.type = "add";
                } else{
                    param.type = "remove";
                }
                /* BTOCSITE-106887 START */
                if(productInfo){
                    var quantity = self.$actionSheet.find('div.select-quantity input.quantity');
                    kakaoPixel('975360282649280347').addToWishList({
                        currency: "KRW",
                        products: [		
                        { id: modelId, name: productInfo.model_name, quantity: quantity.length > 0 ? quantity.val() : "1", price: productInfo.base_price, brand: productInfo.brand }			
                        ]
                    });
                }  
                /* BTOCSITE-106887 END */

                var ajaxUrl = self.$pdpInfo.attr('data-wish-url');

                /* s : BTOCSITE-5938-408 : 찜하기 복수인 경우 */
                var $wishItem = self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]');
                var success = function(data) {
                    self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').removeAttr('disabled'); // BTOCSITE-61135
                    // $this.data("wishItemId",data.wishItemId);
                    // $this.prop("checked",wish);
                    $wishItem.each(function(i){
                        $(this).data("wishItemId",data.wishItemId);
                        $(this).prop("checked",wish);
                    });
                    
                    //찜하기, 위시리스트 태그 삽입
                    if(wish) {
                        self.addWishTag();
                    }

                    // BTOCSITE-13562 : 4월 이벤트 개발 요청_찜하기
                    var eventId = lgkorUI.getCookie("eventZzimId");
                    if(eventId) {
                        lgkorUI.requestAjaxData("/mkt/api/eventManagement/addWishlistEvent", {
                            "modelId" : lgePdpSendData.modelId,
                            "categoryId" : lgePdpSendData.categoryId,
                            "wishFlag" : wish ? 'Y' : 'N',
                            "eventId" :  eventId
                        });
                    }
                };
                var fail = function(data) {
                    self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').removeAttr('disabled'); // BTOCSITE-61135
                    // $this.prop("checked",!wish);
                    $wishItem.each(function(){
                        $(this).prop("checked",!wish);
                    });
                };
                /* e : BTOCSITE-5938-408 */

                lgkorUI.requestWish(
                    param,
                    wish,
                    success,
                    fail,
                    ajaxUrl,
                    $this // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 위시리스트 로그인 확인 팝업 close 시 포커스 이동
                );
            });

            //장바구니
            //BTOCSITE-23825 크리테오tag 삽입 함수 추가
            // BTOCSITE-71622 가전구독 PDP 전화 구매 상담 예약 개선
            self.$pdpInfo.find('div.purchase-button a.cart, div.purchase-button a.btn-cart').on('click', function(e) {
                var opener = $(e.currentTarget).length ? e.currentTarget : ''; // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                e.preventDefault();
                if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
                    return;
                }
                //BTOCSITE-48266 b2b일 때 로그인 체크 start
                if (lgkorUI.getHiddenInputData().b2cYN ==='N') {
                    let className = e.currentTarget.className;
                    if(lgePdpSendData.bizTypeDetail === "CARETAB"){
                        let callbackVal = KRP0008.b2bLoginCheck(e);
                        if(!callbackVal) return;
                    }else{
                        if(className.indexOf("btn-open-action-sheet") == -1){
                            let callbackVal = KRP0008.b2bLoginCheck(e);
                            if(!callbackVal) return;
                        }
                    }
                }
                //BTOCSITE-48266 b2b일 때 로그인 체크 end
                if(!self.rentalAllSelect){
                    lgkorUI.alert("", {title: "모든 옵션을 선택해주세요."}, opener); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                    return;
                }

                var rentalSelfCheck = false;
                
                //BTOCSITE-29501 - 케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    checkCareSelect = lgkorUI.stringToBool(checkinput.val()); //true:신청 / false:미신청
                }

                self.$actionSheet.find('.ui_selectbox').each(function(){
                    if($(this).val() == '방문없음/자가관리' && checkCareSelect) {
                        rentalSelfCheck = true;
                    }
                })

                var param = {
                    "id":lgePdpSendData.id,
                    "sku":lgePdpSendData.sku,
                    "rtSeq":lgePdpSendData.rtSeq,
                    "bizType":lgePdpSendData.bizType,
                    "b2cYN":lgkorUI.getHiddenInputData().b2cYN,
                }

                var $paymentAmount = $(this).parents('.payment-amount');

                //렌탈케어 제품인가(일반구매의 케어십과 틀림)
                var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');

                //소모품이 있는가
                var cart = [];
                var $additionalPurchase = $('.additional-purchase');
                if($additionalPurchase.length > 0) {
                    $additionalPurchase.find('ul.additional-list li').each(function(idx, item){
                        cart.push($(item).data('id')+"|"+$(item).data('quantity'));
                    });
                }

                //선택 수량
                var quantity = self.$actionSheet.find('div.select-quantity input.quantity');
                if(quantity.length > 0) {
                    cart.push(lgePdpSendData.sku+"|"+quantity.val());
                } else {
                    cart.push(lgePdpSendData.sku+"|1");
                }

                param.sku = cart.join(',');

                //var $purchaseButton = $(this).parents('.purchase-button');
                //if($purchaseButton.hasClass('rental')) {
                //렌탈타입
                //   param.typeFlag = "C";
                //} else {
                //제품타입
                param.typeFlag = "P";

                //케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    var checkCareSelect = lgkorUI.stringToBool(checkinput.val());
                    if(checkCareSelect) {
                        //케어쉽 선택
                        param.typeFlag = "C";
                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                    }
                } else {
                    var $careSiblingOption = $('.care-sibling-option');
                    //케어쉽필수 제품인지 체크해서 알림창 뛰움
                    if($careSiblingOption.length < 1) {
                        if(careRequire) {
                            param.typeFlag = "C";
                        }
                    } else {
                        param.typeFlag = "C";
                    }
                }
                //}

                if(param.typeFlag == "C") {
                    if(typeof careshipOnlyFlag !== 'undefined') {
                        param.requireCare = lgkorUI.stringToBool(careshipOnlyFlag) ? true : false;
                    }

                    var careData = $paymentAmount.data('careData');
                    if(careData) {
                        param.rtSeq = careData.rtModelSeq;
			             //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start
			             var modelList = [];
			             var modelMap = {
			                    "modelId":lgePdpSendData.id,
			                    "sku":lgePdpSendData.sku,
			                    "rtModelSeq":careData.rtModelSeq,
			                    "bizType":lgePdpSendData.bizType
			             };
			             modelList.push(modelMap);
			             param.modelList = JSON.stringify(modelList);
	             		//BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 end
                    }

                    var cardData = $paymentAmount.data('cardData');
                    if(cardData) {
                        if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
                            //간편신청카드
                            param.easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
                        }
                    }
                    self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                }

                var ajaxUrl = self.$pdpInfo.attr('data-cart-url');
                
                var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;

                /* 구매시 옵션체크 항목일 경우 START */
                var optItemBuyChkFlag = false;
                var optItemDispNmBuyChk = '';
                var optItemDispValueNmBuyChk = '';
                var action = isRentalCareTab ? '가전 구독' : '구매';

                var optItems = self.$specInfoPopup.find('.sibling-cont > div');
                if (optItems.length > 0) {
                    optItems.each(function(i, e) {
                        if ($(this).data('opt-item-buy-chk-flag') == 'Y') {
                            optItemBuyChkFlag = true;
                            optItemDispNmBuyChk = $(this).data('opt-item-nm');
                            optItemDispValueNmBuyChk = $(this).find('div.option-list input:radio:checked').siblings('label').text();

                            return false;
                        }
                    });
                }

                if (optItemBuyChkFlag === false && buryPipeFlag === 'Y') {
                    optItemBuyChkFlag = true;
                    optItemDispNmBuyChk = '설치타입';
                    optItemDispValueNmBuyChk = '매립배관형';
                }
                // BTOCSITE-85293 START
                self.preCheckTermAndCondition(false, function() {
                    if(optItemBuyChkFlag) {
                        lgkorUI.confirm('', {
                            title:"지금 선택된 제품은 <br>" + optItemDispNmBuyChk + " " +  optItemDispValueNmBuyChk + " 제품입니다.<br>" + optItemDispValueNmBuyChk + " 제품을 " + action + " 하시겠어요?",
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                if(rentalSelfCheck){
                                    lgkorUI.confirm('', {
                                        title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 " + action + " 하시겠어요?",
                                        okBtnName: '확인',
                                        cancelBtnName: '취소',
                                        ok: function() {
                                            if(!isRentalCareTab && param.typeFlag == "C") {
                                                //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START
                                                /* lgkorUI.confirm('', {
                                                     title: "케어십 서비스를 신청하시는 경우<br>1개의 제품만 장바구니에 담을 수 있습니다.<br>해당 제품을 장바구니에 담으시겠어요?",
                                                     okBtnName: '네',
                                                     cancelBtnName: '아니오',
                                                     ok:function(){
                                                         lgkorUI.requestCart(ajaxUrl, param, true);
                                                         self.addCartTag(productInfo, quantity, true);
                                                     }
                                                 });*/
                                                 /* lgkorUI.requestCart(ajaxUrl, param, true);
                                                 self.addCartTag(productInfo, quantity, true);
                                                 //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END
                                                self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선*/
                                                //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                                $('#careRequireBuyCartPopup').vcModal({opener: this});
                                               //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                                return;
                                            }
                                            self.addCartAjaxCall(ajaxUrl, param, true);
                                            self.addCartTag(productInfo, quantity, false);
                                        }
                                    }, opener);  // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                                    return;
                                } else {
                                    if(!isRentalCareTab && param.typeFlag == "C") {
                                        /* lgkorUI.confirm('', {
                                        title: "케어십 서비스를 신청하시는 경우<br>1개의 제품만 장바구니에 담을 수 있습니다.<br>해당 제품을 장바구니에 담으시겠어요?",
                                        okBtnName: '네',
                                        cancelBtnName: '아니오',
                                        ok:function(){
                                            lgkorUI.requestCart(ajaxUrl, param, true);
                                            self.addCartTag(productInfo, quantity, true);
                                        }
                                        });*/
                                      /*  lgkorUI.requestCart(ajaxUrl, param, true);
                                        self.addCartTag(productInfo, quantity, true);
                                      //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END
                                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                                           */
                                         //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건 수정
                                        $('#careRequireBuyCartPopup').vcModal({opener: this});
                                       //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건

                                        return;
                                    }
                                }
                                self.addCartAjaxCall(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, false);
                            }
                        });

                        return;
                    }
                    /* 구매시 옵션체크 항목일 경우 END */

                    if(rentalSelfCheck){
                        lgkorUI.confirm('', {
                            title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 구매하시겠어요?",
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                if(!isRentalCareTab && param.typeFlag == "C") {
                                    //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START
                                    /*
                                    lgkorUI.confirm('', {
                                        title: "케어십 서비스를 신청하시는 경우<br>1개의 제품만 장바구니에 담을 수 있습니다.<br>해당 제품을 장바구니에 담으시겠어요?",
                                        okBtnName: '네',
                                        cancelBtnName: '아니오',
                                        ok:function(){
                                            lgkorUI.requestCart(ajaxUrl, param, true);
                                            self.addCartTag(productInfo, quantity, true);
                                        }
                                    });*/
                                    //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END
                                    /*lgkorUI.requestCart(ajaxUrl, param, true);
                                    self.addCartTag(productInfo, quantity, true);
                                    //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END
                                    self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                                    */
                                    //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                    $('#careRequireBuyCartPopup').vcModal({opener: this});
                                   //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                    return;
                                }
                                self.addCartAjaxCall(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, false);
                            }
                        }, opener); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                        return;
                    }

                    if(!isRentalCareTab && param.typeFlag == "C") {
                        //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START
                        /*
                        lgkorUI.confirm('', {
                            title: "케어십 서비스를 신청하시는 경우<br>1개의 제품만 장바구니에 담을 수 있습니다.<br>해당 제품을 장바구니에 담으시겠어요?",
                            okBtnName: '네',
                            cancelBtnName: '아니오',
                            ok:function(){
                                lgkorUI.requestCart(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, true);
                            }
                        });*/
                        //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 END
                        /*  lgkorUI.requestCart(ajaxUrl, param, true);
                          self.addCartTag(productInfo, quantity, true);
                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선*/

                        //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                        $('#careRequireBuyCartPopup').vcModal({opener: this});
                       //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건

                        return;
                    } else {
                        //BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
                        if(purchaseButtonDisplay === "N"){
                            lgkorUI.alert("", {title: purchaseButtonMassage}, opener); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                        }else{
                            self.addCartAjaxCall(ajaxUrl, param, true);
                            self.addCartTag(productInfo, quantity, false);
                        }
                    }

                });
                // BTOCSITE-85293 END

            });

            // BTOCSITE-74567 [상품구독] LGE.COM 구독 캠페인 광고 스크립트 개발 요청의 건 - 상담예약 (전화구매상담)
            self.$pdpInfo.find('div.rental-reservation-call > a.link-area, div.btn-group > a.btnTelCall').on('click', function(e) {
                e.preventDefault();

                var url = $(this).attr('href').replace("#","");
                if(url) {
                    try {
                        /* BTOCSITE-121070  [구독] 구독 광고 스크립트 개선 개발 */
                        if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
                            // 네이버
                            wcsTraceEvent("inquiry");
                            // 카카오
                            kakaoTraceEvent("consult_reservation");
                            // 메타
                            metaTraceEvent('consulting'); // CSR-10916 [구독]메타픽셀 스크립트 사용하는 이벤트에서 Conversion API 호출하게 변경필요 - 추가보강
                            // 당근마켓
                            karrotTraceEvent("consult_reservation");
                            // 크리테오
                            criteoTraceEvent("consult_reservation");
                            // 구글
                            gtagTraceEvent("consult_reservation");
                            // 토스
                            tossTraceEvent("consultation");
                        } else {
                            // 네이버
                            if (window.wcs) {
                                if(!wcs_add) var wcs_add = {};
                                wcs_add["wa"] = "s_10f2ff8ac82";
                                wcs.inflow("https://www.lge.co.kr/");
                                wcs_do();
                                var _conv = {};
                                _conv.type = "inquiry";
                                wcs.trans(_conv);
                            }
                            // 메타
                            fbq('trackCustom', 'consulting');
                            if (window.LgeMetaCapi) {
                                LgeMetaCapi.trackCustom('consulting', {});
                            }
                            // 당근마켓
                            window.karrotPixel.track('Lead');
                            // 크리테오
                            window.criteo_q = window.criteo_q || [];
                            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                            window.criteo_q.push(
                                { event: "setAccount", account: 114760 },
                                { event: "setSiteType", type: deviceType },
                                { event: "viewHome", sub: "4" }
                            );
                        }


                        
                        // BTOCSITE-80498 Start
                        if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                            if($(this).hasClass('link-area')) {
                                KRP0008.csReservationClickRecordEvent();	// 상담예약
                            } else if($(this).hasClass('btnTelCall')) {
                                KRP0008.csCallClickRecordEvent();			// 전화구매상담
                            }
                        }
                        // BTOCSITE-80498 End
                        
                        /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 start*/

                        /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 end*/
                    } catch (e) {
                        console.log(e);
                    }
                    //[BTOCSITE-92520] 구매상담예약 링크 변경
                    //location.href = url;
                }
                //[BTOCSITE-92520] 구매상담예약 링크 변경
                if ($(this).hasClass('btnTelCall')) { //BTOCSITE-100182 사업자몰_견적문의링크오류
                    // 로그인 여부 확인
                    if (!lgkorUI.stringToBool(loginFlag)) {
                        lgkorUI.confirm('', {
                            title: '구독상담 예약 안내를 위해 로그인이 필요해요. ',
                            okBtnName: '로그인 하기',
                            cancelBtnName: '취소',
                            ok: function () {
                                window.location.href = "/sso/member/login";
                            }
                        });
                        return;
                    }

                    // 파라미터 생성
                    var params = {
                        modelId: lgePdpSendData.modelId,
                        sku: lgePdpSendData.sku,
                        categoryId: lgePdpSendData.categoryId,
                        subCategoryId: lgePdpSendData.subCategoryId,
                        //productName: lgePdpSendData.productName,
                        productImg: lgePdpSendData.productImg,
                        //productAlt: lgePdpSendData.productAlt,
                        gubun: 'C' //구독(PDP)
                    };
                    var queryString = Object.keys(params)
                        .map(key => key + '=' + encodeURIComponent(params[key]))
                        .join('&');

                    // URL에 파라미터 추가
                    var url = '/consultReserve/reg-popup?' + queryString;

                    var conSultPop = window.open(url, 'conSultPop', 'width=444, height=788, top=50, left=50, scrollbars=yes');

                    try {
                        conSultPop.focus();
                    } catch (e) {
                        alert('팝업이 차단되었습니다. 팝업을 해제해주세요.');
                    }
                }
            });

            //전시매장 찾기
            $('div.info-bottom li.find-store a').on('click', function(e) {
                e.preventDefault();
                var url = $(this).attr('href').replace("#","");
                if(url) {
                    if(typeof outletStockFlag !== 'undefined' && lgkorUI.stringToBool(outletStockFlag)){
                        location.href = url;
                    } else {
                        lgkorUI.confirm('', {
                            title: '해당 제품을 전시하는 베스트샵 매장이 없습니다. 가까운 매장을 찾아 최적의 제품을 상담받으시겠어요?',
                            okBtnName: '네',
                            cancelBtnName: '아니오',
                            ok: function() {
                                location.href = url;
                            }
                        }, this); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 전시매장 찾기 클릭 후 노출되는 팝업 close 시 포커스 이동
                    }
                }
            });

            //구매상담예약
            self.$pdpInfo.find('div.purchase-button a.btnConsult').on('click', function(e) {
                e.preventDefault(); // 기본 동작 방지

                // 로그인 여부 확인
                if (!lgkorUI.stringToBool(loginFlag)) {
                    lgkorUI.confirm('', {
                        title:'구매상담 예약 안내를 위해 로그인이 필요해요.',
                        okBtnName: '로그인 하기',
                        cancelBtnName: '취소',
                        ok : function (){
                            window.location.href = "/sso/member/login";
                        }
                    });
                    return;
                }

                // 파라미터 생성
                var params = {
                    modelId: lgePdpSendData.modelId,
                    sku: lgePdpSendData.sku,
                    categoryId: lgePdpSendData.categoryId,
                    subCategoryId: lgePdpSendData.subCategoryId,
                    //productName: lgePdpSendData.productName,
                    productImg: lgePdpSendData.productImg,
                    //productAlt: lgePdpSendData.productAlt,
                    gubun: 'J' //일반(PDP)
                };
                var queryString = Object.keys(params)
                    .map(key => key + '=' + encodeURIComponent(params[key]))
                    .join('&');

                // URL에 파라미터 추가
                var url = '/consultReserve/reg-popup?' + queryString;

                var conSultPop = window.open(url, 'conSultPop', 'width=444, height=788, top=50, left=50, scrollbars=yes');

                try {
                    conSultPop.focus();
                } catch(e){
                    alert('팝업이 차단되었습니다. 팝업을 해제해주세요.');
                }

            });

            //구매/예약/렌탈
            // BTOCSITE-71622 가전구독 PDP 전화 구매 상담 예약 개선
            self.$pdpInfo.find('div.purchase-button a:not(.cart, .btn-cart, .btnTelCall, .black, .soldOk, .ai )').on('click', function(e) { // BTOCSITE-85293
                var opener = $(e.currentTarget).length ? e.currentTarget : ''; // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 장바구니 클릭 후 노출되는 팝업 close 시 포커스 이동
                e.preventDefault();

                if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
                    return;
                }

                // 소모품이고 구매 수량 제한 정책이 적용된 경우 로그인 체크
                if (lgePdpSendData.bizTypeDetail === "DISPOSABLE") {
                    var isPolicyLimit = $('.product-detail-info').attr('data-is-policy-limit') === 'true';
                    if (isPolicyLimit && !lgkorUI.stringToBool(loginFlag)) {
                        lgkorUI.confirm('', {
                            title: '선택하신 제품을 구매하시기 위해서는<br>LG전자 통합 사이트의 로그인이 필요합니다.',
                            okBtnName: '로그인 하기',
                            cancelBtnName: '취소',
                            ok: function () {
                                window.location.href = "/sso/member/login";
                            }
                        });
                        return;
                    }
                }

                //BTOCSITE-48266 b2b일 때 로그인 체크 start
                if (lgkorUI.getHiddenInputData().b2cYN ==='N') {
                    let className = e.currentTarget.className;
                    if(lgePdpSendData.bizTypeDetail === "CARETAB"){
                        let callbackVal = KRP0008.b2bLoginCheck(e);
                        if(!callbackVal) return;
                    }else{
                        if(className.indexOf("btn-open-action-sheet") == -1){
                            let callbackVal = KRP0008.b2bLoginCheck(e);
                            if(!callbackVal) return;
                        }
                    }
                }
                //BTOCSITE-48266 b2b일 때 로그인 체크 end

                // BTOCSITE-22701 add :: 구독일때 구독이벤트 발생
                if (lgePdpSendData.bizType == 'SUBSCRIPTION'){
                    self.$pdpInfo.trigger('subscribe', self.$pdpInfo.data('subscriptionUrl'));
                    return;
                }

                //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 클래스로 인한 중복호출 방지..
                if(e.currentTarget.id == 'btn-up20cart')		return;

                // BTOCSITE-82800 캠페인 광고 스크립트 START
                /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글 광고 태그 추가/수정 요청의 건 start*/
                //구독신청
                try {
                    if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                        /* BTOCSITE-121070  [구독] 구독 광고 스크립트 개선 개발 */
                        // <카카오>
                        kakaoTraceEvent('subscribe');
    
                        // <당근>
                        karrotTraceEvent('subscribe');
    
                        // <메타>
                        metaTraceEvent('subscribe-button');// CSR-10916 [구독]메타픽셀 스크립트 사용하는 이벤트에서 Conversion API 호출하게 변경필요 - 추가보강

                        // <네이버>
                        wcsTraceEvent('custom001');
    
                        // <크리테오>
                        criteoTraceEvent('subscribe');
    
                        //구글 애즈
                        gtagTraceEvent('subscribe');

                        // 토스
                        tossTraceEvent('subscribe');
                    } else {
    
                        // <카카오>
                        kakaoPixel('975360282649280347').pageView();
                        kakaoPixel('975360282649280347').participation('subbutton');
    
                        // <메타>
                        fbq('trackCustom', 'subscribe-button');
                        if (window.LgeMetaCapi) {
                            LgeMetaCapi.trackCustom('subscribe-button', {});
                        }
    
                        // <네이버>
                        if (window.wcs) {
                            if(!wcs_add) var wcs_add = {};
                            // (2) 각 사이트별 식별자 설정
                            wcs_add["wa"] = "s_10f2ff8ac82";      // 사이트 식별자 (=네이버공통키, na_account_id)
    
                            // (3) 광고 전환추적을 위한 cookie domain설정
                            wcs.inflow("https://www.lge.co.kr/");
    
                            // 아래 Script는 개별 이벤트 발생시 로그를 전송하기 위한 구역. 결제 완료 페이지이므로, PV 이벤트 와 결제완료 전환 이벤트를 전송함
    
                            // (4) PV 이벤트 전송
                            wcs_do(); // PV 이벤트 전송
    
                            // (5) 결제완료 전환 이벤트 전송
                            var _conv = {}; // 전환이벤트 정보 담을 object 생성
                            _conv.type = "custom001";  // 전환이벤트의 종류 설정
                            wcs.trans(_conv); // 전환 이벤트 정보를 담은 object를 서버에 전송
                        }
    
                        // <크리테오>
                        window.criteo_q = window.criteo_q || [];
                        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
    
                        window.criteo_q.push(
                            { event: "setAccount", account: 114760 },
                            { event: "setSiteType", type: deviceType },
                            { event: "viewHome", sub: "3" }
                        );
                        // BTOCSITE-82800 캠페인 광고 스크립트 END
                    }
                } catch (e) {
                    // 오류 발생 시 무시 (로그 남기기 등 필요시 추가)
                    console.error("traceEvent 오류:", e);
                }


                var $this = $(this);
                var rentalSelfCheck = false;
                var checkCareSelect = false;
                
                //케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    checkCareSelect = lgkorUI.stringToBool(checkinput.val()); //true:신청 / false:미신청
                }

                self.$actionSheet.find('.ui_selectbox').each(function(){
                    if($(this).val() == '방문없음/자가관리' && checkCareSelect) {
                        rentalSelfCheck = true;
                    }
                })

                if(preOrderFlag && $this.hasClass('btn-pre-order')) {
                    //사전예약 일경우
                    if(lgkorUI.stringToBool(loginFlag)) {
                        //사전예약 안내창 뛰우고 구매진행
                        $('#preOrderPopup').find('div.btn-group button').off('click');
                        $('#preOrderPopup').find('div.btn-group button').on('click',function(e){
                            self.productBuy($this, this);
                        });
                        $('#preOrderPopup').vcModal({opener: this});
                    } else {
                        //로그인 체크후 로그인 안내창 뛰움
                        $('#loginPopup').vcModal({opener: this});
                    }
                } else {
                    if(lgePdpSendData.bizTypeDetail === "PRODUCT" || lgePdpSendData.bizTypeDetail === "DISPOSABLE"){
                        if($(this).hasClass('btn-open-action-sheet')) return;
                    }
                    if(self.rentalAllSelect) {
                    	/* 구매시 옵션체크 항목일 경우 START */
                        var $paymentAmount = $(this).parents('.payment-amount');
                        var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');
                        var action = isRentalCareTab ? '가전 구독' : '구매';

                        if (isRentalCareTab && !lgkorUI.stringToBool(loginFlag)) {
                            //
                        } else {
                            var optItemBuyChkFlag = false;
                            var optItemDispNmBuyChk = '';
                            var optItemDispValueNmBuyChk = '';

                            var optItems = self.$specInfoPopup.find('.sibling-cont > div');
                            if (optItems.length > 0) {
                                optItems.each(function(i, e) {
                                    if ($(this).data('opt-item-buy-chk-flag') == 'Y') {
                                        optItemBuyChkFlag = true;
                                        optItemDispNmBuyChk = $(this).data('opt-item-nm');
                                        optItemDispValueNmBuyChk = $(this).find('div.option-list input:radio:checked').siblings('label').text();

                                        return false;
                                    }
                                });
                            }
                            if (optItemBuyChkFlag === false && buryPipeFlag === 'Y') {
                                optItemBuyChkFlag = true;
                                optItemDispNmBuyChk = '설치타입';
                                optItemDispValueNmBuyChk = '매립배관형';
                            }
                            if(optItemBuyChkFlag) {
                                lgkorUI.confirm('', {
                                    title:"지금 선택된 제품은 <br>" + optItemDispNmBuyChk + " " + optItemDispValueNmBuyChk + " 제품입니다.<br>" + optItemDispValueNmBuyChk + " 제품을 " + action + " 하시겠어요?",
                                    okBtnName: '확인',
                                    cancelBtnName: '취소',
                                    ok: function() {

                                        if(rentalSelfCheck){
                                            lgkorUI.confirm('', {
                                                title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 " + action + " 하시겠어요?",
                                                okBtnName: '확인',
                                                cancelBtnName: '취소',
                                                ok: function() {
                                                    self.productBuy($this, this)
                                                }
                                            });
                                            return;
                                        }

                                        self.productBuy($this, this)
                                    }
                                });
                                return;
                            }
                        }
                        /* 구매시 옵션체크 항목일 경우 END */

                        if(rentalSelfCheck){
                            lgkorUI.confirm('', {
                                title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 " + action + " 하시겠어요?",
                                okBtnName: '확인',
                                cancelBtnName: '취소',
                                ok: function() {
                                    self.productBuy($this, this)
                                }
                            });
                            return;
                        }

                        self.productBuy($this, this);
                    } else {
                        lgkorUI.alert("", {title: "모든 옵션을 선택해주세요."});
                    }
                }
            });

            //구독 BTOCSITE-22701 add :: 구독신청클릭시
            self.$pdpInfo.on('subscribe', function(e, data){

                self.$serviceOptPopup1.trigger('popup', data);

            });

            //상단 스티키 구매버튼
            $(window).on('sendExtraAction.KRP0009', function(e){
                // BTOCSITE-22701 :: 구독일때 케이스 추가
                var $buyButton;
                // [정리] B2C 전용 rentalApply 버튼 분기 제거: b2cYN==='Y'는 이 파일에서 항상 false
                if (lgePdpSendData.bizType == 'SUBSCRIPTION'){
                    $buyButton =  self.$pdpInfo.find('div.purchase-button a:not(.cart)').eq(1);                    
                } else {
                    $buyButton =  self.$pdpInfo.find('div.purchase-button a:not(.cart)').eq(0);
                }                
                $buyButton.trigger('click');
                // if($buyButton.length > 1) {
                //     $buyButton.each(function(idx,item){
                //         var $item = $(item);
                //         var optionParent = $item.parents('div.option-contents');
                //         if(optionParent.css('display') == "block") {
                //             $item.trigger('click');
                //             return false;
                //         }
                //     });
                // } else {
                //     //한개
                //     $buyButton.trigger('click');
                // }
            });

            //링크
            self.$pdpInfo.on('click','a.btn-link:not(.popup)', function(e) {
                e.preventDefault();
                var $this = $(this);
                if(!$this.attr('data-control')) {
                    var url = $this.attr('href').replace("#","");
                    var addS = $this.data('add');
                    if(url) {
                        if(addS) {
                            url += addS;
                        }
                        location.href = url;
                    }
                }
            });

            //팝업 BTOCSITE-1025 : add 20210802
            /* self.$pdpInfo.on('click','.notice-wrap .notice-box a', function(e) {
                 e.preventDefault();
                 self.$mainInitPopup.vcModal({opener: this});
             });*/

            //할인적용가 팝업 BTOCSITE-5781
            //BTOCSITE-7379 PDP > 버튼 UI 변경건
            /*self.$pdpInfo.on('click','li.lists.member .btn-discount-popup', function(e) {
                e.preventDefault();
                self.$saleInfoPopup.vcModal({opener: this});
            });*/

            //구매혜택 팝업 - 추후 삭제 LGECOMVIO-20
            /*self.$pdpInfo.on('click','li.lists.benefit a.btn-link.popup', function(e) {
                e.preventDefault();
                self.$benefitInfoPopup.vcModal({opener: this});
            });*/
            //LGECOMVIO-20 - 구매혜택 팝업
            // S: BTOCSITE-66272 구매 혜택 안내 팝업 신규 디자인
            // self.$pdpInfo.on('click','li.lists .buy-benefit-info a.btn-link.popup', function(e) {
            //     e.preventDefault();
            //     var target = $(this).data("active-target");
            //     self.$buybenefitInfoPopup.vcModal({opener: this});
            //     self.$buybenefitInfoPopup.find('.ui_accordion .lists').each(function(idx,item){
            //         if($(item).attr('id') === target){
            //             self.$buybenefitInfoPopup.find('.ui_accordion').vcAccordion('expand',idx);
            //         }
            //     })
            // });

            // 66272 모달팝업 함수
            self.$pdpInfo.on('click','li.lists .buy-benefit-info a.btn-link.popup', function(e) {
                e.preventDefault();

                var $popup = self.$buybenefitInfoPopupNew;

                $popup.one('modalshow', self.setGiftPopup);
                $popup.vcModal({opener: this}); // 팝업 열기

				//BTOCSITE-75003 팝업 열기시 활성화 탭 보이도록 좌우 이동
                var $this = $(this)
				setTimeout(function(){
					$popup.find('.tabs').eq(0).find('li.on a').trigger('click')
                    setPopupTabArrow($popup);//BTOCSITE-67752 팝업 열기시 활성화 탭 좌우버튼
           
                    var accoId = $this.attr('data-active-target');
                    var accordion = $('#'+accoId).closest('.ui_accordion').vcAccordion('instance');
                    if( accordion ){
                      accordion.expand($('#'+accoId).index(), false);
                    }
				},100);
            });

            //BTOCSITE-67752 팝업 열기시 활성화 탭 좌우버튼
            var hitTest = function(_$obj1, _$obj2){
                var objPos1 = _$obj1.offset().left + _$obj1.width()
                var objPos2 = _$obj2.offset().left + _$obj2.width()
                if( objPos1 < _$obj2.offset().left || objPos2 < _$obj1.offset().left ){
                    return false
                }else{
                    return true
                }
            }
            var setPopupTabArrow = function(_$popup){
                var $popBene = _$popup;
                var $popBeneChild = $popBene.find('.scroll-tab-wrap'); 
                var $popBeneTabWrap = $popBeneChild.find('.tabs-wrap')
                var $popBeneTab = $popBeneTabWrap.find('.tabs')
                var $popBeneTabBtns = $popBeneChild.find('.scroll-controls')
                var $popBeneTabLeft = $popBeneTabBtns.find('.ui_smooth_prev')
                var $popBeneTabRight = $popBeneTabBtns.find('.ui_smooth_next')
                var isTabchange = false;
                
                setTimeout(function(){
                    $popBeneTabWrap.vcSmoothScroll('scrollToActive')
                    $popBeneTabWrap.vcSmoothScroll('instance').options.center=true;
                    var ins = $popBeneTabWrap.vcSmoothScroll('instance')
                    ins.viewWidth = $popBeneTabWrap.width()-($popBeneTabLeft.width*2);
                    $popBeneTabWrap.vcSmoothScroll('scrollToActive')
                    $(window).trigger('resizeend.popuptabarrow')
                },100)
         
                $(window).off('resizeend.popuptabarrow').on('resizeend.popuptabarrow',function(e){
                    $popBeneTabBtns.hide();
                    if(window.innerWidth > 768){
                        if( $popBeneTabWrap.outerWidth() < $popBeneTab.outerWidth()){
                            $popBeneTabBtns.show();
                        }
                    }
                }).trigger('resizeend.popuptabarrow')

                $popBeneTabLeft.off('click').on('click',function(e){
                    if(window.innerWidth < 768){return;}
                    $popBeneTabWrap.vcSmoothScroll('moveFirst');
                })
                $popBeneTabRight.off('click').on('click',function(e){
                    if(window.innerWidth < 768){return;}
                    $popBeneTabWrap.vcSmoothScroll('moveLast');
                })
                $popBeneTabWrap.off('smoothscrollend.popuptabarrow').on('smoothscrollend.popuptabarrow',function(){
                    if(window.innerWidth < 768 || isTabchange == true){return;}
                    var getX = $popBeneTabWrap.vcSmoothScroll('getPosition').x;
                    if(getX == 0){
                        tabArrowVisible('left')
                    }else if(getX + $popBeneTab.width() < $popBeneTabWrap.width()+5 ){
                        tabArrowVisible('right')
                    }else{
                        tabArrowVisible()
                    }
                })
                $popBeneTabWrap.off('tabchange.popuptabarrow').on('tabchange.popuptabarrow',function(){
                    if(window.innerWidth < 768 || isTabchange == true || $popBene.css('display') == 'none'){return;}
                    activeTab_btnArrow_hitTest()
                });
                function activeTab_btnArrow_hitTest(){
                    isTabchange = true;
                    var getX = $popBeneTabWrap.vcSmoothScroll('getPosition').x;
                    var isHitRight = hitTest($popBeneTab.find('.on'), $popBeneTabRight)
                    var isHitLeft = hitTest($popBeneTab.find('.on'), $popBeneTabLeft)
                    if(isHitLeft || isHitRight){
                        var btnW = isHitRight ? -60 : 60; 
                        var ins = $popBeneTabWrap.vcSmoothScroll('instance')
                        ins.scrollTo( getX + btnW ,0,300);
                    }
                    setTimeout(function(){
                        isTabchange=false;
                    },300)
                }
                function tabArrowVisible(direction){
                    if(direction == 'left'){
                        $popBeneTabLeft.hide();
                        $popBeneTabRight.show();
                    }else if(direction == 'right'){
                        $popBeneTabLeft.show();
                        $popBeneTabRight.hide();
                    }else{
                        $popBeneTabLeft.show();
                        $popBeneTabRight.show();
                    }
                }
            }
            ////BTOCSITE-67752 팝업 열기시 활성화 탭 좌우버튼

            // E: BTOCSITE-66272 구매 혜택 안내 팝업 신규 디자인


            //LGECOMVIO-20 - 단순팝업 열기
            function pdpOpenPopup(selector,targetPopup,fn){
                $(selector).on('click',function(e){
                    e.preventDefault();
                    targetPopup.vcModal({opener: this});
                });
            };

            //팝업 BTOCSITE-1025 : add 20210802 - LGECOMVIO-20
            pdpOpenPopup('.notice-wrap .notice-box a', self.$mainInitPopup);
            //할인적용가 팝업 BTOCSITE-5781 - LGECOMVIO-20
            //pdpOpenPopup('li.lists.member .btn-discount-popup', self.$saleInfoPopup);
            //구매혜택 팝업 - 추후 삭제 LGECOMVIO-20
            pdpOpenPopup('li.lists.benefit a.btn-link.popup', self.$benefitInfoPopup);
            //LGECOMVIO-20 - 제휴카드 팝업 - LGECOMVIO-20
            pdpOpenPopup('.promotion-card-info .card-list-more', self.benefitCardPopup) // BTOCSITE-51891 구독 제휴카드 관련 PDP/팝업 수정의 건 

            // pdpOpenPopup('.pdp-tolltip-new .tooltip-icon', self.$staffPricePopup);
            // pdpOpenPopup('.price-info.pdp-price-popup-new', self.$staffPricePopup);

            pdpOpenPopup('a#maxBenefitPopupSelector', self.$maxBenefitPopup);
            // pdpOpenPopup('a#maxBenefitPopupSelector2', self.$maxBenefitPopup2); // 쿠폰팝업에서 분기처리
            if ($('#memberPricePopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#memberPricePopupSelector', self.$memberPricePopup);
            }
            if ($('#couponPricePopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#couponPricePopupSelector', self.$couponPricePopup);
            }
            // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
            pdpOpenPopup('a#tabMaxBenefitPopupSelector', self.$maxBenefitPopup);
            // pdpOpenPopup('a#tabMaxBenefitPopupSelector2', self.$maxBenefitPopup2); // 쿠폰팝업에서 분기처리
            if ($('#tabMemberPricePopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#tabMemberPricePopupSelector', self.$memberPricePopup);
            }
            if ($('#tabCouponPricePopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#tabCouponPricePopupSelector', self.$couponPricePopup);
            }
            pdpOpenPopup('a#employeeTabBenefitPopupSelector', self.$employeeTabMaxBenefitPopup);
            if ($('#employeeTabCouponPopupSelector').hasClass("link-text")) {
                pdpOpenPopup('a#employeeTabCouponPopupSelector', self.$employeeTabCouponPricePopup);
            }

            //소모품 추가구매
            self.$pdpInfoAdditionalPurchase.on('click','div.selectbox-list a', function(e){
                e.preventDefault();
                var $this = $(this);
                var _id = $this.attr('href').replace("#","");
                var price = $this.data('price');
                var $itemInfo = $this.find('.item-info');
                var data = {
                    "id": _id,
                    "title":$itemInfo.find('dt').text(),
                    "price":price,
                    "priceString":(vcui.number.addComma(price) + "원")
                }
                $this.parents('.ui_dropdown').vcDropdown("close");
                var $ul = self.$pdpInfoAdditionalPurchase.find('div.additional-payment ul');
                var $find = $ul.find('li[data-id="' + _id + '"]');
                if($find.length < 1) {
                    self.$pdpInfoAdditionalPurchase.find('div.additional-payment ul').append(vcui.template(additionalItemTemplate, data));
                    
                    // 소모품 추가 시 히스토리 저장
                    if (typeof KRP0008.additionModel !== 'undefined' && typeof KRP0008.additionModel.saveToHistory === 'function') {
                        KRP0008.additionModel.saveToHistory();
                    }
                }

                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                self.updatePaymentAmountPrice($paymentAmount);
            });

            //소모품 추가구매 수량선택
            self.$pdpInfoAdditionalPurchase.on('click','button.minus,button.plus', function(e){
                var $this = $(this);
                var $input = $this.siblings('input');
                var $totalCount = $('.payment-amount .final-count .number');
                var quantity = $input.val();
                if($this.hasClass('minus')) {
                    --quantity;
                    if(quantity < 1) {
                        quantity = 1;
                    }

                    if(quantity == 1) {
                        $this.attr('disabled',true);
                    } else {
                        $this.removeAttr('disabled');
                    }
                } else if($this.hasClass('plus')) {
                    ++quantity;

                    if(quantity > 1) {
                        $this.siblings('button.minus').removeAttr('disabled');
                    }
                }
                $input.val(quantity);
                $totalCount.text(quantity);

                var $li = $this.parents('li');
                $li.data('quantity',quantity);
                
                // 소모품 추가구매 수량 변경 시 히스토리 저장
                if (typeof KRP0008.additionModel !== 'undefined' && typeof KRP0008.additionModel.saveToHistory === 'function') {
                    KRP0008.additionModel.saveToHistory();
                }
                
                var $total = $(".action-sheet .total-payment .price").contents()[1];
                var price = $li.data('price');
                price = price || "0";
                if(typeof price === 'string') {
                    price = vcui.string.replaceAll(price,",","");
                }

                $total.textContent = (vcui.number.addComma(price*quantity) + '원');

                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                self.updatePaymentAmountPrice($paymentAmount, true);
            });

            //소모품 추가구매 삭제
            self.$pdpInfoAdditionalPurchase.on('click','button.btn-delete', function(e){
                var $li = $(this).parents('li');
                $li.remove();

                // 소모품 삭제 시 히스토리 저장
                if (typeof KRP0008.additionModel !== 'undefined' && typeof KRP0008.additionModel.saveToHistory === 'function') {
                    KRP0008.additionModel.saveToHistory();
                }

                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                self.updatePaymentAmountPrice($paymentAmount);
            });

            //BTOCSITE-50143 PDP 수량 수기 입력 Start
            $("#quantity").change(function() {
                var quantity = $(this).val();
                var $totalCount = $('.payment-amount .final-count .number');
                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                $paymentAmount.find('button.plus').removeAttr('disabled');

                var max = $paymentAmount.find('button.plus').data('max');
                if (max && quantity >= max) {
                    // [정리] B2C 전용 plus버튼 비활성화 분기 제거: b2cYN==='Y'는 이 파일에서 항상 false
                    // BTOCSITE-48266 B2B 구매수량 제한
                    if (quantity > max) {
                        $('#businessAlertMaxQty').text(max + 1);
                        $('#businessMembershipMoreAlert1').vcModal();
                    }
                    // B2B에서 25이상 구매시 +버튼 활성화 유지
                    $paymentAmount.find('button.plus').removeAttr('disabled');
                    quantity = max;
                    $paymentAmount.find('input.quantity').val(max);
                }
                if(quantity <= 0 || quantity == '') {
                    quantity = 1;
                    $paymentAmount.find('button.minus').attr('disabled',true);
                    $paymentAmount.find('input.quantity').val(1);
                    lgkorUI.alert("", {title: "주문 가능한 최소 수량은 1 개 입니다."}, $paymentAmount.find('input.quantity')); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close시 포커스 이동
                } else if(quantity == 1) {
                    quantity = 1;
                    $paymentAmount.find('button.minus').attr('disabled',true);
                } else {
                    $paymentAmount.find('button.minus').removeAttr('disabled');
                }
                $totalCount.text(quantity);
                $paymentAmount.data('quantity',quantity);
                self.updatePaymentAmountPrice($paymentAmount, true);

                // 소모품 PDP에서 totalFoldPrice 업데이트를 위해 bottomFoldAreaControl 호출
                var isDisposablePdp = typeof lgePdpSendData !== 'undefined' && lgePdpSendData.bizTypeDetail === 'DISPOSABLE';
                if (isDisposablePdp) {
                    var empYn = 'N';
                    if ($('#employeeDisposableTabArea').is(':visible')) {
                        empYn = $('#employeeTab').hasClass('on') ? 'Y' : 'N';
                    }
                    KRP0008.bottomFoldAreaControl(empYn);
                }
            });
            //BTOCSITE-50143 End

            // 소모품 PDP 수량 직접 입력 (select-quantity 영역 - id가 없는 input.quantity 대응)
            // input/change/keyup 이벤트로 실시간 처리
            self.$pdpInfoPaymentAmount.on('input change keyup', '.select-quantity input.quantity', function(e) {
                var isDisposablePdp = typeof lgePdpSendData !== 'undefined' && lgePdpSendData.bizTypeDetail === 'DISPOSABLE';
                if (!isDisposablePdp) {
                    return; // 소모품 PDP가 아니면 additionModel의 핸들러가 처리
                }

                var $this = $(this);
                var quantity = parseInt($this.val()) || 0;
                var $paymentAmount = $this.closest('.payment-amount');
                var $plusBtn = $paymentAmount.find('button.plus');
                var $minusBtn = $paymentAmount.find('button.minus');
                var max = parseInt($plusBtn.data('max')) || 24;

                // 빈 값이면 가격 업데이트만 하고 리턴 (입력 중)
                if ($this.val() === '') {
                    return;
                }

                // 플러스 버튼 항상 활성화 유지
                $plusBtn.removeAttr('disabled');

                // 최대 수량 제한 - 플러스 버튼은 비활성화하지 않음
                if (max && quantity > max) {
                    // change/blur 이벤트일 때만 알럿 표시 (input 중에는 표시 안함)
                    if (e.type === 'change' || e.type === 'blur') {
                        lgkorUI.alert("", {title: "구매 가능 수량을 초과했어요"}, $this);
                    }
                    quantity = max;
                    $this.val(max);
                }

                // 최소 수량 제한
                if (quantity <= 0) {
                    // change/blur 이벤트일 때만 알럿 표시
                    if (e.type === 'change' || e.type === 'blur') {
                        $this.val(1);
                        $minusBtn.attr('disabled', true);
                        lgkorUI.alert("", {title: "주문 가능한 최소 수량은 1 개 입니다."}, $this);
                    }
                    return;
                } else if (quantity == 1) {
                    $minusBtn.attr('disabled', true);
                } else {
                    $minusBtn.removeAttr('disabled');
                }

                $paymentAmount.data('quantity', quantity);
                self.updatePaymentAmountPrice($paymentAmount, true);

                // 소모품 PDP에서 totalFoldPrice 업데이트를 위해 bottomFoldAreaControl 호출
                // change/blur 이벤트일 때만 (입력 중에는 호출하지 않음)
                if (e.type === 'change' || e.type === 'blur') {
                    var empYn = 'N';
                    if ($('#employeeDisposableTabArea').is(':visible')) {
                        empYn = $('#employeeTab').hasClass('on') ? 'Y' : 'N';
                    }
                    KRP0008.bottomFoldAreaControl(empYn);
                }
            });

            //구매 수량 선택
            self.$pdpInfoPaymentAmount.off('click').on('click', 'button.minus,button.plus',function (e) {
                // 번들링 세트 모드일 때는 additionModel의 핸들러가 처리하도록 함
                // count-check 영역도 additionModel의 핸들러가 처리하도록 함
                // 단, 소모품(DISPOSABLE) PDP 또는 B2B(사업자몰)에서는 이 핸들러에서 처리
                var isDisposablePdp = typeof lgePdpSendData !== 'undefined' && lgePdpSendData.bizTypeDetail === 'DISPOSABLE';
                var isB2B = lgkorUI.getHiddenInputData().b2cYN !== 'Y';
                if (!isDisposablePdp && !isB2B && (
                    $(this).closest('.payment-amount').hasClass('bundling-set') || 
                    $(this).closest('.bundling-payment').length > 0 ||
                    $(this).closest('.count-check').length > 0)) {
                    return;
                }
                
                var $input = $(this).siblings('input');
                var quantity = $input.val();
                var $totalCount = $('.payment-amount .final-count .number');
                if($(this).hasClass('minus')) {
                    --quantity;
                    if(quantity < 1) {
                        quantity = 1;
                    }

                    if(quantity == 1) {
                        $(this).attr('disabled',true);
                        self.$pdpInfoPaymentAmount.find('input.quantity').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 개수 미만 시 포커스 이동
                    } else {
                        $(this).removeAttr('disabled');
                    }

                    $(this).siblings('button.plus').removeAttr('disabled');
                } else if($(this).hasClass('plus')) {
                    var max = $(this).data('max');
                    ++quantity;
                    if (max && quantity >= max) {
                        // 소모품 PDP에서는 플러스 버튼 비활성화하지 않음 (일반 제품 B2B와 동일)
                        if (isDisposablePdp) {
                            if (quantity > max) {
                                lgkorUI.alert("", {title: "구매 가능 수량을 초과했어요"}, $input);
                            }
                            // 플러스 버튼 활성화 유지
                        // [정리] B2C 전용 plus버튼 비활성화 분기 제거: b2cYN==='Y'는 이 파일에서 항상 false
                        } else if (quantity > max) { // BTOCSITE-48266 B2B 구매수량 제한
                            // B2B에서 25이상 구매시 +버튼 활성화 유지
                            $('#businessAlertMaxQty').text(max + 1);
                            $('#businessMembershipMoreAlert1').vcModal({opener: self.$pdpInfoPaymentAmount.find('input.quantity')}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        }
                        quantity = max;
                    }

                    if(quantity > 1) {
                        $(this).siblings('button.minus').removeAttr('disabled');
                    }
                }
                $input.val(quantity);
                $totalCount.text(quantity);

                var $paymentAmount = $input.parents('.payment-amount');
                $paymentAmount.data('quantity',quantity);
                self.updatePaymentAmountPrice($paymentAmount, true);

                // 소모품 PDP에서 totalFoldPrice 업데이트를 위해 bottomFoldAreaControl 호출
                if (isDisposablePdp) {
                    var empYn = 'N';
                    if ($('#employeeDisposableTabArea').is(':visible')) {
                        empYn = $('#employeeTab').hasClass('on') ? 'Y' : 'N';
                    }
                    KRP0008.bottomFoldAreaControl(empYn);
                }
            });

            //케어쉽 서비스 선택 관련
            self.$pdpInfoCareshipService.on('change','input[type=radio]', function(e){
                //케어쉽필수 제품인지 체크해서 알림창 뛰움
                var val = $(this).val();
                var $careshipService = $(this).parents('.careship-service');

                //BTOCSITE-73832 제품 번들링 과제
                KRP0008.additionModel.careshipServiceRadioClick(lgkorUI.stringToBool(val));

                if(!lgkorUI.stringToBool(val)) {
                    if(waterCareRequire) {
                        $(this).parents('ul').find('input[type=radio][value="Y"]').trigger('click');
                        $('#waterCareRequirePopup').vcModal({opener: this});
                    } else if(careRequire) {
                        $(this).parents('ul').find('input[type=radio][value="Y"]').trigger('click');
                        $('#careRequirePopup').vcModal({opener: this});
                    } else {
                        //제품 가격 정보에 케어십 관련 숨김
                        if($careshipService.length > 0) {
                            var $paymentAmount = self.$pdpInfo.find('.payment-amount'); //LGECOMVIO-20
                            var $careshipPriceInfo = $paymentAmount.find('li.careship-price-info');
                            if($careshipPriceInfo.length > 0) {
                                $careshipPriceInfo.hide();
                            }
                            self.updatePaymentAmountPrice($paymentAmount);

                            //수량체크버튼 활성
                            self.updatePaymentAmountState($paymentAmount, false);
                        }
                    }
                } else {
                    if($careshipService.length > 0) {
                        var $paymentAmount = self.$pdpInfo.find('.payment-amount'); //LGECOMVIO-20
                        var $careshipPriceInfo = $paymentAmount.find('li.careship-price-info');
                        if($careshipPriceInfo.length > 0) {
                            $careshipPriceInfo.show();
                        }
                        self.updatePaymentAmountPrice($paymentAmount);

                        //케어십 신청됐으므로 수량체크버튼 비활성
                        self.updatePaymentAmountState($paymentAmount, true);
                    }
                }
                // self.pdpVisualSticky();
            });

            //케어십 이용요금
            self.$pdpInfoCareshipService.on('click','dl.price-info a.btn-link.popup', function(e) {
                e.preventDefault();
                requestItemTip(this);
            });


            //케어솔루션 이용요금
            $('.btn-care-solution-popup').on("click", function(e) {
                e.preventDefault();
                if(self.rentalAllSelect) {
                	if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "CARETAB"){
                        if(lgkorUI.stringToBool(loginFlag) && self.bsnsMbrStat == "USE"){
                        	requestItemTip(this);
                        }else{
                        	KRP0008.b2bLoginCheck(e);
                        }
                    }else{
                    	requestItemTip(this);
                    }
                } else {
                    lgkorUI.alert("", {title: "모든 옵션을 선택해주세요."});
                }
            });

            function requestItemTip(dm) {
                var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                var careData = $paymentAmount.data('careData');
                var ajaxUrl = '/mkt/ajax/commonmodule/monthlyRateBenefit';
                var param = {
                    'visibleArea': 'cart',
                    'rtModelSeq': careData.rtModelSeq
                };

                lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                    openModalFromHtml(result, dm);
                }, null, "html");
            }
            // CSR-4632 [WA][모니터링]1차 심사결과_구독
            function openModalFromHtml(html, opener) {
                $('#request-tip-modal').html(html).vcModal({opener: opener});
            }

            // CSR-13847/CSR-18262 제휴카드 할인 안내 팝업 트리거 - 기존 #benefitCardPopup(정적 마크업)은 그대로 두고 호출부만 교체
            $('.js-alliance-card-benefit-info').on('click', function(e) {
                e.preventDefault();
                requestAllianceCardBenefit(this);
            });

            function requestAllianceCardBenefit(dm) {
                var ajaxUrl = '/mkt/ajax/commonmodule/allianceCardBenefit';

                lgkorUI.requestAjaxData(ajaxUrl, null, function(result){
                    openAllianceCardBenefitModal(result, dm);
                }, null, "html");
            }

            // #request-tip-modal(이용요금 팝업 전용)과는 별개의 쉘 - 응답(header/section/닫기버튼)을 #benefitCardPopupNew에 주입해서 연다
            function openAllianceCardBenefitModal(html, opener) {
                $('#benefitCardPopupNew').html(html).vcModal({opener: opener});
            }


            //케어십 방문주기
            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성으로 변경
            if(self.$careshipInfoSelectBox.length > 0) {
                self.$careshipInfoSelectBox.on('change', function(e,data){
                    var selectOption = $(this).vcSelectbox('selectedOption');
                    var svcTypeDescData = $(selectOption).data('item');
                    var itemData = null;
                    var selectIndex = 0;
                    for (var i = 0, len = svcTypeDescData.length; i < len; i++) {

                        if(svcTypeDescData[i].representChargeFlag == "Y") { // 방문주기 선택시 서비스타입안의 데이터들 중에 대표요금제노출여부가 Y일 경우에 먼저노출
                            selectIndex = i;
                        }
                    }

                    itemData = svcTypeDescData[selectIndex];

                    self.updateCareshipInfoPrice(itemData); // 선택된 가격정보로 업데이트
                    self.careshipInfoSelectBoxUpdate(self.$careshipInfoSelectBox2, svcTypeDescData, 0, true);
                });
            };

            // 케어십 서비스타입
            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성으로 추가
            if(self.$careshipInfoSelectBox2.length > 0) {
                self.$careshipInfoSelectBox2.on('change', function(e,data){
                    var selectOption = $(this).vcSelectbox('selectedOption');
                    var priceData = $(selectOption).data('item');

                    self.updateCareshipInfoPrice(priceData); // 선택된 가격정보로 업데이트
                });
            };
            // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성 END
            //BTOCSITE-3523 - 제휴카드 할인 드롭다운 열림/닫힘 액션
            var cardDropExpanded = "false";
            self.$pdpInfo.on('click','.careship-card-list .ui_dropdown_toggle, .rental-card-list .ui_dropdown_toggle',function(e){
                e.preventDefault();
                var $this = $(this);
                $this.closest('.dropdown-box-wrap').toggleClass('open');
                (cardDropExpanded === "false") ? (cardDropExpanded = "true") : (cardDropExpanded = "false");
                $this.attr('aria-expanded',cardDropExpanded);
            });
            $(document).on('click', function(e) {
                var $rentalCareCardDropList = $('.careship-card-list .dropdown-box-wrap, .rental-card-list .dropdown-box-wrap');
                if($(e.target).closest($rentalCareCardDropList).length == 0){
                    $rentalCareCardDropList.removeClass("open");
                }
            });

            //제휴카드 할인 드롭다운 선택
            //div.option-contents
            self.$pdpInfo.on('click','.rental-card-list div.ui_dropdown_list li a, .careship-card-list div.ui_dropdown_list li a', function(e){
                e.preventDefault();
                var $this = $(this);
                var $dropDown = $this.parents('.dropdown-box-wrap'); //BTOCSITE-3523 수정
                //$dropDown.find('a.ui_dropdown_toggle').text($this.attr('data-card-title'));  //BTOCSITE-3523 삭제

                //BTOCSITE-3523 추가
                if($this.closest("li").hasClass("cancel-item")) {
                    $this.closest('.dropdown-box-wrap').removeClass('is-selected'); //BTOCSITE-3523 수정
                    $dropDown.find('.ui_dropdown_toggle').empty();
                }else{
                    $dropDown.find('.ui_dropdown_toggle').text($this.attr('data-card-title'));
                    $this.closest('.dropdown-box-wrap').addClass('is-selected'); //BTOCSITE-3523 수정
                }

                $dropDown.removeClass('open'); //BTOCSITE-3523 수정

                var cardData = {};
                var cardNameCode = $this.attr('href').replace("#","");
                if(cardNameCode) {
                    cardData.cardNameCode = cardNameCode;
                }
                var cardSale = $this.data('cardSale');
                if(cardSale) {
                    cardData.cardSale = cardSale;
                }
                var cardSubName = $this.data('cardSubName');
                if(cardSubName) {
                    cardData.cardSubName = cardSubName;
                }
                var simpleReqFlag = $this.data('simpleReqFlag');
                if(simpleReqFlag) {
                    cardData.simpleReqFlag = simpleReqFlag;
                }

                var isRental = false;
                var $careshipService = $this.parents('.careship-service');
                if($careshipService.length < 1) {
                    $careshipService = $this.parents('.care-sibling-option');
                    if($careshipService.length > 0) {
                        isRental = true;
                    }
                }
                var $paymentAmount = self.$pdpInfo.find('.payment-amount');

                $paymentAmount.data('cardData',cardData);
                if(isRental){
                    self.updateRentalInfoPrice(self.selectRentalInfoData);
                } else {
                    self.updateCareshipInfoPrice(self.selectCareshipInfoData);
                }
            });


            // [S] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 제휴카드 아코디언 작업
            $(document).on('accordionexpand','.discount-details-new .ui_accordion', function(e){
                var $this = $(this);

                if ($this.find('.ui_accord_content').is(':visible')) {
                    $this.find('.ui_accord_content input[type="radio"]').first().focus();
                }
            });

            $(document).on('keydown','.discount-details-new .ui_accord_toggle', function(e){
                var $this = $(this);
                var $wrap = $this.closest('.ui_accordion');

                if (e.keyCode === 9 && !e.shiftKey && $wrap.find('.ui_accord_content').is(':visible')) {
                    e.preventDefault();
                    $wrap.find('.ui_accord_content input[type="radio"]').first().focus();
                }
            });

            $(document).on('click keydown','.discount-details-new .ui_accordion input[type="radio"]', function(e){
                var $this = $(this);
                var $accordion = $this.closest('.ui_accordion'); //BTOCSITE-3523 수정
                var $title = $accordion.find('.title');


                if (e.type === 'click' && e.clientX === 0 && e.clientY === 0) {
                    e.preventDefault();
                    return;
                }

                if (e.type === 'keydown' && e.keyCode !== 32) {
                    return;
                }

                $this.prop('checked', 'checked');
            });
            // [E] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 제휴카드 아코디언 작업

            //div.option-contents
            var cardDropdown = self.$pdpInfo.find('.rental-card-list div.ui_dropdown_list .simple-card-list, .careship-card-list div.ui_dropdown_list .simple-card-list'); //BTOCSITE-3523 수정
            var firstRow = cardDropdown.find('li a:eq(0)');
            if(firstRow.length > 0) {
                firstRow.trigger('click',firstRow);
            }

            // S : BTOCSITE-20780
            self.$pdpInfo.on('click','li.lists.member .banner-box', function(e) {
                var href = $(this).data('url');
                var eventId = href.substring(href.indexOf("-")+1,href.indexOf("?"));
                var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                var mltlp = $(this).data("mltlp");

                // 다품목 상품이 아닌경우 세션저장 하지 않음
                if(mltlp == "Y" && productInfo) {
                    var stroageItems = lgkorUI.getStorage(eventId + "_calcItems");
                    var item = {}, calcItems = (vcui.isEmpty(stroageItems)) ? [] : JSON.parse(stroageItems);
                    var chkStroageItem = calcItems.filter(function(obj){
                        return obj.sku == lgePdpSendData.sku;
                    });
                    item = {
                        id: 'calc-'+lgePdpSendData.sku,
                        sku: lgePdpSendData.sku,
                        modelName: modelName,
                        oprice: parseInt(productInfo.price),
                        tprice: parseInt(productInfo.discounted_price),
                        dprice: parseInt(productInfo.price) - parseInt(productInfo.discounted_price),
                        odprice: parseInt(lgkorUI.getHiddenInputData().obsDiscountPrice),
                        mediumImageAddr: lgePdpSendData.productImg,
                        imageAltText: lgePdpSendData.productName,
                        modelId: lgePdpSendData.modelId,
                        bizType: lgePdpSendData.bizType,
                        modelStatusCode: lgePdpSendData.modelStatusCode,
                        rtModelSeq: representRtModelSeq,
                        modelComponent: lgePdpSendData.modelComponent
                    }
                    lgkorUI.setStorage(eventId + "_currentItems", JSON.stringify(item), false);
                    if(chkStroageItem.length == 0) {
                        calcItems.push(item);
                        lgkorUI.setStorage(eventId + "_calcItems", JSON.stringify(calcItems), false);
                    }
                }

                location.href = href;
            });
            // E : BTOCSITE-20780

            // S : BTOCSITE-48313
            self.$caresolutionMoreBenefitLink = self.$pdpInfoCareSiblingOption.find('a.more-benefit-link');
            self.$caresolutionMoreBenefitLink.on('click', function(){
                var moreBenefitLinkUrl = $(this).attr('href');
                $(this).attr('href', moreBenefitLinkUrl+self.selectRentalInfoData.rtModelSeq);
            });
            // E : BTOCSITE-48313

            // BTOCSITE-101419
            $(".discount-details-rental").each(function () {
                var $wrap = $(this);
                // CSR-4632 [WA][모니터링]1차 심사결과_구독
                $wrap.find(".details-header a").on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var $btn = $(this);
                    var $box = $wrap.find(".details-box-rental");
                    var isExpanded = $btn.attr("aria-expanded") === "true";

                    if (isExpanded) {
                        $btn.attr("aria-expanded", "false");
                        $box.prop("hidden", true).removeClass("open").addClass("hide");
                        try { $btn.focus(); } catch (err) {}
                    } else {
                        $btn.attr("aria-expanded", "true");
                        $box.prop("hidden", false).removeClass("hide").addClass("open");
                        var $focusTarget = $box.find(".btn-close, a, button, input, [tabindex]").filter(":visible").first();
                        if ($focusTarget.length) {
                            try { $focusTarget.get(0).focus(); } catch (err) {}
                        }
                    }
                });
            });

            //카드혜택 B2C 페이지 임으로 B2B인경우는 새창으로
            // [정리] B2C 분기(b2cYN==='Y')만 제거: #benefitCardPopup 팝업 본체는 articlesArea.jsp에 항상 포함되고
            // 트리거 링크는 infoCaretabAreaB2b.jsp(tab2)에 존재하므로 이 핸들러 자체는 B2B에서도 실사용됨
            $("#benefitCardPopup").find("section").find("a").on('click', function(e){
                e.preventDefault();
                let appUrl = $(this).attr('data-app-url');

                if(isApp()) {
                    let className = e.currentTarget.className;
                    if(className.indexOf('card-request-link') != -1){
                        appUrl = 'https://www.lge.co.kr'+appUrl;
                    }
                    if(vcui.detect.isIOS){
                        let jsonString = JSON.stringify({'url': appUrl, 'command':'openLinkOut'});
                        webkit.messageHandlers.callbackHandler.postMessage(jsonString);
                    } else {
                        android.openLinkOut(appUrl);
                    }
                }else{
                    let openNewWindow = window.open("about:blank");
                    openNewWindow.location.href = appUrl;
                }
            });
        },

        // BTOCSITE-85293 START
        activeModalTermAndCondition: function(funcCallBack) {
            var self = this;
            let isMobileMode = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;
            if (isMobileMode) {
                self.$actionSheetConsentPopup.addClass('active');
            } else {
                self.$actionSheetConsentPopup.vcModal('show').addClass('active');
            }
            self.resetAllTerm();
            /* because state checked has been effected from other common-lib js, so click function can't access to correctly value of input checked --> will use array boolean instead */
            var consentsStates = [false, false, false, false]; // BTOCSITE-85293 V0.8

            var btnCloseModal = $('#actionSheetConsent .sheet-close.btn-close');
            btnCloseModal.off('click').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                self.resetAllTerm();
                let isModal = $(this).closest('.ui_modal_wrap'); // user could switch from pc-mode to mobile-mode, so ui_modal_wrap may still in active
                if (isModal.length > 0) {
                    self.$actionSheetConsentPopup.vcModal('hide').removeClass('active');
                    setTimeout(() => {
                        self.$actionSheetConsentPopup.attr('style','');
                    }, 400);
                } else {
                    self.$actionSheetConsentPopup.removeClass('active');
                    setTimeout(() => {
                        self.$actionSheetConsentPopup.attr('style','');
                    }, 400);
                }
            });

            var btnNextProgress = $('#actionSheetConsent .btn.pink.btn-open-action-sheet');
            btnNextProgress.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();

                if (!btnNextProgress.prop('disabled') && self.checkIsAllTermAccepted()) {
                    btnCloseModal.click();
                    funcCallBack();
                }
            });

            var btnCloseConsent1 = $('#sheetConsent01 .sheet-close.btn-close');
            var btnCloseConsent2 = $('#sheetConsent02 .sheet-close.btn-close');
            var btnCloseConsent3 = $('#sheetConsent03 .sheet-close.btn-close');
            var btnCloseConsent4 = $('#sheetConsent04 .sheet-close.btn-close');
            //var btnCloseConsent5 = $('#sheetConsent05 .sheet-close.btn-close'); // BTOCSITE-85293 V0.8

            btnCloseConsent1.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent1Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent1Popup.attr('style','');
                }, 400);
            });
            btnCloseConsent2.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent2Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent2Popup.attr('style','');
                }, 400);
            });
            btnCloseConsent3.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent3Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent3Popup.attr('style','');
                }, 400);
            });
            btnCloseConsent4.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent4Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent4Popup.attr('style','');
                }, 400);
            });
            // BTOCSITE-85293 V0.8 START
            /* btnCloseConsent5.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.$sheetConsent5Popup.vcModal('hide').removeClass('active');
                setTimeout(() => {
                    self.$sheetConsent5Popup.attr('style','');
                }, 400);
            }); */
            // BTOCSITE-85293 V0.8 END

            var btnAcceptedConsent1 = $('#sheetConsent01 .btn.pink.ui_modal_close');
            var btnAcceptedConsent2 = $('#sheetConsent02 .btn.pink.ui_modal_close');
            var btnAcceptedConsent3 = $('#sheetConsent03 .btn.pink.ui_modal_close');
            var btnAcceptedConsent4 = $('#sheetConsent04 .btn.pink.ui_modal_close');
            //var btnAcceptedConsent5 = $('#sheetConsent05 .btn.pink.ui_modal_close'); // BTOCSITE-85293 V0.8

            btnAcceptedConsent1.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent01').prop('checked', true).trigger('change');
                consentsStates[0] = true;
                btnCloseConsent1.click();
            });
            btnAcceptedConsent2.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent02').prop('checked', true).trigger('change');
                consentsStates[1] = true;
                btnCloseConsent2.click();
            });
            btnAcceptedConsent3.off('click').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent03').prop('checked', true).trigger('change');
                consentsStates[2] = true;
                btnCloseConsent3.click();
            });
            btnAcceptedConsent4.off('click').on('click',function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent04').prop('checked', true).trigger('change');
                consentsStates[3] = true;
                btnCloseConsent4.click();
            });
            // BTOCSITE-85293 V0.8 START
            /* btnAcceptedConsent5.off('click').on('click',function(e){
                e.preventDefault();
                e.stopPropagation();
                $('#consent05').prop('checked', true).trigger('change');
                consentsStates[4] = true;
                btnCloseConsent5.click();
            }); */
            // BTOCSITE-85293 V0.8 END

            var checkBoxConsent1 = $('#consent01');
            var checkBoxConsent2 = $('#consent02');
            var checkBoxConsent3 = $('#consent03');
            var checkBoxConsent4 = $('#consent04');
            //var checkBoxConsent5 = $('#consent05'); // BTOCSITE-85293 V0.8

            checkBoxConsent1.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });

            checkBoxConsent2.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });

            checkBoxConsent3.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });

            checkBoxConsent4.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });

            // BTOCSITE-85293 V0.8 START
            /*checkBoxConsent5.off('change').on('change',function(e){
                e.preventDefault();
                e.stopPropagation();
                if (self.checkIsAllTermAccepted()) {
                    btnNextProgress.prop('disabled', false);
                } else {
                    btnNextProgress.prop('disabled', true);
                }
            });*/
            // BTOCSITE-85293 V0.8 END

            var arrowBtn1        = $('.consent-detail[data-href="#sheetConsent01"]');
            var arrowBtn2        = $('.consent-detail[data-href="#sheetConsent02"]');
            var arrowBtn3        = $('.consent-detail[data-href="#sheetConsent03"]');
            var arrowBtn4        = $('.consent-detail[data-href="#sheetConsent04"]');
            //var arrowBtn5        = $('.consent-detail[data-href="#sheetConsent05"]'); // BTOCSITE-85293 V0.8

            checkBoxConsent1.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[0]) {
                    arrowBtn1.click();
                    e.preventDefault();
                } else {
                    consentsStates[0] = false;
                }
            });

            checkBoxConsent2.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[1]) {
                    arrowBtn2.click();
                    e.preventDefault();
                } else {
                    consentsStates[1] = false;
                }
            });

            checkBoxConsent3.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[2]) {
                    arrowBtn3.click();
                    e.preventDefault();
                } else {
                    consentsStates[2] = false;
                }
            });

            checkBoxConsent4.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[3]) {
                    arrowBtn4.click();
                    e.preventDefault();
                } else {
                    consentsStates[3] = false;
                }
            });

            // BTOCSITE-85293 V0.8 START
            /* checkBoxConsent5.off('click').on('click',function(e){
                e.stopPropagation();
                if (!consentsStates[4]) {
                    arrowBtn5.click();
                    e.preventDefault();
                } else {
                    consentsStates[4] = false;
                }
            }); */
            // BTOCSITE-85293 V0.8 END
        },

        checkIsAllTermAccepted: function() {
            var consent1 = $('#consent01').prop('checked');
            var consent2 = $('#consent02').prop('checked');
            var consent3 = $('#consent03').prop('checked');
            var consent4 = $('#consent04').prop('checked');
            // BTOCSITE-85293 V0.8 START
            //var consent5 = $('#consent05').prop('checked');
            //return consent1 && consent2 && consent3 && consent4 && consent5;
            return consent1 && consent2 && consent3 && consent4;
            // BTOCSITE-85293 V0.8 END
        },

        resetAllTerm: function() {
            $('#consent01').prop('checked', false);
            $('#consent02').prop('checked', false);
            $('#consent03').prop('checked', false);
            $('#consent04').prop('checked', false);
            //$('#consent05').prop('checked', false); // BTOCSITE-85293 V0.8
            var btnNextProgress = $('#actionSheetConsent .btn.pink.btn-open-action-sheet');
            btnNextProgress.prop('disabled', true);
        },

        preCheckTermAndCondition: function(isOnlyCheckBoolean, funcCallBack) {
            var self = this;
            var isCheckTermsAndConditions = $('input[name="isCheckTermsAndConditions"]').val();

            if ('Y' == isCheckTermsAndConditions) {
                if (!isOnlyCheckBoolean) {
                    var checkIsRentalProduct = self.checkIsRentalProduct();

                    /* BTOCSITE-96476 start */
                    if(lgePdpSendData.bizTypeDetail === "CARETAB" && emplCk == "Y"){
                    	checkIsRentalProduct = false;
                    }
                    /* BTOCSITE-96476 end */

                    if (!checkIsRentalProduct) { // checking 4 terms policy not apply to rental product
                        var isMobileMode = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;
                        if (isMobileMode) {
                            // actionSheetPopup is popup for select quantity to buy or add to cart, only active at mobile mode and after 4 terms popup was accepted all
                            var isActionSheetPopupOpen = $('#actionSheetPopup').hasClass('active');
                            if (isActionSheetPopupOpen) {
                                funcCallBack();
                            } else {
                                self.activeModalTermAndCondition(funcCallBack);
                            }
                        } else {
                            self.activeModalTermAndCondition(funcCallBack);
                        }
                    } else {
                        funcCallBack();
                    }
                }
                return true;
            }
            if (!isOnlyCheckBoolean) {
                funcCallBack();
            }
            return false;
        },

        checkIsRentalProduct: function() {
            var self = this;
            var $paymentAmount = self.$pdpInfo.find('.payment-amount');
            var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');
            if (isRentalCareTab) {
                return true;
            }
            var urlLocation = window.location.pathname;
            var isCareSolutionsUrl = urlLocation.includes("/care-solutions");
            return (lgePdpSendData.bizTypeDetail == 'CARETAB' && isCareSolutionsUrl) || (lgePdpSendData.bizTypeDetail == 'UPCARETAB' && isCareSolutionsUrl);
        },
        // BTOCSITE-85293 END

        up20OptionBindSideEvents: function() {
            var self = this;
            var checkCompareClick = false;

            // LGECOMVIO-20 TAB 제외로 수정
            if(self.$pdpInfo.find('.option-contents').length) {
                if ($('#typeOrder').length) {
                    self.$pdpInfo.attr('data-type-cart', 'P');
                } else {
                    self.$pdpInfo.attr('data-type-cart', 'C');
                }
            }

            //모바일 수상내역 버튼
            self.$mobilePdpInfo.on('click','div.inner a.btn-link.popup', function (e) {
                e.preventDefault();
                self.$pdpMoreInfo.find('a.btn-link.popup').trigger('click');
            });

            //비교하기
            self.$pdpInfo.find('.product-compare button').off('click').on('click', function(e) {
                e.preventDefault();
                // BTOCSITE-30428 : 빠른 클릭시 레이아웃이 안뜨는 형상 발생
                if(checkCompareClick) {
                    return;
                }
                checkCompareClick = true;

                var checked = !$(this).hasClass('compare-select');
                var pdpDataId = self.$pdpInfo.attr('data-id'); //BTOCSITE-5856 비교하기 버튼 토글기능 오류

                if(checked) {
                    $(this).addClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
                    $(this).find('span.blind').text('선택됨');
                } else {
                    $(this).removeClass('compare-select');
                    $(this).find('span.blind').text('선택안됨');
                    // BTOCSITE-30428 : $('.sticy-compare .list-inner li') 이벤트 발생되어 비교하기 삭제시에서도 세션캐시 2번 호출로 인한 에러 발생
                    // $('.item-inner[data-id=' + pdpDataId + ']').siblings('.btn-close').trigger('click'); //BTOCSITE-5856 비교하기 버튼 토글기능 오류
                }
                //$(this).prop('checked',!checked);
                //self.requestCompareItem(lgePdpSendData, checked, $(this));
                var categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
                var categoryNm = lgkorUI.getHiddenInputData().defaultCategoryName;

                var compareId = lgePdpSendData.sku.split(".");
                if(typeof modelName !== 'undefined') {
                    compareId = modelName;
                }

                if(checked){
                    var compareObj = {
                        "id": lgePdpSendData.id,
                        "b2bcatemapping":lgePdpSendData.b2bCateMapping,
                        "productName": lgePdpSendData.productName,
                        "productID": compareId,
                        "productImg": lgePdpSendData.productImg,
                        "productAlt": lgePdpSendData.productAlt,
                        "careType": lgePdpSendData.careType,
                        "path": modelUrlPath,
                        "lgecomOnlyFlag" : lgePdpSendData.lgecomOnlyFlag,
                        "b2cYN": lgkorUI.getHiddenInputData().b2cYN
                    }
                    var isAdd = lgkorUI.addCompareProd(categoryId, compareObj, categoryNm);
                    if(!isAdd) {
                        $(this).prop('checked', false);
                        $(this).removeClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
                        $(this).find('span.blind').text('선택안됨');
                    }
                } else{
                    lgkorUI.removeCompareProd(categoryId, lgePdpSendData.id);
                }

                setTimeout(function(){
                    checkCompareClick = false;
                }, 500);
            });

            //비교하기 컴포넌트 변화 체크
            $(window).on("changeStorageData", function(){
                self.setCompares();
            });

            // 장바구니 담기 성공 리턴(BTOCSITE-37933)
            $(window).on("addCartReturn", function(e){
                self.cartRecommend(false);
            });

            //찜하기
            //self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]').on('click', function(e) {
            self.$pdpInfo.find('.top-area-wish input[type=checkbox]').on('click', function(e) {
            	var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                var $this = $(this);
                var _id = lgePdpSendData.modelId;
                var sku = (productInfo.model_sku ? productInfo.model_sku : lgePdpSendData.sku);
                var categoryId = lgePdpSendData.categoryId;
                var wishListId = $this.data("wishListId");
                var wishItemId = $this.data("wishItemId");
                var wish = $this.is(':checked');
                var param = {
                    "id":_id,
                    "sku":sku,
                    "categoryId": categoryId,
                    "wishListId": wishListId,
                    "wishItemId": wishItemId
                }
                if(wish){
                    param.type = "add";
                } else{
                    param.type = "remove";
                }

                var ajaxUrl = self.$pdpInfo.attr('data-wish-url');

                var $wishItem = self.$pdpInfo.find('.chk-wish-wrap input[type=checkbox]');
                var success = function(data) {
                    // $this.data("wishItemId",data.wishItemId);
                    // $this.prop("checked",wish);
                    $wishItem.each(function(i){
                        $(this).data("wishItemId",data.wishItemId);
                        $(this).prop("checked",wish);
                    });
                    
                    //찜하기, 위시리스트 태그 삽입
                    if(wish) {
                        self.addWishTag();
                    }

                    // BTOCSITE-13562 : 4월 이벤트 개발 요청_찜하기
                    var eventId = lgkorUI.getCookie("eventZzimId");
                    if(eventId) {
                        lgkorUI.requestAjaxData("/mkt/api/eventManagement/addWishlistEvent", {
                            "modelId" : lgePdpSendData.modelId,
                            "categoryId" : lgePdpSendData.categoryId,
                            "wishFlag" : wish ? 'Y' : 'N',
                            "eventId" :  eventId
                        });
                    }
                };
                var fail = function(data) {
                    // $this.prop("checked",!wish);
                    $wishItem.each(function(){
                        $(this).prop("checked",!wish);
                    });
                };

                lgkorUI.requestWish(
                    param,
                    wish,
                    success,
                    fail,
                    ajaxUrl,
                    $this // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 위시리스트 로그인 확인 팝업 close 시 포커스 이동
                );
            });

            //장바구니
            //BTOCSITE-23825 크리테오tag 삽입 함수 추가
            self.$pdpInfo.find('div.purchase-button a.cart').on('click', function(e) {
                e.preventDefault();
                //BTOCSITE-48266 b2b일 때 로그인 체크 start
                if (lgkorUI.getHiddenInputData().b2cYN ==='N') {
                    let callbackVal = KRP0008.b2bLoginCheck(e);

                    if(!callbackVal) return;
                }
                //BTOCSITE-48266 b2b일 때 로그인 체크 end
                if(!self.rentalAllSelect){
                    lgkorUI.alert("", {title: "모든 옵션을 선택해주세요."});
                    return;
                }

                var rentalSelfCheck = false;
                
                //BTOCSITE-29501 - 케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    checkCareSelect = lgkorUI.stringToBool(checkinput.val()); //true:신청 / false:미신청
                }

                self.$actionSheet.find('.ui_selectbox').each(function(){
                    if($(this).val() == '방문없음/자가관리' && checkCareSelect) {
                        rentalSelfCheck = true;
                    }
                })

                var param = {
                    "id":lgePdpSendData.id,
                    "sku":lgePdpSendData.sku,
                    "rtSeq":lgePdpSendData.rtSeq,
                    "bizType":lgePdpSendData.bizType
                }

                var $paymentAmount = $(this).parents('.payment-amount');

                //렌탈케어 제품인가(일반구매의 케어십과 틀림)
                var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');

                //소모품이 있는가
                var cart = [];
                var $additionalPurchase = $('.additional-purchase');
                if($additionalPurchase.length > 0) {
                    $additionalPurchase.find('ul.additional-list li').each(function(idx, item){
                        cart.push($(item).data('id')+"|"+$(item).data('quantity'));
                    });
                }

                //선택 수량
                var quantity = self.$actionSheet.find('div.select-quantity input.quantity');
                if(quantity.length > 0) {
                    cart.push(lgePdpSendData.sku+"|"+quantity.val());
                } else {
                    cart.push(lgePdpSendData.sku+"|1");
                }

                param.sku = cart.join(',');

                param.typeFlag = "P";

                //케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    var checkCareSelect = lgkorUI.stringToBool(checkinput.val());
                    if(checkCareSelect) {
                        //케어쉽 선택
                        param.typeFlag = "C";
                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                    }
                } else {
                    var $careSiblingOption = $('.care-sibling-option');
                    //케어쉽필수 제품인지 체크해서 알림창 뛰움
                    if($careSiblingOption.length < 1) {
                        if(careRequire) {
                            param.typeFlag = "C";
                        }
                    } else {
                        param.typeFlag = "C";
                    }
                }
                //}

                if(param.typeFlag == "C") {
                    if(typeof careshipOnlyFlag !== 'undefined') {
                        param.requireCare = lgkorUI.stringToBool(careshipOnlyFlag) ? true : false;
                    }

                    var careData = $paymentAmount.data('careData');
                    if(careData) {
                        param.rtSeq = careData.rtModelSeq;
                    }

                    var cardData = $paymentAmount.data('cardData');
                    if(cardData) {
                        if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
                            //간편신청카드
                            param.easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
                        }
                    }
                    self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                }

                var ajaxUrl = self.$pdpInfo.attr('data-cart-url');
                
                var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;

                /* 구매시 옵션체크 항목일 경우 START */
                var optItemBuyChkFlag = false;
                var optItemDispNmBuyChk = '';
                var optItemDispValueNmBuyChk = '';
                var action = isRentalCareTab ? '가전 구독' : '구매';

                var optItems = self.$specInfoPopup.find('.sibling-cont > div');
                if (optItems.length > 0) {
                    optItems.each(function(i, e) {
                        if ($(this).data('opt-item-buy-chk-flag') == 'Y') {
                            optItemBuyChkFlag = true;
                            optItemDispNmBuyChk = $(this).data('opt-item-nm');
                            optItemDispValueNmBuyChk = $(this).find('div.option-list input:radio:checked').siblings('label').text();

                            return false;
                        }
                    });
                }

                if (optItemBuyChkFlag === false && buryPipeFlag === 'Y') {
                    optItemBuyChkFlag = true;
                    optItemDispNmBuyChk = '설치타입';
                    optItemDispValueNmBuyChk = '매립배관형';
                }
                // BTOCSITE-85293 START
                self.preCheckTermAndCondition(false, function() {
                    if(optItemBuyChkFlag) {
                        lgkorUI.confirm('', {
                            title:"지금 선택된 제품은 <br>" + optItemDispNmBuyChk + " " +  optItemDispValueNmBuyChk + " 제품입니다.<br>" + optItemDispValueNmBuyChk + " 제품을 " + action + " 하시겠어요?",
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                if(rentalSelfCheck){
                                    lgkorUI.confirm('', {
                                        title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 " + action + " 하시겠어요?",
                                        okBtnName: '확인',
                                        cancelBtnName: '취소',
                                        ok: function() {
                                            if(!isRentalCareTab && param.typeFlag == "C") {
                                                //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START

                                                //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                                $('#careRequireBuyCartPopup').vcModal({opener: this});
                                               //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                                return;
                                            }
                                            self.addCartAjaxCall(ajaxUrl, param, true);
                                            self.addCartTag(productInfo, quantity, false);
                                        }
                                    });
                                    return;
                                } else {
                                    if(!isRentalCareTab && param.typeFlag == "C") {

                                         //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건 수정
                                        $('#careRequireBuyCartPopup').vcModal({opener: this});
                                       //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건

                                        return;
                                    }
                                }
                                self.addCartAjaxCall(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, false);
                            }
                        });

                        return;
                    }
                    /* 구매시 옵션체크 항목일 경우 END */

                    if(rentalSelfCheck){
                        lgkorUI.confirm('', {
                            title: "지금 방문주기로 선택된 ‘방문없음/자가관리’ 옵션은 매니저 방문없이 필터만 정기배송됩니다.<br>해당 옵션으로 구매하시겠어요?",
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                if(!isRentalCareTab && param.typeFlag == "C") {
                                    //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START

                                    //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                    $('#careRequireBuyCartPopup').vcModal({opener: this});
                                   //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                                    return;
                                }
                                self.addCartAjaxCall(ajaxUrl, param, true);
                                self.addCartTag(productInfo, quantity, false);
                            }
                        });
                        return;
                    }

                    if(!isRentalCareTab && param.typeFlag == "C") {
                        //BTOCSITE-36222 케어십제품 장바구니 변경 요청의 건 START

                        //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건
                        $('#careRequireBuyCartPopup').vcModal({opener: this});
                       //BTOCSITE-34628 제품 구매 프로세스 안내 팝업 생성 요청의 건

                        return;
                    } else {
                        //BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
                        if(purchaseButtonDisplay === "N"){
                            lgkorUI.alert("", {title: purchaseButtonMassage}, document.activeElement); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        }else{
                            self.addCartAjaxCall(ajaxUrl, param, true);
                            self.addCartTag(productInfo, quantity, false);
                        }
                    }

                });
                // BTOCSITE-85293 END

            });

            //구독 BTOCSITE-22701 add :: 구독신청클릭시
            self.$pdpInfo.on('subscribe', function(e, data){

                self.$serviceOptPopup1.trigger('popup', data);

            });

            //상단 스티키 구매버튼
            $(window).on('sendExtraAction.KRP0009', function(e){
                // BTOCSITE-22701 :: 구독일때 케이스 추가
                var $buyButton;
                if (lgePdpSendData.bizType == 'SUBSCRIPTION'){
                    $buyButton =  self.$pdpInfo.find('div.purchase-button a:not(.cart)').eq(1);                    
                } else {
                    $buyButton =  self.$pdpInfo.find('div.purchase-button a:not(.cart)').eq(0);
                }                
                $buyButton.trigger('click');
            });

            //링크
            self.$pdpInfo.on('click','a.btn-link:not(.popup)', function(e) {
                e.preventDefault();
                var $this = $(this);
                if(!$this.attr('data-control')) {
                    var url = $this.attr('href').replace("#","");
                    var addS = $this.data('add');
                    if(url) {
                        if(addS) {
                            url += addS;
                        }
                        location.href = url;
                    }
                }
            });

            //LGECOMVIO-20 - 구매혜택 팝업
            self.$pdpInfo.on('click','li.lists .buy-benefit-info a.btn-link.popup', function(e) {
                e.preventDefault();
                var target = $(this).data("active-target");
                self.$buybenefitInfoPopup.vcModal({opener: this});
                self.$buybenefitInfoPopup.find('.ui_accordion .lists').each(function(idx,item){
                    if($(item).attr('id') === target){
                        self.$buybenefitInfoPopup.find('.ui_accordion').vcAccordion('expand',idx);
                    }
                })
            });

            //LGECOMVIO-20 - 단순팝업 열기
            function pdpOpenPopup(selector,targetPopup,fn){
                $(selector).on('click',function(e){
                    e.preventDefault();
                    targetPopup.vcModal({opener: this});
                });
            };

            //팝업 BTOCSITE-1025 : add 20210802 - LGECOMVIO-20
            pdpOpenPopup('.notice-wrap .notice-box a', self.$mainInitPopup);
            //할인적용가 팝업 BTOCSITE-5781 - LGECOMVIO-20
            //pdpOpenPopup('li.lists.member .btn-discount-popup', self.$saleInfoPopup);
            //구매혜택 팝업 - 추후 삭제 LGECOMVIO-20
            pdpOpenPopup('li.lists.benefit a.btn-link.popup', self.$benefitInfoPopup);
            //LGECOMVIO-20 - 제휴카드 팝업 - LGECOMVIO-20
            pdpOpenPopup('.promotion-card-info .card-list-more', self.benefitCardPopup) // BTOCSITE-51891 구독 제휴카드 관련 PDP/팝업 수정의 건

            //제휴카드 할인 드롭다운 선택
            //div.option-contents
            self.$pdpInfo.on('click','.rental-card-list div.ui_dropdown_list li a, .careship-card-list div.ui_dropdown_list li a', function(e){
                e.preventDefault();
                var $this = $(this);
                var $dropDown = $this.parents('.dropdown-box-wrap'); //BTOCSITE-3523 수정

                //BTOCSITE-3523 추가
                if($this.closest("li").hasClass("cancel-item")) {
                    $this.closest('.dropdown-box-wrap').removeClass('is-selected'); //BTOCSITE-3523 수정
                    $dropDown.find('.ui_dropdown_toggle').empty();
                }else{
                    $dropDown.find('.ui_dropdown_toggle').text($this.attr('data-card-title'));
                    $this.closest('.dropdown-box-wrap').addClass('is-selected'); //BTOCSITE-3523 수정
                }

                $dropDown.removeClass('open'); //BTOCSITE-3523 수정

                var cardData = {};
                var cardNameCode = $this.attr('href').replace("#","");
                if(cardNameCode) {
                    cardData.cardNameCode = cardNameCode;
                }
                var cardSale = $this.data('cardSale');
                if(cardSale) {
                    cardData.cardSale = cardSale;
                }
                var cardSubName = $this.data('cardSubName');
                if(cardSubName) {
                    cardData.cardSubName = cardSubName;
                }
                var simpleReqFlag = $this.data('simpleReqFlag');
                if(simpleReqFlag) {
                    cardData.simpleReqFlag = simpleReqFlag;
                }

                var isRental = false;
                var $careshipService = $this.parents('.careship-service');
                if($careshipService.length < 1) {
                    $careshipService = $this.parents('.care-sibling-option');
                    if($careshipService.length > 0) {
                        isRental = true;
                    }
                }
                var $paymentAmount = self.$pdpInfo.find('.payment-amount');

                $paymentAmount.data('cardData',cardData);
                if(isRental){
                    self.updateRentalInfoPrice(self.selectRentalInfoData);
                } else {
                    self.updateCareshipInfoPrice(self.selectCareshipInfoData);
                }
            });

            //div.option-contents
            var cardDropdown = self.$pdpInfo.find('.rental-card-list div.ui_dropdown_list .simple-card-list, .careship-card-list div.ui_dropdown_list .simple-card-list'); //BTOCSITE-3523 수정
            var firstRow = cardDropdown.find('li a:eq(0)');
            if(firstRow.length > 0) {
                firstRow.trigger('click',firstRow);
            }

            // S : BTOCSITE-20780
            self.$pdpInfo.on('click','li.lists.member .btn-buy-benefit', function(e) {
                var href = $(this).data('url');
                var eventId = href.substring(href.indexOf("-")+1,href.indexOf("?"));
                var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                var mltlp = $(this).data("mltlp");

                // 다품목 상품이 아닌경우 세션저장 하지 않음
                if(mltlp == "Y" && productInfo) {
                    var stroageItems = lgkorUI.getStorage(eventId + "_calcItems");
                    var item = {}, calcItems = (vcui.isEmpty(stroageItems)) ? [] : JSON.parse(stroageItems);
                    var chkStroageItem = calcItems.filter(function(obj){
                        return obj.sku == lgePdpSendData.sku;
                    });
                    item = {
                        id: 'calc-'+lgePdpSendData.sku,
                        sku: lgePdpSendData.sku,
                        modelName: modelName,
                        oprice: parseInt(productInfo.price),
                        tprice: parseInt(productInfo.discounted_price),
                        dprice: parseInt(productInfo.price) - parseInt(productInfo.discounted_price),
                        odprice: parseInt(lgkorUI.getHiddenInputData().obsDiscountPrice),
                        mediumImageAddr: lgePdpSendData.productImg,
                        imageAltText: lgePdpSendData.productName,
                        modelId: lgePdpSendData.modelId,
                        bizType: lgePdpSendData.bizType,
                        modelStatusCode: lgePdpSendData.modelStatusCode,
                        rtModelSeq: representRtModelSeq,
                        modelComponent: lgePdpSendData.modelComponent
                    }
                    lgkorUI.setStorage(eventId + "_currentItems", JSON.stringify(item), false);
                    if(chkStroageItem.length == 0) {
                        calcItems.push(item);
                        lgkorUI.setStorage(eventId + "_calcItems", JSON.stringify(calcItems), false);
                    }
                }

                location.href = href;
            });
            // E : BTOCSITE-20780
        },

        resize: function(){
            var self = this;
            self.resizePopup($('#specInfoPopup'), true)

            self.setPaymentBtnArea();
        },

        //팝업 버튼 이벤트
        bindPopupEvents: function() {
            var self = this;
            // careRequireBuyPopup 기본적용
            // salesNotificationPopup 판매 알림신청 입력 BTOCSITE-23884
            // salesNotificationLoginPopup 판매 알림신청 - 비회원/로그인 전 BTOCSITE-23884
            // salesNotificationCompletePopup 판매 알림신청 완료 BTOCSITE-23884
            // BTOCSITE-23884 id값을 변경시 팝업창의 내용이 다릅니다.
            // restockNotificationPopup  BTOCSITE-29838 일시품절 재입고 알림신청 입력
            // restockNotificationCompletePopup BTOCSITE-29838 일시품절 재입고 알림신청 완료
            // salesNotificationErrorPopup BTOCSITE-29838 판매 알림신청 - 에러
            $('#careRequireBuyPopup').on('click','.btn-group button',function(e){
            	
            	// BTOCSITE-22810 START
            	e.preventDefault();
            	lgkorUI.showLoading();
            	setTimeout(function(e){
		             //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start - request form 변경에 따라 submit 으로 구조변경.
					 let submitData = {};
		             var modelList = [];
                     ;
		             var modelMap = {
		                    "modelId":null,
		                    "sku":null,
		                    "rtModelSeq":$('#careRequireBuyPopup').data('rtModelSeq'),
		                    "bizType":null,
	                        "itemSeq":'1'
		             };
		             modelList.push(modelMap);
                    // submit
                    var $careSubmitForm = $('<form method="post" action="/order-to-pay/care-pre-check"><input type="text" name="modelList"/><input type="text" name="easyRequestCard"/></form>');
                    if(lgkorUI.getHiddenInputData().b2cYN == 'N'){
                        $careSubmitForm = $('<form method="post" action="/business/order-to-pay/care-pre-check"><input type="text" name="modelList"/><input type="text" name="easyRequestCard"/></form>');
                    }
                    $careSubmitForm.find('[name=modelList]').val(JSON.stringify(modelList));
                    $careSubmitForm.find('[name=easyRequestCard]').val($('#careRequireBuyPopup').data('easyRequestCard'));
                    $('html').append($careSubmitForm);
                    $careSubmitForm.submit();
	            	/*var popUrl = $('#careRequireBuyPopup').data('sendUrl');
	            	
	            	if(vcui.detect.isIOS){
	            		window.location.href = popUrl;
	            	} else {
	            	    location.href = popUrl;
	            	}*/
	             	//BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 end
            	},300);
            	
            	//setTimeout(function(e){
                    //lgkorUI.showLoading();
                    //location.href = $('#careRequireBuyPopup').data('sendUrl');
                //},30);
            	// BTOCSITE-22810 END
            });

            $('article').on('click', 'button[data-link-url]', function(e) {
                var buttonLinkUrl = $(this).attr('data-link-url');
                var isNew = $(this).attr('data-open-new');
                if(buttonLinkUrl) {
                    if(isNew == "Y") {
                        setTimeout(function () {
                            window.open(buttonLinkUrl);
                        },250);
                    } else {
                        setTimeout(function () {
                            location.href = buttonLinkUrl;
                        },250);
                    }
                }
            });

            $('#pop-pdp-visual').on('modalshown',function(e){
                var index = $(this).data('selectIndex');
                self.clickModalThumbnail(index);
            }).on('modalhidden',function(e){ // BTOCSITE-11452
                $(this).find('video').each(function() {
                    this.pause();
                    this.currentTime = 0;
                })
                // BTOCSITE-100135 Start
                if(vcui.detect.isMobileDevice){
                    const only = $('div.sr-only');
                    if(only){
                        only.first().attr('aria-hidden', 'false');
                    }
                    const viewPort = $('div.iw_viewport-wrapper.subRenewPdpWrap');
                    if(viewPort){
                        viewPort.first().attr('aria-hidden', 'false');
                    }
                    const toastMessage = $('div.toast-message');
                    if(toastMessage){
                        toastMessage.first().attr('aria-hidden', 'false');
                    }
                }
                // BTOCSITE-100135 End
                self.open360Stop(); // BTOCSITE-15587
            });

            self.$popPdpVisualImage.find('div.zoom-area img').on('load',function(e) {
                self.pinchZoom.update(true);
            });

            // BTOCSITE-89585(비활성화 옵션 선택불가처리)
            self.$siblingCont.on('click', '.select-option input:radio', function(){

				if($(this).closest('#specInfoPopup').hasClass('notebook_spec')){

					if($(this).hasClass('disabled')){

						return false;

					}

				}

			});

            //BTOCSITE-44: 시블링레이어 라디오버튼 change
            self.$siblingCont.on('change', '.select-option input:radio', function(){
                var _self = this;
                var $this = $(_self);
                var models;

                if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우
                	self.siblingCurrentModel = "";
                	
                	// LGECOMVIO-20: 선택한 핵심스펙의 하위 스펙 disabled, checked 초기화
                	$this.closest('.sibling-select').nextAll('div').find('input:radio').prop('checked', false).prop('disabled', false);
                	
                	if(self.receivedSiblingData.length > 0 && self.receivedSiblingData[0].siblingModels && self.defaultSiblingDataFlag ) {
                		models= self.receivedSiblingData[0].siblingModels;
                	} else {
                		models= siblingList[0].siblingModels;
                	}
                	
                	self.$siblingCont.find('.option-list').each(function(optionIndex){
                		var $this = $(this);
                		var $radio = $this.find('input:radio');
                		
                		$radio.each(function(i){
                			self.setSiblingOptionCheck(this, optionIndex, models)
                		});
                	});

                	// LGECOMVIO-20: 선택한 핵심스펙의 하위 스펙 비노출/비활성화 처리
                	$this.closest('.sibling-select').nextAll('div').find('.option-list').each(function(idx){
                		var $radio = $(this).find('input:radio');
                		
                		$(this).show();
                		
                		$radio.each(function(){
                			var targetValue = String($(this).data('siblingCode'));
                			
                			// 노출/비노출
                			if(self.enableOptionList.indexOf(targetValue) == -1) {
                				$(this).closest('[role="radio"]').hide();
                			} else {
                				$(this).closest('[role="radio"]').show();
                			}
                			
                			// 활성/비활성화 (스펙은 있으나 현재 판매가 불가할 시)
                			if(self.disableOptionList.indexOf(targetValue) == -1) {
                				$(this).prop('disabled', false);
                			} else {
                				$(this).prop('disabled', true);
                			}
                		});
                		
                		// 선택 가능한 스펙이 없을 시 영역 비노출
                		self.$siblingCont.find('.option-list').each(function(){
                			if($(this).find('[role="radio"]:visible').length) {
                				$(this).show();
                			} else {
                				$(this).hide();
                			}
                		});
                	})
                	
                	var optionSelectModels = [];
                	
                	self.$siblingCont.find('.option-list').each(function(i){
                		var currentSiblingCode = $(this).find('input:radio').filter(':checked').attr('data-sibling-code')
                		if( i == 0 ) {
                			optionSelectModels = models.filter(function(model){
                				return model.siblingCode === currentSiblingCode
                			})
                		} else {
                			var modelIds = optionSelectModels.map(function(model){
                				return model.modelId
                			});
                			optionSelectModels = models.filter(function(model){
                				return modelIds.indexOf(model.modelId) > -1
                			}).filter(function(model){
                				return model.siblingCode == currentSiblingCode
                			})
                		}
                	})

                	if( optionSelectModels[0] ) {
                		self.siblingCurrentModel = optionSelectModels[0].modelId;
                	} else {
                		self.siblingCurrentModel = '';
                	}
                	
                	if( self.siblingCurrentModel ) {
                		self.requestSiblingData(self.siblingCurrentModel)
                	} else {
                		self.$siblingCont.removeAttr('data-model-path')
                		self.$siblingBtnComp.addClass('disabled'); // LGECOMVIO-20 수정
                	}
                } else { //옵션일 경우 BTOCSITE-26021
                	//클릭한 아이템 정보
                	var changeOptItemId = $(this).data("optItemId");
                	var changeOptItemValueId = $(this).attr("id");
                	var changeOptModel = {};
                	var changeOptModelUrlPath = $(this).data("optModelUrlPath");
                	var isSelectableOption = $(this).hasClass("disabled");

                	//선택된 옵션 item명 옆에 옵션변경됨 초기화
                	self.$siblingCont.find(".option-change").text("");
                	
                	//선택된 옵션 객체에서 해당 itemId값 삭제 및 변경된 값 추가
                	checkedOpt = checkedOpt.filter((item) => item.optItemId != changeOptItemId);
                	checkedOpt.push({optItemId: changeOptItemId, optItemValueId: changeOptItemValueId});

                	if (isSelectableOption) { //선택가능옵션일때
                		//해당하는 모델의 옵션 정보로 라디오 셋팅
                		for(var i = 0; i < optModelList.length; i++) {
                			var result = optModelList[i].optItem.filter(function(item) {
                				  return item.optItemId == changeOptItemId && item.optItemValueId == changeOptItemValueId;
                			});
                			
                			if (result && result.length > 0) {
                				checkedOpt = optModelList[i].optItem;
                				changeOptModel = optModelList[i];
                				changeOptModelUrlPath = optModelList[i].MODEL_URL_PATH;
                				break;
                			}
                		}
                		//모델 옵션 정보로 체크해준다
                		checkedOpt.forEach(function(obj) {
    	    				KRP0008.$siblingCont.find('input:radio[id="' + obj.optItemValueId + '"]').prop("checked", true);
    	    			});
                		//클릭한 옵션을 제외한 자동으로 변경된 옵션 옆에 옵션변경됨 출력
                		var optItemDiv = self.$siblingCont.children("div");
                		optItemDiv.each(function() {
                			var $this = $(this);
                			if ($this.is("." + changeOptItemId + "-div") == false) {
                				$this.find(".option-change").text("옵션 자동 변경됨");
                			}
                		});
                	}

                	KRP0008.optItemModelMap(); //변경된 값으로 셋팅

                    //BTOCSITE-93074  스펙 기반 선호도 추가
                    var bestOptionList = "";
                    if(bestOptInfo){
                        bestOptInfo.fromOptionValueId = changeOptItemValueId;
                        bestOptionList = KRP0008.calcBestOption(optModelList,bestOptInfo);

                        var bestOpt = bestOptionList.optResult;
                        if(bestOpt.length > 0) {
                            KRP0008.$siblingCont.find('span.best-badge').remove();
                        }

                        bestOpt.forEach(function(option) {
                            if ("Y" == option.bestOptYn) {
                                var elements = KRP0008.$siblingCont.find('label[for="' + option.optItemValueId + '"]');
                                if (elements.length > 0) { // 해당 요소가 존재하는 경우만
                                    var badgeText = (option.percent == 100 || option.percent == "100" || option.percent == "100%") ? "BEST" : option.percent + " 선택";
                                    elements.append('<span class="best-badge">' + badgeText + '</span>');
                                }
                            }
                        });
                    }


                    //선택된 옵션 모델아이디 정보로 상단의 모델정보 display 여부 체인지
                	var changeOptModelId = $(this).data("optModelId");
                	if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                		//BTOCSITE-111584 s
                		const tabObject = self.rentalCurrentTabObjects();
                		let empYn = "N";
                		let $selectItem = $("#tab2 .subscribe-detail-select input:checked").last().data("item");
                		if(tabObject.tabId == "tab01"){
                			//임직원
                			empYn = "Y";
                			$selectItem = $("#tab1 .subscribe-detail-select input:checked").last().data("item");
                		}
	                	const dutyTerm = $selectItem.dutyTerm;
	                	const contractTerm = $selectItem.contractTerm;
	                	let retrieveOptionPriceParam = {};
	                	if(!vcui.isEmpty(dutyTerm) && !isNaN(dutyTerm)){
	                		retrieveOptionPriceParam.dutyTerm = dutyTerm * 12;
	                	}
	                	if(!vcui.isEmpty(contractTerm) && !isNaN(contractTerm)){
	                		retrieveOptionPriceParam.contractTerm = contractTerm * 12;
	                	}
	                	retrieveOptionPriceParam.visitPer = $selectItem.visitPer;
	                	retrieveOptionPriceParam.svcTypeCd = $selectItem.svcTypeCd;
	                	retrieveOptionPriceParam.empYn = empYn;
	                	retrieveOptionPriceParam.modelId = changeOptModelId;
	                	lgkorUI.requestAjaxDataPost("/mkt/ajax/product/retrieveOptionPrice", retrieveOptionPriceParam, function (result) {
	                        if (result.status === "success") {
	                        	let modelPriceHtml = new Array();
	                        	modelPriceHtml.push("<span>월 ");
	                        	modelPriceHtml.push(vcui.number.addComma(result.data.years1TotAmt));
	                        	modelPriceHtml.push("원</span>");
	                        	modelPriceHtml.push("<b>");
	                        	modelPriceHtml.push(getVisitPerText(result.data.visitPer));
	                        	modelPriceHtml.push("</b>");
	                    		self.$optHeader.find(".header-prd[data-opt-model-id='"+changeOptModelId+"'] h5").html(modelPriceHtml.join(''));
	                        }
	                        self.$optHeader.find(".header-prd").css("display","none");
	                        self.$optHeader.find("div[data-opt-model-id=" + changeOptModelId + "]").css("display","");
	                	});
	                	// BTOCSITE-111584 e
                	}else{
                		self.$optHeader.find(".header-prd").css("display","none");
                		self.$optHeader.find("div[data-opt-model-id=" + changeOptModelId + "]").css("display","");
                	}
                	
                	//선택가능옵션 클릭한거면 토스트팝업창도 출력해야함. 
                	if (isSelectableOption) { //선택가능옵션일때
                		var optToastMsg = "";
                		// 판매:1, 판매대기:2, 일시품절:3, 미판매: 4, 단종: 5
                		if (changeOptModel.MODEL_STATUS_ORDER == 1 || changeOptModel.MODEL_STATUS_ORDER == 2 || optBizType == "CARESOLUTION") {
                			optToastMsg = $(this).data("optItemNm") + " " + $(this).data("optItemValueNm") + " 기준으로<br>옵션이 자동 변경되었어요.";
                		} else if (changeOptModel.MODEL_STATUS_ORDER == 3) {
                			optToastMsg = "해당 상품은 품절되었습니다.";
                		} else if (changeOptModel.MODEL_STATUS_ORDER == 5) {
                			optToastMsg ="해당 상품은 단종되었습니다.";
                		} else if (changeOptModel.MODEL_STATUS_ORDER == 4) {
                			optToastMsg ="해당 상품은 제품 정보만 제공하고 있습니다.";
                		}
                		
                		$('.toast-message2').css('z-index', 90002);
                		KRP0008.optPopToastShowHtml(optToastMsg);
                	}
                	//렌탈이면 url끝에 dpType을 붙여준다.
                	if (optBizType == "CARESOLUTION" && (changeOptModelUrlPath.indexOf('dpType=careTab') < 0)) {
                		changeOptModelUrlPath += "?dpType=careTab";
                	}
                	//확인버튼에 해당 modelUrlPath 셋팅
                	self.$siblingBtnComp.data("modelUrlPath", changeOptModelUrlPath);
                }
            });

            //BTOCSITE-44 스펙선택(시블링레이어) 팝업열기
            self.$pdpInfo.on('click','li.lists.Spec a.btn-link.popup', function(e) {
                e.preventDefault();

                self.$specInfoPopup.vcModal({opener: this});
                self.$specInfoPopup.on('modalshown', function(){
                    var $this = $(this);
                    var $siblingCont = $this.find('.sibling-cont');

                    if( !$this.data('init-content') ) {
                        $this.data('init-content', $siblingCont.html());
                        $this.data('init-select-disabled', $this.find('.btn-sibling-select').hasClass('disabled')); // LGECOMVIO-20 수정

                    }
                })
            });

            //BTOSCITE-22701 : 구성상품 팝업
            self.$pdpInfo.on('click','.scrb-composition .btn-link', function(e) {
                e.preventDefault();
                if ($(this).hasClass("no-arrow") == false) {//221208 >가 없는 경우 링크가 안되도록
                    self.$compositionInfoPopup.vcModal({opener: this});
                }
            });            
            
            //BTOSCITE-22701 : 선택옵션수정 팝업
            /*
            self.$pdpInfo.on('click','.scrb-select-option a.btn-pop', function(e) {
                e.preventDefault();
                self.$serviceOptPopup1.trigger('modify');
            });
            */

            //BTOSCITE-22701 결합할인 배너이동 :: START
            self.$bannerLink.on('click', '.more-union a', function(e){
                e.preventDefault();
                var id = $(this).attr('href');
                
                var $nav = $('.KRP0009 .tab-menu-belt')
                var $items = $nav.find('li');
                $items.removeClass('active');
                $nav.find('#pdp_combinedProduct').parent('li').addClass('active');
                
                scrollMoved(id);
            });

            function scrollMoved(id){
                if($(id).length){
                    var checkHeight = 55;
                    var compheight = $('.KRP0009').find('.tab-menu-belt li').eq(0).height();
                    if(compheight < checkHeight) {
                        compheight = checkHeight;
                    } else {
                        checkHeight = compheight;
                    }
                    
                    var movtop = $(id).offset().top - compheight+2;
    
                    if( window.innerWidth < 768 && $(window).scrollTop() > movtop) {
                        movtop = movtop - $('.header').height();
                    }
        
                    $('html, body').stop().animate({scrollTop:movtop}, 200);
                }
            }
            //BTOSCITE-22701 결합할인 배너이동 :: END


            // LGECOMVIO-20 화면사이즈 단위변경 버튼
//            if(self.$specInfoPopup.find('.btn-change-unit').length){
                function cmToInch(cm){
                    var inch = cm/2.54;
                    return Math.ceil(inch);
                }

                self.$specInfoPopup.on('click', '.btn-change-unit', function(){
                    var $this = $(this);
                    var currentUnit = 'cm';

                    if($this.hasClass('is-cm')){
                        $this.removeClass('is-cm');
                        $this.addClass('is-inch').text('cm로 보기');
                        currentUnit = 'inch';
                    } else {
                        $this.removeClass('is-inch');
                        $this.addClass('is-cm').text('인치로 보기');
                        currentUnit = 'cm';
                    }

                    $this.closest('.sibling-select').find('.rdo-wrap').each(function(){
                        var $this = $(this);
                        var targetCode = '';
                        if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우
                        	targetCode = $this.find('input').data('siblingCode');
                        	var siblingValue = $this.attr('title'); // BTOCSITE-32361
                        	if (!isNaN(siblingValue)) {
                        	    siblingValue = targetCode + ' cm';
                        	}
                        	var currentUnitText = currentUnit == 'cm' ? siblingValue : targetCode + ' cm' + '<span class="type-inch">('+ cmToInch(targetCode) + ' inch'+ ')</span>';
                        	$this.find('label').html(currentUnitText);
                        } else { //옵션일 경우 BTOCSITE-26021
                        	targetCode = $this.find('input').data('optItemValueExtra');
                        	targetCodeNm = $this.find('input').data('optItemValueNm');
                        	var currentUnitText = currentUnit == 'cm' ? targetCodeNm : targetCodeNm + '<span class="type-inch">('+ cmToInch(targetCode) + ' inch'+ ')</span>';
                        	$this.find('span.opt-value-nm').html(currentUnitText);
                        }
                    });
                })
//            }

            // LGECOMVIO-20 다시 선택 버튼
            self.$specInfoPopup.find('.btn-sibling-reset').on('click', function(e){
                var $this = $(this);
                var $currentPopup = $this.closest('#specInfoPopup');
                if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우
	                $currentPopup.find('.sibling-cont').empty().append($currentPopup.data('init-content')).removeAttr('data-model-path');
	                if($currentPopup.data('init-select-disabled')){ // LGECOMVIO-20 수정
	                    $currentPopup.find('.btn-sibling-select').addClass('disabled');
	                } else {
	                    $currentPopup.find('.btn-sibling-select').removeClass('disabled');
	                }
                } else { //옵션일 경우 BTOCSITE-26021
                	var $changeUnitBtn = self.$specInfoPopup.find('.btn-change-unit');
                	if ($changeUnitBtn.hasClass('is-inch')) { // cm로 초기화           		
                		$changeUnitBtn.trigger('click');
                	}
                	//선택된 옵션 item명 옆에 옵션변경됨 초기화
                	self.$siblingCont.find(".option-change").text("");
                	checkedOpt = orgCheckedOpt;
                	//모델 옵션 정보로 체크해준다
            		checkedOpt.forEach(function(obj) {
	    				KRP0008.$siblingCont.find('input:radio[id="' + obj.optItemValueId + '"]').prop("checked", true);
	    			});
                	KRP0008.optItemModelMap(); //초기화된 값으로 셋팅
                	//확인버튼에  modelUrlPath 초기화
                	self.$siblingBtnComp.data("modelUrlPath", "");
                	//선택된 옵션 모델아이디 정보로 상단의 모델정보 display 여부 체인지
                	self.$optHeader.find(".header-prd").css("display","none");
                	self.$optHeader.find("div[data-opt-model-id=" + lgePdpSendData.modelId + "]").css("display","");
                }
            })

            //BTOCSITE-44 스펙선택(시블링레이어) 팝업닫기
            self.$specInfoPopup.find('.btn-close').on('click', function(e){
                var $this = $(this);
                var $currentPopup = $this.closest('#specInfoPopup');
                if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우                	
                	$currentPopup.find('.sibling-cont').empty().append($currentPopup.data('init-content')).removeAttr('data-model-path');
                	if($currentPopup.data('init-select-disabled')){ // LGECOMVIO-20 수정
                		$currentPopup.find('.btn-sibling-select').addClass('disabled');
                	} else {
                		$currentPopup.find('.btn-sibling-select').removeClass('disabled');
                	}
                } else { //옵션일 경우 BTOCSITE-26021
                	$currentPopup.hide();
                	var $changeUnitBtn = self.$specInfoPopup.find('.btn-change-unit');
                	if ($changeUnitBtn.hasClass('is-inch')) { // cm로 초기화           		
                		$changeUnitBtn.trigger('click');
                	}
                	//선택된 옵션 item명 옆에 옵션변경됨 초기화
                	self.$siblingCont.find(".option-change").text("");
                	checkedOpt = orgCheckedOpt;
                	//모델 옵션 정보로 체크해준다
            		checkedOpt.forEach(function(obj) {
	    				KRP0008.$siblingCont.find('input:radio[id="' + obj.optItemValueId + '"]').prop("checked", true);
	    			});
                	KRP0008.optItemModelMap(); //초기화된 값으로 셋팅

                    //BTOCSITE-93074  스펙 기반 선호도 추가
                    if (bestOptInfo) {
                        var bestOptionList = "";
                        bestOptInfo.fromOptionValueId = orgModelOptValInfoStr;

                        bestOptionList = KRP0008.calcBestOption(optModelList,bestOptInfo);

                        var bestOpt = bestOptionList.optResult;
                        if(bestOpt.length > 0) {
                            KRP0008.$siblingCont.find('span.best-badge').remove();
                        }

                        bestOpt.forEach(function(option) {
                            if ("Y" == option.bestOptYn) {
                                var elements = KRP0008.$siblingCont.find('label[for="' + option.optItemValueId + '"]');
                                if (elements.length > 0) { // 해당 요소가 존재하는 경우만
                                    var badgeText = (option.percent == 100 || option.percent == "100" || option.percent == "100%") ? "BEST" : option.percent + " 선택";
                                    elements.append('<span class="best-badge">' + badgeText + '</span>');
                                }
                            }
                        });
                    }

                	//확인버튼에  modelUrlPath 초기화
                	self.$siblingBtnComp.data("modelUrlPath", "");
                	//선택된 옵션 모델아이디 정보로 상단의 모델정보 display 여부 체인지
                	self.$optHeader.find(".header-prd").css("display","none");
                	self.$optHeader.find("div[data-opt-model-id=" + lgePdpSendData.modelId + "]").css("display","");
                }
            })

            //BTOCSITE-44 스펙선택(시블링레이어) 선택완료
            self.$siblingBtnComp.on('click', function(e){
                var $this = $(this);
                var _smartHomePackageId = self.$pdpInfo.attr('data-smart-home-package-id');
                if (typeof modelOptInfoStr !== 'undefined' && modelOptInfoStr === "") { // 시블링일 경우
                	if($this.hasClass('disabled')) { // LGECOMVIO-20 disabled 관련 분기 추가
//                    $('.toast-message').css('z-index', 90002);
//                    $(window).trigger("toastshow", '모든 옵션을 선택해주세요.');
                	} else {
                		
                		var $currentPopup = $this.closest('#specInfoPopup');
                		var $siblingCont = $currentPopup.find('.sibling-cont');
                		var _modelPath = $siblingCont.attr('data-model-path');
                		
                		if (_modelPath != undefined && _modelPath != "") {
                            if(_smartHomePackageId != undefined && _smartHomePackageId != ""){
                                _modelPath = _modelPath + "?pkgNo=" + _smartHomePackageId;
                            }
                            /* BTOCSITE-100866 START */
                            // TBT 개선을 위한 비동기 처리
                            if (window.requestIdleCallback) {
                                requestIdleCallback(function() {
                                    try {
                                        SmartViewController.clearPdpHistory(lgeSmartView_category, lgeSmartView_modelId);
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }, { timeout: 3000 });
                            } else {
                                // requestIdleCallback 미지원 브라우저를 위한 fallback
                                requestAnimationFrame(function() {
                                    try {
                                        SmartViewController.clearPdpHistory(lgeSmartView_category, lgeSmartView_modelId);
                                    } catch (e) {
                                        console.log(e);
                                    }
                                });
                            }
                            /* BTOCSITE-100866 END */
                			location.href = lgkorUI.DEFAULT_URL+_modelPath; //BTOCSITE-48266 b2b url 추가
                		} else {
                			$currentPopup.vcModal('hide')
                			$currentPopup.find('.sibling-cont').empty().append($currentPopup.data('init-content')).removeAttr('data-model-path');
                		}
                	}
                } else { //옵션일 경우 BTOCSITE-26021
                	var optModelUrlPath = $this.data("modelUrlPath");
                	$('#specInfoPopup').find('.btn-close').trigger('click');
                    if (optModelUrlPath != null && optModelUrlPath != "" && optModelUrlPath !== modelUrlPath) {
                    	// 초기화
                    	checkedOpt = [];
                    	orgCheckedOpt = [];
                    	optList = [];
                    	optModelList = [];
                    	optBizType = "PRODUCT";
                        // 호출
						
						var param = {
							pickOptionId: null,
							changedOptionIds: null,
							top : $(window).scrollTop()
						};
						if(_smartHomePackageId != undefined && _smartHomePackageId != ""){
                            optModelUrlPath = optModelUrlPath + "?pkgNo=" + _smartHomePackageId;
                        }
                        /* BTOCSITE-100866 START */
                        // TBT 개선을 위한 비동기 처리
                        if (window.requestIdleCallback) {
                            requestIdleCallback(function() {
                                try {
                                    SmartViewController.clearPdpHistory(lgeSmartView_category, lgeSmartView_modelId);
                                } catch (e) {
                                    console.log(e);
                                }
                            }, { timeout: 3000 });
                        } else {
                            // requestIdleCallback 미지원 브라우저를 위한 fallback
                            requestAnimationFrame(function() {
                                try {
                                    SmartViewController.clearPdpHistory(lgeSmartView_category, lgeSmartView_modelId);
                                } catch (e) {
                                    console.log(e);
                                }
                            });
                        }
                        /* BTOCSITE-100866 END */
						location.href = lgkorUI.DEFAULT_URL+optModelUrlPath; //BTOCSITE-48266 b2b url 추가

                    	//__PDP_DOM_MNG__.load(prodModelUrlPath);
                    }
                }
            });

            //BTOCSITE-34628 [OBS] 얼정냉 장바구니 담기 시, 제품 구매 프로세스 안내 팝업 생성 요청의 건 START
            $('#careRequireBuyCartPopup').on('click','.btn-group button',function(e){

            	e.preventDefault();
            	lgkorUI.showLoading();

            	var param = {
                        "id":lgePdpSendData.id,
                        "sku":lgePdpSendData.sku,
                        "rtSeq":lgePdpSendData.rtSeq,
                        "bizType":lgePdpSendData.bizType
                    }

                    var $paymentAmount = self.$pdpInfo.find('.payment-amount');

                    //렌탈케어 제품인가(일반구매의 케어십과 틀림)
                    var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');

                    //소모품이 있는가
                    var cart = [];
                    var $additionalPurchase = $('.additional-purchase');
                    if($additionalPurchase.length > 0) {
                        $additionalPurchase.find('ul.additional-list li').each(function(idx, item){
                            cart.push($(item).data('id')+"|"+$(item).data('quantity'));
                        });
                    }

                    //선택 수량
                    var quantity = self.$actionSheet.find('div.select-quantity input.quantity');
                    if(quantity.length > 0) {
                        cart.push(lgePdpSendData.sku+"|"+quantity.val());
                    } else {
                        cart.push(lgePdpSendData.sku+"|1");
                    }

                    param.sku = cart.join(',');

                    //var $purchaseButton = $(this).parents('.purchase-button');
                    //if($purchaseButton.hasClass('rental')) {
                    //렌탈타입
                    //   param.typeFlag = "C";
                    //} else {
                    //제품타입
                    param.typeFlag = "P";

                    //케어십 선택
                var $careshipService = $('.careship-service');
                var checkinput = $careshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    var checkCareSelect = lgkorUI.stringToBool(checkinput.val());
                    if(checkCareSelect) {
                        //케어쉽 선택
                        param.typeFlag = "C";
                        self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                    }
                } else {
                    var $careSiblingOption = $('.care-sibling-option');
                    //케어쉽필수 제품인지 체크해서 알림창 뛰움
                    if($careSiblingOption.length < 1) {
                        if(careRequire) {
                            param.typeFlag = "C";
                        }
                    } else {
                        param.typeFlag = "C";
                    }
                }


                if(param.typeFlag == "C") {
                    if(typeof careshipOnlyFlag !== 'undefined') {
                        param.requireCare = lgkorUI.stringToBool(careshipOnlyFlag) ? true : false;
                    }

                    var careData = $paymentAmount.data('careData');
                    if(careData) {
                        param.rtSeq = careData.rtModelSeq;
	                    //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start
			             var modelList = [];
			             var modelMap = {
			                    "modelId":lgePdpSendData.id,
			                    "sku":lgePdpSendData.sku,
			                    "rtModelSeq":careData.rtModelSeq,
			                    "bizType":lgePdpSendData.bizType
	                    };
	                    modelList.push(modelMap);
	                    param.modelList = JSON.stringify(modelList);
	                    //BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start
                    }

                    var cardData = $paymentAmount.data('cardData');
                    if(cardData) {
                        if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
                            //간편신청카드
                            param.easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
                        }
                    }
                    self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                }

                 var ajaxUrl = self.$pdpInfo.attr('data-cart-url');
                 var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                 // BTOCSITE-85293 START
                 self.preCheckTermAndCondition(false, function() {
                    $('.careRequireBuyCartPopup .btn-close.ui_modal_close').click();
                     self.addCartAjaxCall(ajaxUrl, param, true);
                     self.addCartTag(productInfo, quantity, true);
                     self.$pdpInfo.attr('data-type-cart', 'C'); //BTOCSITE-10576 [사용자행태분석 개선사항] 장바구니 이동 경로 제공 / 품절 관련 무효클릭 및 안내 개선
                 });
                 // BTOCSITE-85293 END



            });
            //BTOCSITE-34628 [OBS] 얼정냉 장바구니 담기 시, 제품 구매 프로세스 안내 팝업 생성 요청의 건 END


            // 장바구니 바텀시트 팝업내 장바구니 바로가기 클릭(BTOCSITE-37933)
            self.$actionSheetCart.on('click', '.contain-view button', function(e,target,index){
                lgkorUI.setStorage(self.cartRecommendStorageName, lgePdpSendData.modelId);
                location.href = $(e.currentTarget).data("url");
            });

            // 장바구니 바텀시트 팝업내 다품목 기획전 or 상품 클릭
            self.$actionSheetCart.on('click', 'a', function(e,target,index){
                if( !vcui.detect.isMobileDevice && $(e.currentTarget).data("urlTarget") == "_blank"){
                    window.open($(e.currentTarget).data("url"));
                } else {
                    lgkorUI.setStorage(self.cartRecommendStorageName, lgePdpSendData.modelId);
                    location.href = $(e.currentTarget).data("url");
                }
            });

        },

        resizePopup: function($target, footerFlag){
            //BTOCSITE-44 스펙선택(시블링레이어) 팝업 리사이즈 높이값 조정
            var $popup = $target;

            var _minHeight= parseInt($popup.css('min-height'))
            var $head = $popup.find('.pop-header');
            var $cont = $popup.find('.pop-conts')
            var $footer = $popup.find('.pop-footer');

            var _headerHeight = $head.outerHeight();
            var _contHeight = $cont.outerHeight();
            var _footerHeight= $footer.outerHeight()

            var _curPopupHeight = footerFlag ? _headerHeight + _contHeight + _footerHeight:_headerHeight + _contHeight;

            if( $popup.closest('.ui_modal_wrap').length){
                if( _minHeight > _curPopupHeight ) {
                    $popup.css('min-height', _curPopupHeight);
                } else {
                    return
                }
            }
        },

        //PDP SIDE 관련
        //제휴카드 리스트 정리 펑션
        makeAssociatedCardListData: function(cardListData) {
            var arr = [];
            var simpleCardData = [];
            var individualCardData = [];
            var max = 0;
            cardListData.forEach(function(item, index) {
                if(item.maxSalePrice > max) {
                    max = item.maxSalePrice;
                }
                item.title = "[" + item.cardName.replace("카드","")+ "] " + item.cardSubName;
                lgkorUI.stringToBool(item.simpleReqFlag) ? (item.categoryTitle = "[간편 신청]") : (item.categoryTitle = "[개별 신청]"); //BTOCSITE-3523 추가
                lgkorUI.stringToBool(item.simpleReqFlag) ? simpleCardData.push(item) : individualCardData.push(item);
            });


            //최상단 카드취소
            arr.push({
                "groupTitle":null,
                "listItem":[
                    {
                        "cardNameCode":null,
                        "simpleReqFlag":null,
                        "cardSubName":null,
                        "title":"월 최대 " + vcui.number.addComma(max) + "원 할인",
                        "maxSalePrice":0
                    }
                ]
            });

            //간편 신청 카드
            if(simpleCardData.length > 0) {
                arr.push({
                    "groupTitle":"간편 신청 가능 카드",
                    "listItem":simpleCardData
                });
            }

            //개별 신청 카드
            /* 20210513 텍스트 수정 */
            if(individualCardData.length > 0) {
                arr.push({
                    "groupTitle":"개별 신청 가능 카드",
                    "listItem":individualCardData
                });
            }
            /* //20210513 수정 */
            return arr;
        },

        //제휴카드리스트 갱신
        /* 20210513 수정 */
        //BTOCSITE-3523 : 케어솔루션 PDP 상세조건 개선
        updateAssociatedCardList: function ($cardInfo, cardData) {
            if(cardData && cardData.length > 0) {
                //카드데이타
                var selectList = $cardInfo.find('ul.select-list'),
                    simpleCardList = $('ul.select-list.simple-card-list'),
                    individualCardList = $('ul.select-list.individual-card-list');;
                selectList.empty();
                //var groupItemTemplate = '<li class="divide"><span class="inner"><em>{{groupTitle}}</em></span></li>';
                var cardItemTemplate = '<li><a href="#{{cardNameCode}}" data-card-sub-name="{{cardSubName}}" data-simple-req-flag="{{simpleReqFlag}}" data-card-sale="{{maxSalePrice}}" data-card-title="{{title}}"><p class="card-name">{{label}}</p><p class="card-discount">월 최대 -{{maxSalePriceComma}}원</p></a></li>';
                cardData.forEach(function(obj, idx) {
                    /*if(obj.groupTitle) {
                        selectList.append(vcui.template(groupItemTemplate,obj));
                    }*/
                    if(obj.listItem) {
                        obj.listItem.forEach(function(item, index) {
                            item.label = item.title;
                            item.maxSalePriceComma = vcui.number.addComma(item.maxSalePrice);
                            if(!item.cardNameCode) {
                                item.label = "선택취소"
                                cardItemTemplate = '<li class="cancel-item"><a href="#{{cardNameCode}}" data-card-sub-name="{{cardSubName}}" data-simple-req-flag="{{simpleReqFlag}}" data-card-sale="{{maxSalePrice}}" data-card-title="{{title}}"><p class="card-name">{{label}}</p></a></li>';
                            }else{
                                cardItemTemplate = '<li><a href="#{{cardNameCode}}" data-card-sub-name="{{cardSubName}}" data-simple-req-flag="{{simpleReqFlag}}" data-card-sale="{{maxSalePrice}}" data-card-title="{{title}}"><p class="card-name">{{categoryTitle}}{{label}}</p><p class="card-discount">월 최대 -{{maxSalePriceComma}}원</p></a></li>';
                            }
                            //item.maxSaleString = item.maxSalePrice ? vcui.number.addComma(item.maxSalePrice) : null;
                            if(item.simpleReqFlag === "Y"){
                                //간편 신청 가능 카드
                                $cardInfo.find(simpleCardList).append(vcui.template(cardItemTemplate, item));
                            }else if(item.simpleReqFlag === "N"){
                                //개별 신청 가능 카드
                                $cardInfo.find(individualCardList).append(vcui.template(cardItemTemplate, item));
                            }else {
                                //선택취소
                                $cardInfo.find(simpleCardList).append(vcui.template(cardItemTemplate, item));
                            }
                        });
                    }
                });
                $cardInfo.show();
            } else {
                $cardInfo.hide();
            }
        },
        /* //20210513 수정 */

        //케어십 계약기간 셀렉트박스 갱신 펑션
        careshipInfoSelectBoxUpdate: function($selectBox, selectData, selectIndex, changeEvent) {
            var optionTemplate = '<option value="{{value}}" {{#if json}}data-item="{{json}}"{{/if}}>{{title}}</option>';
            if($selectBox.length > 0) {
                $selectBox.empty();
                if(selectData instanceof Array) { // 서비스타입
                    selectData.forEach(function(item, index){
                        //BTOCSITE-7447
//                            if(item.visitPer == 0){
//                                $selectBox.append(vcui.template(optionTemplate,{"value":item.rtModelSeq,"title":"방문없음(자가관리)", "json":JSON.stringify(item)}));
//                            }else{
//                                $selectBox.append(vcui.template(optionTemplate,{"value":item.rtModelSeq,"title":"1회 / "+ item.visitPer + "개월", "json":JSON.stringify(item)}));
//                            }
                        // BTOCSITE-9177 수정 (기존 방문주기에서 서비스타입으로 변경)
                        $selectBox.append(vcui.template(optionTemplate,{"value":item.svcTypeCd,"title":item.svcTypeDesc,"json":JSON.stringify(item)}));
                    });
                } else { // 방문주기
                    for(key in selectData) {
                        $selectBox.append(vcui.template(optionTemplate,{"value":key,"title":key,"json":JSON.stringify(selectData[key])}));
                    }
                }

                try {
                    $selectBox.vcSelectbox('update');
                    $selectBox.vcSelectbox('selectedIndex', selectIndex, changeEvent);
                } catch (error) {
                    // Event after loading vcui library
                    document.addEventListener('vcLoaded', _vcLoaded_3);
                    function _vcLoaded_3() {
                        $selectBox.vcSelectbox('update');
                        $selectBox.vcSelectbox('selectedIndex', selectIndex, changeEvent);
                        document.removeEventListener("vcLoaded", _vcLoaded_3); // 한 번만 실행
                    };
                }
            }
        },

        // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
        // 렌탈 이동 임직원/복지몰 이용요금 노출 추가
        employeeRentalDirectInfoSetting: function (partnerRentalDirectInfo, sellPointCom, selYnCom) {
            let isLogin = $('#rentalDirectinfoListEmployee').data('is_login');
            let partnerType = $('#rentalDirectinfoListEmployee').data('partner_type');
            let bsnsMbrStat = $('#rentalDirectinfoListEmployee').data('bsns_mbr_stat');

            let rentalRepresentInfo = {
                rtModelSeq: '',
                contractTerm: '',
                years1TotAmt: '',
                years2TotAmt: ''
            };

            var rentalDirectInfoTemplate = partnerRentalDirectInfo.map(function (item) {
                rentalRepresentInfo.rtModelSeq = item.rtModelSeq;
                rentalRepresentInfo.contractTerm = item.contractTerm;
                rentalRepresentInfo.years1TotAmt = vcui.number.addComma(item.years1TotAmt);
                rentalRepresentInfo.years2TotAmt = vcui.number.addComma(item.years2TotAmt);

                if (isLogin === 'Y' && partnerType === 'ENT' && bsnsMbrStat === 'USE') {
                    if (item.years2TotAmt && selYnCom === 'Y' && sellPointCom && sellPointCom.includes('반값할인')) {
                        return vcui.template(rentalRepresentPromTemplate2, rentalRepresentInfo);
                    } else {
                        return vcui.template(rentalRepresentTemplate2, rentalRepresentInfo);
                    }
                } else if (isLogin === 'Y' && partnerType === 'B2C' && bsnsMbrStat === 'WAIT') {
                    return vcui.template(rentalDirectTemplate, rentalRepresentInfo);
                } else {
                    return vcui.template(rentalDirectTemplate, rentalRepresentInfo);
                }
            }).join('');

            if (rentalDirectInfoTemplate) {
                $("#rentalDirectinfoListEmployee .product-offer-banner.b2b a").append(rentalDirectInfoTemplate);
            }
        },


        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용
        // rental 상품 정보 세팅
        rentalSetting : function(){
            var self = this;
            $('#empBanner').hide();//임직원 배너 영역

            let param = {
                "modelId": lgePdpSendData.modelId,
                "rentalCareType": 'R',
                "allianceBizType": 'CARESOLUTION',
                "subCategoryId": lgePdpSendData.subCategoryId,
                "superCategoryId": lgePdpSendData.superCategoryId,
                "categoryId": lgePdpSendData.categoryId,
                "bizType": lgePdpSendData.bizType,
                "smartHomeFlag" : digitalData.productInfo.smart_home_flag
            };

            lgkorUI.requestAjaxData("/mkt/ajax/product/retrieveRentalInfoProduct", param, function (result) {
                if (result.status === "success" && !vcui.isEmpty(result.data)) {
                    var data = result.data[0];
                    //재구독 회원 여부
                    self.rentalReSubFlag = data.reSubFlag;
                    
                    // BTOCSITE-73594
                    self.obsLinkOrderOfferFlag = data.obsLinkOrderOfferFlag;	// 연계할인 여부(다운타임 여부 포함)

                    // 임직원 값 세팅
                    partnerRentalInfo = data.rentalInfo;

                    self.$rentalActionSheetSelectBox = $('.detail-option-box--action-sheet .ui_selectbox');

                    //대표요금 임시 저장 일반 요금제에 임직원 대표 요금제가 없을 경우 비교대상으로 사용
                    self.defaultSelectRentalOption = {
                        selectContractTerm:null,
                        selectRtModelSeq:null,
                        selectRtRgstFeePre:null,
                        selectDutyTerm:null,
                        selectVisitTerm:null,
                        selectSvcTypeDesc:null
                    }

                    self.rentalOpenTab = "";// 링크를 타고 들어왔을 경우 탭이 있을때 일반 요금제 탭을 오픈하기 위한 변수

                    // [정리] 사업자몰 미사용 임직원(tab1) 세팅 제거: b2cYN==='N'&&bizTypeDetail==='CARETAB' 가드가 이 파일에서 항상 성립해 tab1 활성화 분기는 도달 불가능했음
                    $('#tab2').show();
                    $("#rentalPriceInfoDisp").removeClass("blind");
                    if($("#rentalIsCareDispText").data('isCareDispText')){
                        $("#rentalIsCareDispText").show();
                    }


                    self.setBannerSwiper();
                    //일반 세팅
                    self.$tab2CaresolutionRentalInfoTabBox = self.$pdpInfoCareSiblingOption.find("#tab2");
                    self.$tab2CaresolutionRentalInfoButtonBox = self.$pdpInfoCareSiblingOption.find('div.detail-option-box #tab2 .subscribe-detail-select > div');
                    self.rentalInfoData = self.rentalOptionSetting(rentalInfo,self.$tab2CaresolutionRentalInfoButtonBox,self.$tab2CaresolutionRentalInfoTabBox,"tab02");
                    sessionStorage.removeItem('dispRtModelSeq');//일반상품에서 찍고 들어온값 제거 처리

                    self.rentalBindSideEvents();

                    //BTOCSITE-90937
                    if(rentalInfo){

                        var ajaxUrl = "/mkt/api/exhibit/retrievePlanEventCarePromotionInfo.lgajax";

                        lgkorUI.requestAjaxData(ajaxUrl, {'model_ids' :  lgePdpSendData.modelId}, function(result) {
                            if (result.status === "success" && result.data.length > 0) {
                                const eventPromotionData= result.data[0];
                                self.isEventCarePromotionsDiscount = false;



                                const promtionUrl = '/benefits/exhibitions/detail-'+eventPromotionData.planEventId;
                                if(eventPromotionData.badgeFilterViewFlag === 'Y'){
                                    let boldBadges = $("#rentalBadges span.b2cRentalBadges");
                                    let setBoldBadges = eventPromotionData.badgeFilterText;//

                                    if(setBoldBadges && setBoldBadges.length > 0) {
                                        //기획전 뱃지가 있으면 볼드 뱃지는 지운다.
                                        boldBadges.remove();
                                        // [정리] B2C 전용 뱃지(b2cRentalBadges) append 제거: b2cYN==='Y'는 이 파일에서 항상 false
                                    }
                                }
                                if(eventPromotionData.benefitInfoViewFlag === 'Y'){
                                    $('#rentalExhibitions > a > strong > span').text(eventPromotionData.benefitInfoMainTitle);
                                    $('#rentalExhibitions > a > span').text(eventPromotionData.benefitInfoSubTitle);
                                    $('#rentalExhibitions > a').attr('href',promtionUrl);
                                    if(!partnerRentalInfo || !partnerRentalInfo.length > 0){
                                        $('#rentalExhibitions').show();
                                    }
                                }else{
                                    $('#rentalExhibitions').remove();
                                }
                                // [정리] B2C 전용 엠블럼/기획전 뱃지 표시(emblmViewFlag) 블록 제거: b2cYN!=='N'는 이 파일에서 항상 false

                            }else{
                                $('#rentalExhibitions').remove();
                            }


                            $(document).ready(function() {//화면 로딩후 탭 클립 한번 해 준다.
                            	let tabIdx = 1;
                                // [정리] B2C 전용 임직원 탭 선택 분기 제거: self.partnerRentalInfoData는 삭제된 tab1 활성화 분기에서만 세팅되어 항상 undefined
                                {
                                    if(self.isEventCarePromotionsDiscount){
                                        $("#subscribe-benefit-popup").find('.price-info dl').eq(1).find('div').eq(0).show();
                                    }else{
                                        $("#subscribe-benefit-popup").find('.price-info dl').eq(1).find('div').eq(0).hide();
                                    }

                                    if($('div.pdp-visual-area div.subscribe-flag-box span').length > 0){
                                        $('div.pdp-visual-area div.subscribe-flag-box, div.pdp-visual-inner div.subscribe-flag-box').show();//겔러리 가전 구독 뱃지
                                    }

                                    //BTOCSITE-90937
                                    if($("#badgeTxtRank").val() != "Y"){
                                    	$("#rentalBadges .b2cRentalBadges").show();
                                    }

                                    //BTOCSITE-90937
                                    /*
                                    //기획전 뱃지 제어
                                    if(vcui.isEmpty($('div.rental-badge-wrap > div.rental-discount-badge >span.dscntBadgeTit').text())){
                                    	$('div.rental-badge-wrap > div.rental-discount-badge').hide();
                                    }else{
                                    	$('div.rental-badge-wrap > div.rental-discount-badge').show();
                                    }
                                    */

                                    //다품목 캐시백 배너 제어
                                    subMultiItemBenefit("N");

                                    chgTabEvent(); //BTOCSITE-90937

                                    //일시불 배너 제어
                                    KRP0008.buyFullAreaDisplay();
                                }
                                
                                //로그인 후 선택 옵션값 유지
								if(!vcui.isEmpty(sessionStorage.getItem("optionValArr"))){
									const optionValArr = JSON.parse(sessionStorage.getItem("optionValArr"));
									optionValArr.forEach(function(item){
										$(".detail-option-box input[value='"+item+"']:visible").trigger("click");
									});
									//선택 옵션값 sessionStorage초기화
									sessionStorage.removeItem("optionValArr");
								}

								//제휴카드 할인 선택 이벤트
						        $("input[name='subDscntCard']").on("click", function(){
						        	const dscntPrice = $(this).data("discount-price");
						        	let dscntPricePrefix = "월 최대 -";
						        	$(".subDscntCardTit").text($(this).data("card-name"));
						        	if(dscntPrice == 0){
						        		dscntPricePrefix = "";
						        	}
						        	$(".subCardDscntAmt").text(dscntPricePrefix+vcui.number.addComma($(this).data("discount-price"))+"원");
						        	KRP0008.updateRentalInfoPrice(getOptItemData());
						        });

						        if($("input[name='subDscntCard']").length > 0){
									//페이지 최초 진입시 최대 할인 금액 제휴카드 선택 처리
							        const maxDscntPrice = Math.max.apply(null, $("input[name='subDscntCard']").map(function (){
							            return $(this).data("discount-price");
							        }).get());
							        $("input[name='subDscntCard'][data-discount-price='"+maxDscntPrice+"']").eq(0).prop("checked",true).trigger("click");
						        }else{
						        	KRP0008.updateRentalInfoPrice(getOptItemData());
						        }

						        //구독 모델 옵션 선택 없을시 영역 hidden처리
						        if(vcui.isEmpty($(".subModelOptWrap ul").text().trim())){
						        	$(".subModelOptWrap").hide();
						        }
						        
						        //[BTOCSITE-98681] 선납할인 조회
					        	retrievePrepayDscnt(getOptItemData(), tabIdx);
                                /* [BTOCSITE-103184] [퍼블]After job 프로모션/혜택 - 구독 추가 혜택 스타일 개선 */
                                $('.add-Benefits-list ul').each(function() {
                                    var $visibleLi = $(this).children('li').filter(function() {
                                        return $(this).css('display') !== 'none';
                                    });
                                    // visible li가 1개 또는 2개일 때 첫번째 visible li의 border-top: 0 적용
                                    if ($visibleLi.length <= 2) {
                                        $visibleLi.first().css('border-top', '0');
                                    }
                                });
                                
                                //가전구독 탭, 이용요금, 셀렉트박스 영역 노출 처리
                                $('#rental-care-sibling-option').eq(0).show();
                            });
                        });
                    }
                }

            },"POST", null, null, 150000, null,function(error){
                console.log("error:"+error.statusText);
                }
            );
        },

        reSubDisCount: function(){
            var self = this;
            let param = {
                "modelId": lgePdpSendData.modelId,
                "rentalCareType": 'R',
            };
            lgkorUI.requestAjaxDataPost("/mkt/ajax/product/retrieveReSubFlagCheck", param, function (result) {
                var data = result.data[0];
                
                self.reSubFlagCheck = data.reSubFlag; // 재구독
                var obsLinkOrderOfferFlag = !vcui.isEmpty(data.obsLinkOrderOfferFlag)?data.obsLinkOrderOfferFlag:"N";

                // 가전구독연계 할인 고정 문구
                if(lgkorUI.stringToBool(loginFlag)){
                    if($('#employeePriceTabArea').length > 0){
                        $('#obsLinkOrderOfferLink').show();
                    }else{
                        if(data.obsLinkOrderOfferB2cYn === "Y"){
                            $('#obsLinkOrderOfferLink').show();
                        }else{
                            $('#obsLinkOrderOfferLink').hide();
                        }
                    }
                }else{
                    $('#obsLinkOrderOfferLink').show();
                }

                // 재구독 > 가전연계 순으로 할인
                if(self.reSubFlagCheck == "Y"){

                    $('#rental-info-resub').find('li').each(function(index,item){
                        var $reMaxSalePrice = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('reMaxSalePrice')); //기존 최대혜택가
                        var $years1TotAmt = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('years1Price')); //1년치구독료
                        var $reOrderPrice = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('reorderPrice')); //재구독료
                        var $reSubPrice = $years1TotAmt -$reOrderPrice;
                        let $applyReSubPrice = $('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p');
                        if($reSubPrice < 0){
                            $reSubPrice =0;
                        }

                        if($reOrderPrice > 0){ //재구독료가 있으면 적용
                            if($reMaxSalePrice-$reSubPrice > 0){
                                $applyReSubPrice.html('<span>월</span> '+vcui.number.addComma($reMaxSalePrice-$reSubPrice)+'원'); //재구독 할인가를 적용
                            }else{
                                $applyReSubPrice.html('<span>월</span> 0원'); //기존최대혜택가 - 재구독할인가 = 마이너스인경우
                            }
                        }else{
                            $applyReSubPrice.html('<span>월</span> '+vcui.number.addComma($reMaxSalePrice)+'원'); //재구독가가 없으므로 기존 최대혜택가 적용
                        }

                    });
                }else if(self.reSubFlagCheck === "N" && obsLinkOrderOfferFlag ==="Y"){
                    //BTOCSITE-73428 가전연계
                    $('#rental-info-resub').find('li').each(function(index,item){
                        let $years1TotAmt = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('years1Price')); //일반구독 월구독료
                        let $b2cLinkOrderYears1TotAmt = vcui.number.parse($('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p').data('b2cLinkOrderPrice')); //가전연계 월구독료
                        let $cardDiscountPrice = vcui.number.parse($('#rentalRepresentInfoItem').data('rental-max_price'));//카드할인
                        let $reSubDisCountPrice = $years1TotAmt - $b2cLinkOrderYears1TotAmt; //가전연계 할인가
                        let $applyB2cLinkOrderBenefit = $('#rental-info-resub').find('li').eq(index).find('div.rental-benefit p');

                        //최대혜택가
                        if($b2cLinkOrderYears1TotAmt > 0){

                            if($cardDiscountPrice > 0){
                                //최대혜택가 = 월 이용금액 - 가전연계할인 (일반월구독료 - 가전연계월구독료) - 제휴카드할인
                                var maxSalePrice = $years1TotAmt - $reSubDisCountPrice - $cardDiscountPrice;

                                if(maxSalePrice > 0 && $years1TotAmt > maxSalePrice){
                                    $applyB2cLinkOrderBenefit.html('<span>월</span> '+vcui.number.addComma(maxSalePrice)+'원');
                                }else{
                                    //가전연계 월 구독료가 최대혜택가보다 작으면 0원으로 노출
                                    $applyB2cLinkOrderBenefit.html('<span>월</span> 0원');
                                }
                            }else{
                                $applyB2cLinkOrderBenefit.empty();
                            }
                        }
                    });
                }
            });
        },

        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용
        // rental Option 세팅
        rentalOptionSetting: function(rentalInfo, caresolutionRentalInfoButtonBox,caresolutionRentalInfoTabBox,tabId){
            var self = this;

            //렌탈 가격 정보 정리
            var rentalInfoData = null;

            var defaultSelectRentalOption = {
                selectRtModelSeq:null,
                selectContractDutyTerm:null,
                selectVisitTerm:null,
                selectSvcTypeDesc:null
            }

            // BTOCSITE-51366 :: PDP 렌탈이동 경로개선
            var dispRtModelSeq = '';
            var initDispRtModelSeq = sessionStorage.getItem('dispRtModelSeq');
            //BTOCSITE-102517 네이버 PCS EP 대응 구독 계약별 PDP 노출 페이지 설정
            const urlObj = new URL(location.href);
            const pageParam = urlObj.searchParams;
            const ptype = pageParam.get("ptype");
            if (!vcui.isEmpty(initDispRtModelSeq)) {
                dispRtModelSeq = sessionStorage.getItem('dispRtModelSeq');
            }else if (!vcui.isEmpty(ptype)) {
                dispRtModelSeq = ptype;
            }else{
                dispRtModelSeq = '';
            }


            if(typeof rentalInfo !== 'undefined' && rentalInfo.length > 0) {

                var rentalPriceData = {};
                rentalInfo.forEach(function(item, index) {

                    var contractDutyTerm = (item.contractTerm+"년");
                    var visitPerTxt = item.visitText;
                    var visitPerKey  = visitPerTxt;

                    var svcTypeDesc = (item.svcTypeUseYn === "Y") ? ("" + item.svcTypeDesc) : ""; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성

                    var dataByVisit = rentalPriceData[contractDutyTerm] || {};
                    var dataBySvcTypeDesc = dataByVisit[visitPerKey] || []; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성
                    dataBySvcTypeDesc.push(item);

                    dataByVisit[visitPerKey] = dataBySvcTypeDesc; // 세번째 값
                    rentalPriceData[contractDutyTerm] = dataByVisit; // 첫번째 값

                    //BTOCSITE-51366 :: PDP 렌탈이동 경로개선
                    if(item.rtModelSeq == dispRtModelSeq){
                        defaultSelectRentalOption.selectRtModelSeq = item.rtModelSeq;
                        defaultSelectRentalOption.selectContractDutyTerm = contractDutyTerm;
                        defaultSelectRentalOption.selectVisitTerm =  visitPerTxt;
                        defaultSelectRentalOption.selectSvcTypeDesc = svcTypeDesc;

                        if(partnerRentalInfo.length > 0 && caresolutionRentalInfoTabBox.prop("id") === 'tab2'){
                            self.rentalOpenTab = 'tab2';
                        }
                    }

                    if(
                        dispRtModelSeq === '' &&
                        self.defaultSelectRentalOption.selectRtModelSeq != null &&
                        contractDutyTerm === self.defaultSelectRentalOption.selectContractDutyTerm &&
                        visitPerTxt === self.defaultSelectRentalOption.selectVisitTerm &&
                        svcTypeDesc === self.defaultSelectRentalOption.selectSvcTypeDesc
                    ){
                        defaultSelectRentalOption = self.defaultSelectRentalOption;
                        defaultSelectRentalOption.selectRtModelSeq = item.rtModelSeq;
                    }

                    if(defaultSelectRentalOption.selectRtModelSeq == null && item.representChargeFlag == "Y") {
                        defaultSelectRentalOption.selectRtModelSeq = item.rtModelSeq;
                        defaultSelectRentalOption.selectContractDutyTerm = contractDutyTerm;
                        defaultSelectRentalOption.selectVisitTerm =  visitPerTxt;
                        defaultSelectRentalOption.selectSvcTypeDesc = svcTypeDesc; // BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성
                    }

                    //일반탭 + 재구독 할인가
                    if(caresolutionRentalInfoTabBox.prop("id") === 'tab2' && self.rentalReSubFlag == "Y"){
                        //
                        var reSubDisCountPrice = parseInt(item.years1TotAmt) - parseInt(item.b2cReorderYears1TotAmt);
                        var reSubPrice = parseInt(item.b2cReorderYears1TotAmt);
					}else if(caresolutionRentalInfoTabBox.prop("id") === 'tab2' && self.obsLinkOrderOfferFlag == "Y"){
                        // 일반탭 + 가전연계 할인가
                        var reSubDisCountPrice = parseInt(item.years1TotAmt) - parseInt(item.b2cLinkOrderYears1TotAmt);
                        var reSubPrice = parseInt(item.b2cLinkOrderYears1TotAmt);
					}
                });
                rentalInfoData = rentalPriceData;
            }


            var rentalButtonBoxIndex = {
                rentalButtonBoxIndex1 : 0, //계약의무기간 contractDutyTerm
                rentalButtonBoxIndex2 : 0, //방문주기 visitPer
                rentalButtonBoxIndex3 : 0,
            }


            //최초 기본값 찾기
            if(defaultSelectRentalOption.selectRtModelSeq) {
                // 기본 계약 기간 찾기
                var array = Object.keys(rentalInfoData);
                for (var i = 0, len = array.length; i < len; i++) {
                    if(array[i] == defaultSelectRentalOption.selectContractDutyTerm) {
                        rentalButtonBoxIndex.rentalButtonBoxIndex1 = i;
                        break;
                    }
                }

                // 방문주기 찾기
                var dataByVisit = rentalInfoData[defaultSelectRentalOption.selectContractDutyTerm];
                if(!dataByVisit){//default 값이 없으면
                    dataByVisit = rentalInfoData[Object.keys(rentalInfoData)[0]];
                }
                var array = Object.keys(dataByVisit);
                for (var i = 0, len = array.length; i < len; i++) {
                    if(array[i] == defaultSelectRentalOption.selectVisitTerm) {
                        rentalButtonBoxIndex.rentalButtonBoxIndex2 = i;
                        break;
                    }
                }

                // 서비스타입찾기
                var array = dataByVisit[defaultSelectRentalOption.selectSvcTypeDesc];
                if(!array){//default 값이 없으면
                    array = dataByVisit[Object.keys(dataByVisit)[0]];
                }
                for (var i = 0, len = array.length; i < len; i++) {
                    //BTOCSITE-51366 :: PDP 렌탈이동 경로개선
                    if(array[i].rtModelSeq == dispRtModelSeq){
                        rentalButtonBoxIndex.rentalButtonBoxIndex3 = i;
                        break;
                    }
                    if(rentalButtonBoxIndex.rentalButtonBoxIndex3 == 0 && array[i].representChargeFlag == "Y") {
                        rentalButtonBoxIndex.rentalButtonBoxIndex3 = i;
                        break;
                    }
                }
            }

            self.defaultSelectRentalOption = defaultSelectRentalOption;

            if(rentalInfoData && caresolutionRentalInfoButtonBox.length > 0) {
                //의무사용기간 세팅
                self.rentalInfoButtonBoxUpdate(0,rentalInfoData,rentalButtonBoxIndex.rentalButtonBoxIndex1,'pageLoad', caresolutionRentalInfoButtonBox,tabId);

                //방문주기 세팅
                var key = Object.keys(rentalInfoData)[rentalButtonBoxIndex.rentalButtonBoxIndex1];
                var visitPerData = rentalInfoData[key];

                if(visitPerData) {
                    self.rentalInfoButtonBoxUpdate(1,visitPerData,rentalButtonBoxIndex.rentalButtonBoxIndex2,'pageLoad', caresolutionRentalInfoButtonBox,tabId);

                    // 서비스타입
                    key = Object.keys(visitPerData)[rentalButtonBoxIndex.rentalButtonBoxIndex2];
                    var svcTypeDescData = visitPerData[key]

                    if(svcTypeDescData) {
                        self.rentalInfoButtonBoxUpdate(2,svcTypeDescData,rentalButtonBoxIndex.rentalButtonBoxIndex3,'pageLoad', caresolutionRentalInfoButtonBox,tabId);
                    }
                }
            }

            return rentalInfoData;
        },

        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용
        // rental 값 세팅후 이벤트 연결
        rentalBindSideEvents : function(){
            var self = this;

            const selectBox01EventSet =
                [
                    self.$tab1CaresolutionRentalInfoButtonBox && self.$tab1CaresolutionRentalInfoButtonBox.eq(0),
                    self.$tab2CaresolutionRentalInfoButtonBox && self.$tab2CaresolutionRentalInfoButtonBox.eq(0)
                ];
            selectBox01EventSet.forEach(el =>{
                if(el){

                    el.on('click','dd > ul > li > input',function(e){
                        const {caresolutionRentalInfoButtonBox, tabId} = self.rentalCurrentTabObjects();

                        const itemData = $(this).data('item');
                        self.rentalInfoButtonBoxUpdate(1,itemData,0,'changeEvent', caresolutionRentalInfoButtonBox, tabId);
                    });
                }
            });

            const selectBox02EventSet =
                [
                    self.$tab1CaresolutionRentalInfoButtonBox && self.$tab1CaresolutionRentalInfoButtonBox.eq(1),
                    self.$tab2CaresolutionRentalInfoButtonBox && self.$tab2CaresolutionRentalInfoButtonBox.eq(1)
                ];
            selectBox02EventSet.forEach(el =>{
                if(el){
                    el.on('click','dd > ul > li > input',function(e){
                        const {caresolutionRentalInfoButtonBox,tabId} = self.rentalCurrentTabObjects();


                        const itemData = $(this).data('item');
                        self.rentalInfoButtonBoxUpdate(2,itemData,0,'changeEvent', caresolutionRentalInfoButtonBox,tabId);
                    });
                }
            });

            const selectBox03EventSet =
                [
                    self.$tab1CaresolutionRentalInfoButtonBox && self.$tab1CaresolutionRentalInfoButtonBox.eq(2),
                    self.$tab2CaresolutionRentalInfoButtonBox && self.$tab2CaresolutionRentalInfoButtonBox.eq(2)
                ];
            selectBox03EventSet.forEach(el =>{
                if(el){
                    el.on('click','dd > ul > li > input',function(e){
                    	/* 상품 옵션 선택 이벤트 */
                        const itemData = $(this).data('item');
                        self.updateRentalInfoPrice(itemData);
                        //[BTOCSITE-98681] 선납할인 조회
                        const $tab = $(".product-detail-option").find("ul.tabs li");
                        let tabIdx = 1;
                        if($tab.length > 0){
                        	tabIdx = $tab.index($(".product-detail-option").find("ul.tabs li.on"));
                        }
                    	retrievePrepayDscnt(itemData, tabIdx);
                    });
                }
            });

        },

        //렌탈 케어솔루션 계약기간 셀렉트박스 갱신 펑션
        // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
        // 20220208 BTOCSITE-9177 [렌탈케어] RAC 제품군 런칭에 따른 케어서비스 타입 구분자 생성 수정
        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용 현재 탭 파라미터 추가
        rentalInfoButtonBoxUpdate: function(buttonBoxIndex, selectData, selectIndex, actionType, caresolutionRentalInfoButtonBox, tabId) {
            const self = this;
            const optionButtonTemplate = '<li><input type="radio" name="{{name}}" id="{{id}}" value="{{value}}" {{#if json}}data-item="{{json}}"{{/if}}><label for="{{id}}">{{title}}</label></li>';
            const optionButtonTemplate2 = '<li><input type="radio" name="{{name}}" id="{{id}}" value="{{value}}" {{#if json}}data-item="{{json}}"{{/if}}><label for="{{id}}">{{title}}<span>{{text}}</span></label></li>';

            if(caresolutionRentalInfoButtonBox.eq(buttonBoxIndex)){
                const $buttonBox = caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find("dd > ul");
                $buttonBox.find('li').remove();
                if(selectData instanceof Array) { // 서비스타입
                    let svcTypeTooltipText = []
                    caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).hide();
                    selectData.forEach(function(item, index){
                    	// [정리] B2C 전용 서비스타입 버튼(optionButtonTemplate2) 분기 제거: b2cYN==='Y'는 이 파일에서 항상 false
                    	$buttonBox.append(vcui.template(optionButtonTemplate,{"name":"name_"+tabId+"_"+buttonBoxIndex,"id":"id_"+tabId+"_"+buttonBoxIndex+"_"+index,"value":item.svcTypeCd,"title":item.svcTypeDesc,"json":JSON.stringify(item)}));
                        if(item.svcTypeTooltipText && item.svcTypeTooltipText.length > 0){
                            svcTypeTooltipText.push(item.svcTypeTooltipText);
                        }

                        if(item.svcTypeUseYn === 'Y'){
                            caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).show();
                        }
                    });

                    //서비스 툴팁 설정
                    caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap .bullet-list > li').remove();
                    if(svcTypeTooltipText && svcTypeTooltipText.length > 0){
                        svcTypeTooltipText.forEach(function(item){
                            caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap .bullet-list').append("<li>"+item+"</li>");
                        })

                        if('CT50238004' === lgePdpSendData.categoryId){
                            caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap .bullet-list').append("<li>기본(방문없음/자가관리) : 무상A/S</li>");
                        }

                        caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap').show();
                    }else{
                    	// [정리] B2C 전용 툴팁 노출 분기 제거: b2cYN==='Y'는 이 파일에서 항상 false
                    	caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).find('.tooltip-wrap').hide();
                    }
                }else{
                    Object.keys(selectData).forEach((key, index) => {
                        // 여기서 index 는 현재 반복의 인덱스
                        $buttonBox.append(vcui.template(optionButtonTemplate,{"name":"name_"+tabId+"_"+buttonBoxIndex,"id":"id_"+tabId+"_"+buttonBoxIndex+"_"+index,"value":key,"title": key,"json": JSON.stringify(selectData[key])}));
                    });
                }
            }

            if(actionType === 'pageLoad'){
                $("input[name='name_"+tabId+"_"+buttonBoxIndex+"']").eq(selectIndex).attr("checked",true);
                if(buttonBoxIndex < 2 || (selectData[0].svcTypeCd && selectData[0].svcTypeUseYn === 'Y')) {
                    caresolutionRentalInfoButtonBox.eq(buttonBoxIndex).show();
                }
            }else if(actionType === 'changeEvent'){
                $("input[name='name_"+tabId+"_"+buttonBoxIndex+"']").eq(selectIndex).trigger('click');
            }
        },

        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용
        //구독 페이지 현재 선택된 tab 의 관련 Object 리턴
        rentalCurrentTabObjects : function(){
            if(this.$pdpInfoCareSiblingOption.find('ul.tabs>li').length > 0
                && this.$pdpInfoCareSiblingOption.find('.detail-option-box').hasClass('first')){
                var selectItemData = null;
                selectItemData = this.$tab1CaresolutionRentalInfoButtonBox.eq(2).find("dd > ul > li > input:checked").data('item');

                return {
                    tabId : "tab01",
                    caresolutionRentalInfoSelectBox: null,
                    caresolutionRentalInfoButtonBox: this.$tab1CaresolutionRentalInfoButtonBox,
                    rentalInfoData: this.partnerRentalInfoData,
                    selectItemData: selectItemData,
                    tabBox: this.$tab1CaresolutionRentalInfoTabBox
                };
            }else{
                var selectItemData = null;
                selectItemData = this.$tab2CaresolutionRentalInfoButtonBox.eq(2).find("dd > ul > li > input:checked").data('item');

                return {
                    tabId : "tab02",
                    caresolutionRentalInfoSelectBox: null,
                    caresolutionRentalInfoButtonBox: this.$tab2CaresolutionRentalInfoButtonBox,
                    rentalInfoData: this.rentalInfoData,
                    selectItemData: selectItemData,
                    tabBox: this.$tab2CaresolutionRentalInfoTabBox
                };
            }
        },

        //렌탈 케어솔루션 계약기간 선택에 따른 가격정보 변경
        // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
        // BTOCSITE-62965 [상품] [구독 Task] Sales - 임직원가 적용 현재 탭 파라미터 추가
        updateRentalInfoPrice: function(selectRentalInfoData, caresolutionRentalInfoTabBox) {
            var self = this;

            if(!caresolutionRentalInfoTabBox){
                var currentCaresolutionRentalInfo = self.rentalCurrentTabObjects();
                caresolutionRentalInfoTabBox = currentCaresolutionRentalInfo.tabBox;
            }


            self.selectRentalInfoData = selectRentalInfoData;
            var carePrice = parseInt(selectRentalInfoData.subsMmStandardAmt) - parseInt(selectRentalInfoData.totDiscountAmt);
            var $paymentAmount = self.$pdpInfo.find('.payment-amount');

console.log("rentalReSubFlag : " + self.rentalReSubFlag + " , obsLinkOrderOfferFlag : " + self.obsLinkOrderOfferFlag + " , b2cLinkOrderYears1TotAmt : " + selectRentalInfoData.b2cLinkOrderYears1TotAmt);
            // [정리] 사업자몰 재구독 할인 없음 - reSubPrice(항상 0) 변수 및 관련 표기 제거
            $('#reSubScribePrice').addClass('blind');
            $('#reSubScribePricePop').css('display', 'none');

            //선택된 카드 데이타
            var cardData = $paymentAmount.data('cardData');
            var monthPrice = carePrice;
            if(cardData && cardData.cardSale) {
                monthPrice -= cardData.cardSale;
            }
            if(monthPrice < 0) {
                monthPrice = 0;
            }

            // 구독료 *개월 무료 혜택 표기
            if(selectRentalInfoData.freeMonth){
                var benefitBadge =  '구독료 ' + selectRentalInfoData.freeMonth + '개월 무료';
                caresolutionRentalInfoTabBox.find('div.rental-badge-wrap > div.rental-benefit-badge').html(benefitBadge); // PC
                caresolutionRentalInfoTabBox.find('div.rental-badge-wrap > div.rental-benefit-badge').show(); // PC
                $('.action-sheet').find('div.rental-badge-wrap > div.rental-benefit-badge').html(benefitBadge); // MO
                $('.action-sheet').find('div.rental-badge-wrap > div.rental-benefit-badge').show(); // MO
            }else{
                caresolutionRentalInfoTabBox.find('div.rental-badge-wrap > div.rental-benefit-badge').html(''); // PC
                caresolutionRentalInfoTabBox.find('div.rental-badge-wrap > div.rental-benefit-badge').hide(); // PC
                $('.action-sheet').find('div.rental-badge-wrap > div.rental-benefit-badge').html(''); // MO
                $('.action-sheet').find('div.rental-badge-wrap > div.rental-benefit-badge').hide(); // MO
            }

            let $viewDiscountDetails = caresolutionRentalInfoTabBox.find('.discount-details-rental');//할인 / 혜택 내용보기

            let $viewDiscountDetailsPrice = $viewDiscountDetails.find('dl.price  dd.content');//할인 / 혜택 내용보기  > 할인 이용 요금
            let $viewDiscountDetailsDiscount = $viewDiscountDetails.find('dl.discount  dd.content');//할인 / 혜택 내용보기  > 제휴카드 할인
            let $viewDiscountDetailsPayment = $viewDiscountDetails.find('dl.payment  dd.content span.won');//할인 / 혜택 내용보기  > 최대혜택가

            let $subscribeBenefitPopup = $("#subscribe-benefit-popup");//모바일 최대혜택가 팝업
            let $subscribeBenefitPopupPrice = $subscribeBenefitPopup.find('.price-info dl').eq(0).find('dd span');//모바일 최대혜택가 팝업
            let $subscribeBenefitPopupPriceText = $subscribeBenefitPopup.find('.price-info dl').eq(1).find('div').eq(0).find('dt');
            let $subscribeBenefitPopupPrice2 = $subscribeBenefitPopup.find('.price-info dl').eq(1).find('div').eq(0).find('dd span');
            let $subscribeBenefitPopupDiscount = $subscribeBenefitPopup.find('.price-info dl').eq(1).find('div').eq(2).find('dd span');
            let $subscribeBenefitPopupPayment = $subscribeBenefitPopup.find('.price-info dl').eq(1).find('div.total').find('dd span');

            //월 이용요금
            var $priceInfo = $(".care-sibling-option").find('dl.price-info span.price.is-all-select');
            var $actionSheetPriceInfo = $('.action-sheet .price.is-all-select');

            var innerHtml = '<span class="rate"></span><span class="sub-text2">월 </span>' +
                '<strong class="price-won mo">' + vcui.number.addComma(monthPrice) + '<span>원</span></strong><strong class="price-won pc">' + vcui.number.addComma(monthPrice) + '<span>원</span></strong>';
            var innerHtmlActionSheet = '<span class="sub-text2">월</span> ' + '<strong>' + vcui.number.addComma(monthPrice) + '</strong>원'; //BTOCSITE-59756 [상품] [구독 Task] Sales - 임직원가 적용

            $priceInfo.html(innerHtml);
            $actionSheetPriceInfo.html(innerHtmlActionSheet);
            $subscribeBenefitPopupPrice.html(vcui.number.addComma(monthPrice));
            if(self.isEventCarePromotionsDiscount && caresolutionRentalInfoTabBox.attr('id') === 'tab2'){
                $("#subscribe-benefit-popup").find('.price-info dl').eq(1).find('div').eq(0).show();
            }else{
                $("#subscribe-benefit-popup").find('.price-info dl').eq(1).find('div').eq(0).hide();
            }

            $subscribeBenefitPopupPrice2.html(vcui.number.addComma(monthPrice));

            $viewDiscountDetailsPrice.html('<span class="sub-text"></span><span class="sub-text2">월</span><span class="won">'+vcui.number.addComma(monthPrice)+'원</span>');

            //::BTOCSITE-51891 구독 제휴카드 관련 PDP/팝업 수정의 건
            var $benefitPriceInfo = $(".care-sibling-option").find('div.benefit-info div.benefit-price em');  // 최대혜택가
            var $actionSheetBenefitPriceInfo = $('.action-sheet div.benefit-info div.benefit-price em');//모바일

            // [정리] 사업자몰은 b2cYN==='N'&&bizTypeDetail==='CARETAB' 가드가 이 파일에서 항상 성립해 B2C 기본값(subDscntCard 체크값) 분기는 도달 불가능했음
            let rentalSalePrice = caresolutionRentalInfoTabBox.find('div.benefit-info').data('rental-sale-price'); // 제휴카드할인금액
            if(vcui.isEmpty(rentalSalePrice)){
            	rentalSalePrice = 0;
            }
            var $rentalSalePriceInfo = $('div.promotion-card-info p.card-discount') // 제휴카드할인가

            var finelSalePrice = monthPrice - rentalSalePrice ;

            if(finelSalePrice < 0 ){
                finelSalePrice = 0;
                $rentalSalePriceInfo.html('월 최대<span>-' + vcui.number.addComma(monthPrice) + '원</span>');
                $viewDiscountDetailsDiscount.html('<span class="won">월 최대 -'+vcui.number.addComma(rentalSalePrice)+'원부터</span>');
                $subscribeBenefitPopupDiscount.html('-'+vcui.number.addComma(monthPrice));
            }else{
                $rentalSalePriceInfo.html('월 최대<span>-' + vcui.number.addComma(rentalSalePrice) + '원</span>');
                $viewDiscountDetailsDiscount.html('<span class="won">월 최대 -'+vcui.number.addComma(rentalSalePrice)+'원부터</span>');
                $subscribeBenefitPopupDiscount.html('-'+vcui.number.addComma(rentalSalePrice));
            }

            // [CSR-13847-B] START 임시 조치(Admin 구독카드 혜택 관리 연계 시 이 블록 제거): PC 할인/혜택 내용보기의 제휴카드 할인만 "월 최대 -N원부터"(카드할인금액 원본)로 표기 변경, 0원이면 접두어 없이 금액만. 모바일 팝업(subscribeBenefitPopupDiscount)은 위 기존 if/else가 이미 계산된(capped) 금액으로 세팅해두므로 여기서 건드리지 않음
            if(lgkorUI.getHiddenInputData().b2cYN === 'N' && lgePdpSendData.bizTypeDetail === "CARETAB"){
                var b2bCardDscntText = rentalSalePrice > 0 ? '월 최대 -' + vcui.number.addComma(rentalSalePrice) + '원부터' : vcui.number.addComma(rentalSalePrice) + '원';
                $viewDiscountDetailsDiscount.html('<span class="won">' + b2bCardDscntText + '</span>'); // PC 할인/혜택 내용보기 > 제휴카드 할인
            }
            // [CSR-13847-B] END

            // sonarqube
            $benefitPriceInfo.html(vcui.number.addComma(finelSalePrice)+'<span>원</span>');
            $actionSheetBenefitPriceInfo.html(vcui.number.addComma(finelSalePrice));
            $subscribeBenefitPopupPayment.html(vcui.number.addComma(finelSalePrice));
            $viewDiscountDetailsPayment.html('월 '+vcui.number.addComma(finelSalePrice)+'원');//할인 / 혜택 내용보기  > 최대혜택가

            //가격정보
            var careData = {
                "rtModelSeq":selectRentalInfoData.rtModelSeq,
                "caresolutionSalesCodeSuffix":selectRentalInfoData.caresolutionSalesCodeSuffix,
                "dutyTerm":selectRentalInfoData.dutyTerm,
                "contractTerm":selectRentalInfoData.contractTerm
            }

            //결헙하여 할인받기 링크용 값 추가
            $('#rentalCarePlanerSale').data('add',selectRentalInfoData.rtModelSeq);

            $paymentAmount.data({"careData":careData,"carePrice":carePrice,"price":0});
            $paymentAmount.data('prefix', '월');
            self.updatePaymentAmountPrice($paymentAmount);
            //
            //꼭 확인하세요 부분 케어솔루션 총요금 업데이트
            var selectInfoData = selectRentalInfoData;
            var rtFreePeriod = selectInfoData.rtFreePeriod ? selectInfoData.rtFreePeriod.split(',') : [];
            var infoTotal = 0;
            
            // BTOCSITE-37605 렌탈 PDP 내 총요금 계산 오류 개선 건 START
            // 주문타입에서는 1년차, 2년차, 3년차, 4년차, 5년차, 6년차 이상, 6개로 관리되며 7년차 부터는 6년차 금액을 더하여 총 금액을 산출하는 방식.
            var maxYears = 6; 
            // BTOCSITE-37605 렌탈 PDP 내 총요금 계산 오류 개선 건 END
            
            // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
            var popupData = {
                "rtFreePeriod":selectInfoData.rtFreePeriod,
                "rtFreePeriodCount":rtFreePeriod.length,
            };

            for(var y=1;y<=selectInfoData.contractTerm;y++){
                var key = y+"";
                // 20210923 BTOCSITE-4441 렌탈제품 PDP 내 신규요금제 출시 배너에 대한 문구 수정 요청
                if(selectInfoData.hasOwnProperty('years'+y+'TotAmt') ) {
                    if(!popupData[key]) popupData[key] = {}
                    var price = selectInfoData['years'+y+'TotAmt'] || 0;
                    if(price == 0){
                    	price = selectInfoData['years1TotAmt']
                    }
                    // BTOCSITE-106518 [구독] 일시불PDP 케어십 요금이 0원인 케이스 대응
                    if( price != null && price >= 0 ) {
                        popupData[key].price = price;
                        popupData[key].free = [];
                        infoTotal += (price * 12);
                    }
                }
                
                // BTOCSITE-37605 렌탈 PDP 내 총요금 계산 오류 개선 건 START
                if(y > maxYears) {
                	let price = selectInfoData['years' + maxYears + 'TotAmt'] || 0;
                	 if(price == 0){
                     	price = selectInfoData['years1TotAmt']
                     }
                	infoTotal += (price * 12);
                }
                // BTOCSITE-37605 렌탈 PDP 내 총요금 계산 오류 개선 건 END
            }

            rtFreePeriod.forEach(function(item, index){
                for(var y=1;y<=selectInfoData.contractTerm;y++){
                    // 20210923 BTOCSITE-4441 렌탈제품 PDP 내 신규요금제 출시 배너에 대한 문구 수정 요청
                    if(item <= y*12 && selectInfoData.hasOwnProperty('years'+y+'TotAmt')) {
                        popupData[y+""].free.push(item);
                        break;
                    }
                }
            });
            //BTOCSITE-22218
            var visitPerTxt = "";
            if((selectInfoData.visitPer === '0') || (selectInfoData.careCategoryName = '전기레인지' && parseInt(selectInfoData.visitPer) == 37) ){
                visitPerTxt = '원 ('+selectInfoData.visitText+')';
            }else{
                visitPerTxt = '원 ('+selectInfoData.visitPer+'개월 방문 기준)';
            }

            // 요금제 별 가전구독 할인적용 총요금 설정
            if (typeof selectInfoData['allTotSaleAmt'] !== 'undefined' && selectInfoData['allTotSaleAmt'] != infoTotal) {
                infoTotal = selectInfoData['allTotSaleAmt'];
            }

            // [정리] 사업자몰 미사용 tab1(#rentalPartnerPriceInfoDisp) 분기 제거: tab1이 DOM에 없어 항상 else로 귀결되던 코드
            $infoBox = $("#rentalPriceInfoDisp");
            if(lgkorUI.getHiddenInputData().b2cYN ==='N'){
                $infoBox = $("#b2bRentalPriceInfoDisp");
            }
            $infoBox.find('li:eq(0) div').html("<span class='subsMmStandardAmtTot'></span>"+vcui.number.addComma(infoTotal) + (selectInfoData.visitPer ? visitPerTxt : '원 (대표요금제 기준)')); //::BTOCSITE-51891 //BTOCSITE-21048
            $paymentAmount.data('popupData',popupData);
            
            //BTOCSITE-101724
            // [정리] B2C 전용(개인고객몰) 분기 제거: b2cYN==='N'는 이 파일에서 항상 true
            if(lgkorUI.stringToBool(loginFlag) && self.bsnsType == 'ENT' && self.bsnsMbrStat == 'USE'){
            	$("#specInfoPopup").find(".pop-header").find(".prd-right-price>h5").html("<span>월 "+vcui.number.addComma(monthPrice)+"원</span><b>("+selectInfoData.visitText+")</b>")
            }

            // [정리] B2C 전용 retrieveHalfPeriod() 호출 제거: 함수 전체가 b2cYN=='Y' 단일 조건으로만 이루어져 이 파일에서 항상 no-op
            const subsMmAmtDcRate = self.selectRentalInfoData.subsMmAmtDcRate;
            const subsMmStandardAmt = self.selectRentalInfoData.subsMmStandardAmt;
            $priceInfo.find("span.rate").text("");
            if(!vcui.isEmpty(subsMmAmtDcRate) || !vcui.isEmpty(subsMmStandardAmt)){
	            if(carePrice == subsMmStandardAmt) {
                    $("span.subsMmStandardAmt").text("");
                    $("span.subsMmStandardAmt").parent().hide();
                // b2b 구독 + 개인사업자, 법인사업자 인증회원만 이용요금 확인 가능
                } else if (lgkorUI.getHiddenInputData().b2cYN === 'N' && lgePdpSendData.bizTypeDetail === "CARETAB") {
                    if (lgkorUI.stringToBool(loginFlag) && lgkorUI.getHiddenInputData().memberPartnerGrp == 'ENT'
                        && (lgkorUI.getHiddenInputData().bsnsType == 'ENT' || lgkorUI.getHiddenInputData().bsnsType == 'CORP')) {
                        $("span.subsMmStandardAmt").text("월 "+vcui.number.addComma(subsMmStandardAmt)+"원");
                        $("span.subsMmStandardAmt").parent().show();
                    } else {
                        $("span.subsMmStandardAmt").text("");
                        $("span.subsMmStandardAmt").parent().hide();
                    }
                }else{
	            	$("span.subsMmStandardAmt").text("월 "+vcui.number.addComma(subsMmStandardAmt)+"원");
	            	$("span.subsMmStandardAmt").parent().show();
	            }
	            if(subsMmAmtDcRate >= 5){
	            	$priceInfo.find("span.rate").text(subsMmAmtDcRate+"%");
	            }
                // 할인이 적용된경우 총 요금 노출, 적용되지 않은 계약기간인 경우 미노출
                if(carePrice < subsMmStandardAmt) {
                    const subsMmStandardAmtTot = subsMmStandardAmt * selectInfoData.contractTerm * 12;
                    // [CSR-3827] 할인이 적용된 제품일 경우 정상가 가전구독 총 요금 노출 삭제
                    // $("span.subsMmStandardAmtTot").text(vcui.number.addComma(subsMmStandardAmtTot)+visitPerTxt);
                }
            }else{
            	$("span.subsMmStandardAmt").parent().hide();
            	$("span.subsMmStandardAmtTot").hide();
            }
        },

        //케어십 계약기간 선택에 따른 가격정보 변경
        // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
        updateCareshipInfoPrice: function(selectCareshipInfoData) {
            var self = this;
            if(!selectCareshipInfoData) return;
            self.selectCareshipInfoData = selectCareshipInfoData;
            var carePrice = parseInt(selectCareshipInfoData.years1TotAmt);
            var $paymentAmount = self.$pdpInfo.find('.payment-amount');

            //선택된 카드 데이타
            var cardData = $paymentAmount.data('cardData');
            var monthPrice = carePrice;
            if(cardData && cardData.cardSale) {
                monthPrice -= cardData.cardSale;
            }
            if(monthPrice < 0) {
                monthPrice = 0;
            }
            //월 이용요금
            //[BTOCSITE-73060] 제품 PDP UI 개선 START
            var $careshipPriceInfo = self.$pdpInfoCareshipService.find('#careshipPriceInfo');
            // [정리] B2C 전용 케어십 실사용요금(true-price) 표시 제거: b2cYN==='Y'는 이 파일에서 항상 false
            $careshipPriceInfo.html('월 <strong>' + vcui.number.addComma(monthPrice) + '</strong>원');
            var $priceInfoBenefit = self.$pdpInfoCareshipService.find('#priceBenefitInfo');
            if($priceInfoBenefit){
                if(selectCareshipInfoData.freeMonth){
                    $priceInfoBenefit.show();
                    $priceInfoBenefit.html(selectCareshipInfoData.freeMonth + '개월 무료혜택');
                } else{
                    $priceInfoBenefit.hide();
                    $priceInfoBenefit.html('');
                }
            }
            //[BTOCSITE-73060] 제품 PDP UI 개선 END

            //가격정보
            var careData = {
                "rtModelSeq":selectCareshipInfoData.rtModelSeq,
                "caresolutionSalesCodeSuffix":selectCareshipInfoData.caresolutionSalesCodeSuffix,
                "dutyTerm":selectCareshipInfoData.dutyTerm
            }
            $paymentAmount.data({"careData":careData,"carePrice":carePrice});
            self.updatePaymentAmountPrice($paymentAmount);

            //케어십 할인 혜택 이용요금 팝업용 데이타
            var selectInfoData = selectCareshipInfoData;
            var rtFreePeriod = selectInfoData.rtFreePeriod ? selectInfoData.rtFreePeriod.split(',') : [];
            var infoTotal = 0;

            // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
            var popupData = {
                "rtFreePeriod":selectInfoData.rtFreePeriod,
                "rtFreePeriodCount":rtFreePeriod.length,
            };

            for(var y=1;y<=selectInfoData.contractTerm;y++){
                var key = y+"";
                if(selectInfoData.hasOwnProperty('years'+y+'TotAmt') ) {
                    if(!popupData[key]) popupData[key] = {}
                    var price = selectInfoData['years'+y+'TotAmt'] || 0;
                    // BTOCSITE-106518 [구독] 일시불PDP 케어십 요금이 0원인 케이스 대응
                    if( price != null && price >= 0 ) {
                        popupData[key].price = price;
                        popupData[key].free = [];
                        infoTotal += (price * 12);
                    }
                }
            }

            rtFreePeriod.forEach(function(item, index){
            	if(!vcui.isEmpty(item)){
	                for(var y=1;y<=selectInfoData.contractTerm;y++){
	                    if(item <= y*12 && selectInfoData.hasOwnProperty('years'+y+'TotAmt')) {
	                        popupData[y+""].free.push(item);
	                        break;
	                    }
	                }
            	}
            });

            $paymentAmount.data('popupData',popupData);
        },

        //구매 가격정보 갱신
        updatePaymentAmountPrice: function($paymentAmount, quantityChange) {
            var self = this;

            //렌탈케어 제품인가(일반구매의 케어십과 틀림)
            var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');

            var quantity = $paymentAmount.data('quantity');
            var price = parseInt($paymentAmount.data('price'));
            var carePrice = parseInt($paymentAmount.data('carePrice'));
            var cardData = $paymentAmount.data('cardData');
            //cardData = cardData ? cardData : {};
            var prefix = $paymentAmount.data('prefix');
            prefix = !prefix ? "" : prefix + " ";
            var businessPrice = parseInt($paymentAmount.data('businessPrice'));  //BTOCSITE-48266 b2b일 때 총금액 변경

            let isEmployee = self.additionModel.getIsEmployee();
            let bundleDiscountPrice = isEmployee
                ? vcui.number.parse($('#foldPriceArea').data('employee-bundle-discount-price') || 0)
                : vcui.number.parse($('#foldPriceArea').data('bundle-discount-price') || 0);
            
            var setPrice;
            var $employeeCouponPrice;
            var $priceTotalChk;
            var $priceChk;
            var $priceChk2More;
            var applyCpCnt;
            var isEmployeeTabSelected;
            var isWelfareTabSelected;
            var $employeeCouponMember;
            var $employeeCouponMemberArea;
            var employeeBundleDiscountPrice;
            var initialEmployeeCouponPrice;
            var welfareBundleDiscountPrice;
            var $welfareCouponMember;
            var $welfareCouponMemberArea;
            var initialWelfareCouponPrice;
            var cachedData;
            var userCpPriceNumber;
            var mainProductCouponUnitPrice;
            var finalPrice;
            var currentPartnerType;
            var isWelfareLogin;
            var isEmployeeLogin;

            // 복지몰 쿠폰 초기 가격 계산 헬퍼 함수 (중복 코드 제거)
            var calculateInitialWelfareCouponPrice = function($welfareCouponMemberEl) {
                var initialPrice = null;
                if(typeof _KRP0008_COUPON !== 'undefined' && _KRP0008_COUPON.getInitialCouponPriceByTab('welfare')) {
                    initialPrice = _KRP0008_COUPON.getInitialCouponPriceByTab('welfare');
                } else {
                    // 초기 가격이 없으면 data('price')에서 가져오거나, 없으면 일반 가격 사용
                    initialPrice = $welfareCouponMemberEl.data('price');
                    if(!initialPrice || initialPrice <= 0) {
                        initialPrice = self.partnerPrice;
                    }
                }
                return initialPrice;
            };

            //2021-03-17
            //구매의 케어십은 카드세일을 적용하여 표시하지 않는다 (렌탈케어만 적용해서 표시)
            if(cardData && cardData.cardSale) {
                carePrice -= parseInt(cardData.cardSale);
            }

            var totalPrice = price;
            if(isRentalCareTab) {
                totalPrice = (carePrice ? carePrice : 0);
            }
            //var totalPrice = price + (isRentalCareTab ? (carePrice ? carePrice : 0) : 0);
            //BTOCSITE-48266 b2b일 때 총금액 변경
            if (lgkorUI.stringToBool(loginFlag) && lgkorUI.getHiddenInputData().b2cYN ==='N') {
                totalPrice = businessPrice;
            }
            var $careLi = $paymentAmount.find('li.careship-price-info');
            if($careLi.length > 0 && self.$pdpInfoCareshipService && self.$pdpInfoCareshipService.length > 0) {

                //케어쉽 체크 여부
                var checkinput = self.$pdpInfoCareshipService.find('input[type=radio]:checked');
                if(checkinput.length > 0) {
                    var check = lgkorUI.stringToBool(checkinput.val());
                }

                //if(!carePrice || parseInt(carePrice) <= 0) {
                //케어십 미신청 일경우 케어십 이용요금 숨김
                if(!check) {
                    $careLi.hide();
                    //totalPrice = price;
                } else {
                    if(carePrice < 0) {
                        carePrice = 0;
                    }

                    $careLi.find('span.price').text("월 " + vcui.number.addComma(carePrice) +"원");

                    var $careshipService = $('.careship-service');
                    var checkinput = $careshipService.find('input[type=radio]:checked');
                    if(checkinput.length > 0) {
                        if(lgkorUI.stringToBool(checkinput.val())) {
                            $careLi.show();
                        } else {
                            $careLi.hide();
                            totalPrice = price;
                        }
                    }
                }
            }

            //소모품이 있는가
            var totalAdditional = 0;
            var $additionalPurchase = $('.additional-purchase');
            if($additionalPurchase.length > 0) {
                $additionalPurchase.find('ul.additional-list li').each(function(idx, item){
                    var quantity = $(item).data('quantity');
                    var price = $(item).data('price');
                    price = price || "0";

                    if(typeof price === 'string'){
                        price = vcui.string.replaceAll(price,",","") ;
                    }

                    if(quantity && price) {
                        totalAdditional += (quantity * price);
                    }
                });

                //totalPrice += totalAdditional;
            }

            var $total = self.$actionSheet.find('dl.total-payment span.price');

            // 추가품 가격 계산
            var additionTotalPrice = 0;
            var selectedCount = 0;
            if (self.additionModel && typeof self.additionModel.getSelectedAdditionCount === 'function') {
                selectedCount = self.additionModel.getSelectedAdditionCount();
                if (selectedCount > 0 && typeof self.additionModel.getAdditionTotalPrice === 'function') {
                    // 추가품 총 가격 계산
                    additionTotalPrice = self.additionModel.getAdditionTotalPrice();
                }
            }
            
            // 총 결제 금액 표시
            if (selectedCount > 0) {
                // 본품 가격에 수량 곱하고, 추가품 총 가격(이미 수량 반영됨)을 더함
                $total.html(prefix + '<em>' + vcui.number.addComma((bundleDiscountPrice * quantity) + additionTotalPrice) + '</em>원');
                // 추가품 선택 시에도 calcTotalPrice 호출
                KRP0008.calcTotalPrice(prefix, bundleDiscountPrice, quantity, totalAdditional);
            } else {
                $total.html(prefix + '<em>' + vcui.number.addComma((totalPrice * quantity) + totalAdditional) + '</em>원'); //[BTOCSITE-73060] 제품 PDP UI 개선
                KRP0008.calcTotalPrice(prefix,totalPrice,quantity,totalAdditional);
            }

            //쿠폰 로직 개선
            //BTOCSITE-48266 : b2b 쿠폰가 수정
            if($('.total-coupon-payment').length) {
                var $discountPrice = $('.total-coupon-payment .payment .price');
                applyCpCnt = vcui.number.parse($('.total-coupon-payment .payment').data('cp-max-qty')); //최대구매최대할인수량
                
                if (selectedCount > 0) {
                    // 추가품 선택 시: 본품 번들 할인가(단가)만 쿠폰 API에 전달
                    // 로그인 상태일 때만 쿠폰 API 호출
                    if (typeof _KRP0008_COUPON !== 'undefined' && typeof loginFlag !== 'undefined' && lgkorUI.stringToBool(loginFlag)) {
                        // 번들 쿠폰 데이터가 이미 계산되어 있으면 캐시된 값 직접 사용 (API 호출 없음)
                        if (_KRP0008_COUPON.isBundleCouponCalculated && _KRP0008_COUPON.isBundleCouponCalculated(bundleDiscountPrice)) {
                            cachedData = _KRP0008_COUPON.getBundleCouponData();
                            if (cachedData && cachedData.userCpPrice) {
                                userCpPriceNumber = Number(cachedData.userCpPrice.replaceAll(',', ''));
                                mainProductCouponUnitPrice = bundleDiscountPrice - userCpPriceNumber;
                                if (mainProductCouponUnitPrice < 0) mainProductCouponUnitPrice = 0;
                                finalPrice = (mainProductCouponUnitPrice * quantity) + additionTotalPrice;
                                $discountPrice.html(prefix + '<em>' + vcui.number.addComma(finalPrice) + '</em>원');
                            } else {
                                setPrice = (bundleDiscountPrice * quantity) + additionTotalPrice;
                                $discountPrice.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                            }
                        } else if (quantityChange) {
                            // 번들을 처음 체크했을 때만 API 호출 (quantityChange가 true이고 번들 쿠폰이 계산되지 않았을 때만)
                            _KRP0008_COUPON.requestCouponWithPrice(bundleDiscountPrice, function(resultJson) {
                                if (resultJson && resultJson.data && resultJson.data.userCpPrice) {
                                    userCpPriceNumber = Number(resultJson.data.userCpPrice.replaceAll(',', ''));
                                    // 쿠폰 할인된 본품 단가 계산
                                    mainProductCouponUnitPrice = bundleDiscountPrice - userCpPriceNumber;
                                    if (mainProductCouponUnitPrice < 0) mainProductCouponUnitPrice = 0;
                                    
                                    // (쿠폰 할인된 본품 단가 × 수량) + 추가품 번들 할인가
                                    finalPrice = (mainProductCouponUnitPrice * quantity) + additionTotalPrice;
                                    $discountPrice.html(prefix + '<em>' + vcui.number.addComma(finalPrice) + '</em>원');
                                } else {
                                    // 쿠폰 정보가 없으면 그냥 합산
                                    setPrice = (bundleDiscountPrice * quantity) + additionTotalPrice;
                                    $discountPrice.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                                }
                            });
                        } else {
                            // 수량 변경 시에는 번들 가격만 표시 (API 호출 없음)
                            setPrice = (bundleDiscountPrice * quantity) + additionTotalPrice;
                            $discountPrice.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                        }
                    } else {
                        // 비로그인이거나 _KRP0008_COUPON이 없으면 기존 로직
                        setPrice = (bundleDiscountPrice * quantity) + additionTotalPrice;
                        $discountPrice.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                    }
                } else {
                    // 추가품이 모두 해제된 경우 - 초기 쿠폰 가격 사용
                    var initialCouponPrice = (typeof _KRP0008_COUPON !== 'undefined' && _KRP0008_COUPON.getInitialCouponPrice()) 
                        ? _KRP0008_COUPON.getInitialCouponPrice() 
                        : $discountPrice.data('price');
                    
                    if(applyCpCnt > 0){
                        if( quantity <= applyCpCnt) {
                            $discountPrice.html(prefix + '<em>' + vcui.number.addComma(initialCouponPrice * quantity) + '</em>원');
                        }else{
                            $priceChk = initialCouponPrice * applyCpCnt;
                            $priceChk2More  = (totalPrice * (quantity-applyCpCnt)) + totalAdditional;
                            $priceTotalChk = vcui.number.parse($priceChk) + vcui.number.parse($priceChk2More);
                            $discountPrice.html(prefix + '<em>' + vcui.number.addComma($priceTotalChk) + '</em>원');
                        }
                    }else{
                        $discountPrice.html(prefix + '<em>' + vcui.number.addComma(initialCouponPrice * quantity) + '</em>원');
                    }
                }

            }

            /* BTOCSITE-26123 임직원 할인가 */
            if($('.is-price-calc-new').length && quantityChange) {
                var $employeePrice = $('.is-price-calc-new .payment .price');
                
                if (selectedCount > 0) {
                    // 추가품 선택 시: 본품 가격 × 수량 + 추가품 총액(이미 수량 반영됨)
                    setPrice = (bundleDiscountPrice * quantity) + additionTotalPrice;
                    $employeePrice.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                } else {
                    /* BTOCSITE-73832 제품 번들링 과제 */
                    $employeePrice.html(prefix + '<em>' + vcui.number.addComma((self.partnerPrice * quantity) +  totalAdditional) + '</em>원');
                }

                // 임직원/복지몰 탭 확인 (첫 번째 탭은 임직원/복지몰 탭, 둘 다 동일한 개념)
                isEmployeeTabSelected = false;
                isWelfareTabSelected = false;
                if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                    isEmployeeTabSelected = $('#employeeTab').hasClass('on');
                    // 첫 번째 탭이 선택되었으면 임직원/복지몰 탭 (동일한 개념)
                    // isWelfareTabSelected는 더 이상 사용하지 않음
                }
                
                // 로그인 타입 확인 (AFC: 복지몰, AFF/LGE: 임직원)
                currentPartnerType = typeof digitalData !== 'undefined' && digitalData.userInfo ? digitalData.userInfo.partnerType : '';
                isWelfareLogin = currentPartnerType === 'AFC';
                isEmployeeLogin = currentPartnerType === 'AFF' || currentPartnerType === 'LGE';
                
                // 임직원/복지몰 탭 선택 시 쿠폰할인가 처리 (로그인 타입에 따라 적절한 쿠폰 처리)
                if(isEmployeeTabSelected) {
                    // 임직원 로그인 시 임직원 쿠폰 처리
                    if(isEmployeeLogin) {
                        $employeeCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-member .payment .price');
                        $employeeCouponMemberArea = $employeeCouponMember.closest('.is-coupon-price-calc-new.is-popup-cont-member');
                        var wasEmployeeCouponVisible = $employeeCouponMemberArea.is(':visible') && $employeeCouponMemberArea.data('set-coupon-discount-price') == 'Y';
                        
                        if(selectedCount > 0) {
                            // 추가품 선택 시: 쿠폰할인가 갱신 (번들 선택 전에 노출되어 있으면 계속 노출)
                            // 번들을 처음 체크했을 때만 API 호출 (번들 쿠폰이 계산되지 않았을 때만)
                            if(wasEmployeeCouponVisible && typeof _KRP0008_COUPON !== 'undefined' && typeof loginFlag !== 'undefined' && lgkorUI.stringToBool(loginFlag)) {
                                // 임직원 번들 할인가 가져오기
                                employeeBundleDiscountPrice = vcui.number.parse($('#foldPriceArea').data('employee-bundle-discount-price') || bundleDiscountPrice);
                                
                                // 번들 쿠폰 데이터가 이미 계산되어 있으면 캐시된 값 직접 사용 (API 호출 없음)
                                if (_KRP0008_COUPON.isTabBundleCouponCalculated && _KRP0008_COUPON.isTabBundleCouponCalculated(employeeBundleDiscountPrice, 'member')) {
                                    cachedData = _KRP0008_COUPON.getTabBundleCouponData('member');
                                    if (cachedData && cachedData.userCpPrice) {
                                        userCpPriceNumber = Number(cachedData.userCpPrice.replaceAll(',', ''));
                                        mainProductCouponUnitPrice = employeeBundleDiscountPrice - userCpPriceNumber;
                                        if (mainProductCouponUnitPrice < 0) mainProductCouponUnitPrice = 0;
                                        finalPrice = (mainProductCouponUnitPrice * quantity) + additionTotalPrice;
                                        $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma(finalPrice) + '</em>원');
                                        $employeeCouponMemberArea.show();
                                    } else {
                                        setPrice = (employeeBundleDiscountPrice * quantity) + additionTotalPrice;
                                        $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                                        $employeeCouponMemberArea.show();
                                    }
                                } else if (quantityChange === true && !_KRP0008_COUPON.isTabBundleCouponCalculated(employeeBundleDiscountPrice, 'member')) {
                                    // 번들을 처음 체크했을 때만 API 호출 (quantityChange가 true이고 번들 쿠폰이 계산되지 않았을 때만)
                                    _KRP0008_COUPON.requestCouponWithPriceByTab(employeeBundleDiscountPrice, 'member', function(resultJson) {
                                        if (resultJson && resultJson.data && resultJson.data.userCpPrice) {
                                            userCpPriceNumber = Number(resultJson.data.userCpPrice.replaceAll(',', ''));
                                            // 쿠폰 할인된 본품 단가 계산
                                            mainProductCouponUnitPrice = employeeBundleDiscountPrice - userCpPriceNumber;
                                            if (mainProductCouponUnitPrice < 0) mainProductCouponUnitPrice = 0;
                                            
                                            // (쿠폰 할인된 본품 단가 × 수량) + 추가품 번들 할인가
                                            finalPrice = (mainProductCouponUnitPrice * quantity) + additionTotalPrice;
                                            $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma(finalPrice) + '</em>원');
                                            $employeeCouponMemberArea.show();
                                        } else {
                                            // 쿠폰 정보가 없으면 번들 가격만 표시
                                            setPrice = (employeeBundleDiscountPrice * quantity) + additionTotalPrice;
                                            $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                                            $employeeCouponMemberArea.show();
                                        }
                                    });
                                } else {
                                    // 수량 변경 시에는 번들 가격만 표시 (API 호출 없음)
                                    setPrice = (employeeBundleDiscountPrice * quantity) + additionTotalPrice;
                                    $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                                    $employeeCouponMemberArea.show();
                                }
                            } else if(!wasEmployeeCouponVisible) {
                                // 번들 선택 전에 노출되지 않았으면 숨김
                                $employeeCouponMemberArea.hide();
                            }
                        } else if($employeeCouponMember.length > 0 && $employeeCouponMemberArea.length > 0) {
                            // 추가품이 모두 해제된 경우 - 초기 쿠폰 가격 사용
                            applyCpCnt = vcui.number.parse($employeeCouponMember.closest('.payment').data('cp-max-qty')); //최대구매최대할인수량
                            
                            initialEmployeeCouponPrice = null;
                            if(typeof _KRP0008_COUPON !== 'undefined' && _KRP0008_COUPON.getInitialCouponPriceByTab('member')) {
                                initialEmployeeCouponPrice = _KRP0008_COUPON.getInitialCouponPriceByTab('member');
                            } else {
                                // 초기 가격을 data('price')에서 가져오거나, 없으면 일반 가격 사용
                                initialEmployeeCouponPrice = $employeeCouponMember.data('price');
                                if(!initialEmployeeCouponPrice || initialEmployeeCouponPrice <= 0) {
                                    initialEmployeeCouponPrice = self.partnerPrice;
                                }
                            }
                            
                            // 초기 쿠폰 가격이 유효하고, 실제 쿠폰이 있는 경우에만 업데이트 (set-coupon-discount-price가 'Y'일 때만)
                            if(initialEmployeeCouponPrice && initialEmployeeCouponPrice > 0 && $employeeCouponMemberArea.data('set-coupon-discount-price') == 'Y') {
                                if(applyCpCnt > 0){
                                    if( quantity <= applyCpCnt) {
                                        $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma(initialEmployeeCouponPrice * quantity) + '</em>원');
                                    }else{
                                        $priceChk = initialEmployeeCouponPrice * applyCpCnt;
                                        $priceChk2More  = (self.partnerPrice * (quantity-applyCpCnt)) + totalAdditional;
                                        $priceTotalChk = vcui.number.parse($priceChk) + vcui.number.parse($priceChk2More);
                                        $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma($priceTotalChk) + '</em>원');
                                    }
                                }else{
                                    $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma(initialEmployeeCouponPrice * quantity) + '</em>원');
                                }
                                $employeeCouponMemberArea.show();
                            }
                        }
                    }
                    // 복지몰 로그인 시 복지몰 쿠폰 처리
                    else if(isWelfareLogin) {
                        $welfareCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-welfare .payment .price');
                        $welfareCouponMemberArea = $welfareCouponMember.closest('.is-coupon-price-calc-new.is-popup-cont-welfare');
                        var wasWelfareCouponVisible = $welfareCouponMemberArea.is(':visible') && $welfareCouponMemberArea.data('set-coupon-discount-price') == 'Y';
                        
                        if(selectedCount > 0) {
                            // 추가품 선택 시: 쿠폰할인가 갱신 (번들 선택 전에 노출되어 있으면 계속 노출)
                            // 번들을 처음 체크했을 때만 API 호출 (번들 쿠폰이 계산되지 않았을 때만)
                            if(wasWelfareCouponVisible && typeof _KRP0008_COUPON !== 'undefined' && typeof loginFlag !== 'undefined' && lgkorUI.stringToBool(loginFlag)) {
                                // 복지몰 번들 할인가 가져오기 (임직원 번들 할인가와 동일하게 사용)
                                welfareBundleDiscountPrice = vcui.number.parse($('#foldPriceArea').data('employee-bundle-discount-price') || bundleDiscountPrice);
                                
                                // 번들 쿠폰 데이터가 이미 계산되어 있으면 캐시된 값 직접 사용 (API 호출 없음)
                                if (_KRP0008_COUPON.isTabBundleCouponCalculated && _KRP0008_COUPON.isTabBundleCouponCalculated(welfareBundleDiscountPrice, 'welfare')) {
                                    cachedData = _KRP0008_COUPON.getTabBundleCouponData('welfare');
                                    if (cachedData && cachedData.userCpPrice) {
                                        userCpPriceNumber = Number(cachedData.userCpPrice.replaceAll(',', ''));
                                        mainProductCouponUnitPrice = welfareBundleDiscountPrice - userCpPriceNumber;
                                        if (mainProductCouponUnitPrice < 0) mainProductCouponUnitPrice = 0;
                                        finalPrice = (mainProductCouponUnitPrice * quantity) + additionTotalPrice;
                                        $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma(finalPrice) + '</em>원');
                                        $welfareCouponMemberArea.show();
                                    } else {
                                        setPrice = (welfareBundleDiscountPrice * quantity) + additionTotalPrice;
                                        $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                                        $welfareCouponMemberArea.show();
                                    }
                                } else if (quantityChange === true && !_KRP0008_COUPON.isTabBundleCouponCalculated(welfareBundleDiscountPrice, 'welfare')) {
                                    // 번들을 처음 체크했을 때만 API 호출 (quantityChange가 true이고 번들 쿠폰이 계산되지 않았을 때만)
                                    _KRP0008_COUPON.requestCouponWithPriceByTab(welfareBundleDiscountPrice, 'welfare', function(resultJson) {
                                        if (resultJson && resultJson.data && resultJson.data.userCpPrice) {
                                            userCpPriceNumber = Number(resultJson.data.userCpPrice.replaceAll(',', ''));
                                            // 쿠폰 할인된 본품 단가 계산
                                            mainProductCouponUnitPrice = welfareBundleDiscountPrice - userCpPriceNumber;
                                            if (mainProductCouponUnitPrice < 0) mainProductCouponUnitPrice = 0;
                                            
                                            // (쿠폰 할인된 본품 단가 × 수량) + 추가품 번들 할인가
                                            finalPrice = (mainProductCouponUnitPrice * quantity) + additionTotalPrice;
                                            $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma(finalPrice) + '</em>원');
                                            $welfareCouponMemberArea.show();
                                        } else {
                                            // 쿠폰 정보가 없으면 번들 가격만 표시
                                            setPrice = (welfareBundleDiscountPrice * quantity) + additionTotalPrice;
                                            $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                                            $welfareCouponMemberArea.show();
                                        }
                                    });
                                } else {
                                    // 수량 변경 시에는 번들 가격만 표시 (API 호출 없음)
                                    setPrice = (welfareBundleDiscountPrice * quantity) + additionTotalPrice;
                                    $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma(setPrice) + '</em>원');
                                    $welfareCouponMemberArea.show();
                                }
                            } else if(!wasWelfareCouponVisible) {
                                // 번들 선택 전에 노출되지 않았으면 숨김
                                $welfareCouponMemberArea.hide();
                            }
                        } else if($welfareCouponMember.length > 0 && $welfareCouponMemberArea.length > 0) {
                            // 추가품이 모두 해제된 경우 - 초기 쿠폰 가격 사용
                            applyCpCnt = vcui.number.parse($welfareCouponMember.closest('.payment').data('cp-max-qty')); //최대구매최대할인수량
                            
                            // 초기 쿠폰 가격이 유효한 경우에만 업데이트
                            initialWelfareCouponPrice = null;
                            if(typeof _KRP0008_COUPON !== 'undefined' && _KRP0008_COUPON.getInitialCouponPriceByTab('welfare')) {
                                initialWelfareCouponPrice = _KRP0008_COUPON.getInitialCouponPriceByTab('welfare');
                            } else {
                                // 초기 가격을 data('price')에서 가져오거나, 없으면 일반 가격 사용
                                initialWelfareCouponPrice = $welfareCouponMember.data('price');
                                if(!initialWelfareCouponPrice || initialWelfareCouponPrice <= 0) {
                                    initialWelfareCouponPrice = self.partnerPrice;
                                }
                            }

                            // 초기 쿠폰 가격이 유효하고, 실제 쿠폰이 있는 경우에만 업데이트 (set-coupon-discount-price가 'Y'일 때만)
                            if(initialWelfareCouponPrice && initialWelfareCouponPrice > 0 && $welfareCouponMemberArea.data('set-coupon-discount-price') == 'Y') {
                                if(applyCpCnt > 0){
                                    if( quantity <= applyCpCnt) {
                                        $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma(initialWelfareCouponPrice * quantity) + '</em>원');
                                    }else{
                                        $priceChk = initialWelfareCouponPrice * applyCpCnt;
                                        $priceChk2More  = (self.partnerPrice * (quantity-applyCpCnt)) + totalAdditional;
                                        $priceTotalChk = vcui.number.parse($priceChk) + vcui.number.parse($priceChk2More);
                                        $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma($priceTotalChk) + '</em>원');
                                    }
                                }else{
                                    $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma(initialWelfareCouponPrice * quantity) + '</em>원');
                                }
                                $welfareCouponMemberArea.show();
                            }
                        }
                    }
                }

            }

                // 번들 해제 시 임직원/복지몰 쿠폰할인가 복원 (quantityChange와 관계없이 실행)
            if($('.is-price-calc-new').length && selectedCount === 0 && !quantityChange) {
                // 임직원/복지몰 탭 확인 (첫 번째 탭은 임직원/복지몰 탭, 둘 다 동일한 개념)
                isEmployeeTabSelected = false;
                if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                    isEmployeeTabSelected = $('#employeeTab').hasClass('on');
                }
                
                // 로그인 타입 확인 (AFC: 복지몰, AFF/LGE: 임직원)
                currentPartnerType = typeof digitalData !== 'undefined' && digitalData.userInfo ? digitalData.userInfo.partnerType : '';
                isWelfareLogin = currentPartnerType === 'AFC';
                isEmployeeLogin = currentPartnerType === 'AFF' || currentPartnerType === 'LGE';
                
                // 임직원/복지몰 탭 선택 시 쿠폰할인가 복원 (로그인 타입에 따라 적절한 쿠폰 처리)
                if(isEmployeeTabSelected) {
                    // 임직원 로그인 시 임직원 쿠폰 복원
                    if(isEmployeeLogin) {
                        $employeeCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-member .payment .price');
                        $employeeCouponMemberArea = $employeeCouponMember.closest('.is-coupon-price-calc-new.is-popup-cont-member');
                        
                        if($employeeCouponMember.length > 0 && $employeeCouponMemberArea.length > 0) {
                            applyCpCnt = vcui.number.parse($employeeCouponMember.closest('.payment').data('cp-max-qty')); //최대구매최대할인수량
                            
                            initialEmployeeCouponPrice = null;
                            if(typeof _KRP0008_COUPON !== 'undefined' && _KRP0008_COUPON.getInitialCouponPriceByTab('member')) {
                                initialEmployeeCouponPrice = _KRP0008_COUPON.getInitialCouponPriceByTab('member');
                            } else {
                                // 초기 가격을 data('price')에서 가져오거나, 없으면 일반 가격 사용
                                initialEmployeeCouponPrice = $employeeCouponMember.data('price');
                                if(!initialEmployeeCouponPrice || initialEmployeeCouponPrice <= 0) {
                                    initialEmployeeCouponPrice = self.partnerPrice;
                                }
                            }
                            
                            // 초기 쿠폰 가격이 유효하고, 실제 쿠폰이 있는 경우에만 업데이트 (set-coupon-discount-price가 'Y'일 때만)
                            if(initialEmployeeCouponPrice && initialEmployeeCouponPrice > 0 && $employeeCouponMemberArea.data('set-coupon-discount-price') == 'Y') {
                                if(applyCpCnt > 0){
                                    if( quantity <= applyCpCnt) {
                                        $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma(initialEmployeeCouponPrice * quantity) + '</em>원');
                                    }else{
                                        $priceChk = initialEmployeeCouponPrice * applyCpCnt;
                                        $priceChk2More  = (self.partnerPrice * (quantity-applyCpCnt)) + totalAdditional;
                                        $priceTotalChk = vcui.number.parse($priceChk) + vcui.number.parse($priceChk2More);
                                        $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma($priceTotalChk) + '</em>원');
                                    }
                                }else{
                                    $employeeCouponMember.html(prefix + '<em>' + vcui.number.addComma(initialEmployeeCouponPrice * quantity) + '</em>원');
                                }
                                $employeeCouponMemberArea.show();
                            }
                        }
                    }
                    // 복지몰 로그인 시 복지몰 쿠폰 복원
                    else if(isWelfareLogin) {
                        $welfareCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-welfare .payment .price');
                        $welfareCouponMemberArea = $welfareCouponMember.closest('.is-coupon-price-calc-new.is-popup-cont-welfare');
                        
                        if($welfareCouponMember.length > 0 && $welfareCouponMemberArea.length > 0) {
                            applyCpCnt = vcui.number.parse($welfareCouponMember.closest('.payment').data('cp-max-qty')); //최대구매최대할인수량
                            
                            initialWelfareCouponPrice = null;
                            if(typeof _KRP0008_COUPON !== 'undefined' && _KRP0008_COUPON.getInitialCouponPriceByTab('welfare')) {
                                initialWelfareCouponPrice = _KRP0008_COUPON.getInitialCouponPriceByTab('welfare');
                            } else {
                                // 초기 가격을 data('price')에서 가져오거나, 없으면 일반 가격 사용
                                initialWelfareCouponPrice = $welfareCouponMember.data('price');
                                if(!initialWelfareCouponPrice || initialWelfareCouponPrice <= 0) {
                                    initialWelfareCouponPrice = self.partnerPrice;
                                }
                            }
                            
                            // 초기 쿠폰 가격이 유효하고, 실제 쿠폰이 있는 경우에만 업데이트 (set-coupon-discount-price가 'Y'일 때만)
                            if(initialWelfareCouponPrice && initialWelfareCouponPrice > 0 && $welfareCouponMemberArea.data('set-coupon-discount-price') == 'Y') {
                                if(applyCpCnt > 0){
                                    if( quantity <= applyCpCnt) {
                                        $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma(initialWelfareCouponPrice * quantity) + '</em>원');
                                    }else{
                                        $priceChk = initialWelfareCouponPrice * applyCpCnt;
                                        $priceChk2More  = (self.partnerPrice * (quantity-applyCpCnt)) + totalAdditional;
                                        $priceTotalChk = vcui.number.parse($priceChk) + vcui.number.parse($priceChk2More);
                                        $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma($priceTotalChk) + '</em>원');
                                    }
                                }else{
                                    $welfareCouponMember.html(prefix + '<em>' + vcui.number.addComma(initialWelfareCouponPrice * quantity) + '</em>원');
                                }
                                $welfareCouponMemberArea.show();
                            }
                        }
                    }
                }
            }

            if($('#employeeDisposableTotalPriceArea').length && quantityChange){
                var $employeeDisposablePrice = $('#employeeDisposableTotalPriceArea .content .price');
                
                if (selectedCount > 0) {
                    // 추가품 선택 시: 본품 번들할인가 × 수량 + 추가품 총액(이미 수량 반영됨)
                    setPrice = (bundleDiscountPrice * quantity) + additionTotalPrice;
                    $employeeDisposablePrice.text(prefix + vcui.number.addComma(setPrice) + '원');
                } else {
                    $employeeDisposablePrice.text(prefix + vcui.number.addComma((self.partnerPrice * quantity) +  totalAdditional) + '원');
                }

                // BTOCSITE-68092 임직원 소모품 쿠폰
                // 임직원 탭일 때만 임직원 쿠폰 가격 업데이트
                // 쿠폰할인가가 실제로 있을 때만 업데이트 (set-coupon-discount-price가 'Y'일 때만)
                // 번들(추가품)이 선택되었을 때는 쿠폰할인가를 표시하지 않음
                isEmployeeTabSelected = false;
                if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                    isEmployeeTabSelected = $('#employeeTab').hasClass('on');
                }
                
                if(isEmployeeTabSelected) {
                    $employeeCouponPrice = $('.is-coupon-price-calc-new .payment .price');
                    
                    // 번들이 선택되었을 때는 쿠폰할인가를 숨김
                    if (selectedCount > 0) {
                        $employeeCouponPrice.closest('.is-coupon-price-calc-new').hide();
                    } else if($employeeCouponPrice.length > 0 && $employeeCouponPrice.data('set-coupon-discount-price') == 'Y') {
                        // 쿠폰할인가가 실제로 있을 때만 업데이트
                        applyCpCnt = vcui.number.parse($('.is-coupon-price-calc-new .payment').data('cp-max-qty')); //최대구매최대할인수량
                        
                        var couponPrice = $employeeCouponPrice.data('price');
                        // 쿠폰 가격이 유효한 경우에만 업데이트
                        if(couponPrice && couponPrice > 0) {
                            if(applyCpCnt > 0){
                                if( quantity <= applyCpCnt) {
                                    $employeeCouponPrice.html(prefix + '<em>' + vcui.number.addComma(couponPrice * quantity) + '</em>원'); // 기존로직
                                }else{
                                    $priceChk = couponPrice * applyCpCnt;
                                    //var $priceChk2More  = (totalPrice * (quantity-applyCpCnt)) + totalAdditional;
                                    $priceChk2More = (self.partnerPrice * (quantity-applyCpCnt)) +  totalAdditional;
                                    $priceTotalChk = vcui.number.parse($priceChk) + vcui.number.parse($priceChk2More);
                                    $employeeCouponPrice.html(prefix + '<em>' + vcui.number.addComma($priceTotalChk) + '</em>원');
                                }
                            }else{
                                $employeeCouponPrice.html(prefix + '<em>' + vcui.number.addComma(couponPrice * quantity) + '</em>원'); // 기존로직
                            }
                        }
                    }
                }
            }
            /* BTOCSITE-26123 임직원 할인가 */
        },

        //케어솔루션 선택 여부에 따른 구매수량 버튼 활성/비활성
        updatePaymentAmountState: function($paymentAmount, isCare) {
            var self = this;
            var isQtyChange = false; // BTOCSITE-32528
            if(isCare) {
                //케어십 신청됐으므로 수량체크버튼 비활성
                $paymentAmount.find('button.minus').attr('disabled',true);
                $paymentAmount.find('button.plus').attr('disabled',true);
                if ($paymentAmount.data('quantity') != 1) {
                    $paymentAmount.find('input.quantity').val(1);
                    $paymentAmount.data('quantity',1);
                    isQtyChange = true;
                }
                // $paymentAmount.find('>.info-text').show(); // BTOSITE-55778

                //[BTOCSITE-73060] 제품 PDP UI 개선 start
                $paymentAmount.find('#quantity').attr('disabled',true);
                // 케어십일 때 qtyNotice 숨기기 (PC/모바일 모두)
                $paymentAmount.find('#qtyNotice').hide();
                $paymentAmount.find('#qtyNoticeMobile').hide();
                $paymentAmount.find('#careshipQtyNotice').show();
                //[BTOCSITE-73060] 제품 PDP UI 개선 end
            } else {
                //수량체크버튼 활성
                var $input = $paymentAmount.find('input.quantity');
                if(parseInt($input.val()) == 1) {
                    $paymentAmount.find('button.minus').attr('disabled',true);
                    $paymentAmount.find('button.plus').attr('disabled',false);
                } else {
                    $paymentAmount.find('button.minus').attr('disabled',false);
                    $paymentAmount.find('button.plus').attr('disabled',false);
                    isQtyChange = true;
                }
                // $paymentAmount.find('>.info-text').hide(); // BTOSITE-55778
                //[BTOCSITE-73060] 제품 PDP UI 개선 start
                $paymentAmount.find('#quantity').attr('disabled',false);

                // purchaseLimitQty가 있을 때만 qtyNotice와 qtyNoticeMobile 표시
                var $countCheckArea = $('.box.payment-amount.count-check');
                var purchaseLimitQty = parseInt($countCheckArea.data('purchase-limit-qty'));
                var isMobile = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;
                var $qtyNotice = $paymentAmount.find('#qtyNotice');
                var $qtyNoticeMobile = $paymentAmount.find('#qtyNoticeMobile');
                
                if (purchaseLimitQty && purchaseLimitQty > 0) {
                    // purchaseLimitQty가 있을 때만 표시
                    if (isMobile) {
                        // 모바일: qtyNoticeMobile만 표시
                        if ($qtyNoticeMobile.length > 0) {
                            $qtyNoticeMobile.show();
                        }
                        // PC용 qtyNotice는 숨김
                        if ($qtyNotice.length > 0) {
                            $qtyNotice.hide();
                        }
                    } else {
                        // PC: qtyNotice만 표시
                        if ($qtyNotice.length > 0) {
                            $qtyNotice.show();
                        }
                        // 모바일용 qtyNoticeMobile은 숨김
                        if ($qtyNoticeMobile.length > 0) {
                            $qtyNoticeMobile.hide();
                        }
                    }
                } else {
                    // purchaseLimitQty가 없으면 숨김
                    $qtyNotice.hide();
                    $qtyNoticeMobile.hide();
                }

                $paymentAmount.find('#careshipQtyNotice').hide();
                //[BTOCSITE-73060] 제품 PDP UI 개선 end
            }

            self.updatePaymentAmountPrice($paymentAmount, isQtyChange);
        },

        //구매진행
        productBuy: function($dm, eventTarget) {
            var self = this;

          //BTOCSITE-109874 NetFunnel
        	updateNfStartSection(function(){
        		// BTOCSITE-85293 START
        		self.preCheckTermAndCondition(false, function() {

        			//홈브류 제품 로그인 안내 뛰우기
        			if (location.href.indexOf("lg-homebrew") > -1 && !lgkorUI.stringToBool(loginFlag)) {
        				if(eventTarget) {
        					$('#memberBuyGuide').vcModal({opener: eventTarget});
        				} else {
        					$('#memberBuyGuide').vcModal();
        				}
        				return;
        			};

        			if (lgePdpSendData.isTimeDeal && !lgkorUI.stringToBool(loginFlag)) { // BTOCSITE-49751 [상품] 딜 플랫폼
        				const timeDealLoginPopup = $('article#alertNew6');
        				timeDealLoginPopup.vcModal({opener: eventTarget}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
        				return;
        			}

        			self.processProductBuy = null;

        			var tempSendData = JSON.parse(JSON.stringify(lgePdpSendData));
        			var $paymentAmount = $dm.parents('.payment-amount');

        			//렌탈케어 제품인가(일반구매의 케어십과 틀림)
        			var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');

        			//구매타입
        			var isRental = false;
        			var param = {};
        			if(typeof modelGubun !== 'undefined') {
        				if(modelGubun == "1" || modelGubun == "2") {
        					param.order_type = "NB";
        				} else if(modelGubun == "3") {
        					param.order_type = "SM";
        				}
        			}

        			param.id = lgePdpSendData.id;

        			//소모품이 있는가
        			var cart = [];
        			var $additionalPurchase = $('.additional-purchase');
        			if($additionalPurchase.length > 0) {
        				$additionalPurchase.find('ul.additional-list li').each(function(idx, item){
        					cart.push({
        						"sku":$(item).data('id'),
        						"quantity":$(item).data('quantity')
        					});
        					if(param.order_type == "NB") {
        						param.order_type = "NS";
        					}
        				});
        			}

        			//케어십 선택
        			//오더타입 교체할것
        			var $careshipService = $('.careship-service');
        			var checkinput = $careshipService.find('input[type=radio]:checked');
        			if(checkinput.length > 0) {
        				isRental = lgkorUI.stringToBool(checkinput.val());
        			} else {
        				var $careSiblingOption = $('.care-sibling-option').eq(0);
        				//케어쉽필수 제품인지 체크해서 알림창 뛰움
        				if($careSiblingOption.length < 1) {
        					if(careRequire) {
        						//$('#careRequireBuyPopup').vcModal();
        						isRental = true;
        					}
        				} else {
        					isRental = true;
        				}
        			}

        			//선택 수량
        			var quantity = self.$actionSheet.find('div.select-quantity input.quantity');
        			if(quantity.length > 0) {
        				cart.push({
        					"sku":tempSendData.sku,
        					"quantity":quantity.val()
        				});
        			} else if (preOrderFlag && tempSendData.modelStatusCode === "READY_FOR_SALE") { /* BTOCSITE-34432 사전예약 */
        				cart.push({
        					"sku":tempSendData.sku,
        					"quantity":"1"
        				});
        			}

        			//렌탈타입
        			var careData = $paymentAmount.data('careData');

        			if(careData) {
        				param.rtModelSeq = careData.rtModelSeq;
        				//BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start
        				var modelList = [];
        				var modelMap = {
        						"modelId":lgePdpSendData.id,
        						"sku":lgePdpSendData.sku,
        						"rtModelSeq":careData.rtModelSeq,
        						"bizType":lgePdpSendData.bizType,
        						"itemSeq":'1'
        				};
        				modelList.push(modelMap);
        				param.modelList = JSON.stringify(modelList);
        				//BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 end
        			}

        			var cardData = $paymentAmount.data('cardData');
        			if(cardData) {
        				if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
        					//간편신청카드
        					param.easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
        				}
        			}

        			/*
                //선택된 케어쉽
                var careData = $paymentAmount.data('careData');
                if(careData) {
                    param.rtModelSeq = careData.rtModelSeq;
                    param.caresolutionSalesCodeSuffix = careData.caresolutionSalesCodeSuffix;
                }
                //선택된 카드
                var cardData = $paymentAmount.data('cardData');
                if(cardData && cardData.cardNameCode) {
                    console.log(cardData);
                    param.cardNameCode = cardData.cardNameCode;
                }
        			 */
        			if(cart.length > 0) {
        				var cart_items = [];
        				cart.forEach(function(obj,idx){
        					cart_items.push({"data":obj});
        				});
        				param.cart_items = cart_items;
        				param.order_item_qty = cart_items.length;
        			}

        			//BTOCSITE-45195 임직원몰 개선(임직원 전용제품 적용)
        			let inputdata = lgkorUI.getHiddenInputData();

        			var ajaxUrl;
        			//BTOCSITE-6011
        			if(isRental) {
        				// BTOCSITE-80498 렌탈 신청
        				if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
        					KRP0008.csSubscribeClickRecordEvent();
        				}

        				var isDirectBuy = !$paymentAmount.find('.purchase-button').hasClass('rental');

        				if( (careshipOnlyFlag == 'Y') && (!careShipInfo.length) && isDirectBuy ){
        					ajaxUrl = self.$pdpInfo.attr('data-buy-url');
        					//ajaxUrl = "https://wwwdev50.lge.co.kr/mkt/product/addCartDirectPurchase.lgajax"
        					if(ajaxUrl) {
        						lgkorUI.showLoading();
        						lgkorUI.requestAjaxDataPost(ajaxUrl, param, function(result){
        							//console.log(result);
        							var data = result.data;
        							var obsDirectPurchaseUrl = data.obsDirectPurchaseUrl;
        							if(obsDirectPurchaseUrl){
        								location.href = obsDirectPurchaseUrl;
        							}
        						});
        					}
        				}else{
        					if(self.loginCheckEnd) {

        						if(lgkorUI.stringToBool(loginFlag)) {
        							ajaxUrl = self.$pdpInfo.attr('data-rental-url');
        							//var url = ajaxUrl + "?rtModelSeq=" + param.rtModelSeq + (param.easyRequestCard ? ("&easyRequestCard=" + param.easyRequestCard) : "");
        							if(ajaxUrl) {
        								if(isDirectBuy) {
        									//$('#careRequireBuyPopup').data('sendUrl',url);
        									$('#careRequireBuyPopup').data('rtModelSeq',param.rtModelSeq);
        									$('#careRequireBuyPopup').data('easyRequestCard',param.easyRequestCard);
        									/*
                                        $('#careRequireBuyPopup').find('.btn-group button').removeAttr('data-link-url');
                                        $('#careRequireBuyPopup').off('.goto').on('click.goto','.btn-group button',function(e){
                                            console.log($('#careRequireBuyPopup').data('sendUrl'));
                                            location.href = $('#careRequireBuyPopup').data('sendUrl');
                                        });
        									 */
        									var isCare = lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab';

        									if(!isCare){
        										if(eventTarget) {
        											$('#careRequireBuyPopup').vcModal({opener: eventTarget});
        										} else {
        											$('#careRequireBuyPopup').vcModal();
        										}
        									}
        								} else {
        									if($paymentAmount){
        										if($paymentAmount.data('careData')){
        											//BTOCSITE-49721 UP가전2.0 고도화 통합장바구니기능구현 start - request form 변경에 따라 submit 으로 구조변경.
        											var easyRequestCard = '';
        											var modelList = [];
        											var modelMap = {
        													"modelId":null,
        													"sku":null,
        													"rtModelSeq":$paymentAmount.data('careData').rtModelSeq,
        													"bizType":null,
        													"itemSeq":'1'
        											};
        											modelList.push(modelMap);
        											let careData = $paymentAmount.data('careData');
        											if(cardData) {
        												if(lgkorUI.stringToBool(cardData.simpleReqFlag)) {
        													//간편신청카드
        													easyRequestCard = cardData.cardNameCode + "|" + cardData.cardSubName;
        												}
        											}
        											// submit
        											ajaxUrl = self.$pdpInfo.attr('data-rental-url');

        											setTimeout(function(e){

        												let $careSubmitForm = $('<form method="post" action="/order-to-pay/care-pre-check"><input type="text" name="modelList"/><input type="text" name="easyRequestCard"/></form>');
        												if(lgkorUI.getHiddenInputData().b2cYN == 'N'){
        													$careSubmitForm = $('<form method="post" action="/business/order-to-pay/care-pre-check"><input type="text" name="modelList"/><input type="text" name="easyRequestCard"/></form>');
        												}
        												$careSubmitForm.find('[name=modelList]').val(JSON.stringify(modelList));
        												$careSubmitForm.find('[name=easyRequestCard]').val(easyRequestCard);

        												$('html').append($careSubmitForm);
        												$careSubmitForm.submit();

        											},10);
        										}else{
        											eventTarget.stopPropagation();
        											eventTarget.stopImmediatePropagation();
        											return false;
        										}
        									}else{
        										eventTarget.stopPropagation();
        										eventTarget.stopImmediatePropagation();
        										return false;
        									}
        								}
        							}
        						} else {
        							ajaxUrl = self.$pdpInfo.attr('data-rental-url-notlogin');
        							//스테이지 세팅후 제거 코드
        							ajaxUrl = ajaxUrl ? ajaxUrl : "/care-solutions/orderPay.lgajax";
        							var sendParam = {
        									"rtModelSeq":param.rtModelSeq,
        									"easyRequestCard": "",
        									"salesChannelContribution":""
        							};
        							if(sendParam.easyRequestCard) {
        								sendParam.easyRequestCard = param.easyRequestCard
        							}

        							sendParam.modelUrlPath = location.pathname + location.search;
        							/*
                                if(typeof modelUrlPath !== 'undefined') {
                                    var queryString = location.search;
                                    sendParam.modelUrlPath = modelUrlPath + queryString;
                                }
        							 */

        							if(isDirectBuy) {
        								lgkorUI.showLoading();
        								lgkorUI.requestAjaxDataPost(ajaxUrl, sendParam, function(result){
        									//console.log(result);
        								});
        							} else {
        								lgkorUI.showLoading();
        								lgkorUI.requestAjaxDataPost(ajaxUrl, sendParam, function(result){
        									//console.log(result);
        								});
        							}
        						}
        					} else {
        						self.processProductBuy = $dm;
        					}
        				}
        			}else {

        				// BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
        				if(purchaseButtonDisplay === "N") {
        					lgkorUI.alert("", {title: purchaseButtonMassage}, document.activeElement); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
        					return;
        				}

        				ajaxUrl = self.$pdpInfo.attr('data-buy-url');
        				//ajaxUrl = "https://wwwdev50.lge.co.kr/mkt/product/addCartDirectPurchase.lgajax"
        				if(ajaxUrl) {
        					//BTOCSITE-73832  제품 번들링 과제
        					var hasBundleSelected = KRP0008.additionModel.getAdditionSelectModelBuyParam(param);
                        
                        // 번들 상품이 선택되어 있고 비로그인 상태인 경우
                        if (hasBundleSelected && (typeof loginFlag === 'undefined' || !lgkorUI.stringToBool(loginFlag))) {
                            lgkorUI.confirm('', {
                                title: '번들 할인 제품을 구매하시기 위해서는</br> LG전자 통합 사이트의 로그인이 필요합니다.</br>',
                                okBtnName: '로그인',
                                cancelBtnName: '취소',
                                ok: function() {
                                    // 로그인 페이지로 이동
                                    location.href = "/sso/member/login?state=" + encodeURIComponent(location.href.replace(location.origin, ""));
                                },
                                cancel: function() {
                                    // 취소 - 아무것도 하지 않음
                                }
                            }, document.activeElement);
                            return;
                        }

        					lgkorUI.showLoading();
        					lgkorUI.requestAjaxDataPost(ajaxUrl, param, function(result){
        						//console.log(result);
        						var data = result.data;

        						if (result.status != "success") {
        							if(data && data.alert && !vcui.isEmpty(data.alert)) {
        								lgkorUI.alert("", {
        									title: data.alert.title
        								}, document.activeElement); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
        							} else {
        								if(result.isAddition && Array.isArray(result.message)){
        									let  additionErrorTemplate = "{{#each (item, idx) in list}}" +
        									"<li>" +
        									" <p class=\"name\">{{item.modelDisplayName}}</p>" +
        									" <span class=\"sku\">{{item.modelName}}</span>" +
        									" <p class=\"txt\">{{item.message}}</p>" +
        									"</li>" +
        									"{{/each}}";
        									$("#additionErrorMessageListBoxPopup .guide-list > li").remove();
        									$("#additionErrorMessageListBoxPopup .guide-list").append(vcui.template(additionErrorTemplate, { 'list' : result.message }))

        									$('#additionErrorMessageListBoxPopup').vcModal({opener: eventTarget}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
        								}else if(result.message) {
        									lgkorUI.alert("", {
        										title: result.message,
        										ok: function() {
        											if (result.code && result.code == "OUT_OF_STOCK" && lgePdpSendData.bizType && lgePdpSendData.bizType == "DISPOSABLE") {
        												var newUrl = window.location.href + '?refresh=true';
        												window.location.href = newUrl;
        											}
        										}
        									});
        								}
        							}
        							return;
        						}
        						var obsDirectPurchaseUrl = data.obsDirectPurchaseUrl;
        						if(obsDirectPurchaseUrl){
        							if(lgkorUI.getHiddenInputData().b2cYN === "N"){ //BTOCSITE-48266 [상품] B2B OBS 구축
        								let url = obsDirectPurchaseUrl.replace('/shop', '/business/shop');
        								location.href = url;
        							}else{
        								// 소모품 PDP - 바로구매 salesType Parameter추가
        								if(lgkorUI.getHiddenInputData().bizType === "DISPOSABLE"){
        									var salesType = $("#employeeDisposableTabArea").find("li.on").attr("data-salestype");
        									if(!$("#employeeDisposableTab").is(":visible")){
        										salesType = "B";
        									}
        									obsDirectPurchaseUrl = obsDirectPurchaseUrl + "&salesType=" + salesType;

        									// BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
        								} else if (lgkorUI.getHiddenInputData().bizType === "PRODUCT") {
        									if ($("#employeePriceTabArea").is(":visible")) {
        										if ($('#b2cTab').hasClass('on')) {
        											obsDirectPurchaseUrl = obsDirectPurchaseUrl + "&salesType=B"; // 일반
        										} else if ($('#employeeTab').hasClass('on')) {
        											obsDirectPurchaseUrl = obsDirectPurchaseUrl + "&salesType=E"; // 임직원
        										}
        									}
        								}
        								location.href = obsDirectPurchaseUrl;
        							}
        						}
        					}, true);
        				}
        			}
        			//BTOCSITE-6011
        		});
        		// BTOCSITE-85293 END
        	});


        },

        //상품 정보 가져오기(ajax)
        getRewardInfo: function() {
            if(typeof lgePdpSendData !== 'undefined') {
                var self = this;
                var ajaxUrl = self.$pdpInfo.attr('data-reward-url');
                //BTOCSITE-85864
				var pcsYn = (location.search.indexOf("naver_code") > 0)? "Y" : "N";
                //BTOCSITE-48266
                var modelUrl = ""
                if(lgkorUI.getHiddenInputData().b2cYN ==='N'){
                    modelUrl = location.pathname.replace("/business","");
                }else{
                    modelUrl = location.pathname;
                }

                var param = {
                    modelId: lgePdpSendData.modelId,
                    modelUrlPath: modelUrl,
                    b2cYN : lgkorUI.getHiddenInputData().b2cYN, //BTOCSITE-48266 : 사업자회원가 가져오기위함.
                    pcsYn: pcsYn								//BTOCSITE-85864
                }

                if(ajaxUrl) {
                    $.ajax({
                        url: ajaxUrl,
                        method: "POST",
                        async : false,
                        data: param,
                        success : function(result) {
                            var data = result.data[0];
                            //보유멤버쉽 포인트
                            var myMembershipPoint = data.myMembershipPoint;
                            let inputdata = lgkorUI.getHiddenInputData(); //BTOCSITE-48266 [상품] B2B OBS 구축

                            digitalData.productInfo.obsSellingPrice = data.obsSellingPrice;
                            digitalData.productInfo.obsOriginalPrice = data.obsOriginalPrice;
                            digitalData.productInfo.obsMemberPrice = data.obsMemberPrice;
                            digitalData.productInfo.obsDiscountPrice = data.obsDiscountPrice;
                            digitalData.productInfo.obsControlPrice = data.obsControlPrice;
                            digitalData.productInfo.partnerLastBenefitPrice = data.partnerLastBenefitPrice;

                            KRP0008.addNoteBookBestBadges(data); //BTOCSITE-93074 스펙 기반의 선호도

                            // BTOCSITE-98607 3d공간 카운트 뱃지
                            var homeViewCount = data.homeViewCount;
                            if(homeViewCount > 0){
                                if(homeViewCount > 99){
                                    homeViewCount = '99+';
                                }
                                $('#btn-3dSpaceCount').text(homeViewCount);
                                $('#btn-3dSpaceCount').show();
                            }

                            //BTOCSITE-45195 임직원몰 개선(임직원 전용제품 적용) : 로그인 여부 지역변수로 수정
                            loginFlag = data.loginFlag;
                            if(lgkorUI.stringToBool(loginFlag)){
                                if(lgePdpSendData.bizTypeDetail === 'DISPOSABLE'){
                                    self.memberPartnerGrp = vcui.isEmpty(data.memberPartnerGrp) ? "" : data.memberPartnerGrp;
                                    self.partnerPrice = vcui.isNumber(data.partnerPrice) ? data.partnerPrice : 0 ;
                                    self.obsOriginalPrice = vcui.isNumber(data.obsOriginalPrice) ? data.obsOriginalPrice : 0;
                                    digitalData.productInfo.partnerPrice = self.partnerPrice;
                                    digitalData.productInfo.memberPartnerGrp = data.memberPartnerGrp;
                                    self.partnerBoldBadgesArr = vcui.isEmpty(data.partnerBoldBadges) ? "" : data.partnerBoldBadges;

                                    self.displayDisposalbeEmployeeArea();

                                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                                    $("#buyBenefitInfoPoint .benefit-text").data('employeePoint',vcui.isEmpty(data.rewardPoint) ? "" : vcui.number.addComma(data.rewardPoint));
                                    self.displayBenefitPointArea(digitalData.userInfo.partnerType);

                                }else{

                                    // 혜택가 관련 정보 갱신
                                    // 로그인 이후 데이터 기준으로 쿠폰 팝업에서 최대 혜택가를 재계산하기 위함
                                    lgkorUI.setHiddenInputData({
                                        apprDateDiscountLimitPrice: vcui.isNumber(data.apprDateDiscountLimitPrice) ? data.apprDateDiscountLimitPrice : 0,
                                        discountApprPrice: vcui.isNumber(data.discountApprPrice) ? data.discountApprPrice : 0,
                                        apprDateDiscountRate: vcui.isNumber(data.apprDateDiscountRate) ? data.apprDateDiscountRate : 0,
                                        apprDateDiscountPrice:vcui.isNumber(data.apprDateDiscountPrice) ? data.apprDateDiscountPrice : 0,
                                        rewardAmt:vcui.isEmpty(data.rewardAmt) ? "0" : data.rewardAmt,
                                        obsLastBenefitPrice:vcui.isNumber(data.obsLastBenefitPrice) ? data.obsLastBenefitPrice : 0,
                                        obsCouponDiscountRate:vcui.isNumber(data.obsCouponDiscountRate) ? data.obsCouponDiscountRate : 0,
                                    });

                                    // [정리] B2C 전용 로그인 시 포인트/임직원가 갱신 로직 제거: inputdata.b2cYN==='Y'는 이 파일에서 항상 false
                                    {
                                        self.memberPartnerGrp = vcui.isEmpty(data.memberPartnerGrp) ? "" : data.memberPartnerGrp;
                                        self.bsnsMbrStat = vcui.isEmpty(data.bsnsMbrStat) ? "" :data.bsnsMbrStat;
                                        // BTOCSITE-85521 [구독] B2B 구독 도입
                                        self.bsnsPstnCd = vcui.isEmpty(data.bsnsPstnCd) ? "" :data.bsnsPstnCd;
                                        self.rprsnNm = vcui.isEmpty(data.rprsnNm) ? "" :data.rprsnNm;
                                        self.bsnsType = vcui.isEmpty(data.bsnsType) ? "" :data.bsnsType;
                                        self.mbrName = vcui.isEmpty(data.mbrName) ? "" :data.mbrName;
                                        self.bsnsMbrUpdStat = vcui.isEmpty(data.bsnsMbrUpdStat) ? "" :data.bsnsMbrUpdStat;
                                        // BTOCSITE-85521 [구독] B2B 구독 도입
                                        self.partnerPrice = vcui.isNumber(data.partnerPrice) ? data.partnerPrice : 0 ;
                                        var $paymentAmount = self.$pdpInfo.find('.payment-amount');
                                        $paymentAmount.data('businessPrice',self.partnerPrice);
                                        $('#bsnsMbrStat').val(self.bsnsMbrStat) //KRP0009 컴포넌트 구매버튼의 로그인체크를 위함.
                                        $('#memberPartnerGrp').val(self.memberPartnerGrp) //KRP0009 컴포넌트 구매버튼의 로그인체크를 위함.
                                        self.displayB2bPriceArea();
                                    }
                                }
                            } else {
                                //로그인 아님
                                // [정리] B2C 전용 미로그인 포인트 표시 제거: inputdata.b2cYN==='Y'는 이 파일에서 항상 false
                                {
                                    self.memberPartnerGrp = vcui.isEmpty(data.memberPartnerGrp) ? "" : data.memberPartnerGrp;
                                    self.bsnsMbrStat = vcui.isEmpty(data.bsnsMbrStat) ? "" :data.bsnsMbrStat;
                                    // BTOCSITE-85521 [구독] B2B 구독 도입
                                    self.bsnsPstnCd = vcui.isEmpty(data.bsnsPstnCd) ? "" :data.bsnsPstnCd;
                                    self.rprsnNm = vcui.isEmpty(data.rprsnNm) ? "" :data.rprsnNm;
                                    self.bsnsType = vcui.isEmpty(data.bsnsType) ? "" :data.bsnsType;
                                    self.mbrName = vcui.isEmpty(data.mbrName) ? "" :data.mbrName;
                                    self.bsnsMbrUpdStat = vcui.isEmpty(data.bsnsMbrUpdStat) ? "" :data.bsnsMbrUpdStat;
                                    // BTOCSITE-85521 [구독] B2B 구독 도입
                                    self.partnerPrice = vcui.isNumber(data.partnerPrice) ? data.partnerPrice : 0 ;
                                    $('#bsnsMbrStat').val(self.bsnsMbrStat) //KRP0009 컴포넌트 구매버튼의 로그인체크를 위함.
                                    $('#memberPartnerGrp').val(self.memberPartnerGrp) //KRP0009 컴포넌트 구매버튼의 로그인체크를 위함.
                                    self.displayB2bPriceArea();
                                }
                            }

                            self.loginCheckEnd = true;
                            if(self.processProductBuy) {
                                self.productBuy(self.processProductBuy);
                            }

                            KRP0008.isGetRewardExcuted = true;
                            
                            // API 응답 데이터 저장 (additionModel에서 재사용)
                            KRP0008.rewardInfoData = data;
                            
                            // additionModel 초기화 (API 호출이 완료된 후)
                            if(typeof KRP0008.additionModel !== 'undefined' && typeof KRP0008.additionModel.init === 'function') {
                                KRP0008.additionModel.init();
                            }
                        },
                        error : function(error){
                            console.log(error);
                        }
                    });
                }
            }
        },
        //BTOCSITE-93074 스펙 기반의 선호도 : 노트북 선호도 뱃지 추가
        addNoteBookBestBadges : function(data) {
			var modelOptionInfo = data.modelOptionInfo;
            if (modelOptionInfo && modelOptionInfo.options && modelOptionInfo.options.length !== undefined) {
                modelOptionInfo.options.forEach(function(option) {
		        option.optionValues.forEach(function(optionValue) {
		            // percent가 null이 아니고 0이 아닌 경우에만 처리
		            if (optionValue.percent !== null &&
		                optionValue.percent !== undefined &&
		                optionValue.percent > 0 ) {

		                var labelSelector = 'label[for="opt-' + optionValue.optItemValueId + '"]';
		                var badgeText = (optionValue.percent == 100 || optionValue.percent == "100" || optionValue.percent == "100%") ? "BEST" : optionValue.percent + "% 선택";
		                var bestBadgeHtml = '<span class="best-badge">' + badgeText + '</span>';

                        $(labelSelector).not(':has(span.best-badge)').append(bestBadgeHtml);
		            }
		        });
		    });

            }

		},

        initDisposable: function(){
            $('span[id^="b2cBadge"]').show();
        },

        setNotifications: function () { // BTOCSITE-29838 알림 신청
            if(typeof lgePdpSendData !== 'undefined') {
                var self = this;
                var ajaxUrl = self.$pdpInfo.attr('data-notice-url');
                var param = {
                    modelId: lgePdpSendData.modelId,
                    modelUrlPath: location.pathname
                }

                if (ajaxUrl) {
                    lgkorUI.requestAjaxDataPost(ajaxUrl, param, function(result){
                        var data = result.data[0];

                        if(self.$component.data('consumables')) { // 소모품 재입고 알림 신청
                            self.consumables.init(data);
                        } else if (self.$component.data('notification')) { // 일반 제품 알림 신청
                            self.notification.init(data);
                        }
                    }, true);
                }
            }
        },

        //PDP 이미지 관련

        //페이지에 저장된 pdp 데이타 가져오기
        findPdpData: function(index) {
            var self = this;
            var inputs = self.$pdpData.find('div:eq(' + index +') input');
            var item = {};
            inputs.each(function (i, o) {
                item[$(o).attr('name')] = $(o).val();
            });
            return item;
        },

        //썸네일 리스트 클릭
        clickThumbnailSlide: function(index, eventTarget) {
            var self = this;
            var item = self.findPdpData(index);

            //이전에 선택되었던 썸네일 활성화 제거 및 새로운 썸네일 활성화
            if(item.type !== "360") {
                var $thumbItem = self.$pdpThumbnail.find('li:eq(' + index + ')');

                self.$pdpThumbnail.find('li').removeClass('active');
                self.$pdpThumbnail.find('li > a').children('.blind').text("선택안됨"); //BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정

                $thumbItem.addClass('active');
                $thumbItem.find('.blind').text("선택됨");

                self.$pdpVisualAnimation.find('.video-controller').removeClass('is-active');
                self.$pdpVisualAnimation.find('.video-controller').find('button').removeClass('is-active');
                self.$pdpVisualAnimation.find('.video-controller').find('.btn-pause').addClass('is-active');
                
                self.showDisclaimer(self.$pdpVisualNotices, null); // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가 옵션 요청드립니다.
            }

            switch(item.type) {
                case "360":
                    // S : BTOCSITE-15587
                    // BTOCSITE-100135 Start
                    if(vcui.detect.isMobileDevice){
                        const only = $('div.sr-only');
                        if(only){
                           only.first().attr('aria-hidden', 'true');
                        }
                        const viewPort = $('div.iw_viewport-wrapper.subRenewPdpWrap');
                        if(viewPort){
                           viewPort.first().attr('aria-hidden', 'true');
                        }
                        const toastMessage = $('div.toast-message');
                        if(toastMessage){
                           toastMessage.first().attr('aria-hidden', 'true');
                        }
                    }
                    // BTOCSITE-100135 End
                    self.openVisualModal(index, eventTarget);
                    self.open360Resize();
                    // E : BTOCSITE-15587
                    break;

                case "image":
                    self.$pdpVisualVideo.find('iframe').attr('src', '');
                    self.$pdpVisualAnimation.find('video').attr('src', '');
                    self.$pdpVisualAnimation.find('video source').attr('src', '');

                    self.$pdpImage.find('a').attr({'data-link-name':item.linkName,'data-idx':(""+index)});
                    self.$pdpImage.find('a img').attr({'src':item.imagePdp,'alt':item.alt});

                    self.$pdpVisualList.removeClass('is-active');
                    self.$pdpImage.addClass('is-active');

                    self.$pdpVisualNotice.addClass('is-active'); // BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다.
                    if(self.$pdpVisualNotice.hasClass('first')){ // BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다.
                        self.$pdpVisualNotice.removeClass('first');
                    }
                    break;

                case "interior":
                    self.$pdpVisualVideo.find('iframe').attr('src', '');
                    self.$pdpVisualAnimation.find('video').attr('src', '');
                    self.$pdpVisualAnimation.find('video source').attr('src', '');

                    self.$pdpImage.find('a').attr({'data-link-name':item.linkName,'data-idx':(""+index)});
                    self.$pdpImage.find('a img').attr({'src':item.imagePdp,'alt':item.alt});

                    self.$pdpVisualList.removeClass('is-active');
                    self.$pdpImage.addClass('is-active');

                    self.showDisclaimer(self.$pdpVisualNotices, 'interior'); // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가 옵션 요청드립니다.

                    break;

                case "video":
                    if(self.$pdpVisualVideo.length) {
                        self.$pdpVisualAnimation.find('video').attr('src', '');
                        self.$pdpVisualAnimation.find('video source').attr('src', '');

                        self.$pdpVisualList.removeClass('is-active');
                        self.$pdpVisualVideo.find('iframe').attr('src', item.videoUrl + '?autoplay=1&mute=1');
                        self.$pdpVisualVideo.find('.image-cover img').attr('src', item.imagePdp);
                        self.$pdpVisualVideo.find('.see-video').attr({
                            'data-src': item.videoUrl,
                            'data-link-name': item.linkName
                        });
                        self.$pdpVisualVideo.addClass('is-active');
                    } else {
                        self.openVisualModal(index, eventTarget);
                    }
                    break;

                case "animation":
                    if(self.$pdpVisualAnimation.length) {
                        var $video = self.$pdpVisualAnimation.find('video');

                        self.$pdpVisualVideo.find('iframe').attr('src', '');

                        self.$pdpVisualList.removeClass('is-active');
                        $video.attr({'src': item.videoUrl, 'poster': item.imagePdp});
                        $video.find('source').attr({'src': item.videoUrl, 'type': 'video/' + item.videoType});
                        self.$pdpVisualAnimation.addClass('is-active');
                        self.$pdpVisualAnimation.find('.image-cover img').attr('src', item.imagePdp);
                        self.$pdpVisualAnimation.find('.video-box span.blind').text(item.blindText);//BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정

                        var $controller = self.$pdpVisualAnimation.find('.video-controller');
                        var $pause = $controller.find('.btn-pause');
                        var $play = $controller.find('.btn-play');

                        $video.on('click', function () {
                            $controller.addClass('is-active');
                        })

                        $pause.on('click', function () {
                            $video[0].pause();
                            $(this).removeClass('is-active');
                            $play.addClass('is-active');
                        });

                        $play.on('click', function () {
                            $video[0].play();
                            $controller.removeClass('is-active');
                            $(this).removeClass('is-active');
                            $pause.addClass('is-active');
                        });

                        self.showDisclaimer(self.$pdpVisualNotices, 'animation'); // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가 옵션 요청드립니다.

                    } else {
                        self.openVisualModal(index, eventTarget);
                    }

                    break;
                default:
                    break;
            }
        },

        //PDP모달 오픈
        openVisualModal: function(index, eventTarget) {
            var self = this;
            //self.clickModalThumbnail(index);
            var popPdp = $('#pop-pdp-visual');
            popPdp.data('selectIndex',index);
            self.$popPdpVisualImage.hide();
            if(eventTarget) {
                $('#pop-pdp-visual').vcModal({opener: eventTarget});
            } else {
                $('#pop-pdp-visual').vcModal();
            }
        },

        clickModalThumbnail: function(index) {
            var self = this;
            index = parseInt(index);
            var item = self.findPdpData(index);

            self.$itemNumber.text(index + 1);

            //이전에 선택되었던 썸네일 활성화 제거 및 새로운 썸네일 활성화
            var thumbItem = self.$popPdpThumbnail.find('li:eq('+index+')');
            if(self.$selectModalItemTarget) {
                self.$selectModalItemTarget.removeClass('active');
                self.$selectModalItemTarget.find(">a").attr("aria-selected","false");
            }
            self.$selectModalItemTarget = thumbItem;
            self.$selectModalItemTarget.addClass('active');
            self.$selectModalItemTarget.find(">a").attr("aria-selected","true");

            //self.pinchZoom.runZoom(1, false);
            //self.$popPdpVisualVideo.html('');
            self.$popPdpVisualAnimation.find('div.animation-box').vcVideoBox('reset');
            //if(self.$popPdpVisual.width() <= 450) self.$popPdpVisual.find('div.item-number').show(); // BTOCSITE-15587

            self.showDisclaimer(self.$pdpVisualNoticePopup, null); // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가 옵션 요청드립니다.
            self.showDisclaimer(self.$popPdpDisclaimer, null); // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가 옵션 요청드립니다.
            let imgAltText = item.alt; //BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정

            switch(item.type) {
                case "360":
                    // S : BTOCSITE-15587
                    self.$popPdpVisualImage.hide();
                    self.$popPdpVisualVideo.hide();
                    self.$popPdpVisualAnimation.hide();
                    self.$popPdpZoomArea.hide();
                    self.$popPdpVisual360.show();
                    self.open360Resize();

                    self.showDisclaimer(self.$popPdpDisclaimer, 'animation'); // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가 옵션 요청드립니다.
                    //if(self.$popPdpVisual.width() <= 450) self.$popPdpVisual.find('div.item-number').hide();
                    // E : BTOCSITE-15587
                    break;
                case "image":
                    self.open360Stop(); // BTOCSITE-15587
                    self.pinchZoom.runZoom(1, false);
                    self.$popPdpVisualImage.find('div.zoom-area img').attr({'data-pc-src':item.imagePC,'data-m-src':item.imageMobile, 'alt' : imgAltText.replace('메인이미지','줌이미지')}); //BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정
                    //self.$popPdpVisualImage.vcImageSwitch('reload');
                    $('body').vcLazyLoaderSwitch('reload',self.$popPdpVisualImage);
                    self.$popPdpVisualImage.show();
                    self.$popPdpVisualVideo.hide();
                    self.$popPdpVisualAnimation.hide();
                    self.$popPdpVisual360.hide();
                    self.$popPdpZoomArea.show();
                    self.pinchZoom.update(true);
                    break;
                case "interior":
                    self.open360Stop(); // BTOCSITE-15587
                    self.pinchZoom.runZoom(1, false);
                    self.$popPdpVisualImage.find('div.zoom-area img').attr({'data-pc-src':item.imagePC,'data-m-src':item.imageMobile, 'alt' : imgAltText.replace('메인이미지','줌이미지')}); //BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정
                    //self.$popPdpVisualImage.vcImageSwitch('reload');
                    $('body').vcLazyLoaderSwitch('reload',self.$popPdpVisualImage);
                    self.$popPdpVisualImage.show();
                    self.$popPdpVisualVideo.hide();
                    self.$popPdpVisualAnimation.hide();
                    self.$popPdpVisual360.hide();
                    self.$popPdpZoomArea.hide();
                    self.pinchZoom.update(true);

                    self.showDisclaimer(self.$pdpVisualNoticePopup, 'interior'); // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가 옵션 요청드립니다.

                    break;
                case "video":
                    /*
                    self.$popPdpVisualVideo.find('div.thumnail img').attr({
                        'data-pc-src':item.imagePC,
                        'data-m-src':item.imageMobile,
                        'alt':item.alt
                    });
                    */
                    self.open360Stop(); // BTOCSITE-15587
                    self.$popPdpVisualVideo.find('div.thumnail a').attr({
                        'data-src':item.adUrl,
                        'data-link-name':item.linkName,
                        'aria-describedby':item.alt
                    });
                    self.$popPdpVisualVideo.find('iframe').attr('src',item.videoUrl + '?autoplay=0&mute=1');
                    self.$popPdpVisualImage.hide();
                    self.$popPdpVisualVideo.show();
                    self.$popPdpVisualAnimation.hide();
                    self.$popPdpVisual360.hide();
                    self.$popPdpZoomArea.hide();
                    break;
                case "animation":
                    self.open360Stop(); // BTOCSITE-15587

                    var $targetAnimation = self.$popPdpVisualAnimation.find('div.visual-box div.visual-area');

                    $targetAnimation.find('a').attr({'data-src':item.adUrl,'aria-describedby':item.alt});
                    $targetAnimation.find('p.hidden').text(item.alt);
                    $targetAnimation.find('div.animation-area video source').attr({'src':item.videoUrl,'type':('video/'+item.videoType)});
                    $targetAnimation.find('div.animation-area video').attr({'src':item.videoUrl})
                    $targetAnimation.find('div.animation-area span.blind').text(item.blindText);//BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 수정

                    $targetAnimation.find('.wa-btn button').removeClass('play');
                    $targetAnimation.find('.wa-btn button').addClass('pause');
                    $targetAnimation.find('div.animation-area video')[0].play();

                    $targetAnimation.find('.wa-btn button').off('click').on('click', function(){
                        if($(this).hasClass('play')) {
                            $targetAnimation.find('.wa-btn button').removeClass('play');
                            $targetAnimation.find('.wa-btn button').addClass('pause');
                            $targetAnimation.find('div.animation-area video')[0].play();
                        } else {
                            $targetAnimation.find('.wa-btn button').removeClass('pause');
                            $targetAnimation.find('.wa-btn button').addClass('play');
                            $targetAnimation.find('div.animation-area video')[0].pause();
                        }
                    });

                    /* BTOCSITE-24792 START */
                    $targetAnimation.find('.play-animaion-btn').off('click').on('click', function(){
                        if($(this).hasClass('acc-btn')) {
                            var aniText = $(this).data('ani-text');
                            $(this).attr('aria-label', aniText).addClass('ani-btn').removeClass('acc-btn').text(aniText);
                            $targetAnimation.find('div.animation-area > video').prop('muted', false); // BTOCSITE-118447 소리 켜기 버튼(acc-btn) 클릭 시 음소거 해제
                        } else {
                            var accAniText = $(this).data('acc-ani-text');
                            $(this).attr('aria-label', accAniText).addClass('acc-btn').removeClass('ani-btn').text(accAniText);
                            $targetAnimation.find('div.animation-area > video').prop('muted', true); // BTOCSITE-118447 소리 끄기 버튼(ani-btn) 클릭 시 음소거 적용
                        }
                    });
                    /* BTOCSITE-24792 END */

                    self.$popPdpVisualImage.hide();
                    self.$popPdpVisualVideo.hide();
                    self.$popPdpVisualAnimation.show();
                    self.$popPdpVisual360.hide();
                    self.$popPdpZoomArea.hide();
                    /* s : BTOCSITE-11059 */
                    var caption = self.$popPdpVisualAnimation.find('div.visual-box div.visual-area .caption');
                    if(item.alt == '') {
                        caption.hide();
                    }else {
                        caption.html(item.alt).show();
                    }
                    if(caption.outerWidth() > 0 && caption.outerWidth() + 10 < caption.get(0).scrollWidth) {
                        var marqueeSpeed = (vcui.detect.isIE || vcui.detect.isMobile) ? 4 : 5;
                        if(caption.find('marquee').size() == 0) caption.wrapInner('<marquee scrollamount="'+marqueeSpeed+'" />')
                    }
                    /* e : BTOCSITE-11059 */

                    self.showDisclaimer(self.$popPdpDisclaimer, 'animation'); // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가 옵션 요청드립니다.

                    break;
                default:
                    break;
            }
        },

        // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가 옵션 요청드립니다.
        /**
         * 디스클레이머 show/hide 범용 함수
         * @param {jQuery} $notices - 대상 디스클레이머 jQuery 객체 (예: self.$pdpVisualNotices, self.$pdpVisualNoticePopup 등)
         * @param {String} type - 보여줄 data-type 값 ('interior', 'animation' 등), 없으면 모두 hide
         */
        showDisclaimer: function($notices, type) {
            $notices.each(function() {
                var $notice = $(this);
                var noticeType = $notice.data('type');
                if (noticeType === type) {
                    $notice.show();
                } else {
                    $notice.hide();
                }
            });
        },

        //ajax 팝업뷰 뛰우기
        requestModal: function(dm) {
            var self = this;
            var ajaxUrl = $(dm).attr('href');
            lgkorUI.requestAjaxData(ajaxUrl, null, function(result){
                self.openModalFromHtml(result);
            }, null, "html");
        },

        openModalFromHtml: function(html) {
            $('#pdp-modal').html(html).vcModal();
        },
        //선택된 옵션으로 케어쉽 가격 가져오기
        requestSelectCareOption: function($dom) {
            var self = this;
            var ajaxUrl = self.$pdpInfo.attr('data-care-select-url');
            var $checkedinputs = $dom.find('input:checked');
            var $hiddenInputs = $dom.find('input[type=hidden]');
            var param = {};
            $checkedinputs.each(function (i, o) {
                var $o = $(o);
                param[$o.attr('name')] = $o.attr('value');
            });
            $hiddenInputs.each(function (i, o) {
                var $o = $(o);
                param[$o.attr('name')] = $o.attr('value');
            });

            lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                var data = result.data;
                $dom.find('span.price').contents()[0].textContent = data.price;
            });
        },

        //선택된 옵션으로 케어쉽 렌탈 가격 가져오기
        requestSelectCareSiblingOption: function($dom) {
            var self = this;
            var ajaxUrl = self.$pdpInfo.attr('data-care-select-url');
            var $checkedinputs = $dom.find('input:checked');
            var $hiddenInputs = $dom.find('input[type=hidden]');
            var param = {};
            $checkedinputs.each(function (i, o) {
                var $o = $(o);
                param[$o.attr('name')] = $o.attr('value');
            });
            $hiddenInputs.each(function (i, o) {
                var $o = $(o);
                param[$o.attr('name')] = $o.attr('value');
            });

            lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                var data = result.data;
                $dom.find('span.price').contents()[2].textContent = data.price;
            });
        },

        //비교하기 저장 유무 체크...
        setCompares:function(){
            var self = this;
            var chk = false;
            var categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
            var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, categoryId);
            var isCompare = vcui.isEmpty(storageCompare);

            if(!isCompare){
                storageCompare['data'].forEach(function (item) {
                    if(lgePdpSendData['id'] == item['id']) chk = true;
                });
            }

            var $dm = self.$pdpInfo.find('.product-compare button');
            $dm.prop('checked', chk)
            if(chk) {
                $dm.addClass('compare-select pdpPick'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 비교하기 컨텐츠 삭제 시 포커스 이동
                $dm.find('span.blind').text('선택됨');
            } else {
                $dm.removeClass('compare-select');
                $dm.find('span.blind').text('선택안됨');
            }
        },
        // 비교하기 버튼 상태 변경
        compareBtnStatus:function(){
            var self = this;
            var categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
            var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, categoryId);
            // BTOCSITE-22701 :: 에러처리
            if (!!storageCompare && !!storageCompare['data'] == false){
                return;
            }

            if(storageCompare && storageCompare['data'].length > 0){
                var data = storageCompare['data'][0];
                if(data.b2bcatemapping != lgePdpSendData.b2bCateMapping) self.$pdpInfo.find('.product-compare').hide();
            }
        },

        setSiblingOptionCheck: function(target, currentIndex, modelsData){
            // LGECOMVIO-20 핵심스펙 기능 일부 변경 및 추가
            var self = this;
            var $target = $(target);
            var $siblingCont = $('.sibling-cont');
            var $optionList = $siblingCont.find('.option-list');
            var currentSiblingCode = $target.attr('data-sibling-code');
            var checkedOptionArray = [];

            $optionList.find('input:radio:checked').each(function(optionIndex){
                if(optionIndex === currentIndex) return;

                var $this = $(this);
                var $checkedRadio = $this;
                var radioSiblingCode = $checkedRadio.attr('data-sibling-code');
                var enableOption = [];
                var enableOptionValue = [];
                var enableOptionUniqueArr = [];
                var disableOption = [];
                var disableOptionValue = [];
                var disableOptionUniqueArr = [];

                if(checkedOptionArray.length == 0) {
                    checkedOptionArray = modelsData.filter(function(v){
                        return v.siblingCode == radioSiblingCode
                    });
                } else {
                    var modelId = checkedOptionArray.map(function(model){
                        return model.modelId
                    });

                    checkedOptionArray = modelsData.filter(function(siblingModel){
                        return modelId.indexOf(siblingModel.modelId) > -1
                    }).filter(function(model){
                        return model.siblingCode == radioSiblingCode;
                    })
                }

                // LGECOMVIO-20 : 스펙 노출/비노출 및 활성/비활성화 처리를 위한 데이터 취합
                checkedOptionArray.forEach(function(item){
                    var arr = item.siblingValueList.split(',');
                    enableOption.push(arr);

                    if(item.enableModelFlag == 'N') {
                        disableOption.push(item.siblingValueList.split(','));
                    }
                })

                enableOption.forEach(function(item){
                    enableOptionValue = enableOptionValue.concat(item);
                })

                disableOption.forEach(function(item){
                    disableOptionValue = disableOptionValue.concat(item);
                })

                disableOptionValue.forEach(function(item){
                    var enableArr = enableOptionValue.filter(function(v){
                        return v == item;
                    });

                    var disableArr = disableOptionValue.filter(function(v){
                        return v == item;
                    });

                    if(enableArr.length == disableArr.length) {
                        disableOptionUniqueArr.push(item);
                    }
                });

                enableOptionUniqueArr = enableOptionValue.filter(function(item, idx, self) {
                    return self.indexOf(item) == idx;
                })

                disableOptionUniqueArr = disableOptionUniqueArr.filter(function(item, idx, self) {
                    return self.indexOf(item) == idx;
                })

                self.enableOptionList = enableOptionUniqueArr;
                self.disableOptionList = disableOptionUniqueArr;
            });

            if(checkedOptionArray.length > 0){
                var currentModelId = checkedOptionArray.map(function(model){
                    return model.modelId
                });

                checkedOptionArray = modelsData.filter(function(siblingModel){
                    return currentModelId.indexOf(siblingModel.modelId) > -1
                }).filter(function(model){
                    return model.siblingCode == currentSiblingCode;
                })
            } else {
                if(currentIndex == 0) {
                    checkedOptionArray = modelsData.filter(function(model){
                        return model.siblingCode == currentSiblingCode;
                    })
                }
            }
        },

        requestSiblingData: function(modelId){
            //BTOCSITE-44 시블링레이어 model request
            var self = this;
            var ajaxUrl = self.$pdpInfo.attr('data-sibling-ajax');

            if( ajaxUrl && ajaxUrl != "" ) {
                // lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(ajaxUrl, {modelId: modelId}, function(resultData) {
                    if( resultData.status == "success" && resultData.data) {
                        self.defaultSiblingDataFlag = false;
                        self.receivedSiblingData = resultData.data;

                        var currentPath = resultData.data[0].siblingModels.filter(function(v){
                            return v.modelId == modelId
                        })[0].modelUrlPath;
                        // lgkorUI.hideLoading();
                        self.$siblingCont.attr('data-model-path', currentPath)
                        self.$siblingBtnComp.removeClass('disabled'); // LGECOMVIO-20 수정
                    } else {
                        self.defaultSiblingDataFlag = true;
                        self.receivedSiblingData = [];
                        self.$siblingCont.removeAttr('data-model-path', currentPath)
                        self.$siblingBtnComp.addClass('disabled'); // LGECOMVIO-20 수정
                    }
                });
            }
        },
        // BTOCSITE-659 [UI개발]마이컬렉션 추천 서비스로 개편 : pdp
        addAWSPdpUp: function() {
            // /mkt/commonModule/addAWSPdpUp.lgajax
            // 파라미터
            // itemId : SKU (OLED65A1MS.AKRG : salesmodelcode + surffixcode)

            // BTOCSITE-41671 server Error 로 인해 주석처리
            // lgkorUI.requestAjaxData("/mkt/commonModule/addAWSPdpUp.lgajax",  { "itemId":lgePdpSendData.sku});
        },
        // S : BTOCSITE-15587
        open360: function() {
            var self = this;
            self.view = new View360();
            var opt = $.extend({pathType: 'A'}, self.$view360.data()); // BTOCSITE-19022
            self.view.setConfig({
                width: self.$view360.scrollWidth,
                height: self.$view360.scrollHeight,
                columns: opt.rotateTotal,
                open_cols: opt.openTotal, 
                pathType: opt.pathType, // BTOCSITE-19022
            });
            self.view.setNavigationConfig({
                showOpen: opt.openTotal > 1 ? true:false,
                showTurnLeft: opt.openTotal > 1 ? true:false,
            });
            self.view.setImagesDirectory( opt.productPath + opt.productCode );
            self.view.start(self.$view360[0]);
            self.$view360.append('<span class="View360-text-info">※ 제품의 대표 색상 및 디자인에 대한 이해를 돕기 위한 예시 이미지입니다.<br>해당 모델 색상은 아래 버튼의 이미지컷을 참고하세요.</span>');
        },
        open360Stop: function() {
            var self = this;

            if(self.$view360.length) {
                self.view.stopAutoRotate();
                self.view.lastCol = 0;
                self.view.latestImageIdx = 0;
                self.view.currentCol = 0;
                self.view.currentRow = 0;
                self.view.displayCurrentImage();
            }
        },
        open360Resize: function() {
            var self = this;

            if(self.$view360.length) {
                var w = self.$popPdpVisual.width();
                var p = Number(self.$popPdpVisual.find('.default').css('padding-left').replace('px','') * 2);
                var ww = (w > 450)? 540 : w - p , hh = (w > 450) ? 540 : w - p;
                self.$view360.css({
                    'width':ww,
                    'height':hh
                })
                if ( !!self.view ) {
                    self.view.setConfig({
                        width:  ww,
                        height: hh
                    });
                };
                self.view.updateCanvasSize();
                self.view.displayCurrentImage();
            }
        },
        // E : BTOCSITE-15587
        //렌탈 케어 솔루션 toast popup - LGECOMVIO-20
        // BTOCSITE-47671 색상 선택
        laptapSelectColor: function() {
            var laptabWrap = $('.laptap-opt-wrap').find('.opt-colorchip-wrap');
            var colorchipSelc = laptabWrap.find('input[type="radio"]:checked').parent().attr('title');
            var colorchip = laptabWrap.find('input[type="radio"]').siblings('label');
            $('.opt-info-list').find('.selc-color').text(colorchipSelc);
            colorchip.on('click', function() {

				// BTOCSITE-89585(색상 클릭시 비활성화 되있는 색상 이름변경불가처리)
				if(!$(this).parent().find('input[type="radio"]').hasClass('disabled')){

	                var selcColor = $(this).parent().attr('title');
	                $('.opt-info-list').find('.selc-color').text(selcColor);

				}

	        });
        },
        // BTOCSITE-47671 Popup Carousel
        laptabPopupCarousel: function() {
            $('.btn-opt-tit').on('click', function() {
                if(isMobile){
					var specInfoPopupId = $(this).attr('data-href');
					 $(specInfoPopupId).addClass('active');
				}
                $('.opt-slider-wrap').buildCommonUI();
                var _this = $(this);
                var popId = _this.attr('data-href');

                vcui.require(['ui/carousel'], function () {
                    $(popId).find('.ui_carousel_slider').vcCarousel({
                        infinite: true,
                        swipeToSlide: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        prevArrow:'.btn-arrow.prev',
                        nextArrow:'.btn-arrow.next',
                        adaptiveHeight:false,
                        lazyLoad:'anticipated', //수정 jsw
                        cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                        touchThreshold: 100,
                        speed: 150
                    });
                });
                setTimeout(function() {
                    var optCarouselSlider = $(popId).find('.ui_carousel_slider');
                    var optCarouselSlideLast = parseInt(optCarouselSlider.find('.ui_carousel_slide:last').attr('data-ui_carousel_index'));
                    if(optCarouselSlideLast == 0) {
                        optCarouselSlider.find('.slide-controls').hide();
                    } else {
                        optCarouselSlider.find('.slide-controls').children('.slide-number').children('span').text(optCarouselSlideLast);
                    }
                },200);
    
                $(popId).find('.ui_carousel_slider').on('carouselafterchange', function(e,target,index){
                    $(popId).find('.slide-number').children('.current').text(index + 1);
                });
            });
        },
        // BTOCSITE-47671 Popup Close
        laptabPopupClose: function() {
            var self = this;
            $(document).on('click', '.ui_modal_dim', function (e) {
                // actionSheet가 열려있고 알럿이 표시되어 있으면 actionSheet를 닫지 않음
                if (self.isModalVisible() && $('#actionSheetPopup').hasClass('active')) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
                $('.opt-popup-wrap').find('.ui_modal_close').trigger('click');
            });
        },
        // BTOCSITE-93074 Popup Carousel
        modelOptionPopupCarousel: function() {

            var optSpecTemplateStr = "";
            $(document).on('click', 'button.icon-info',function (e) {
                var optionItemId = $('button.icon-info').attr('data-opt-item-id');
                var optionItemNm = $('button.icon-info').attr('data-opt-item-nm');
                $('#specTermsPopup').html('');

                setTimeout (() => {
                    if(optDescList !== null){
                        if (optDescList && optDescList.length > 0) {
                            for(var itemDescValue of optDescList) {
                                if(optionItemId && itemDescValue && itemDescValue.optItemId && optionItemId === itemDescValue.optItemId){
                                    itemDescValue.desc.optItemNm = optionItemNm;
                                    optSpecTemplateStr = vcui.template(optSpecTemplate, itemDescValue.desc);
                                    break;
                                }
                            }
                        }
                    }
                    $('#specTermsPopup').append(optSpecTemplateStr);
                    if(isMobile){
                        $('#specTermsPopup').addClass('active');
                    }
                    // BTOCSITE-93074 Popup Carousel
                    $(window).trigger('addSpecTermsPopup');
                }, 10)
            });
        },
        // BTOCSITE-93074 Popup Close
        modelOptionPopupClose: function() {
            // 팝업 닫기
            $('.specTermsPopup .sheet-close').on('click', function() {
                $(this).parents('.specTermsPopup').removeClass('active');
            });
            // 팝업 닫기 (배경 클릭 시)
            $(document).on('click', '.ui_modal_dim', function (e) {
                // alert 타입의 모달이면 actionSheet를 닫지 않음
                var $modalContainer = $(e.target).siblings('.ui_modal_container');
                if ($modalContainer.length > 0 && $modalContainer.vcModal('instance') && $modalContainer.vcModal('instance').getOption('alertType') === true) {
                    return;
                }
                // actionSheet가 열려있고 알럿이 표시되어 있으면 actionSheet를 닫지 않음
                if (KRP0008.isModalVisible() && $('#actionSheetPopup').hasClass('active')) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
                $('.action-sheet').find('.sheet-close').trigger('click');
            });

        },
        //LGECOMVIO-20 - 액션시트 팝업 실행
        actionSheetCallEvent: function(){
            var self = this;
            
            self.$actionSheetCallBtn.find('.btn-open-action-sheet').on('click', function(e){
                e.preventDefault();
                // BTOCSITE-85293 START
                self.preCheckTermAndCondition(false, function(e) {
                    $('html, body').css('overflow','hidden');
                    $('#actionSheetPopup').addClass('active');
                    $('#actionSheetPopup').children('.sheet-close').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 액션 시트 노출 시 포커스 이동

                    /* BTOCSITE-73060 제품 PDP UI 개선 */
                    var empTit = self.$actionSheet.find('.emp-title');

                    // 임직원/복지몰 할인가 유/무에 따라 하단 간격 수정
                    if( empTit.text().length == 0 ){
                        empTit.css('padding-bottom', 0);
                    } else{
                        empTit.removeAttr('style');
                    }
                    /* //BTOCSITE-73060 제품 PDP UI 개선 */
                });
                // BTOCSITE-85293 END
            });
            /* BTOCSITE-73060 제품 PDP UI 개선 */
            $(document).on('click',function(e){
                //툴팁팝업 열기 상태일때
                if( self.$actionSheetCallBtn.find('.tooltip-wrap').hasClass('active') ){
                    var $this = $(e.target);
                    if($this.hasClass('tooltip-box') || $this.parents('.tooltip-box').length > 0) {
                        //툴팁팝업 내부클릭일때
                    } else {
                        //툴팁팝업 외부클릭일때
                        $('html, body').css('overflow','');
                    }
                }
            })
            //툴팁팝업 닫기버튼
            self.$actionSheetCallBtn.find('.tooltip-wrap').find('.btn-close').on('click', function(){
                 $('html, body').css('overflow','');
            });
            self.$actionSheetCallBtn.find('.price-info .tooltip-icon').on('click', function(e){
                var priceTooltip = $(this).parent('.tooltip-wrap');
                if( !priceTooltip.hasClass('active') ) {
                    $('html, body').css('overflow','hidden');
                }
            });
            /* //BTOCSITE-73060 제품 PDP UI 개선 */
            self.$actionSheet.find('.sheet-close').on('click', function(e){
                // alert나 모달이 표시되어 있으면 actionSheet를 닫지 않음
                if (self.isModalVisible()) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
                $('html, body').css('overflow','');
                $('#actionSheetPopup').removeClass('active');
                // BTOCSITE-37933 다품목 판매 활성화
                $('#actionSheetCart').removeClass('active');
                self.$actionSheetCallBtn.find('.btn-open-action-sheet').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 액션 시트 close 시 포커스 이동
            })

            $(window).on('resize', function(){
                if($(window).width() > 767){
                    $('html, body').css('overflow','');
                    $('#actionSheetPopup').removeClass('active');
                }
            })

            // actionSheet 내부 컨텐츠 영역 클릭 시 이벤트 전파 차단 (actionSheet가 닫히지 않도록)
            $("#actionSheetPopup .action-sheet").on("click", function(e){
                // mask가 아닌 영역을 클릭한 경우 이벤트 전파 차단
                if (!$(e.target).closest('.action-sheet-mask').length) {
                    e.stopPropagation();
                }
            });
            
            $("#actionSheetPopup .action-sheet-mask").on("click", function(e){
                // alert나 모달이 표시되어 있으면 actionSheet를 닫지 않음
                if (self.isModalVisible()) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
                // 클릭된 요소가 알럿 모달 내부인지 확인
                var $clickedElement = $(e.target);
                if ($clickedElement.closest('.ui_modal_container').length > 0 || 
                    $clickedElement.closest('.ui_modal_dim').length > 0 ||
                    $clickedElement.hasClass('ui_modal_container') ||
                    $clickedElement.hasClass('ui_modal_dim')) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
                $('html, body').css('overflow','');
                $('#actionSheetPopup').removeClass('active');
                self.$actionSheetCallBtn.find('.btn-open-action-sheet').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 액션 시트 close 시 포커스 이동
            })

            // BTOCSITE-37933 다품목 판매 활성화
            $("#actionSheetCart .action-sheet-mask").on("click", function(e){
                $('html, body').css('overflow','');
                $('#actionSheetCart').removeClass('active');
                self.$actionSheetCallBtn.find('.btn-open-action-sheet').focus(); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 액션 시트 close 시 포커스 이동
            })

            // BTOCSITE-85293 START
            $("#actionSheetConsent .action-sheet-mask").on("click", function(e){
                $('html, body').css('overflow','');
                $('#actionSheetConsent').removeClass('active');
            })
            // BTOCSITE-85293 END
        },
        //LGECOMVIO-20 - AR 체험안내 팝업(모바일)
        settingAppByArPopup: function(){
            $('#arPopup .btn-group .btn').on('click',function(){
                goAppUrl();
            })
        },

        /**
         * isScrollDown 정의 함수
         * @param {number} from 현 y 위치
         * @param {number} to 목적 y 위치
         * @returns {array}
         */
        setIsScrollDown: function (from, to) {
            var self = this;
            var pageDirection = (from !== to) ? vcui.math.getDirection({y: from}, {y: to}, 'vertical') : null;
            var isDown = (pageDirection) ? pageDirection === 'up' : null; // true | false | null
            
            if (isDown !== null) self.isScrollDown = isDown;
        },

        /**
         * 위치값 반환 시 소수점으로 반환되어 일관성을 위해 해당 함수를 거쳐 계산
         * @param {number} value 
         * @returns {number} Math.ceil 로 통일 반환
         */
        cutDecimal: function (value) {
            return Math.ceil(value);
        },

        // 스마트홈 스티키 메뉴 // BTOCSITE-62058 스마트홈 경험 솔루션
        smartProdSticky: function () {
            var self = this;

            var $smartProdArea = $('.package-product-area');

            if (!$smartProdArea.length) return;

            var $menu = $smartProdArea.find('.package-product-item');
            var $header = $('header');

            var lastScrollTop = 0;

            var top = 0;
            var paddingBottom = parseInt($smartProdArea.css('paddingBottom')) || 0;
            var space = $header.height() + $smartProdArea.outerHeight() + paddingBottom; // $smartProdArea fixed 로 인해 빠지는 doc 높이

            // destroy
            $(document).off('.smarthome');
            if (headerMutationObserver) {
                headerMutationObserver.disconnect();
                headerMutationObserver = null;
            }

            // scroll.smarthome 에서 적용시킨 css 복구 함수
            var restoreStyle = function () {
                $smartProdArea.removeClass('is-sticky shadow-none').css('top', '').parent().css('padding-top', '');
            }

            // initialize
            if (isMobile) {
                headerMutationObserver = new MutationObserver(function (mutationList) {
                    mutationList.forEach(function (mutation) {
                        if (mutation.attributeName === 'class') {
                            $(document).triggerHandler('scroll.smarthome');
                        }
                    });
                });
            
                if (!!$header.length) headerMutationObserver.observe($header.get(0), { attributes: true });

                $(document).on('scroll.smarthome', function () {
                    var krp0009 = $('.KRP0009');
                    var scrollTop = self.cutDecimal($(window).scrollTop()); // 화면 스크롤 위치

                    $header.addClass('shadow-none'); // header 그림자 강제 숨김

                    self.setIsScrollDown(lastScrollTop, scrollTop); // 스크롤 방향 계산

                    if (krp0009.is('.fixed') && $header.is('.hide')) { // KRP0009 넘어지는 영역에서 header 숨겨지면
                            top = -$smartProdArea.outerHeight(); // 스마트홈 전체 숨김
                    } else {
                        top = $header.outerHeight() // 스마트홈 전체 노출

                        if (!!$menu.length && self.isScrollDown && scrollTop > $header.height()) { // 스크롤 내릴 때 헤드 넘어서기 시작하면
                            top = -$menu.position().top; // 스마트홈 타이틀 높이만큼 위로 당김
                        }
                    }

                    if ($(window).scrollTop() > 0) {
                        $smartProdArea
                            .toggleClass('shadow-none', krp0009.is('.fixed'))  // 그림자 토글
                            .addClass('is-sticky').css('top', top).parent().css('padding-top', space); // doc 높이 유지
                    } else {
                        restoreStyle();
                    }

                    lastScrollTop = self.cutDecimal(window.scrollY);
                })
            } else {
                restoreStyle();
            }
        },

        // visual sticky - only pc
        // pdpVisualSticky: function(){
        //     var $visual = $('.pdp-visual-wrap');
        //     var $info = $('.pdp-info-area');

        //     if(window.innerWidth > 767) {
        //         var offset = ($info.offset().top + $info.outerHeight(true)) - $visual.height();
        //         var notStickyTop = (offset - $('.header').outerHeight(true) - $('.breadcrumb').outerHeight(true) - 80);

        //         if ($(window).scrollTop()-60 > $info.offset().top && $(window).scrollTop() <= offset) {
        //             $visual.addClass('is-sticky');
        //             $visual.removeClass('is-not-sticky').css('top', '');
        //         } else {
        //             if($(window).scrollTop() >= offset){
        //                 $visual.removeClass('is-sticky');
        //                 $visual.addClass('is-not-sticky').css('top', notStickyTop);
        //             } else {
        //                 $visual.removeClass('is-sticky');
        //                 $visual.removeClass('is-not-sticky').css('top', '');
        //             }
        //         }
        //     } else {
        //         $visual.removeClass('is-sticky');
        //         $visual.removeClass('is-not-sticky').css('top', '');
        //     }
        // },
        
        //BTOCSITE-23825 크리테오 tag삽입
        addCartTag: function(productInfo, quantity, isCareShip) {
        	var self = this;
        	var modelId = productInfo.model_id;
        	var quantity = quantity.length > 0 ? parseInt(quantity.val()) : 1;
        	var price = 0;
        	       	
        	var checkCareSelect = false;
        	if (isCareShip) { //케어십O -> 케어십 신청 여부 체크
        		var $careshipService = $('.careship-service');
        		var checkinput = $careshipService.find('input[type=radio]:checked');
        		if(checkinput.length > 0) {
        			checkCareSelect = lgkorUI.stringToBool(checkinput.val());
        		}
        	}
        	
        	var $paymentAmount = self.$pdpInfo.find('.payment-amount');
        	if (isCareShip && checkCareSelect) { //케어십 선택시        		
        		price = $paymentAmount.data('carePrice');
    			if ($paymentAmount.data('carePrice')) {
    				price = parseInt($paymentAmount.data('carePrice')); //케어십 서비스 신청 가격
    			}
        	} else { //케어십X or 케어십 미신청
        		var isRentalCareTab = $paymentAmount.find('div.purchase-button').hasClass('rental');
        		if (isRentalCareTab) { //렌탈이면
        			if ($paymentAmount.data('carePrice')) {
        				price = parseInt($paymentAmount.data('carePrice'));
        			} else {
        				price = productInfo.rental_price;
        			}
        		} else { //일반이면
        			price = productInfo.price;
        		}
        	}


            //BTOCSITE-42097 [개발] 상품- brid.zzz (브리즈) PDP 페이지 내 디지털 매체 스크립트 삽입
            if (typeof bridzYn !== 'undefined' && bridzYn == "Y") {
                // 카카오
                kakaoPixel('4611006492189376410').addToCart({
                    id: modelId
                });
                // 트위터
                //<!-- Twitter conversion tracking event code -->
                    // Insert Twitter Event ID
                    twq('event', 'tw-ofcqj-ofcsf', {
                    value: null,
                    currency: null,
                    contents: [
                {
                    content_type: productInfo.category,
                    content_id: modelId,
                    content_name: "brid.zzz by LG Labs",
                    content_price: productInfo.price,
                    num_items: quantity,
                    content_group_id: null
                }],
                    conversion_id: null,
                    email_address: null,
                    phone_number: null
                });
                //<!-- End Twitter conversion tracking event code -->
            }

            //BTOCSITE-92888 [구독] LGE.COM 구독 캠페인 당근마켓 스크립트 개발 요청의 건 E

            if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
                // BTOCSITE-74567 [상품구독] LGE.COM 구독 캠페인 광고 스크립트 개발 요청의 건
                self.addRentalCartTag(modelId, price, quantity);
            } else {
                //BTOCSITE-33840 카카오 픽셀
                kakaoPixel('975360282649280347').addToCart({
                    currency: "KRW",
                    products: [
                        { id: modelId, name: productInfo.model_name, quantity: quantity, price: productInfo.base_price, brand: productInfo.brand }
                    ]
                });

                //BTOCSITE-92888 [구독] LGE.COM 구독 캠페인 당근마켓 스크립트 개발 요청의 건 S
                window.karrotPixel.track(
                    'AddToCart',
                    {
                        'products': [{
                            'id': modelId,
                            'name': productInfo.model_name,
                            'quantity': quantity,
                            'price': price,
                        }]
                    }
                );

                // 크리테오, RTB하우스 스크립트의 경우 구독과 나머지 분기하여 처리
                window.criteo_q = window.criteo_q || [];
                var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                window.criteo_q.push(
                    { event: "setAccount", account: 76661},
                    { event: "setEmail", email: "", hash_method: "" },
                    { event: "setZipcode", zipcode: "" },
                    { event: "setSiteType", type: deviceType},
                    { event: "addToCart", item: [
                            {id: modelId, price: price, quantity: quantity }
                        ]}
                );

            }
        },

        // BTOCSITE-74567 [상품구독] LGE.COM 구독 캠페인 광고 스크립트 개발 요청의 건
        addRentalCartTag: function(modelId, price, quantity) {
            try {
                // 네이버
                wcsTraceEvent("add_to_cart");
                // 카카오
                kakaoTraceEvent('add_to_cart');
                // 당근
                karrotTraceEvent('add_to_cart');
                // 크리테오
                criteoTraceEvent('add_to_cart', [{id: modelId, price: price, quantity: quantity }]);
                // 메타
                metaTraceEvent('Addtocart_subscribe'); // CSR-10916 [구독]메타픽셀 스크립트 사용하는 이벤트에서 Conversion API 호출하게 변경필요 - 추가보강
                // 구글
                gtagTraceEvent('add_to_cart');
                // 토스
                tossTraceEvent('addtocart')
            } catch (e) {
                // 오류 발생 시 무시 (로그 남기기 등 필요시 추가)
                console.error("traceEvent 오류:", e);
            }
        },
        addWishTag: function() {
            // BTOCSITE-79021 (상품) LGE.COM 네이버 스크립트 설치 요청의 건
            KRP0008.naverTransEvent("add_to_wishlist");
        },
        
        // 옵션 팝업 BTOCSITE-26021
        optionPopupSet: function () {
        	if (modelOptInfoStr == "" || modelOptGrpId == "") { //옵션값이 없다면
        		return;
        	}
        	if (window.location.href.indexOf('dpType=careTab') > -1) {
        		optBizType = "CARESOLUTION";
        	}
            var ajaxUrl = "/mkt/api/product/retrieveModelGrpOptionList";
            var param = {
                    "modelId": lgePdpSendData.modelId,
                    "modelOptGrpId": modelOptGrpId,
                    "categoryId" : lgePdpSendData.categoryId,
                    "subCategoryId" : lgePdpSendData.subCategoryId,
                    "bizType" : optBizType,
                    "b2cYN" : lgkorUI.getHiddenInputData().b2cYN,
                }
            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                param,
                function (result) {
                    if (result.status === "success") {
                        //success
                    	optList = result.data.grpOptList;
                    	optModelList = result.data.optGrpModelList;
                    	if (result.data.grpOptListCount > 0) {
                            // BTOCSITE-93074 스펙 기반 선호도
                            window.addEventListener('popstate',  () => { KRP0008.bestOptCheckUrl(optUrlList) });
                            this.bestOptCheckUrl(optModelList);
                    		this.renderOptionList(result.data);
                    		this.renderOptionModelList(result.data);
                    	} else {
                    		this.$pdpInfo.find("li.Spec").css("display","none"); //옵션영역 disabled..비활성화 처리
                    	}
                    } else {
                    	this.$pdpInfo.find("li.Spec").css("display","none"); //옵션영역 disabled..비활성화 처리
                    }
                }.bind(this),
                true,
                true
            );
        },
        renderOptionList: function (data) {
        	var optionList = data.grpOptList;
        	var optionListCnt = data.grpOptListCount;
            var optGrpModelList = data.optGrpModelList;
        	var curOptItemNm = "";
        	var optionTemplateStr = "";
        	var optionLongValueItem = [];

            // BTOCSITE-93074 스펙 기반 선호도
            optDescList = data.optDescriptionList;
            var bestOptionList = [];

        	for (var i = 0; i < optionListCnt; i++) {
                var item = optionList[i];

                if (modelOptValInfoStr.indexOf(item.optItemValueId) > -1) { //현재 모델의 옵션값중에 있는 값이면
                	item._valueChchked = "Y";
                	var checkedOptObj = {
                			"optItemId" : item.optItemId,
                			"optItemValueId" : item.optItemValueId
                		};
                	checkedOpt.push(checkedOptObj);
                	orgCheckedOpt.push(checkedOptObj);
                } else {
                	item._valueChchked = "N";                	
                }
                //BTOCSITE-93074 스펙 기반 선호도 추가
                item.bestOptYn = "N";
                item.percent = "0";

                // 클래스명
                // BTOCSITE-93074 스펙 기반 선호도 : 구독 노트북 카테고리(CT50238004) notebook_Op-color 제거
                if (item.optItemAttrCode == "02") { //컬러
                	item._itemClass = "sibling-color";

                } else { //일반
                	item._itemClass = "sibling-select";
                	if (item.optItemValueDispNm.length > 10) {
                		if (!optionLongValueItem.includes(item.optItemId)) { // 템플릿을 그려줄 때 itemdiv를 안그릴때도 있기 때문에 먼저 배열에 담는다.
                			optionLongValueItem.push(item.optItemId);
                		}
                	}
                }

                // BTOCSITE-93074 스펙 기반 선호도
                item.desc = null;

                if(optDescList !== null){
                    if (optDescList && optDescList.length > 0) {
						for (var itemDescValue of optDescList) {
							if (item && item.optItemId && itemDescValue && itemDescValue.optItemId && item.optItemId === itemDescValue.optItemId) {
								item.desc = itemDescValue.desc;
							}
						}
					}
                }

                // 데이터가 optItem-optItemValue 형식이라서 optItemNm이 같을때 달라질때 템플릿도 달라진다.
                if (i == 0) {
                	curOptItemNm = item.optItemNm;
                	optionTemplateStr += vcui.template(optionStartTemplate, item);
                } else if (item.optItemNm != curOptItemNm) {
                	curOptItemNm = item.optItemNm;
                	optionTemplateStr += vcui.template(optionNextTemplate, item);
                } else {
                	optionTemplateStr += vcui.template(optionValueTemplate, item);
                }
        	}
        	this.$siblingCont.append(optionTemplateStr + '</div></div></div>');
        	
        	for (var i = 0; i < optionLongValueItem.length; i++) { //옵션명이 길 경우 클래스명 추가
        		this.$siblingCont.children('.' + optionLongValueItem[i] + '-div').addClass("sibling-time sibling-select"); //BTOCSITE-93074 스펙 기반 선호도 추가 - 스펙용어사전
        	}
        	
        	this.optItemModelMap();
            if (data.bestOptInfo) {
                // BTOCSITE-93074  스펙 기반 선호도 추가

                bestOptInfo = data.bestOptInfo;
                bestOptInfo.fromOptionValueId = modelOptValInfoStr;

                bestOptionList = KRP0008.calcBestOption(optGrpModelList,bestOptInfo);
                var bestOpt = bestOptionList.optResult;

                if(bestOpt.length > 0) {
                    KRP0008.$siblingCont.find('span.best-badge').remove();
                }

                bestOpt.forEach(function(option) {
                    if ("Y" == option.bestOptYn) {
                        var elements = KRP0008.$siblingCont.find('label[for="' + option.optItemValueId + '"]');
                        if (elements.length > 0) { // 해당 요소가 존재하는 경우만
                            elements.append('<span class="best-badge">' + option.percent + '선택</span>');
                        }
                    }
                });
            }
        },
        renderOptionModelList: function (data) {
        	var optGrpModelList = data.optGrpModelList;
        	for (var i = 0; i < optGrpModelList.length; i++) {
                var item = optGrpModelList[i];
                if(item.MODEL_ID == lgePdpSendData.modelId) {
                	item._display = "Y";
                } else {
                	item._display = "N";                	
                }
                
                if (optBizType !== "PRODUCT" && item.VISIT_PER != null) {
                	item._visitPer = getVisitPerText(item.VISIT_PER);
                } else {
                	item._visitPer = "";
                }
                
                item._statusClass = "";
                item._rentalPrice = "";
                item._price = "";
                item._memberPriceTxt = "";
                if ((item.BIZ_TYPE == "CARESOLUTION" || item.BIZ_TYPE == "CARESHIP") && item.OBS_SELLING_PRICE != null && item.OBS_SELLING_PRICE > 0) {
                    // [정리] B2C 전용 렌탈가 표시 제거: b2cYN==='Y'는 이 파일에서 항상 false
                    //BTOCSITE-101724
                    const hiddenbData = lgkorUI.getHiddenInputData();
                    if(lgkorUI.stringToBool(loginFlag) && hiddenbData.bsnsType == 'ENT' && hiddenbData.bsnsMbrStat == 'USE'){
                        item._rentalPrice = vcui.number.addComma(item.OBS_SELLING_PRICE);
                    }
                } else {
                    //사업자몰은 사업자 인증 회원일 경우에만 가격 노출
                    // [정리] B2C 전용 회원할인가 표시 제거: b2cYN==='N'는 이 파일에서 항상 true
                    if (item.PARTNER_PRICE > 0) {
                        item._price = vcui.number.addComma(item.PARTNER_PRICE);
                    }
                }
                
                item._modelSalePlannedDate = "";
                item._modelStatusOrder = item.MODEL_STATUS_ORDER;
                item._mixProductFlag = item.MIX_PRODUCT_FLAG;
                // 판매:1, 판매대기:2, 일시품절:3, 미판매: 4, 단종: 5
                if( item.MIX_PRODUCT_FLAG == "Y"){
                    item._statusClass += " prd-right-unsold";
                }else{
                    if (item.MODEL_STATUS_ORDER == 2 && optBizType !== "CARESOLUTION") {
                        item._statusClass += " prd-right-standSale";
                        //판매대기일 노출 여부에 따라 날짜 노출/미노출
                        if (item.MODEL_SALE_PLANNED_DISP_FLAG == 'Y') {
                            if (!vcui.isEmpty(item.MODEL_SALE_PLANNED_MONTH)) {
                                item._modelSalePlannedDate = item.MODEL_SALE_PLANNED_MONTH;
                            }
                            if (!vcui.isEmpty(item.MODEL_SALE_PLANNED_WEEK) && vcui.isEmpty(item.MODEL_SALE_PLANNED_DATE)) {
                                item._modelSalePlannedDate += "월" + item.MODEL_SALE_PLANNED_WEEK;
                            } else if (!vcui.isEmpty(item.MODEL_SALE_PLANNED_DATE)) {
                                item._modelSalePlannedDate += "/" + item.MODEL_SALE_PLANNED_DATE;
                            }
                        } else {
                            item._modelSalePlannedDate = '';
                        }
                        //판매가격 노출 여부에 따라 가격 노출/미노출
                        if (item.MODEL_SALE_PLANNED_PRICE_DISP_FLAG != 'Y') {
                            item._price = "";
                        }
                    } else if (item.MODEL_STATUS_ORDER == 3 && optBizType !== "CARESOLUTION") {
                        item._statusClass += " prd-right-stock";
                    } else if (item.MODEL_STATUS_ORDER == 4  && optBizType !== "CARESOLUTION") {
                        item._statusClass += " prd-right-unsold";
                    } else if (item.MODEL_STATUS_ORDER == 5) {
                        item._statusClass += " prd-right-discontinuance";
                    } else {
                        item._statusClass += " prd-right-price";
                        item._modelStatusOrder = 1;
                    }
                }

                
                //BTOCSITE-19200 참고. 
                if (optBizType !== "CARESOLUTION" && item.OBS_INVENTORY_FLAG == "Y" && item.OBS_SELL_FLAG == "Y") {                	
                	item._obsFlag = "Y";
                } else {
                	item._obsFlag = "N";                	
                }
                
                //optHeaderTemplate 매립배관형은 <sup>태그가 들어가서 replace해줘야함.
                var replaceTemplate = vcui.template(optHeaderTemplate, item);
                replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;br&gt;","<br>",false); // BTOCSITE-38138
            	replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;sup&gt;","<sup>",false);
            	replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;/sup&gt;","</sup>",false);
            	this.$optHeader.append(replaceTemplate);
        	}

        },
        optItemModelMap: function() {
        	this.$siblingCont.find('.option-list').each(function() {
        		var $radio = $(this).find('input:radio');
        		$radio.each(function(){
	        		var radioOptArr = [];
	    			//현재 라디오 옵션값
	    			var curRadioOptItemId = $(this).data("optItemId"); //itemId
	    			var curRadioOptItemValueId = $(this).attr("id");
	    			radioOptArr.push({"optItemId" : curRadioOptItemId, "optItemValueId" : curRadioOptItemValueId});
	    			
	    			//체크되어있는 옵션들중 현재 라디오(옵션value)의 옵션이 아닌 다른옵션의 옵션값
	    			for (var j = 0; j < checkedOpt.length; j++) {
	    				if (checkedOpt[j].optItemId != curRadioOptItemId) {
	    					radioOptArr.push(checkedOpt[j]);
	    				}
	    			}
	    			//위 두개의 조합으로 옵션-모델맵핑list에서 찾기
	    			radioOptArr = radioOptArr.sort((a, b) => a.optItemId < b.optItemId ? -1 : 1); // itemId로 정렬
	    			var radioOptArrStr = "";
	    			radioOptArr.forEach(function(obj) {
	    				radioOptArrStr += obj.optItemValueId;
	    			});
	    			
	    			var radioOptModelId = "";
	    			for (var k = 0; k < optModelList.length; k++) {
	    				var optModelObjOptArr = optModelList[k].optItem.sort((a, b) => a.optItemId < b.optItemId ? -1 : 1);
	    				var optModelObjOptArrStr = "";
	    				optModelObjOptArr.forEach(function(obj) {
	    					optModelObjOptArrStr += obj.optItemValueId;
		    			});
	    				if (radioOptArrStr == optModelObjOptArrStr) {
	    					radioOptModelId = optModelList[k].MODEL_ID;
	    					$(this).data("optModelId", radioOptModelId); //모델id 셋팅
	    					$(this).data("optModelUrlPath", optModelList[k].MODEL_URL_PATH); //모델urlPath 셋팅
	    					break;
	    				}
	    			}
	    			if (radioOptModelId == ""){ //맵핑되는 모델 없음(선택가능옵션)
	    				$(this).addClass("disabled");
	    				$(this).siblings("label").addClass("check-option");
	    				radioOptModelId = KRP0008.selectableOptionModelId(curRadioOptItemId, curRadioOptItemValueId);
	    				$(this).data("optModelId", radioOptModelId); //모델id 셋팅
	    			} else {
	    				$(this).removeClass("disabled");
	    				$(this).siblings("label").removeClass("check-option");
	    			}
        		});
        	});
        },
        selectableOptionModelId: function(curRadioOptItemId, curRadioOptItemValueId) {
        	var radioModelId = "";
        	//선택가능옵션은 우선순위 계산하여 모델id추출
        	//현재 선택한 옵션 item, value 기준으로 해당 옵션에 해당되는 모델리스트 추출
        	//optModelList 사용
        	var optSortArr = [];
    		for(var i = 0; i < optModelList.length; i++) {
    			var result = optModelList[i].optItem.filter(function(item){
    				  return item.optItemId == curRadioOptItemId && item.optItemValueId == curRadioOptItemValueId;
    			});
    			
    			if (result && result.length > 0) {
    				optSortArr.push(optModelList[i]);
    				break;
    			}
    		}
    		
        	//추출한 리스트에서 우선순위 정렬
    		if(optSortArr.length > 1) {  			
    			//우선순위는 판매상태에 따라 먼저 정렬 MODEL_STATUS_ORDER
    			optSortArr = optSortArr.sort((a, b) => a.MODEL_STATUS_ORDER - b.MODEL_STATUS_ORDER);
    			//숫자가 제일 적은것으로 추출
    			var minStatNum = optSortArr[0].MODEL_STATUS_ORDER;
    			optSortArr = optSortArr.filter(function(item){
    				return item.MODEL_STATUS_ORDER == minStatNum;
    			});
    			//추출한 데이터가 두개 이상이면 opt_item_order 체크해서 숫자로 정렬 및 제일 적은것으로 modelid 추출
    			if (optSortArr.length > 1) {
    				optSortArr = optSortArr.sort((a, b) => a.OPT_ITEM_ORDER - b.OPT_ITEM_ORDER);
    			}
    		}
    		//정렬한 리스트에서 제일 첫번째 modelId반환
    		if (optSortArr.length > 0 && optSortArr[0].MODEL_ID != null) {    			
    			radioModelId = optSortArr[0].MODEL_ID;
    		}
        	
        	return radioModelId;
        },
        // BTOCSITE-93074 스펙 기반 선호도
        calcBestOption: function(optGrpModelList, bestOptInfo) {
            if (!optGrpModelList || !optGrpModelList.length) {
                return { optBase: [], optResult: [] };
            }

            // 기본 설정
            var firstItem = optGrpModelList[0];
            var maxLevel = 1;

            for (var i = 1; i <= 5; i++) {
                if (firstItem['OPT_ITEM_ID' + i] && firstItem['OPT_ITEM_ID' + i].trim() !== '') {
                    maxLevel = i;
                }
            }

            var targetLevel, compareLevel;
            var baseOptionValueIds = []; //선택된 옵션 배열로 변경

            if(bestOptInfo.optionLevel > 0){
                // 레벨 및 기준 옵션 설정
                if (bestOptInfo.minValue && bestOptInfo.maxValue) {
                    if (bestOptInfo.minValue !== bestOptInfo.maxValue) { // 옵션 코드 2개 일경우
                        targetLevel = bestOptInfo.maxValue;
                        compareLevel = bestOptInfo.minValue;

                        // fromOptionValueId 처리 (최초 일땐 쉼표로 구분된 여러 ID 처리 / 최초가 아닐땐 단일 ID 처리)
                        if (bestOptInfo.fromOptionValueId) { // 최초인지 아닌지 확인
                            var fromOptionStr = bestOptInfo.fromOptionValueId.toString().trim();

                            // 쉼표로 구분된 여러 ID인 경우
                            if (fromOptionStr.indexOf(',') > -1) {
                                baseOptionValueIds = fromOptionStr.split(',').map(function(id) {
                                    return id.trim();
                                });
                            }
                        }
                    } else { // 옵션 코드가 동일한 경우
                        targetLevel = bestOptInfo.maxValue;
                        compareLevel = null;
                    }
                } else { // 옵션 코드가 없을 경우
                    var tmpFromOptionStr = bestOptInfo.fromOptionValueId.toString().trim();
                    // 쉼표로 구분된 여러 ID인 경우
                    if (tmpFromOptionStr.indexOf(',') > -1) {
                        baseOptionValueIds = tmpFromOptionStr.split(',').map(function(id) {
                            return id.trim();
                        });
                    }
                    targetLevel = maxLevel;
                    compareLevel = (maxLevel-1);
                }
            }else{
                return { optBase: [], optResult: [] };
            }

            var checkedOptions = [];

            // checked된 라디오 버튼 찾기
            this.$siblingCont.find('.option-list input:radio:checked').each(function() {
                var optItemValueId = $(this).attr("id");
                if (optItemValueId && optItemValueId.length === 12) {
                    checkedOptions.push(optItemValueId);
                }
            });

            // baseOptionValueIds가 null이면 checkedOptions 사용
            var targetOptionIds = (baseOptionValueIds == null || baseOptionValueIds.length === 0) ? checkedOptions : baseOptionValueIds;

            //fromOptionValueId들이 optItemId에 속해있는지 검증
            if (compareLevel && targetOptionIds.length > 0) {
                var validBaseOptionIds = [];

                // 각 targetOptionId에 대해서 검증
                targetOptionIds.forEach(function(targetOptionId) {
                    var isValidBaseOption = false;

                    for (var itemValue of optGrpModelList) {
                        var compareValue = itemValue['OPT_ITEM_VALUE_ID' + compareLevel];
                        if (compareValue) {
                            if (targetOptionId.length === 12) {
                                if (compareValue === targetOptionId) {
                                    isValidBaseOption = true;
                                    break;
                                }
                            } else {
                                var numericPart = compareValue.replace(/\D/g, ''); // 숫자가 아닌 문자 제거
                                if (numericPart === targetOptionId) {
                                    isValidBaseOption = true;
                                    break;
                                }
                            }
                        }
                    }

                    // 유효한 targetOptionId만 저장
                    if (isValidBaseOption) {
                        validBaseOptionIds.push(targetOptionId);
                    }
                });

                // 선택된 ValueId 하나도 없으면 스킵
                if (validBaseOptionIds.length === 0) {
                    return { optBase: [], optResult: [] };
                }

                // 유효한 ID들만 사용
                baseOptionValueIds = validBaseOptionIds;
            }

            // disabled된 옵션만 제외
            var disabledOptions = [];
            this.$siblingCont.find('.option-list input:radio.disabled').each(function() {
                var optItemValueId = $(this).attr("id");
                if (optItemValueId && optItemValueId.length === 12) {
                    disabledOptions.push(optItemValueId);
                }
            });

            var seenValues = {};
            var optBase = [];
            var groupedQty = {};
            var totalQty = 0;

            // 데이터 수집 로직
            for (var item of optGrpModelList) {

                // 단종인 경우 해당 옵션 값들을 disabledOptions에 추가 (판매/ 일시품절 확인)
                if (item.MODEL_STATUS_ORDER === 5 || item.MODEL_STATUS_ORDER === 4 || item.MODEL_STATUS_ORDER === 2) {
                    for (var ii = 1; ii <= maxLevel; ii++) {
                        var optionValueIds = item['OPT_ITEM_VALUE_ID' + ii];
                        if (optionValueIds && !disabledOptions.includes(optionValueIds)) {
                            disabledOptions.push(optionValueIds);
                        }
                    }
                }

                // baseOptionValueIds 기준으로 필터링 (여러 ID 중 하나라도 매칭되면 포함)
                if (compareLevel && baseOptionValueIds.length > 0) {
                    var compareValue = item['OPT_ITEM_VALUE_ID' + compareLevel];
                    var isMatch = false;

                    if (compareValue) {
                        baseOptionValueIds.forEach(function(baseOptionValueId) {
                            if (isMatch) return; // 이미 매칭된 경우 스킵

                            if (compareValue === baseOptionValueId) {
                                isMatch = true;
                            }

                        });
                    }
                    if (!isMatch) {
                        continue; // 기준 옵션들 중 어느 것도 매칭되지 않으면 제외
                    }
                }

                var valueId = item['OPT_ITEM_VALUE_ID' + targetLevel];

                // 유효하지 않거나 disabled된 옵션만 제외 (선택된 옵션은 포함)
                if (!valueId || disabledOptions.includes(valueId)) {
                    continue;
                }

                var qty = parseInt(item.QTY) || 0;

                // optBase 수집
                if (!seenValues[valueId]) {
                    seenValues[valueId] = true;
                    optBase.push({
                        optItemValueId: valueId
                    });
                }

                // qty 합계 계산
                if (!groupedQty[valueId]) {
                    groupedQty[valueId] = {
                        optItemValueId: valueId,
                        qty: 0
                    };
                }

                groupedQty[valueId].qty += qty;
                totalQty += qty;
            }

            // 유효한 옵션이 1개 이하이거나 합계가 0인 경우(선호도 노출 안함)
            if (Object.keys(groupedQty).length <= 1 || totalQty === 0) {
                var emptyResult = Object.keys(groupedQty).map(function(valueId) {
                    return {
                        optItemValueId: valueId,
                        qty: groupedQty[valueId].qty,
                        percent: '',
                        bestOptYn: 'SKIP'
                    };
                });

                return {
                    optBase: optBase,
                    optResult: emptyResult
                };
            }

            // 퍼센트 계산 및 결과 생성
            var maxPercentage = 0;
            var optResult = [];

            for (var valueIds in groupedQty) {
                var percentageValue = totalQty ? Math.floor((groupedQty[valueIds].qty / totalQty) * 100) : 0;
                if (percentageValue > maxPercentage) {
                    maxPercentage = percentageValue;
                }

                optResult.push({
                    optItemValueId: valueIds,
                    qty: groupedQty[valueIds].qty,
                    percent: percentageValue + '%',
                    percentageValue: percentageValue
                });
            }

            var finalOptResult = optResult.map(function(item) {
                return {
                    optItemValueId: item.optItemValueId,
                    qty: item.qty,
                    percent: item.percent,
                    bestOptYn: item.percentageValue === maxPercentage ? 'Y' : 'N'
                };
            });

           return {
                optBase: optBase,
                optResult: finalOptResult
            };

        },
        // BTOCSITE-93074 스펙 기반 선호도
        laptapOptionUrlSet: function () {
            if (window.location.href.indexOf('dpType=careTab') > -1) {
                return;
            }else{
                //KRP0008.$pdpInfo.find('li').hasClass('laptap-opt')) 확인 해보고 if로 나중에 변경
                var ajaxUrl = "/mkt/api/product/retrieveModelGrpOptionUrlList";
                let param = {
                    "modelId": lgePdpSendData.modelId,
                    "modelOptGrpId": modelOptGrpId,
                    "categoryId" : lgePdpSendData.categoryId,
                    "subCategoryId" : lgePdpSendData.subCategoryId,
                    "bizType" : optBizType,
                    "b2cYN" : lgkorUI.getHiddenInputData().b2cYN
                }

                lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrieveModelGrpOptionUrlList", {
					method: "POST",
					data: param,
					success: function (result) {
						var optUrlList = result.data.optUrlList;
						window.addEventListener('popstate', () => { KRP0008.bestOptCheckUrl(optUrlList) });
						KRP0008.bestOptCheckUrl(optUrlList);
					},
					error: function (e) {
						console.log('Error retrieving option URLs');
					}

				});
            }
        },
        // BTOCSITE-93074 스펙 기반 선호도 - 옵션 그룹 url 리스트
        getBestOptRegisteredUrls : function() {
            const savedUrls = sessionStorage.getItem('registeredUrls');
            return savedUrls ? JSON.parse(savedUrls) : [];
        },
        //BTOCSITE-93074 스펙 기반 선호도 - 옵션 URL 목록 저장하기
        bestOptSaveUrls : function(urls) {
            sessionStorage.setItem('registeredUrls', JSON.stringify(urls));
        },
        //BTOCSITE-93074 스펙 기반 선호도 - 옵션 URL 체크 및 화면 표시
        bestOptCheckUrl : function(optModelList) {
            if (isUpdating) return; // 이미 업데이트 중이면 실행하지 않음

            isUpdating = true; // 업데이트 시작
            const currentUrl = window.location.pathname;
            const registeredUrls = this.getBestOptRegisteredUrls();
            var loginCheck = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
            if (registeredUrls.includes(currentUrl) || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab') {
                return;
            } else {
                try {
                    if(lgePdpSendData.modelStatusCode !== "ACTIVE" && lgePdpSendData.modelStatusCode !== "SOLD_OUT"){
                        return;
                    }
                    // 데이터 초기화
                    const snackbarData = KRP0008.getSnackbarData();
                    const partnerMap = KRP0008.createPartnerMap(snackbarData);
                    const partnerGrp = lgkorUI.getHiddenInputData().partnerGrp;

                    if (!partnerGrp) {
                        return false;
                    }

                    // 기본 수량 계산
                    let qty = KRP0008.calculateBaseQty(partnerGrp, partnerMap);

                    // 로그인 사용자 수량 재계산
                    if (loginCheck === 'Y' && digitalData.userInfo.partnerType) {
                        const loginQty = KRP0008.calculateLoginUserQty(
                            digitalData.userInfo.partnerType,
                            partnerGrp,
                            snackbarData
                        );

                        if (loginQty !== null) {
                            qty = loginQty;
                        }
                    }

                    //비로그인 경우 b2c만 노출
                    var hasb2c = partnerGrp.indexOf("B2C") !== -1 ;
					if(loginCheck === 'N' && !hasb2c){
						return;
					}

                    // UI 업데이트
                    $(".preference-snackbar em").text(qty);

                    // 스낵바 조건 체크
                    const snackbarCheck = KRP0008.checkSnackbarConditions(qty, {
                        subCategoryCount: snackbarData.subCategoryCount,
                        categoryCount: snackbarData.categoryCount,
                        salesDefaultVolume: snackbarData.salesDefaultVolume
                    });

                    if(snackbarCheck && lgkorUI.getHiddenInputData().bizType === 'PRODUCT') {
                        snackbarPosition();
                        showSnackbar();
                        window.addEventListener('resize', function () {
                            snackbarPosition();
                        });
                    }
                    KRP0008.bestOptUrlClearAll();
                    var list  = optModelList;
                    if(list != null && list != ''){
                        list.forEach(function(obj) {
                            KRP0008.bestOptRegisterUrl(obj.MODEL_URL_PATH);
                        });
                    }else{
                        KRP0008.bestOptRegisterUrl(currentUrl);
                    }

                } catch (error) {
                    console.error('Error processing preference snackbar:', error);
                    return false;
                }
            }
        },// 데이터 추출 및 초기화 함수
        getSnackbarData : function() {
            const $snackbar = $(".preference-snackbar");
            const attributeMap = {
                'b2c': 'b2c',
                'lge': 'lge',
                'afc': 'afc',
                'aff': 'aff',
                'subcategorycount': 'subCategoryCount',
                'categorycount': 'categoryCount',
                'salesdefaultvolume': 'salesDefaultVolume'
            };

            return Object.keys(attributeMap).reduce((data, attr) => {
                const value = $snackbar.attr(`data-${attr}`);

                const parsedValue = (value && !isNaN(value)) ? parseInt(value, 10) : null;
                const key = attributeMap[attr];

                data[key] = parsedValue;
                return data;
            }, {});

        },// 파트너 그룹별 수량 맵 생성
        createPartnerMap : function(data) {
            return {
                "B2C": data.b2c,
                "LGE": data.lge,
                "AFC": data.afc,
                "AFF": data.aff
            };
        },// 기본 수량 계산 (B2C 포함)
        calculateBaseQty : function(partnerGrp, partnerMap) {
            if (!partnerGrp) return 0;

            return partnerGrp.split(',').reduce((total, grp) => {
                return total + (partnerMap[grp.trim()] || 0);
            }, 0);
        },// 로그인 사용자 파트너 타입별 수량 계산
        calculateLoginUserQty : function(partnerType, partnerGrp, quantities) {
            const { lge, afc, aff } = quantities;
            const hasLGE = partnerGrp.includes('LGE');
            const hasAFF = partnerGrp.includes('AFF');
            const isLGEAFFOnly = hasLGE && hasAFF && partnerGrp.split(',').length === 2;

            const partnerCalculators = {
                'LGE': () => {
                    if (!hasLGE) return null; // 임직원 미포함시 기본값 유지

                    if (partnerGrp === 'LGE') {
                        return lge;
                    }

                    if (isLGEAFFOnly) {
                        return lge + aff;
                    }

                    return null;
                },
                'AFF': () => {
                    if (isLGEAFCOnly) {
                        return lge + aff;
                    }
                    return null;
                },
                'AFC': () => {
                    if (partnerGrp === 'AFC') {
                        return afc;
                    }
                    return null;
                }
            };

            const calculator = partnerCalculators[partnerType];
            return calculator ? calculator() : null;

        },// 스낵바 조건 체크
        checkSnackbarConditions : function(qty, conditions) {
            if (qty <= 0) return false;

            const { subCategoryCount, categoryCount, salesDefaultVolume } = conditions;

			// 1. subCategoryCount 확인
			if (typeof subCategoryCount === 'number' && Number.isFinite(subCategoryCount)) {
			    return qty >= subCategoryCount;
			}

			// 2. categoryCount 확인
			if (typeof categoryCount === 'number' && Number.isFinite(categoryCount)) {
			    return qty >= categoryCount;
			}

			// 3. salesDefaultVolume 확인
			if (typeof salesDefaultVolume === 'number' && Number.isFinite(salesDefaultVolume)) {
			    return qty >= salesDefaultVolume;
			}

			return false;
        },
        //BTOCSITE-93074 스펙 기반 선호도 - 옵션 URL 등록
        bestOptRegisterUrl : function(url) {
            const registeredUrls = KRP0008.getBestOptRegisteredUrls();
            if (!registeredUrls.includes(url)) {
                registeredUrls.push(url);
                KRP0008.bestOptSaveUrls(registeredUrls);
            }
        },
        //BTOCSITE-93074 스펙 기반 선호도 - 옵션 URL 전체 삭제
        bestOptUrlClearAll : function(){
            sessionStorage.removeItem('registeredUrls');
        },
        optPopToastShowHtml: function(msg){
        	$('.toast-message2').find('.toast-text').html(msg);
        	$('.toast-message2').stop().css({
                display:'block',
                opacity:0
            }).animate({opacity:1}, 150);
        	setTimeout(function() {
        		KRP0008.optPopToastClose();
            }, 3000);
        },
        optPopToastClose: function(){
            $('.toast-message2').stop()
            .animate({opacity:0}, 120, function(){
            	$('.toast-message2').css('display', 'none');
            });
        },

        // BTOCSITE-37933 다품목 판매 활성화
        cartSwiper: function() {
            var swiperCommonOpt = {
                speed: 300,
                observer: true,
                observeParents: true,
                slidesPerGroup: 3,
                slidesPerView: 'auto',
                spaceBetween: 0,
                freeMode: true,
                breakpoints: { // [BTOCSITE-67116] 상품 장바구니 담기 팝업 swiper 수정
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 11,
                        freeMode: false,
                    }
                },
            }

            vcui.require(['libs/swiper-8.2.4.min'],function(){ // [BTOCSITE-66557] 시네빔 큐브 포토리뷰 오류
                var cartSwiper1 = new Swiper('.cart-swiper1', $.extend(swiperCommonOpt , {
                    navigation: {
                        nextEl: '.cart-slider-wrap1 .btn-arrow.next',
                        prevEl: '.cart-slider-wrap1 .btn-arrow.prev',
                    }
                }));

                var cartSwiper2 = new Swiper('.cart-swiper2', $.extend(swiperCommonOpt , {
                    navigation: {
                        nextEl: '.cart-slider-wrap2 .btn-arrow.next',
                        prevEl: '.cart-slider-wrap2 .btn-arrow.prev',
                    }
                }));
            });
        },

        // BTOCSITE-51366 PDP 렌탈이동 경로 개선 
        rentalSwiper: function () {
            // [S] BTOCSITE-91373 [QC][AOS] 구독 계약기간별 상품 이동 영역 내 특정 구독 건 선택 시 페이지 이동되지 않음
            var rentalSwiperOpt = {
                slidesPerView: 'auto',
                spaceBetween: 8,
                breakpoints: {
                    1024: {
                        spaceBetween: 13,
                    },
                },
                a11y: false,
                on: {
                    init: function(swiper, e) {
                        var $swiperEl = $(this.el);
                        var $swiperSlide = $swiperEl.find('.swiper-slide');

                        $swiperSlide.each(function(idx) {
                            var $this = $(this);
                            $this.attr('aria-label', (idx+1) +' / '+ $swiperSlide.length);
                            $this.attr('role', 'group');

                        });
                    }
                }
            }

			$(document).off('keydown.rental').on('keydown.rental', function(e) {
                var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
                var isShiftPressed = e.shiftKey;

                setTimeout(function(){
                    var $focusableEl = $(document.activeElement);

                    if ($focusableEl.closest('.rental-new-wrap').length && $focusableEl.closest('.swiper-slide').length) {
                        var swiper = $focusableEl.closest('.rental-new-wrap')[0].swiper;

                        if (swiper) swiper.slideTo($focusableEl.closest('.swiper-slide').index(), 0);
                    }
                }, 10);
            });
            // [E] BTOCSITE-91373 [QC][AOS] 구독 계약기간별 상품 이동 영역 내 특정 구독 건 선택 시 페이지 이동되지 않음

            $(".rental-new-wrap").each(function () {
                var rentalItemsLength = $(this).find('.rental-new-item').length;

                if ($(window).width() > 1024 && rentalItemsLength > 3) {
                    var rentalSwiper = new Swiper(this, rentalSwiperOpt);

                    $(this).addClass("is-swipe");

                    rentalSwiper.on('slideChangeTransitionEnd', function () {
                        if (rentalSwiper.isEnd) {
                            $(rentalSwiper.$el).removeClass("is-swipe");
                        }
                    });

                    rentalSwiper.on('slideChangeTransitionStart', function () {
                        if (rentalSwiper.isBeginning) {
                            $(rentalSwiper.$el).addClass("is-swipe");
                        }
                    });
                } else if ($(window).width() <= 1024 && rentalItemsLength > 2) {
                    var rentalSwiper = new Swiper(this, rentalSwiperOpt);
                }
            });
        },

        // BTOCSITE-62058 스마트홈 경험 솔루션 
        smartPackageSwiper: function () {
            var smartPackageCarousel = $('.smart-package-wrap');
            var smartSetCarousel = $('.smart-set-wrap');
            var smartPackageList = smartPackageCarousel.find('.slide-conts').length;
            var smartSetList = smartSetCarousel.find('.slide-conts').length;

            if (!isMobile) {
                if(window.innerWidth >= 1200 && smartPackageList >= 5){
                    smartPackageCarousel.vcCarousel('destroy');
                    smartPackageCarousel.removeClass('unslick');
                    smartPackageCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 3,    // BTOCSITE-78355 [ThinQ AI Home] 가전 PDP 및 홈IoT 제품 PDP 내 'AI Home' 상품/솔루션 추천 기능 순서 변경 및 통합
                        slidesToScroll: 3,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else if(window.innerWidth < 1200 && smartPackageList >= 4){
                    smartPackageCarousel.vcCarousel('destroy');
                    smartPackageCarousel.removeClass('unslick');
                    smartPackageCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else{
                    smartPackageCarousel.vcCarousel('destroy');
                    smartPackageCarousel.addClass('unslick');
                }                

                if(window.innerWidth >= 1200 && smartSetList >= 6){
                    smartSetCarousel.vcCarousel('destroy');
                    smartSetCarousel.removeClass('unslick');
                    smartSetCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else if(window.innerWidth < 1200 && window.innerWidth > 1000 && smartSetList >= 5){
                    smartSetCarousel.vcCarousel('destroy');
                    smartSetCarousel.removeClass('unslick');
                    smartSetCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else if(window.innerWidth < 1000 && smartSetList >= 4){
                    smartSetCarousel.vcCarousel('destroy');
                    smartSetCarousel.removeClass('unslick');
                    smartSetCarousel.vcCarousel({
                        infinite: false,
                        autoplay: false,
                        pauseOnHover: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                        speed: 150,
                    });
                }else{
                    smartSetCarousel.vcCarousel('destroy');
                    smartSetCarousel.addClass('unslick');
                }
            } else {
                smartPackageCarousel.vcCarousel('destroy');
                smartSetCarousel.vcCarousel('destroy');
            }
        }, 

        packageScrollLeft: function () {
            var $smartProdArea = $('.package-product-area');
            if (!$smartProdArea.length) return;

            var pkgListElm = $smartProdArea.get(0).querySelector('ul.package-product-item-list');
            var actBtnElm = pkgListElm.querySelector('a.active');

            if (pkgListElm && actBtnElm) {
                var compLeft = $smartProdArea.offset().left;

                if (isMobile) {
                    var actLeft = actBtnElm.offsetLeft - compLeft;
                    var actRight = actLeft + actBtnElm.clientWidth;
                    var isOver = actRight > pkgListElm.clientWidth;

                    pkgListElm.scrollLeft = isOver ? actLeft : 0;
                } else {
                    actBtnElm.scrollIntoView({ block: 'nearest', inline: 'center' });
                }
                
                var isScroll = pkgListElm.scrollWidth !== pkgListElm.clientWidth && !isMobile;
                $(pkgListElm).css('padding-bottom', isScroll ? 24 : '');
            }
        },

        /**
         * 스와이프 제거
         * @param {jQueryElement} $swiper
         */
        destroySwiper: function ($swiper) {
            var $target = $swiper.hasClass("swiper-initialized")
            ? $swiper
            : $swiper.find(".swiper-initialized");

            $target.each(function (_, el) {
            var swiper = $(el)[0].swiper;

            if (swiper !== undefined) {
                swiper.destroy(true, true);
                // console.log("!!!!! destroySwiper", swiper);
            }
            });
        },

        /**
         * 함께 구매 가능한.. 상태변경 함수// BTOCSITE-72217
         * @param {jQueryElement} $target 대상 .bundled-products-wrap
         * @param {number} idx 인덱스
         */
        changeStateBundled: function ($target, idx) {
            var isMobile = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;

            if (isMobile) {
                // mo
                if (!!$target.length && $target[0].swiper) {
                    var swiper = $target[0].swiper;
                    if (!isNaN(idx)) swiper.slideTo(idx);
                }
            } else {
                // pc
            }
        },

        // BTOCSITE-35421 [PLP/PDP] 구매혜택/다품목/내일배송 개선
        benefitPriceDisplayInit : function () {
            var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
            var modelGubun = '';
            if (productInfo != null) {
                modelGubun = productInfo.model_gubun;
            }

            if(modelGubun === "일반제품" || modelGubun === "케어솔루션"){

                var inputdata = lgkorUI.getHiddenInputData();

                //할인/혜택 내용보기 영역
                var obsLastBenefitPrice = !vcui.isEmpty(inputdata.obsLastBenefitPrice)  && inputdata.obsLastBenefitPrice !=="0" ? vcui.number.parse(inputdata.obsLastBenefitPrice): 0;
                if(obsLastBenefitPrice > 0){
                    $('.view-discount-details').show(); //할인 / 혜택 내용보기 영역
                }

                //할인/혜택 내용보기 영역 > 할인결제가 영역
                var discountApprPrice = !vcui.isEmpty(inputdata.discountApprPrice)  && inputdata.discountApprPrice !=="0" ? vcui.number.parse(inputdata.discountApprPrice): 0;
                var obsOriginalPrice = !vcui.isEmpty(inputdata.obsOriginalPrice)  && inputdata.obsOriginalPrice !=="0" ? vcui.number.parse(inputdata.obsOriginalPrice): 0;
                if(discountApprPrice > 0 && (obsOriginalPrice > discountApprPrice)){
                    $('.view-discount-details .details-box .discount-payment').show();
                }else{
                    $('.view-discount-details .details-box .discount-payment').hide();
                }

                // 캐시백
                var rewardAmt = !vcui.isEmpty(inputdata.rewardAmt)  && inputdata.rewardAmt !=="0" ? vcui.number.parse(inputdata.rewardAmt): 0;
                //결제일할인금액
                var apprDateDiscountPrice = !vcui.isEmpty(inputdata.apprDateDiscountPrice)  && inputdata.apprDateDiscountPrice !=="0" ? vcui.number.parse(inputdata.apprDateDiscountPrice): 0;
                if((rewardAmt >0  || apprDateDiscountPrice > 0) || productInfo.model_id == 'MD10250832'){
                    $('#benefitPrice, #b2cTabBenefitPrice').show(); //가격정보 영역 > 최대혜택가
                    $('.maximum-benefit-price').show(); // 할인/혜택 내용보기 > 최대혜택가

                    // 최대혜택가 노출 시 쿠폰할인가 팝업 제거 처리
                    var $maxPriceCouponPopupLink = $('#couponPricePopupSelector, #tabCouponPricePopupSelector');
                    $maxPriceCouponPopupLink.removeAttr('href');
                    $maxPriceCouponPopupLink.removeClass('link-text');
                    $maxPriceCouponPopupLink.off('click');

                    // 할인/혜택 내용보기 > 결제일 할인영역
                    if(apprDateDiscountPrice > 0 || productInfo.model_id == 'MD10250832' ){
                        $('.maximum-benefit-price .day').show();
                    }

                    if(rewardAmt > 0 || apprDateDiscountPrice > 0){
                        if(rewardAmt > 0){
                            $('#employeeTabBenefitDesc').show();
                        }else{
                            $('#employeeTabBenefitDescNoCash').show();
                        }
                    }
                }

                //쿠폰 할인율
                var obsCouponDiscountRate = !vcui.isEmpty(inputdata.obsCouponDiscountRate)  && inputdata.obsCouponDiscountRate !=="0" ? vcui.number.parse(inputdata.obsCouponDiscountRate): 0;
                if(obsCouponDiscountRate > 0){
                    $('#couponDiscountRate').text(obsCouponDiscountRate+'%');
                }

                // (취소선 가격 외)
                // 가격 1개 노출 > regular
                // 가격 2개 노출 > 강조표기 금액만 bold
                // 가격 3개 노출 > 판매가/회원할인가, 쿠폰할인가 bold | 최대혜택가 regular
                var originalPrice = $('#originalPrice').find('.content').find('.price').text();
                var memberPrice = $('#memberPrice').find('.content').find('.price').text();
                var couponPrice = $('#couponPrice').find('.content').find('.price').text();
                var benefitPrice = $('#benefitPrice').find('.content').find('.price').text();

                var priceList =0;

                if(!vcui.isEmpty(memberPrice)){
                    priceList ++;
                }
                if(!vcui.isEmpty(originalPrice)){
                    priceList ++;
                }
                if(!vcui.isEmpty(couponPrice)){
                    priceList ++;
                }
                if(!vcui.isEmpty(benefitPrice)){
                    priceList ++;
                }

                if(priceList>1){
                    // 할인혜택이 없는 경우 : 회원할인가, 판매가 bold
                    if(vcui.isEmpty(benefitPrice)){
                        $('#memberPrice').attr('class', 'price-detail-item2');
                        $('#originalPrice').attr('class', 'price-detail-item2');
                    }else{
                        //할인혜택이 있는 경우
                        if(vcui.isEmpty(couponPrice)){
                            $('#memberPrice').attr('class', 'price-detail-item3');
                            $('#originalPrice').attr('class', 'price-detail-item3');
                        }else{
                            $('#memberPrice').attr('class', 'price-detail-item2');
                            $('#originalPrice').attr('class', 'price-detail-item2');
                        }
                    }

                    //판매가 강조
                    if($('#memberPrice').hasClass("price-detail-item3")){
                        $('.view-discount-details .details-box').find('.price2').attr("class","price");
                    }
                }
            }else if(modelGubun === "소모품"){
                var inputdata = lgkorUI.getHiddenInputData();
                // 캐시백
                var rewardAmt = !vcui.isEmpty(inputdata.rewardAmt)  && inputdata.rewardAmt !=="0" ? vcui.number.parse(inputdata.rewardAmt): 0;
                //결제일할인금액
                var apprDateDiscountPrice = !vcui.isEmpty(inputdata.apprDateDiscountPrice)  && inputdata.apprDateDiscountPrice !=="0" ? vcui.number.parse(inputdata.apprDateDiscountPrice): 0;
                if(rewardAmt >0  || apprDateDiscountPrice > 0){
                   if(rewardAmt > 0){
                       $('#employeeDisposablePriceAreaDesc').show();
                   }else{
                       $('#employeeDisposablePriceAreaDescNoCash').show();
                   }
                }
            }

            //할인 / 혜택 내용보기 이벤트
            $('.details-header').click(function(){
                $(this).find('img').toggleClass('deg');
                $(this).next('div[class*="details-box"]').toggleClass('hide');// [BTOCSITE-63370] [구독 Task] 구독 탐색 강화 - 구독PDP 개선
            });
        },

        /* BTOCSITE-36570 [개인맞춤서비스] 일반제품/소모품 제품추천 영역 추가 */
        setPersonalRecommendation: function () {
            try {
                var unifyId = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId;

                if (lgePdpSendData.bizType === "PRODUCT" || (lgePdpSendData.bizType === "DISPOSABLE" && loginFlag === "Y")) {
                    window.addEventListener('scroll', KRP0008.onViewport);

                    let param = {
                        unifyId: lgkorUI.stringToBool(loginFlag) ? unifyId : "",
                        modelId: lgePdpSendData.modelId !== null ? lgePdpSendData.modelId : "",
                        sku: lgePdpSendData.sku,
                        smartHomeFlag: digitalData.productInfo.smart_home_flag,
                        clientId: lgkorUI.getCookie('_ga')
                    }
                    let personalRecommendation = "";

                    lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrievePersonalRecommendation", {
                        method: "POST",
                        data: param,
                        success: function (result) {
                            personalRecommendation = result.data;

                            let $recommend = $('div.item-recommend-wrap.recommend-type-a');

                            if (personalRecommendation.recommendModels !== null && personalRecommendation.recommendModels.length > 0) {
                                let wrapDisplayFlag = false;

                                if (lgePdpSendData.bizType === "PRODUCT" && personalRecommendation.recommendModels.length >= 3) {
                                    if (["s2_6", "s2_6_1", "s2_6_2"].includes(personalRecommendation.scenarioNo)) wrapDisplayFlag = true;
                                    else if (param.unifyId !== "" && (["s2_3", "s2_3_1", "s2_3_2"].includes(personalRecommendation.scenarioNo) || ["s2_4", "s2_4_1", "s2_4_2", "s2_7", "s2_8"].includes(personalRecommendation.scenarioNo))) wrapDisplayFlag = true;
                                } else if (lgePdpSendData.bizType === "DISPOSABLE") {
                                    if (param.unifyId !== "" && ["s2_1", "s2_1_1", "s2_1_2"].includes(personalRecommendation.scenarioNo)) wrapDisplayFlag = true;
                                    // 비로그인 s2_5인 경우 KRP0012에서 호출
                                }

                                if (lgePdpSendData.bizType === "PRODUCT" && personalRecommendation.scenarioNo === 's9_9_9') {
									wrapDisplayFlag = true;
                                }

                                if (wrapDisplayFlag) {
                                    var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                                    if (productInfo !== undefined && productInfo !== null && ["s2_3", "s2_3_1", "s2_3_2", "s2_4", "s2_4_1", "s2_4_2", "s2_6", "s2_6_1", "s2_6_2", "s2_7", "s2_8"].includes(personalRecommendation.scenarioNo)) {
                                        if ("LG 오브제컬렉션|LG 시그니처|LG 업 가전".includes(productInfo.model_category)) {
                                            personalRecommendation.categoryName = productInfo.model_sub_category;
                                            // CDP API 호출 결과, '워시콤보;워시타워;세탁기'인 경우, '워시콤보, 워시타워, 세탁기'로 표시 - BTOCSITE-63269
                                        } else if (['s2_4', 's2_4_1', 's2_4_2', 's2_6', 's2_6_1', 's2_6_2', 's2_7', 's2_8'].includes(personalRecommendation.scenarioNo) && personalRecommendation.categoryName === '워시콤보, 워시타워, 세탁기') {
                                        } else {
                                            personalRecommendation.categoryName = productInfo.model_category;
                                        }
                                        personalRecommendation.categoryName = personalRecommendation.categoryName.replace(/_/g, "/");
                                        if ("공기청정기|제습/가습기".includes(personalRecommendation.categoryName)) {
                                            personalRecommendation.categoryName = "공기청정기, 제습/가습기";
                                        }
                                    }

                                    personalRecommendation.recommendLen = personalRecommendation.recommendModels.length;

                                    let recommendModelList = '';
                                    for (var i = 0; i < personalRecommendation.recommendLen; ++i) {
                                        recommendModelList += personalRecommendation.recommendModels[i].sku + '/';
                                    }
                                    personalRecommendation.eventLabel = personalRecommendation.scenarioNo + '/' + recommendModelList.slice(0, -1);

                                    $recommend.empty();	// 중복생성 방지
                                    $recommend.css('display', 'block');
                                    $recommend.append(vcui.template(recommendationTemplate, personalRecommendation));

                                    if ((window.innerWidth > 767 && personalRecommendation.recommendLen > 5)
                                        || (window.innerWidth <= 767 && personalRecommendation.recommendLen > 2)) {
                                        $recommend.find('ul').on('scroll', function () {
                                            let recommendEventCategory = "클릭";
                                            let recommendEventAction = "PDP 개인화 추천 영역 - 스크롤 클릭";
                                            let recommendEventLabel = "클릭 컨텐츠 : 스크롤 이동";
                                            KRP0008.pushDataLayer('', recommendEventCategory, recommendEventAction, recommendEventLabel);
                                            $recommend.find('ul').off('scroll');
                                        });
                                    }
                                } else if (!["s2_5", "s2_5_1", "s2_5_2"].includes(personalRecommendation.scenarioNo) && !["e2_5", "e2_5_1", "e2_5_2"].includes(personalRecommendation.scenarioNo)) { // 미노출
                                    handleNoneDisplay(personalRecommendation.scenarioNo);
                                }
                            } else if (personalRecommendation.scenarioNo !== null && !["s2_5", "s2_5_1", "s2_5_2"].includes(personalRecommendation.scenarioNo) && !["e2_5", "e2_5_1", "e2_5_2"].includes(personalRecommendation.scenarioNo)) { // 미노출
                                handleNoneDisplay(personalRecommendation.scenarioNo);
                            }
                        },
                        error: function (e) {
                            console.log(e);
                        }
                    });
                }

                function handleNoneDisplay(scenarioNo) {
                    let recommendEventCategory = "배너노출";
                    let recommendEventAction = "PDP 배너 노출 - 개인화 추천";
                    let recommendEventLabel = scenarioNo.replace("s", "e");
                    KRP0008.pushDataLayer('', recommendEventCategory, recommendEventAction, recommendEventLabel);
                }
            } catch (e) {}
        },

        // BTOCSITE-51366 PDP 렌탈이동 경로 개선
        setDirectRentalChange : function() {
            if (lgePdpSendData.bizTypeDetail === "PRODUCT") {
                window.addEventListener('scroll', KRP0008.onRentalViewport);
            }
        },

        // target 영역이 화면에 완전히 노출되는 경우 true
        isElementInViewport: function(target) {
            try {
                let viewportHeight  = $(window).height();
                let scrollTop  = $(window).scrollTop();
                let targetTop = target.offset().top;
                let targetHeight = target.height();

                return ((targetTop + targetHeight) < (viewportHeight + scrollTop)) && (targetTop > scrollTop);
            } catch (e) {
                console.log(e);
            }
        },

        onViewport: function() {
            try {
                let $recommendWrap = $('div.item-recommend-wrap.recommend-type-a');
                let recommendEventLabel = $recommendWrap.find('div.req-top-main-title').attr('data-label');

                if (KRP0008.isElementInViewport($recommendWrap) && recommendEventLabel !== null) {
                    let recommendEventCategory = "배너노출";
                    let recommendEventAction = "PDP 배너 노출 - 개인화 추천";
                    KRP0008.pushDataLayer('', recommendEventCategory, recommendEventAction, recommendEventLabel);
                    window.removeEventListener('scroll', KRP0008.onViewport);
                }
                if (recommendEventLabel === null || $recommendWrap.css('display') === "none") { // 영역이 존재하지 않는 경우
                    window.removeEventListener('scroll', KRP0008.onViewport);
                }
            } catch (e) {
                console.log(e);
            }
        },

        // BTOCSITE-51366 PDP 렌탈이동 경로 개선, 신규 UI에 따른 영역 변경
        onRentalViewport: function() {
            try {
                let $rentalBannerWrap = $('.lists .rental-new .rental-new-wrap');

                if (KRP0008.isElementInViewport($rentalBannerWrap)) {
                    let recommendEventCategory = "배너노출";
                    let recommendEventAction = "배너노출 - PDP 가전구독";
                    KRP0008.pushDataLayer('', recommendEventCategory, recommendEventAction, '');
                    window.removeEventListener('scroll', KRP0008.onRentalViewport);
                } else if ($rentalBannerWrap.length < 1) {
                    window.removeEventListener('scroll', KRP0008.onRentalViewport);
                }
            } catch (e) {
                console.log(e);
            }
        },

        // 윈도우 이벤트 (BTOCSITE-37933)
        pageshowEvent: function(event){
            if (event.persisted || window.performance && window.performance.navigation.type == 2) {
                // 히스토리백시 장바구니 담기 다품목 추천 상품노출 (BTOCSITE-37933)
                try {
                    var sessionCart = lgkorUI.getStorage(KRP0008.cartRecommendStorageName);
                    if(sessionCart == lgePdpSendData.modelId) {
                        KRP0008.cartRecommend(true);
                    }
                    lgkorUI.removeStorage(KRP0008.cartRecommendStorageName);
                } catch (e) {
                    console.log("pageshowEvent Error" + e);
                }
            }
        },

        // 장바구니 담기 ajax Call (BTOCSITE-37933 )
        addCartAjaxCall: function(ajaxUrl, param, isToast) {

            //BTOCSITE-73832  제품 번들링 과제
            var hasBundleSelected = KRP0008.additionModel.getAdditionSelectModelCartParam(param);
            
            // 번들 상품이 선택되어 있고 비로그인 상태인 경우
            if (hasBundleSelected && (typeof loginFlag === 'undefined' || !lgkorUI.stringToBool(loginFlag))) {
                lgkorUI.confirm('', {
                    title: '번들 할인 제품을 구매하시기 위해서는</br> LG전자 통합 사이트의 로그인이 필요합니다.</br>',
                    okBtnName: '로그인',
                    cancelBtnName: '취소',
                    ok: function() {
                        // 로그인 페이지로 이동
                        location.href = "/sso/member/login?state=" + encodeURIComponent(location.href.replace(location.origin, ""));
                    },
                    cancel: function() {
                        // 취소 - 아무것도 하지 않음
                    }
                }, document.activeElement);
                return;
            }

            var addCartTrigerReturn = false;
            // [정리] B2C PRODUCT 전용 다품목 팝업 미노출 분기 제거: b2cYN==='Y' && dpType!=='careTab'는 이 파일에서 항상 false

            lgkorUI.removeStorage(KRP0008.cartRecommendStorageName);
            lgkorUI.requestCart(ajaxUrl, param, isToast, addCartTrigerReturn);

            /* BTOCSITE-61062 START */
            KRP0008.gtag_report_conversion();
            /* BTOCSITE-61062 END */
            
            /* BTOCSITE-65254 START */
            try {
                KRP0008.metaAddToCartEvent();
            } catch (e) {
                console.log(e);
            }

            /* BTOCSITE-80498 */
            if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
				KRP0008.csAddToCartRecordEvent();
			}else{
	            /* BTOCSITE-65254 END */
	            /* BTOCSITE-60453 START */
	            KRP0008.addToCartRecordEvent();
	            /* BTOCSITE-60453 END */
	            /* BTOCSITE-62357 START */
                // BTOCSITE-79021 (상품) LGE.COM 네이버 스크립트 설치 요청의 건
                try {
                    KRP0008.naverTransEvent("add_to_cart");
                } catch (e) {
                    console.log(e);
                }
			}
            /* BTOCSITE-62357 END */
        },

        // 장바구니 담기 다품목 추천 상품 (BTOCSITE-37933)
        cartRecommend: function (isHistoryBack) {
            var ajaxUrl = "/mkt/api/product/retrieveMultipleItemRecommend" ;
            var smallProductrSection = $('#actionSheetCart').find("section:eq(0)");
            var largeProductrSection = $('#actionSheetCart').find("section:eq(1)");
            var cartUrlSection = $('#actionSheetCart').find(".contain-view button");

            // lg.commmon과 동일한 경로
            var typeFlag = self.$('.btn-cart').attr('data-type-flag');
            var pdpInfoFlag = self.$('.pdp-info-area').attr('data-type-cart');
            var wishTypeFlag = self.$('.info-tbl-wrap ul').attr('data-type-cart');
            var compareFlag = self.$('.product-items').attr('data-type-cart');

            var cartLink = "/shop/lgobscart/cart/quote";
            if( typeFlag == "CARESOLUTION" || pdpInfoFlag == "C" || wishTypeFlag == "C" || compareFlag == "C" ){
                cartLink = "/add-to-cart/rental-care-solution";
            // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
            } else if ($('#b2cTab').hasClass('on')) { // 임직원탭노출 > 일반탭 선택된 경우
                /*
                firstYn : 보내는쪽에서 결정한대로 따름
                salesType : B(일반) / E (임직원/복지몰)
                 */
                cartLink = "/shop/cart/index?firstYn=N&salesType=B";
            } else if (lgkorUI.getHiddenInputData().b2cYN ==='N') {
                cartLink = "/business/shop/lgobscart/cart/quote";
            }


			let vsPartnerType = '';
			let vsPartnerCode = '';

			//BTOCSITE-86873 임직원,복지몰 탭활성화에 따른 분기처리
			if($('#employeePriceTabArea').is(':visible')){
			   if($('#employeePriceTabArea .tabs > li').length > 0 && $('#employeeTab').hasClass('on')){
				    vsPartnerType = digitalData.userInfo.partnerType;
					vsPartnerCode = digitalData.userInfo.partnerCode;
				}else{
					vsPartnerType = ' ';
					vsPartnerCode = ' ';
				}
			}else{
				vsPartnerType = ' ';
				vsPartnerCode = ' ';
			}

			var cartParam = {
                "modelId": lgePdpSendData.modelId,
                "categoryId": lgkorUI.getHiddenInputData().defaultCategoryId,
				"partnerGrp": vsPartnerType,
				"partnerCd": vsPartnerCode
            };

            cartUrlSection.attr('data-url', cartLink);

            smallProductrSection.find(".swiper-wrapper").empty();
            largeProductrSection.find(".swiper-wrapper").empty();

            lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrieveMultipleItemRecommend", {
                method: "POST",
                data: cartParam,
                success: function (result) {
                    var smallProductList = result.data.smallProductList;
                    var largeProductList = result.data.largeProductList;
                    var isShow = false;
                    var smallTitle = smallProductrSection.find(".component-header__title").text();
                    var largeTitle = largeProductrSection.find(".component-header__title").text();

                    if (smallProductList.length > 0) {
                        smallProductList.forEach(function (item, index) {
                            item.subtitle = smallTitle;
                            var listItem = KRP0008.recommendMakeListItem(item);

                            smallProductrSection.find(".swiper-wrapper").append(listItem);
                        });
                        smallProductrSection.show();

                        isShow = true;
                    }
                    if (largeProductList.length > 0) {
                        largeProductList.forEach(function (item, index) {
                            item.subtitle = largeTitle;
                            var listItem = KRP0008.recommendMakeListItem(item);
                            largeProductrSection.find(".swiper-wrapper").append(listItem);
                        });
                        largeProductrSection.show();
                        isShow = true;
                    }

                    if (isShow) {
                        KRP0008.pushDataLayer('cart_recommend', '장바구니추천제품', '장바구니바텀시트노출', lgePdpSendData.modelId);
                        $('#actionSheetCart').vcModal({opener: document.activeElement}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                        $('#actionSheetPopup').removeClass('active');
                        setTimeout(function () {
                            $('#actionSheetCart').addClass('active');
                        }, 300);

                        setTimeout(function () {
                            KRP0008.recommandActionSheet();
                        }, 100);
                    } else {
                        if (!isHistoryBack) {
                            $(window).trigger("toastshow", "선택하신 제품을 장바구니에 담았습니다.");
                            $('.toast-text').append('<br><a href="' + cartLink + '" class="btn-link white">장바구니 이동하기</a>');
                        }
                    }
                },
                error: function (e) {
                    console.log(e);
                }
            });
        },

        // GA 태그 호출
        pushDataLayer: function(eventName, eventCategory, eventAction, eventLabel) {
            if(dataLayer) {
                dataLayer.push({
                    'event': 'customEvent',
                    'ga4event': eventName,
                    'customEventCategory': eventCategory,
                    'customEventAction': eventAction,
                    'customEventLabel': eventLabel
                });
            }
        },

        /* BTOCSITE-61062 START */
        gtag_report_conversion: function(url) {
            var callback = function () {
                if (typeof(url) != 'undefined') {
                    window.location = url;
                }
            };
            /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 start*/
            //장바구니 등록
            if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
            	gtag('event', 'conversion', {
            		'send_to': 'AW-362582935/27pYCJ6SxPgZEJen8qwB',
            		'event_callback': callback
            	});
            	
            }else{
	            gtag('event', 'conversion', {
	                'send_to': 'AW-1029049388/MtYACK6Lq4UZEKyY2OoD',
	                'event_callback': callback
	            });
            }
            /*[BTOCSITE-87081] [개발][상품] 구독 캠페인_ 구글/RTB하우스 광고 태그 추가/수정 요청의 건 end*/
            return false;
        },
        /* BTOCSITE-61062 END */

        /* BTOCSITE-65254 START */
        metaAddToCartEvent: function() {
            var quantity = $('#quantity').val();
            fbq('track', 'AddToCart',
                // begin parameter object data
                {
                    value: lgkorUI.getHiddenInputData().obsOriginalPrice,
                    currency: 'KRW',
                    contents: [
                        {
                            id: lgePdpSendData.modelId,
                            quantity: quantity
                        }],
                    content_type: 'product'
                }
                // end parameter object data
            )
        },
        /* BTOCSITE-65254 END */

        /* BTOCSITE-60454 START */
        recordEvent: function(eventName,eventValue) {
            var iframe = document.createElement("IFRAME");
            iframe.setAttribute("src", "af-event://inappevent?eventName="+eventName+"&eventValue="+eventValue);
            document.documentElement.appendChild(iframe);
            iframe.parentNode.removeChild(iframe);
            iframe = null;
        },

        contentViewRecordEvent: function() {
            var eventName = "af_content_view";
            var eventValue = {"af_price": lgkorUI.getHiddenInputData().obsOriginalPrice, "af_currency": "KRW", "af_content_type": digitalData.productInfo.category, "af_content_id": lgePdpSendData.modelId, "af_content": lgePdpSendData.productName};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
        },

        // BTOCSITE-79021 (상품) LGE.COM 네이버 스크립트 설치 요청의 건
        naverTransEvent: function(eventType) {
            if (window.wcs) {
                if(!wcs_add) var wcs_add = {};
                wcs_add["wa"] = "s_10f2ff8ac82";
                wcs.inflow("lge.co.kr");
                wcs_do();
                var _conv = {};
                _conv.type = eventType;
                _conv.items = [
                    {
                        id: lgePdpSendData.modelId
                    }
                ];
                wcs.trans(_conv);
            }
        },

        addToCartRecordEvent: function() {
            var quantity = $('#quantity').val();
            var eventName = "af_add_to_cart";
            var eventValue = {"af_price": lgkorUI.getHiddenInputData().obsOriginalPrice, "af_currency": "KRW", "af_content_type": digitalData.productInfo.category, "af_content_id": lgePdpSendData.modelId, "af_content": lgePdpSendData.productName, "af_quantity": quantity};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
        /* BTOCSITE-60454 END */

		/* BTOCSITE-80498 Start */
        csContentViewRecordEvent: function() {
            var eventName       = "af_cs_content_view";
			var af_price        = digitalData.productInfo.rental_price;
			var af_currency     = "KRW";
			var af_content_type = digitalData.productInfo.category;
			var af_content_id   = lgePdpSendData.modelId;
			var af_content      = lgePdpSendData.productName;
            var eventValue = {"af_price": af_price, "af_currency": af_currency, "af_content_type": af_content_type, "af_content_id": af_content_id, "af_content": af_content};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
        },
        csAddToCartRecordEvent: function() {
            var eventName       = "af_cs_add_to_cart";
			var af_param_1      = (Number(digitalData.productInfo.contract_term)/12)+"년"+"/"+(Number(digitalData.productInfo.duty_term)/12)+"년";
			var af_price        = digitalData.productInfo.rental_price;
			var af_currency     = "KRW";
			var af_content_type = digitalData.productInfo.category;
			var af_content_id   = lgePdpSendData.modelId;
			var af_content      = lgePdpSendData.productName;
			var af_quantity     = $('#quantity').val();
            var eventValue = {"af_param_1": af_param_1, "af_price": af_price, "af_currency": af_currency, "af_content_type": af_content_type, "af_content_id": af_content_id, "af_content": af_content, "af_quantity": af_quantity};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
        csSubscribeClickRecordEvent: function() {
            var eventName       = "af_cs_subscribe_click";
			var af_content_type = digitalData.productInfo.category;
			var af_content      = lgePdpSendData.productName;
			var af_content_id   = lgePdpSendData.modelId;
			var af_price        = digitalData.productInfo.rental_price;
			var af_param_1      = (Number(digitalData.productInfo.contract_term)/12)+"년"+"/"+(Number(digitalData.productInfo.duty_term)/12)+"년";
			var af_currency     = "KRW";
            var eventValue = {"af_content_type": af_content_type, "af_content": af_content, "af_content_id": af_content_id, "af_price": af_price, "af_param_1": af_param_1, "af_currency": af_currency};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
        csReservationClickRecordEvent: function() {
            var eventName       = "af_cs_reservation_click";
			var af_content_type = digitalData.productInfo.category;
			var af_content      = lgePdpSendData.productName;
			var af_content_id   = lgePdpSendData.modelId;
            var eventValue = {"af_content_type": af_content_type, "af_content": af_content, "af_content_id": af_content_id};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
        csCallClickRecordEvent: function() {
            var eventName       = "af_cs_call_click";
			var af_content_type = digitalData.productInfo.category;
			var af_content      = lgePdpSendData.productName;
			var af_content_id   = lgePdpSendData.modelId;
            var eventValue = {"af_content_type": af_content_type, "af_content": af_content, "af_content_id": af_content_id};
            if (isApp()) {
                KRP0008.recordEvent(eventName, JSON.stringify(eventValue));
            }
            return false;
        },
		/* BTOCSITE-80498 End */

        // 장바구니 담기 다품목 추천 상품 아이템 (BTOCSITE-37933)
        recommendMakeListItem: function (item) {
            var orgPrice = Number(item.obsOriginalPrice);
            var sellPrice = Number(item.obsSellingPrice);
            item._discountRate = Math.floor(((orgPrice - sellPrice) / orgPrice) * 100);
            item._obsSellingPrice = sellPrice > 0 ? vcui.number.addComma(item.obsSellingPrice) : null;

            item._target = ""
            if(!vcui.detect.isMobileDevice){
                item._target = "_blank";
            }

            function getEcCategoryName(item){
                if( item.subCategoryName == "" || item.subCategoryName == undefined) {
                    return item.superCategoryName + "/" + item.categoryName
                } else {
                    return item.superCategoryName + "/" + item.categoryName  + '/' + item.subCategoryName
                }
            }

            item.modelDisplayNameConvert = item.modelDisplayName.replace(/(<([^>]+)>)/ig,"");

            var ecProduct = {
                "model_name": item.modelDisplayNameConvert,
                "model_id": item.modelId,
                "model_sku": item.modelName,
                "model_gubun": item.modelGubunName,
                "price": vcui.number.addComma(item.obsOriginalPrice),
                "discounted_price": vcui.number.addComma(item.obsSellingPrice),
                "brand": "LG",
                "category": getEcCategoryName(item),
                "ct_id": item.subCategoryId
            }

            item.ecProduct = JSON.stringify(ecProduct);
            item.tail = "btm_rec_cart";

            return vcui.template(cartRecommendTemplate, item);
        },
        // 장바구니 담기 다품목 UI (BTOCSITE-37933)
        recommandActionSheet: function() {
            if(document.getElementById('actionSheetCart')) { // BTOCSITE-37933 다품목 판매 활성화_ PDP
                if(window.innerWidth > 767) {
                    var size0 = document.querySelector('#actionSheetCart .component-wrap');
                    var size1 = document.getElementById('actionSheetCart');
                    var size2 = document.querySelector('#actionSheetCart .action-sheet-inner');
                    if(size0.offsetHeight > 318) {
                        size2.style.height = size1.offsetHeight - 70 + 'px';
                    }
                    else {
                        size2.style.removeProperty('height');
                    }
                } else {
                    var scrollBtm = false;
                    $('.cart-wrap').scroll(function() {
                        var _this = $(this);
                        var scrollTop = _this.scrollTop();
                        var innerHeight = _this.innerHeight();
                        var scrollHeight = _this.prop('scrollHeight');

                        if(scrollTop + innerHeight >= scrollHeight) {
                            if(scrollBtm == false) {
                                scrollBtm = true;
                                dataLayer.push({
                                    'event': 'customEvent',
                                    'ga4event': 'cart_recommendScroll',
                                    'customEventCategory': '장바구니추천제품',
                                    'customEventAction': '장바구니바텀시트노출스와이프',
                                    'customEventLabel': lgePdpSendData.modelId
                                });
                            }
                        }
                    });
                }
            }
        },

        //BTOCSITE-45195 임직원몰 개선(임직원 전용제품 적용)
        displayEmployeeArea : function () {
            var self = this;
            let inputdata = lgkorUI.getHiddenInputData();
            let displayPurchaseAreaYn = true;
            let modelPartnerGrp = inputdata.partnerGrp;
            let employeeDisplayYn= false;
            let displaySmartHomeBuybtn = inputdata.displaySmartHomeBuybtn;

            var buyDisplayYN = "N";

            if(modelPartnerGrp.indexOf(self.default_partner_grp) > -1) {
                buyDisplayYN = "Y";
            }

            if(lgkorUI.stringToBool(loginFlag) && !vcui.isEmpty(self.memberPartnerGrp) && self.memberPartnerGrp != self.default_partner_grp) {

                // B2C 회원이 아닌경우 : 모델그룹에 멤버 그룹에 포함된 경우 구매영역 노출, 임직원/복지몰가 노출
                if(modelPartnerGrp.indexOf(self.memberPartnerGrp) > -1){
                    buyDisplayYN = "Y";

                    //var checkEmployeeIntervalTimer = setInterval(function() {
                        try {
                            //if (this.isSetTimeDealExcuted) {
                                // 임직원/복지몰 가격 정보 있으며, 딜 제품이 아닌 경우 노출 (이벤트 처리시 class 로 제어 하므로 동일 요소는 삭제 처리)
                                // if(self.partnerPrice > 0 && !lgePdpSendData.isTimeDeal) {
                                if(self.partnerPrice > 0) {
                                    var $priceArea;
                                    var $priceTotalArea;
                                    var partnerEmpYN = "N";
                                    var $percentArea;
                                    var $maxBenefitPrice;
                                    var $partnerPricePopupArea; //파트너 할인가
                                    var $partnerApprDateDiscountAmtPopupArea; //파트너 결제일 할인
                                    var $partnerLastBenefitPricePopupArea; //파트너 최대혜택가
                                    var $partnerRewardAmtPopupArea; //파트너 캐시백
                                    var $partnerApprDateDiscountRatePopupArea; //파트너 결제일 할인율
                                    var $partnerMaxBenefitArea;
                                    var $partnerCouponPopupLink;

                                    // 임직원으로 표시 or 복지몰로 표시 여부 확인
                                    if (self.emp_partner_grp.indexOf(self.memberPartnerGrp) > -1) {
                                        partnerEmpYN = "Y";
                                        $priceTotalArea = $('#employeePriceTotalArea .content .payment .price');
                                    } else {
                                        $priceTotalArea = $('#partnerPriceTotalArea .content .payment .price');
                                    }

                                    // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
                                    $priceArea = $('#employeeTabDiscountPrice .content .price');
                                    $percentArea = $('#employeeTabDiscountPrice .content .percent');
                                    $maxBenefitPrice = $('#employeeTabBenefitPrice .content .maxBenefitPrice');
                                    $partnerPricePopupArea = $("#employeeTabMaxBenefitPopup .Employees-discounts-price, #employeeTabCouponPricePopup .Employees-discounts-price");
                                    $partnerApprDateDiscountAmtPopupArea = $("#employeeTabMaxBenefitPopup .appr-date-discount-rate");
                                    $partnerLastBenefitPricePopupArea = $("#employeeTabMaxBenefitPopup .last-benefit-price");
                                    $partnerRewardAmtPopupArea = $("#employeeTabMaxBenefitPopup li.partner-cash-back");
                                    $partnerApprDateDiscountRatePopupArea = $("#employeeTabMaxBenefitPopup li.partner-appr-date-discount");
                                    $partnerMaxBenefitArea = $("#employeeTabBenefitPrice");
                                    $partnerCouponPopupLink = $("#employeeTabCouponPopupSelector");

                                    $priceArea.html('<em class="blind">가격</em>'+ vcui.number.addComma(self.partnerPrice) + '원'); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0  : 가격 em 태그 제거 및 숨김 텍스트 추가
                                    $priceTotalArea.html('<em>' + vcui.number.addComma(self.partnerPrice * parseInt($('div.pdp-info-area .payment-amount input.quantity').val())) +  '</em>원');
                                    $percentArea.html('<em class="blind">'+'할인율'+'</em>'+vcui.number.addComma(self.partnerDiscountRate) + '%');// BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0  : 숨김 텍스트 추가

                                    // 쿠폰할인가 포함 임직원 최대혜택가 적용
                                    if ($maxBenefitPrice.data('coupon-add-price') == 'N') {
                                        $maxBenefitPrice.html('<em>' + vcui.number.addComma(self.partnerLastBenefitPrice) + '</em>원');
                                        $partnerLastBenefitPricePopupArea.text(vcui.number.addComma(self.partnerLastBenefitPrice) + '원');
                                    }
                                    $partnerPricePopupArea.text(vcui.number.addComma(self.partnerPrice) + '원');
                                    $partnerApprDateDiscountAmtPopupArea.text('-'+vcui.number.addComma(self.partnerApprDateDiscountAmt)+'원');
                                    $partnerRewardAmtPopupArea.find('.won').text('-'+vcui.number.addComma(self.partnerRewardAmt)+'원');
                                    $partnerApprDateDiscountRatePopupArea.find('.txt').text('결제일 할인 '+self.partnerApprDateDiscountRate+'% (최대)');

                                    if(self.partnerRewardAmt > 0) {
                                        $partnerRewardAmtPopupArea.show();
                                    } else {
                                        $partnerRewardAmtPopupArea.hide();
                                    }

                                    if(self.partnerApprDateDiscountRate > 0) {
                                        $partnerApprDateDiscountRatePopupArea.show();
                                    } else {
                                        $partnerApprDateDiscountRatePopupArea.hide();
                                    }

                                    if (self.partnerRewardAmt > 0 || self.partnerApprDateDiscountAmt > 0) {
                                        $partnerCouponPopupLink.removeAttr('href');
                                        $partnerCouponPopupLink.removeClass('link-text');
                                        $partnerCouponPopupLink.off("click");
                                        $partnerMaxBenefitArea.show();
                                    } else {
                                        $partnerMaxBenefitArea.hide();
                                    }

                                    // 임직원 전용 상품인 경우 일반회원 탭 노출 제거
                                    if (modelPartnerGrp.indexOf("B2C") < 0) {
                                        // 탭 영역 이동 이벤트 삭제
                                        $('#b2cTab').on('click', function(e) {
                                            $('#employeePriceTabArea').find('div.tabs-wrap.ui_tab').off('click');
                                        });
                                        $('#b2cTab').html('<button type="button" data-href="#emppop01" data-control="modal"><p class="tabs-title">일반회원 할인가</p></button>');
                                        $('#b2cTabArea').remove();
                                    }

                                    // 임직원/복지몰 탭 상단 가격 변경
                                    $('#employeeTab .tabs-price').html('<em>' + vcui.number.addComma(self.partnerPrice) + '</em>원');

                                    // 임직원/복지몰 프로모션 뱃지 세팅
                                    $('span[id^="b2cBadge"]').hide();
                                    if(self.partnerBoldBadgesArr && self.partnerBoldBadgesArr.length > 0 && $('span[id^="employeeBadge"]').length == 0){
                                        let boldBadges = self.partnerBoldBadgesArr.map(function(item, index, array) {
                                            if(index < 2){
                                                let template = '<span class="flag imp" id="employeeBadge_' + index + '">' + item.badgeName + '</span>';
                                                return template;
                                            }
                                        }).join('');

                                        $('#badgeArea').append(boldBadges);
                                    } else {
                                        if ($('#badgeArea').find('span').not('span[id^="b2cBadge"]').length > 0 && $('span[id^="b2cBadge"]').length > 0) {
                                            $('#badgeArea').prepend($('span[id^="b2cBadge"]'));
                                        }
                                    }

                                    // 임직원인 경우 임직원/B2C 각각의 가격에 따라 구매 혜택 안내 > 결제일 할인 노출 여부를 별도 처리
                                    let buyBenefitInfoPurchase = $('#buyBenefitInfoPurchase');
                                    if (buyBenefitInfoPurchase.length > 0) {
                                        let minOrdAmtComp = Number(buyBenefitInfoPurchase.data("min-ord-amt"));

                                        if ((self.partnerPrice >= minOrdAmtComp)
                                            && ( ((self.obsOriginalPrice > 0) && self.obsOriginalPrice - self.partnerPrice > 0 )
                                                || buyBenefitInfoPurchase.data("original_member_equals_models") == 'Y')
                                        ) {
                                            self.displayBenefitPurchaseArea(true);
                                            buyBenefitInfoPurchase.data("employee_purchase_yn","Y");
                                        } else {
                                            self.displayBenefitPurchaseArea(false);
                                            buyBenefitInfoPurchase.data("employee_purchase_yn","N");
                                        }
                                    }

                                    // 임직원/복지몰 렌탈 경로 개선 영역 설정
                                    if (self.partnerRentalDirectInfoArr.length > 0 && $('#rentalDirectinfoListEmployee .text').length == 0) {
                                        self.employeeRentalDirectInfoSetting(self.partnerRentalDirectInfoArr, self.sellPointCom, self.selYnCom);
                                        $('#rentalDirectinfoList').hide();
                                        $('#rentalDirectinfoListEmployee').show();
                                    }


                                    // 임직원 영역 노출
                                    if (partnerEmpYN == "Y") {
                                        $('#partnerTooltipArea').remove();
                                        $('#employeePriceTotalArea').show();
                                        $('.is-popup-cont-welfare').remove();
                                        $('#actionSheetDiscountType').text('임직원 할인');

                                    // 복지몰 영역 노출
                                    } else {
                                        // 임직원 -> 복지몰 탭명 및 툴팁 텍스트 변경
                                        $('#employeePriceTabArea .disp-member-type').each(function() {
                                            let text = $(this).html();
                                            $(this).html(text.replace('임직원', '복지몰'));
                                        });

                                        // 임직원 -> 복지몰 최대혜택가 팝업 텍스트 변경
                                        $('#employeeTabMaxBenefitPopup').html($('#employeeTabMaxBenefitPopup').html().replace('임직원', '복지몰'));

                                        // 임직원 -> 복지몰 전용 상품 팝업 & 쿠폰팝업 텍스트 변경
                                        $('#emppop01').html($('#emppop01').html().replace('임직원', '복지몰'));
                                        $('#employeeCouponPopup span').text('복지몰');
                                        $('#employeeTabCouponPricePopup').html($('#employeeTabCouponPricePopup').html().replace('임직원', '복지몰'));

                                        $('#employeeTooltipArea').remove();
                                        $('.is-popup-cont-member').remove();
                                        $('#partnerPriceTotalArea').show();
                                        $('#actionSheetDiscountType').text('복지몰 할인');
                                    }

                                    // $('#actionSheetDiscountType').css("display","");
                                    $('li.lists.member.pdp-tolltip-new').removeClass('pdp-tolltip-new'); // 임직원가격탭 노출일 경우 별도 CSS 적용을 위함
                                    $('#employeePriceTabArea').show();

                                    // 회원할인가 존재하는 경우 일반회원 탭 노출 가격 변경
                                    if ($('#b2cTabArea .type-small-dept').length > 0 && $('#memberDiscountPrice').text().length > 0) {
                                        let dispArea = $('#b2cTab .tabs-title').html();
                                        $('#b2cTab .tabs-title').html(dispArea.replace('판매가', '할인가'));
                                        $('#b2cTab .tabs-price').html('<em class="blind">가격</em> <em>' + $('#memberDiscountPrice').text() + '</em>원');
                                    }

                                    // 바텀영역 일반 쿠폰할인가 비노출
                                    $('.total-coupon-payment').hide();

                                    $('#b2cPriceArea').remove();
                                    employeeDisplayYn = true;

                                    KRP0008.bottomFoldAreaControl('Y');
                                } else {
                                    $('#employeePriceTabArea').remove();
                                    $('.emp-price-info.is-price-calc-new').remove();
                                    $('.emp-price-info.is-coupon-price-calc-new').remove();
                                }
                           // }
                            //self.interValStop(checkEmployeeIntervalTimer);
                        } catch (e) {
                            //self.interValStop(checkEmployeeIntervalTimer);
                        }
                    //}, 200);
                }
            }

            //일반상품에 대해서만 체크
            if (lgePdpSendData.bizTypeDetail === "PRODUCT" && (buyDisplayYN !== "Y" || displaySmartHomeBuybtn === "N")) {
                displayPurchaseAreaYn = false;
            }

            // 일반일 경우 뱃지 노출
            if (!employeeDisplayYn && lgePdpSendData.bizTypeDetail !== "DISPOSABLE") {
                $('span[id^="b2cBadge"]').show();
            }

            //영역 노출 비노출 여부
            if(displayPurchaseAreaYn){
                //일반상품과 일반회원 or 비회원 or 임직원 상품
                $('#productDetailOptionArea').show(); //구매영역
                $('#abnormalDetailOptionArea').hide(); // 구매영역
                $('#badgeArea').show(); //뱃지
                $('#productCompareArea').show(); //비교하기
                $('#topWishArea').show(); //위시리스트
                $('#paymentButtonArea').show(); //장바구니, 구매하기버튼 영역
                $('#extraBtn').show();      // KRP0009 영역 - 구매하기, 일시품절.. 버튼
            }else {
                //임직원 상품과 일반회원 or 비회원 제외한 경우
                $('#productDetailOptionArea').hide(); //구매영역
                if (displaySmartHomeBuybtn === "N") {
                    $('#abnormalDetailOptionArea').hide(); // 구매영역 숨김
                } else {
                    $('#abnormalDetailOptionArea').show(); // 구매영역
                }
                $('#badgeArea').hide(); //뱃지
                $('#productCompareArea').hide(); //비교하기
                $('#topWishArea').hide(); //위시리스트
                $('#paymentButtonArea').hide(); //장바구니, 구매하기버튼 영역
                $('#extraBtn').hide();      // KRP0009 영역 - 구매하기, 일시품절.. 버튼
            }

            /* BTOCSITE-80676 START */
            if (!self.$pdpInfoWrap.hasClass('isLoaded')) {
                self.$pdpInfoWrap.addClass('isLoaded');
            }
            /* BTOCSITE-80676 END */

            $('#pdp-notice-banner').addClass('active'); // KRP 63182
        },

        /* 구매혜택 */
        displayBenefitPurchaseArea : function (chkVal) {
            if (chkVal == true) {
                $('#buyBenefitInfo').show();
                $('#buyBenefitInfoPurchase').show();
                /* BTOCSITE-75630 PLCC START */
                $('#buyBenefitInfoPlcc').length && $('#buyBenefitInfoPlcc').show();
                $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').length && $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').show();
                $('#buyBenefitInfoPopupNew').find('#tab06').length && $('#buyBenefitInfoPopupNew').find('#tab06').show();
                $('#shinhanBannerWrap').length && $('#shinhanBannerWrap').show();
                /* BTOCSITE-75630 PLCC END */
                $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="discount"]').show();
                $('#buyBenefitInfoPopupNew').find('#tab03').show();
            } else {
                if ($('#buyBenefitInfo').data("benefit_display_yn") == 'Y') {
                    // 구매헤택 노출대상이 결제일 할인만 있는경우 전체 비노출 그외인 경우 결제일 할인만 비노출
                    if($("#buyBenefitInfo").find("li").length == 1 && $('#buyBenefitInfoPurchase').length == 1) {
                        $('#buyBenefitInfo').hide();
                        $('#buyBenefitInfoPurchase').hide();
                        /* BTOCSITE-75630 PLCC START */
                        $('#buyBenefitInfoPlcc').length && $('#buyBenefitInfoPlcc').hide();
                        $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').length && $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').hide();
                        $('#buyBenefitInfoPopupNew').find('#tab06').length && $('#buyBenefitInfoPopupNew').find('#tab06').hide();
                        $('#shinhanBannerWrap').length && $('#shinhanBannerWrap').hide();
                        /* BTOCSITE-75630 PLCC END */
                        $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="discount"]').hide();
                        $('#buyBenefitInfoPopupNew').find('#tab03').hide();
                    } else {
                        $('#buyBenefitInfo').show();
                        $('#buyBenefitInfoPurchase').hide();
                        /* BTOCSITE-75630 PLCC START */
                        $('#buyBenefitInfoPlcc').length && $('#buyBenefitInfoPlcc').hide();
                        $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').length && $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="partnership"]').hide();
                        $('#buyBenefitInfoPopupNew').find('#tab06').length && $('#buyBenefitInfoPopupNew').find('#tab06').hide();
                        $('#shinhanBannerWrap').length && $('#shinhanBannerWrap').hide();
                        /* BTOCSITE-75630 PLCC END */
                        $("#buyBenefitInfoPopupNew").find('ul.tabs > li[data-active-target="discount"]').hide();
                        $('#buyBenefitInfoPopupNew').find('#tab03').hide();
                    }
                } else {
                    $('#buyBenefitInfo').hide();
                }
            }
            
        },
        //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
        displayBenefitPointArea : function(partnerType){
            if(partnerType){
                if(partnerType === 'B2C'){

                    let b2cPoint = $("#buyBenefitInfoPoint .benefit-text").data('b2cPoint');
                    if(b2cPoint && b2cPoint.length > 1){
                        $("#buyBenefitInfoPoint .benefit-text").text("최대 "+b2cPoint+" 멤버십 포인트 적립");
                        $("#buyBenefitInfoPoint").show();

                        $("#buyBenefitInfoPopupNew .pop-body div[data-content-name='point'] p").text("최대 "+b2cPoint+" 멤버십 포인트 적립");
                        $("#buyBenefitInfoPopupNew .tabs li[data-active-target='point']").show();
                    }else{
                        $("#buyBenefitInfoPoint").hide();
                        $("#buyBenefitInfoPopupNew .tabs li[data-active-target='point']").hide();
                    }
                }else{
                    // 포인트
                    let employeePoint = $("#buyBenefitInfoPoint .benefit-text").data('employeePoint');
                    if(employeePoint && employeePoint.length > 1){
                        $("#buyBenefitInfoPoint .benefit-text").text("최대 "+employeePoint+" 멤버십 포인트 적립");
                        $("#buyBenefitInfoPoint").show();

                        $("#buyBenefitInfoPopupNew .pop-body div[data-content-name='point'] p").text("최대 "+employeePoint+" 멤버십 포인트 적립");
                        $("#buyBenefitInfoPopupNew .tabs li[data-active-target='point']").show();

                        $("#employeeTabMaxBenefitPopupPoint").text("+ 구매시, LG전자 멤버십 포인트 "+employeePoint+" 원 적립");
                        $("#employeeTabMaxBenefitPopupPoint").show();
                    }else{
                        $("#buyBenefitInfoPoint").hide();
                        $("#buyBenefitInfoPopupNew .tabs li[data-active-target='point']").hide();
                        $("#employeeTabMaxBenefitPopupPoint").hide();
                    }


                    let benefitsCnt = $("#employeeTabMaxBenefitPopup .additional-benefits li").filter(function() {
                        return $(this).css('display') !== 'none';
                    }).length;
                    if(benefitsCnt > 0){
                        $("#employeeTabMaxBenefitPopup .additional-benefits").show();
                    }else{
                        $("#employeeTabMaxBenefitPopup .additional-benefits").hide();
                    }
                }
            }
        },

        /* 임직원 소모품 할인가 BTOCSITE-60292 */
        displayDisposalbeEmployeeArea : function () {
            var self = this;

            if(lgkorUI.stringToBool(loginFlag) && !vcui.isEmpty(self.memberPartnerGrp) && self.memberPartnerGrp != self.default_partner_grp){
                if(self.partnerPrice > 0 && self.partnerPrice < memberDiscountPrice){
                    var $priceArea;
                    var $priceTotalArea;
                    var $percentArea;
                    var $employeePrice = $('.is-price-calc-new .payment .price');
                    // 임직원으로 표시 or 복지몰로 표시 여부 확인
					var actionSheetDiscountTypeName = (self.emp_partner_grp.indexOf(self.memberPartnerGrp) > -1 ? '임직원' : '복지몰') +' 할인';
					$('#actionSheetDiscountType').text(actionSheetDiscountTypeName);
                    // $('#actionSheetDiscountType').css("display","");

                    $('#employeeDisposableArea').css('display', 'block');
                    $('#employeeDisposableTotalPriceArea').css('display', 'block');
                    $priceArea = $('#employeeDisposablePriceArea .content .price');
                    $percentArea = $('#employeeDisposablePriceArea .content .percent');


                    $priceArea.html('<em class="blind">가격</em><em>' + vcui.number.addComma(self.partnerPrice) + '</em>원');
                    $percentArea.html('<em class="blind">할인율</em>'+Math.floor((Number(self.obsOriginalPrice)-Number(self.partnerPrice))/Number(self.obsOriginalPrice)*100.0) + '%');
                    
                    $employeePrice.html('<em>' + vcui.number.addComma(self.partnerPrice * parseInt($('div.pdp-info-area .payment-amount input.quantity').val())) + '</em>원'); // BTOCSITE-70412

                    //BTOCSITE-68092 소모품 임직원 쿠폰 ( 임직원일시 탭 활성화
                    $('#employeeDisposableTab').css('display', 'block');
                    $('#employeeDisposableArea').css('display', 'none');
                    $('#priceArea').css('display', 'none');
                    $tabArea = $('#employeeDisposableTabArea .tabs-price .employee');
                    $tabArea.text(vcui.number.addComma(self.partnerPrice) + '원');

                    $tabPriceArea = $('#employeeDisposableTabPriceArea .content .price');
                    $tabPercentArea = $('#employeeDisposableTabPriceArea .content .percent');

                    $tabPriceArea.html('<em class="blind">가격</em>'+vcui.number.addComma(self.partnerPrice) + '원');
                    $tabPercentArea.html('<em class="blind">할인율</em>'+Math.floor((Number(self.obsOriginalPrice)-Number(self.partnerPrice))/Number(self.obsOriginalPrice)*100.0) + '%');

                    $priceTotalArea = $('#employeeDisposableTotalPriceArea .content .price');
                    $priceTotalArea.text(vcui.number.addComma(self.partnerPrice) + '원');

                    if(Math.floor((Number(self.obsOriginalPrice)-Number(self.partnerPrice))/Number(self.obsOriginalPrice)*100.0) < 1){
                        $percentArea.remove();
                    }else{
                        $percentArea.show();
                    }

                    $('span[id^="b2cBadge"]').hide();
                    if(self.partnerBoldBadgesArr && self.partnerBoldBadgesArr.length > 0 && $('span[id^="employeeBadge"]').length == 0){
                        let boldBadges = self.partnerBoldBadgesArr.map(function(item, index, array) {
                            if(index < 2){
                                let template = '<span class="flag imp" id="employeeBadge_' + index + '">' + item.badgeName + '</span>';
                                return template;
                            }
                        }).join('');

                        $('#badgeArea').append(boldBadges);
                    }
                    // 바텀영역 일반 쿠폰할인가 비노출
                    $('.total-coupon-payment').hide();

                    KRP0008.bottomFoldAreaControl('Y');
                }
            }
        },

		setCookie: function(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + value + expires + "; path=/";
		},

        //BTOCSITE-46911 : 임직원 전용제품 구매하기 버튼 적용하기 위한 처리
        displayEmployeeBuyBtn : function () {
            var self = this;
            try {
                self.checkIntervalCount++;
                if(self.checkIntervalCount < 20) {
                    if ($("#contentLoading").is(':visible') == false) {
                       self.displayEmployeeArea();
                        self.interValStop(self.checkIntervalTimer);
                    }
                } else {
                    $('#extraBtn').hide();
                    self.interValStop(self.checkIntervalTimer);
                }
            } catch (e) {
                $('#extraBtn').hide();
                self.interValStop(self.checkIntervalTimer);
            }
        },
        interValStop : function(timer){
            clearInterval(timer);
        },

        // (BTOCSITE-44432 | PDP 진입시 모델정보 세션 저장)
        defaultValueInit: function() {
            var data = { 'modelId' : lgePdpSendData.modelId, 'categoryId' : lgkorUI.getHiddenInputData().defaultCategoryId};
            lgkorUI.setStorage("recent_view_pdp_info", data);
        },

        // BTOCSITE-48212 SFDC 오픈 대응 소모품 주문 불가 레이어 팝업 작업 요청
        disposablePaymentButtonInit:function (code , message) {
            let bizType = lgkorUI.getHiddenInputData().bizType;

            //메세지 코드와 구성 코드 값을 받아서 추후 공통으로 사용 가능
            let param = {
                code:code,
                message : message
            };

            try {
                lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/isDisplayPaymentButtonArea", {
                    method: "POST",
                    data: param,
                    success: function (result) {
                        let displayFlag = result.data.flag
                        // 소모품 외에 적용 할려면 삼항 조건문 삭제
                        purchaseButtonDisplay = (bizType === "DISPOSABLE") ? displayFlag : "Y";
                        if (displayFlag === "N") {
                            purchaseButtonMassage = result.data.message;
                        }
                    },
                    error: function (e) {
                        console.log(e);
                    }
                });
            }catch (e) {
                console.log(e)
            }
        },

        // BTOCSITE-49751 [상품] 딜 플랫폼
        setTimeDeal: function () {
            var self = this; //  BTOCSITE-89574
            try {
                let timeDealProduct = null;
                let endDateTime;

                let param = {
                    "modelId": lgePdpSendData.modelId,
                    "modelStatusCode": lgePdpSendData.modelStatusCode
                };
                //  BTOCSITE-89574 START
                var $timeDealPcTemplate = $('#time-deal-area-pc');
                var $timeDealMoTemplate = $('#time-deal-area-mo');
                var $timeDealAreaPc = $($timeDealPcTemplate.html());
                var $timeDealAreaMo = $($timeDealMoTemplate.html());
                //  BTOCSITE-89574 END

                lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrieveDealProduct", {
                    data: param,
                    method: 'POST',
                    success: function (result) {
                        var timeDealProduct = result.data.dealProductModel; //  BTOCSITE-89574

                        if (timeDealProduct != null && timeDealProduct.modelId !== undefined && timeDealProduct.modelId !== null) {
                            lgePdpSendData.isTimeDeal = true;

                            $('#memberPrice').css('display', 'none');
                            $('#timeDealPrice').css('display', 'block');

                            let timeDealInfo = {
                                isTimeDealSoldOut: false,
                                remainingCount: '',
                                remainingDay: '',
                            };

                            //  BTOCSITE-89574 START
                            var modelStatusCodeValue = self.$pdpInfo.attr('data-model-status-code');
                            if ((timeDealProduct.dealInventoryQty == 0 && 'ACTIVE' == modelStatusCodeValue) || (timeDealProduct.dealInventoryQty > 0 && 'SOLD_OUT' == modelStatusCodeValue)) {
                                /* 만약 이 두 가지 경우 중 하나에 해당된다면 (비정상)
                                1. 구매하기 버튼 상태를 일시품절 버튼으로 변경합니다.
                                2. 아래 이미지와 같이 타임딜 영역의 UI를 비노출하게 처리합니다. */
                                timeDealProduct.timeDealSoldOut = true;

                            }
                            //  BTOCSITE-89574 END

                            if (timeDealProduct.timeDealSoldOut) { // BTOCSITE-89574
                                $timeDealAreaPc.addClass('soldout');
                                $timeDealAreaMo.addClass('soldout');

                                timeDealInfo.isTimeDealSoldOut = timeDealProduct.timeDealSoldOut; // BTOCSITE-89574


                                // BTOCSITE-89574 START
                                //KRP0008.$pdpInfo.find('div.purchase-button.pre-order button.btn.oneLineBtn').prop('disabled', true).addClass('disabled').find('span').text('일시품절');
                                var btnBuyNow = KRP0008.$pdpInfo.find('div.purchase-button.pre-order button.btn.oneLineBtn');
                                if (btnBuyNow.length == 0) {
                                    btnBuyNow = self.$pdpInfo.find('div.purchase-button a:not(.cart, .btn-cart, .btnTelCall, .black, .soldOk, .ai )');
                                }
                                btnBuyNow.prop('disabled', true).addClass('disabled').find('span').text('일시품절');
                                // BTOCSITE-89574 END

                            } else {
                                timeDealInfo.remainingCount = timeDealProduct.dealInventoryQty + '개 남음';

                                endDateTime = new Date(timeDealProduct.endDate);

                                // BTOCSITE-55771 타임딜
                                const current = new Date();
                                const utc = current.getTime() + (current.getTimezoneOffset() * _MINUTE);
                                const currentKRDateTime = new Date(utc + (KR_TIME_DIFF));

                                let remainingTime = endDateTime - currentKRDateTime;
                                if (remainingTime > _DAY) {
                                    let days = Math.floor(remainingTime / _DAY);
                                    // BTOCSITE-72837 START
                                    timeDealInfo.remainingDay = "D-" + days;
                                    // BTOCSITE-72837 END
                                }

                                clearInterval(timeDealTimer);
                                timeDealTimer = setInterval(function () {
                                    KRP0008.calculateRemainingTime(endDateTime, $('.time-deal-area > span.time'));
                                }, 1000);
                            }
                            // BTOCSITE-61287 START
                            $(".time-deal-area.no-timedeal").hide().promise().then(function () {
                                $timeDealAreaPc.append(vcui.template(timeDealInnerTemplate, timeDealInfo));
                                $timeDealAreaMo.append(vcui.template(timeDealInnerTemplate, timeDealInfo));

                                $timeDealPcTemplate.after($timeDealAreaPc);
                                $timeDealMoTemplate.after($timeDealAreaMo);

                                // BTOCSITE-58033 START
                                let showMoreButtonElement = document.getElementsByClassName('time-deal-area pc')[0].getElementsByTagName('a')[0];
                                showMoreButtonElement.setAttribute('style', 'display: none');
                                let isActiveShowMore = timeDealProduct.isActiveShowMore;
                                if (!isActiveShowMore) {
                                    showMoreButtonElement.setAttribute('style', 'display: none');
                                } else {
                                    showMoreButtonElement.setAttribute('style', 'display: unset');
                                }
                                //e BTOCSITE-58033 END
                            });
                            // BTOCSITE-61287 END

                            // BTOCSITE-54300 딜플랫폼 딜재고차감 및 주문/결제 프로세스 개선 건
                            KRP0008.$pdpInfo.find('div.purchase-button.default div.btn-group a.btn.cart').css('display', 'none'); // 장바구니 버튼 미노출
                            // KRP0008.$pdpInfo.find('div.box.payment-amount.count-check > div.info-text > p.time-deal-info').css('display', 'block'); // 타임딜 안내 문구 노출
                        }
                    },
                    error: function (e) {
                        console.log(e);
                    }
                });
            } catch (e) {
                console.log(e);
            }
        },

        /* BTOCSITE-112460 : 임직원/제휴사 타임딜 적용 *//* B2C 메소드 copy 후 정리 */
        setTimeDealB2b: function () {

            try {

                let param = {
                    "modelId": lgePdpSendData.modelId,
                    "modelStatusCode": lgePdpSendData.modelStatusCode
                };

                lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrieveDealProduct", {
                    data: param,
                    method: 'POST',
                    success: function (result) {
                        let timeDealProduct = result.data.dealProductModel; //  BTOCSITE-89574

                        if (timeDealProduct != null && timeDealProduct.modelId !== undefined && timeDealProduct.modelId !== null) {
                            lgePdpSendData.isTimeDeal = true;

                            // BTOCSITE-54300 딜플랫폼 딜재고차감 및 주문/결제 프로세스 개선 건
                            KRP0008.$pdpInfo.find('div.purchase-button.default div.btn-group a.btn.cart').css('display', 'none'); // 장바구니 버튼 미노출
                            KRP0008.$pdpInfo.find('div.box.payment-amount.count-check > div.info-text > p.time-deal-info').css('display', 'block'); // 타임딜 안내 문구 노출

                        }
                    },
                    error: function (e) {
                        console.log(e);
                    }
                });
            } catch (e) {
                console.log(e);
            }
        },

        // 1초 타이머
        calculateRemainingTime: function(targetDateTime, targetElement) {
            try {
                const current = new Date();
                const utc = current.getTime() + (current.getTimezoneOffset() * _MINUTE);
                const currentKRDateTime = new Date(utc + (KR_TIME_DIFF));

                let remainingTime = targetDateTime - currentKRDateTime;

                if (remainingTime > _DAY) {
                    clearInterval(timeDealTimer);
                } else {
                    if (remainingTime <= 0) {
                        clearInterval(timeDealTimer);
                    } else {
                        let hours = Math.floor((remainingTime % _DAY) / _HOUR);
                        let minutes = Math.floor((remainingTime % _HOUR) / _MINUTE);
                        let seconds = Math.floor((remainingTime % _MINUTE) / _SECOND);

                        hours = hours < 10 ? "0" + hours : hours;
                        minutes = minutes < 10 ? "0" + minutes : minutes;
                        seconds = seconds < 10 ? "0" + seconds : seconds;

                        targetElement.text(hours + ":" + minutes + ":" + seconds);
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },

        // 구매하기 버튼 영역 // BTOCSITE-68538 [모니터링 G][APP] Chatbot 아이콘 위에 Top버튼이 노출
        setPaymentBtnArea: function () {
            var self = this;

            if (self.$actionSheetCallBtn && self.$actionSheetCallBtn.length > 0) {
                var areaH = 0;
                var $rentalSheet = self.$actionSheet.filter('.rental-sheet');

                // 구독 월 요금영역 존재하면 높이 추가
                if ($rentalSheet.length > 0) areaH += $rentalSheet.outerHeight();

                var floatingWrap = document.querySelector(".floating-wrap");
                var btnFloatingWrap = document.querySelector(".btn-floating-wrap");
    
                // [S] BTOCSITE-82293 사업자몰(B2B)구독 도입 // top버튼 위치 수정
                if (window.breakpoint.isMobile) {
                    areaH += self.$actionSheetCallBtn.outerHeight();
                    if (floatingWrap) floatingWrap.style.setProperty('--bottom', areaH + 'px');
                    if (btnFloatingWrap) btnFloatingWrap.style.setProperty('--bottom', areaH + 'px');
                } else {
                    if (floatingWrap) floatingWrap.style.removeProperty('--bottom');
                    if (btnFloatingWrap) btnFloatingWrap.style.removeProperty('--bottom');
                }
                // [E] BTOCSITE-82293 사업자몰(B2B)구독 도입 // top버튼 위치 수정
            }
        },

        b2bCartCheck: function() {     // b2b일 때 장바구니 체크
            var self = this;

            if(lgkorUI.stringToBool(loginFlag)){

                if(self.memberPartnerGrp === "ENT") { //사업자회원(승인 완료)
                    return true;
                } else if(self.memberPartnerGrp === 'B2C' || self.bsnsMbrStat === 'WAIT') { //B2C회원(사업자회원 승인대기)
                    $('#businessMembershipMoreAlert4').vcModal({opener: document.activeElement}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    return false;
                } else { // 일반회원 (b2c 회원 외에 임직원 계정도 b2b에서는 일반회원 취급)
                    $('#businessMembershipMoreAlert3').vcModal({opener: document.activeElement}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    return false;
                }
            }else{
                $('#businessMembershipMoreAlert2').vcModal({opener: document.activeElement}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                return false;
            }
        },

        //BTOCSITE-48266 [상품] B2B OBS 구축 start
        b2bLoginCheck: function(e) {     // b2b일 때 로그인 체크
            var self = this;
            var opener = $(e.currentTarget).length ? e.currentTarget : ''; // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
            
            // BITCSITE-85521
            if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "CARETAB"){
                if (lgkorUI.stringToBool(loginFlag)) {
                    if(self.bsnsMbrStat === 'WAIT') {//B2C회원(사업자회원 승인대기)
                        $('#businessMembershipMoreAlert4').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    } else if(self.memberPartnerGrp === 'B2C'){
                        $('#businessMembershipMoreAlert3').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    } else if (self.bsnsMbrStat === 'USE') {
                        if (self.bsnsMbrUpdStat === 'UPD') {
                            let className = e.currentTarget.className;
                            if(className.indexOf("btn black") != -1){         // 견적문의 엑션시트
                                return true;
                            } else if(className.indexOf("cart") != -1){       // 장바구니 담기는 수정승인 체크 안함
                                return true;
                            } else if(className.indexOf("link-area") != -1){  // 견적문의 배너 버튼
                                return true;
                            } else{
                                $('#businessMembershipMoreAlert6').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                                return false
                            }
                        } else if (self.bsnsType === 'ENT' && !self.rprsnNm.includes(self.mbrName)) {
                            $('#businessMembershipMoreAlert5').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        $('#businessMembershipMoreAlert3').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    }
                } else {
                    $('#businessMembershipMoreAlert2').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                    return false;
                }
            }else{
                if(lgkorUI.stringToBool(loginFlag)){

                    if(self.bsnsMbrStat === 'WAIT') {//B2C회원(사업자회원 승인대기)
                        $('#businessMembershipMoreAlert4').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    } else if(self.memberPartnerGrp === 'B2C'){
                        $('#businessMembershipMoreAlert3').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    } else if (self.bsnsMbrStat === 'USE') {
                        return true;
                    } else { // 일반회원 (b2c 회원 외에 임직원 계정도 b2b에서는 일반회원 취급)
                        $('#businessMembershipMoreAlert3').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                        return false;
                    }
                }else{
                    $('#businessMembershipMoreAlert2').vcModal({opener:opener}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // b2b 로그인 체크 팝업 close 시 포커스 이동
                    return false;
                }
            }
        },

        // 가격영역, 액션시트, 장바구니,구매하기 버튼 영역
        displayB2bPriceArea : function () {
            var self = this;
            let inputdata = lgkorUI.getHiddenInputData();
            let modelPartnerGrp = inputdata.partnerGrp;
            let displaySmartHomeBuybtn = inputdata.displaySmartHomeBuybtn;

            $('#noneBusinessProductDetail').hide(); // LGE.COM에서는 제품정보만 제공하고 있습니다. 문구
            $('#businessBadgeArea').show(); // 뱃지영역
            $('#businessCompareArea').show(); //비교하기버튼
            $('#businessProductDetail').show();//가격영역
            $('#actionSheetCall').show();
            if(displaySmartHomeBuybtn === "N"){
                $('#extraBtn').hide();
            }else{
                $('#extraBtn').show();
            }

            if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "CARETAB"){            // b2b 구독
                if(lgkorUI.stringToBool(loginFlag) && self.bsnsType == 'ENT' && self.bsnsMbrStat == 'USE'){
                    $('#b2bBenefitsPrice').show();
                    $('#b2bBenefitsInfo').show();
                    $('#b2bPriceLogin').show();
                    $('#b2bPriceMbLogin').show();
                    $('#b2bRentalPriceInfoDisp').show();
                    $('#b2bMbBestDiscountPrice').show();
                    
                    // BTOCSITE-113740 [Afterjob][구독] LGE.COM 가전구독 PLP/PDP 內 물동정보(내일배송 뱃지) 노출 (사업자몰)
                    $('#b2bRentalNoticeList .details-header-business').show();
                    $('#b2bRentalNoticeList .details-box-business').removeClass('open')
                    
                }else{
                    $('#b2bBenefitsPrice').hide();
                    $('#b2bBenefitsInfo').hide();
                    $('#b2bRentalPriceInfoDisp').hide();
                    $('#b2bMbBestDiscountPrice').hide();
                    
                    // BTOCSITE-113740 [Afterjob][구독] LGE.COM 가전구독 PLP/PDP 內 물동정보(내일배송 뱃지) 노출 (사업자몰)
                    $('#b2bRentalNoticeList .details-header-business').hide();
                    $('#b2bRentalNoticeList .details-box-business').addClass('open')
                }

                if(lgkorUI.stringToBool(loginFlag)){
                    $('#b2bPriceInfoNonLogin').hide();
                    $('#b2bPriceInfoMbNonLogin').hide();
                    $('#b2bPriceInfoLogin').show();
                    $('#b2bPriceInfoMbLogin').show();
                    if(self.memberPartnerGrp === 'B2C' || self.bsnsMbrStat === 'WAIT') {//B2C회원(사업자회원 승인대기)
                        $('#b2bPriceInfoNonLogin').show();
                        $('#b2bPriceInfoMbNonLogin').show();
                        $('#b2bPriceInfoLogin').hide();
                        $('#b2bPriceInfoMbLogin').hide();
                    }
                    if(self.bsnsType == 'CORP'){
                        $('#b2bPriceLogin').show();
                        $('#b2bPriceInfoMbLogin').hide();       // 모바일은 가격을 보여주지 않음.
                        $('#b2bPriceMbLogin').hide();       // 모바일은 가격을 보여주지 않음.
                    }
                }else{
                    $('#b2bPriceInfoLogin').hide();
                    $('#b2bPriceInfoMbLogin').hide();
                    $('#b2bPriceInfoNonLogin').show();
                    $('#b2bPriceInfoMbNonLogin').show();
                }

                if(self.memberPartnerGrp === 'B2C'){
                    $('#b2bPriceInfoLogin').hide();
                    $('#b2bPriceInfoMbLogin').hide();
                    $('#b2bPriceInfoNonLogin').show();
                    $('#b2bPriceInfoMbNonLogin').show();
                }
            }else if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgePdpSendData.bizTypeDetail === "PRODUCT"){      // b2b 일시불
                if(self.memberPartnerGrp === 'ENT'){
                    //로그인
                    if(lgkorUI.stringToBool(loginFlag)){
                        $('#businessPriceAreaNoneLogin').hide();
                        $('#totalPaymentNoneLogin').hide();
                        $('#totalPaymentLogin').show();
                        $('#paymentCount').show();

                        if(Number(self.partnerPrice) > 0){
                            $('#businessPriceAreaLogin').show();
                            $('#actionSheetPopup').show();
                            $("[id^='b2bMonthPriceArea_']").show();
                            $("[id^='b2bMonthPriceAreaNonLogin_']").hide();

                            if(self.bsnsType == 'ENT' && self.bsnsMbrStat == 'USE'){
                                $("[id^='b2bMaxSalePriceArea_']").show();
                                $("[id^='b2bMonthPriceArea_']").show();
                                $("[id^='b2bMonthPriceAreaNonLogin_']").hide();
                            }else{
                                $("[id^='b2bMaxSalePriceArea_']").hide();

                                if(self.bsnsType == 'CORP'){
                                    $("[id^='b2bMonthPriceArea_']").show();
                                }else{
                                    $("[id^='b2bMonthPriceArea_']").hide();
                                    $("[id^='b2bMonthPriceAreaNonLogin_']").show();
                                }
                            }


                            $('#businessPriceText').text(vcui.number.addComma(self.partnerPrice) + '원');
                            $('#totalPayment').text(vcui.number.addComma(self.partnerPrice) + '원');

                            //견적문의
                            if(lgePdpSendData.modelStatusCode === "ACTIVE"){
                                self.displayB2bOnlineCounselArea();
                            }
                        }else{
                            if(lgePdpSendData.modelStatusCode === "READY_FOR_SALE"){
                                $('#readyForSaleNonePrice').show();
                                $('#businessProductDetail').hide();
                            }else if(lgePdpSendData.modelStatusCode === "SOLD_OUT"){
                                $('#businessProductDetail').hide();
                                $('#noneBusinessProductDetail').show();
                            }else if(lgePdpSendData.modelStatusCode === "ACTIVE"){
                                $('#noneBusinessProductDetail').show();
                                $('#businessProductDetail').hide();
                                $('#actionSheetCall').hide();
                            }
                        }

                        if(lgePdpSendData.modelStatusCode === "NOT_FOR_SALE"){
                            self.displayB2bOnlineCounselArea();
                        }
                    }else{
                        $('#totalPaymentLogin').hide();
                        $('#paymentCount').hide();
                        $("[id^='b2bMonthPriceAreaNonLogin_']").show();
                        //비로그인
                        if(lgePdpSendData.modelStatusCode === "READY_FOR_SALE"){
                            $('#noneBusinessProductDetail').hide();// LGE.COM에서는 제품정보만 제공하고 있습니다. 문구
                            $('#actionSheetCall').show();//장바구니, 구매하기 버튼

                            if(Number(self.partnerPrice) > 0){
                                $('#businessProductDetail').show(); //가격전체영역
                                $('#businessPriceAreaLogin').hide(); //가격영역
                                $('#readyForSaleNonePrice').hide();
                                $('#businessPriceAreaNoneLogin').show();
                            }else{

                                $('#readyForSaleNonePrice').show();
                                $('#businessProductDetail').hide();
                            }
                        }else if(lgePdpSendData.modelStatusCode === "SOLD_OUT"){
                            if(Number(self.partnerPrice) > 0){
                                $('#businessProductDetail').show();
                                $('#businessPriceAreaNoneLogin').show();
                            }else{
                                $('#businessProductDetail').hide();
                                $('#noneBusinessProductDetail').show();
                            }
                        }else if(lgePdpSendData.modelStatusCode === "ACTIVE"){
                            if(Number(self.partnerPrice) > 0){
                                $('#totalPaymentNoneLogin').show();
                                $('#businessProductDetail').show();
                                $('#businessPriceAreaNoneLogin').show();
                                self.displayB2bOnlineCounselArea();
                            }else{
                                $('#totalPaymentNoneLogin').hide();
                                $('#businessProductDetail').hide();
                                $('#actionSheetCall').hide();
                                $('#noneBusinessProductDetail').show();// LGE.COM에서는 제품정보만 제공하고 있습니다. 문구
                            }
                        }else if(lgePdpSendData.modelStatusCode === "NOT_FOR_SALE"){
                            self.displayB2bOnlineCounselArea();
                        }
                    }
                }else{      //B2C 횡원
                    $("[id^='b2bMonthPriceAreaNonLogin_']").show();
                    // 가격이 0일 경우...
                    if(Number(self.partnerPrice) > 0){
                        if(lgePdpSendData.modelStatusCode === "READY_FOR_SALE"){
                            $('#readyForSaleNonePrice').hide();
                        }
                        if(lgePdpSendData.modelStatusCode === "ACTIVE" || lgePdpSendData.modelStatusCode === "NOT_FOR_SALE"){
                            self.displayB2bOnlineCounselArea();
                        }
                        $('#businessProductDetail').show(); //가격영역
                        $('#businessPriceAreaNoneLogin').show();
                        $('#businessPriceAreaLogin').hide();
                        $('#totalPaymentNoneLogin').show();
                        $('#totalPaymentLogin').hide();
                        $('#paymentCount').hide();
                    }else{
                        if(lgePdpSendData.modelStatusCode === "READY_FOR_SALE"){
                            $('#businessProductDetail').hide(); //가격영역
                            $('#readyForSaleNonePrice').show();
                        }else if(lgePdpSendData.modelStatusCode === "ACTIVE" || lgePdpSendData.modelStatusCode === "SOLD_OUT"){
                            $('#actionSheetCall').hide(); //가격영역
                            $('#businessProductDetail').hide(); //가격영역
                            $('#noneBusinessProductDetail').show();// LGE.COM에서는 제품정보만 제공하고 있습니다. 문구
                        }else if(lgePdpSendData.modelStatusCode === "NOT_FOR_SALE"){
                            $('#businessProductDetail').show(); //가격영역
                            self.displayB2bOnlineCounselArea();
                        }
                    }
                } //B2C 횡원
            } // b2b PRODUCT
        },

        //견적문의 하기 영역 노출 조건
        displayB2bOnlineCounselArea : function () {
            let inputdata = lgkorUI.getHiddenInputData();
            let modelPartnerGrp = inputdata.partnerGrp;
            let quoteInquiryFlag = inputdata.quoteInquiryFlag;

            //견적문의플래그 ="Y" and 상품판매대상이 일반+사업자, 사업자 경우 노출
            if(quoteInquiryFlag === "Y" &&  ((modelPartnerGrp.indexOf("B2C") > -1 && modelPartnerGrp.indexOf("ENT") > -1) || modelPartnerGrp === "ENT")){
                $('#onlineCounselArea').show();

            }else{
                $('#onlineCounselArea').hide();
            }
        },

        //클릭 이벤트
        b2bClickEventLoad: function (e) {
            $('#memberPriceLook .blt-arrow').unbind('click').bind('click',function(e){
                e.preventDefault();
                KRP0008.b2bLoginCheck(e);
            });

            $('#totalPaymentNoneLogin .blt-arrow').unbind('click').bind('click',function(e){
                e.preventDefault();
                KRP0008.b2bLoginCheck(e);
            });

            $('#businessMembershipLogin').unbind('click').bind('click',function(e){
                e.preventDefault();
                var loginUrl = "/sso/member/login?state=";
                var moveUrl = location.pathname + location.search;
                location.href = vcui.uri.updateQueryParam(
                    loginUrl,
                    "state",
                    encodeURIComponent(moveUrl)
                );
            });

            //일시불 베너
            $('#businessMembershipLoginMovePurchase').unbind('click').bind('click',function(e){
                e.preventDefault();
                let loginUrl = "/sso/member/login?state=";
                let moveUrl = $('#b2bLumpSumPurchase').data("url");
                location.href = vcui.uri.updateQueryParam(
                    loginUrl,
                    "state",
                    encodeURIComponent(moveUrl)
                );
            });

            //사업자 인증하기 화면
            $('#goCertification').unbind('click').bind('click',function(e){
                e.preventDefault();
                var moveUrl = location.pathname + location.search;
                var loginUrl = "/business/registration";
                location.href = vcui.uri.updateQueryParam(
                    loginUrl,
                    "state",
                    encodeURIComponent(moveUrl)
                );
            });

            // 온라인 견적문의 버튼
            $('#onlineCounsel .counsel-link').unbind('click').bind('click',function(e){
                e.preventDefault();
                //&qty=4 추가
                let url = $('#onlineCounsel').data("url");
                window.location.href = url;
            });

            // b2b 견적문의 버튼
            $('#b2bOnlineCounsel .link-area , #b2bCorpEstimate , #b2bCorpCounsel').unbind('click').bind('click',function(e){
                e.preventDefault();

                //&qty=4 추가
                // BTOCSITE-101896 [구독][모니터링][공통] B2B_가전구독 PDP > '견적문의' 페이지로 넘어갈 시, 구매수량 'undefined' 노출
                let qty = !vcui.isEmpty($('#quantity').val()) ? $('#quantity').val() : 1;
                let url = $('#b2bOnlineCounsel').data("url")+'&qty='+qty;
                console.log("businessCounsel" + url);
                let callBackValue = KRP0008.b2bLoginCheck(e);
                if(callBackValue){
                    if(isApp()) {
                        if(vcui.detect.isIOS){
                            window.location.href = url;
                        }else{
                            let openNewWindow = window.open("about:blank");
                            openNewWindow.location.href = url;
                        }
                    } else {
                        // let openNewWindow = window.open("about:blank");
                        // openNewWindow.location.href = url;
                        window.location.href = url;
                    }
                }
            });

            // 견적문의
            $('#businessCounsel').unbind('click').bind('click',function(e){
                e.preventDefault();
                // BTOCSITE-101896 [구독][모니터링][공통] B2B_가전구독 PDP > '견적문의' 페이지로 넘어갈 시, 구매수량 'undefined' 노출
                let qty = !vcui.isEmpty($('#quantity').val()) ? $('#quantity').val() : 1;
                let url = $('#b2bOnlineCounsel').data("url")+'&qty='+qty;

                if(isApp()) {
                    if(vcui.detect.isIOS){
                        window.location.href = url;
                    }else{
                        let openNewWindow = window.open("about:blank");
                        openNewWindow.location.href = url;
                    }
                } else {
                    window.location.href = url;
                }
            });

            // B2B 구독 일시불 구매
            $('#b2bLumpSumPurchase').unbind('click').bind('click',function(e){
                e.preventDefault();
                let url = $('#b2bLumpSumPurchase').data("url");
                if (lgkorUI.stringToBool(loginFlag)) {
                    window.location.href = url;
                }else{
                    $('#businessMembershipMoreAlertMovePurchase').vcModal({opener: this}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    return false;
                }
            });

            $('.b2bOfferBannerLink').unbind('click').bind('click', function (e) {
                e.preventDefault();
                let url = $(this).data("url");
                if (lgkorUI.stringToBool(loginFlag)) {
                    window.location.href = url;
                } else {
                    $('#businessMembershipMoreAlertMovePurchase').vcModal({ opener: this });
                    return false;
                }
            });

        },
        //BTOCSITE-72646 START
        getTemplateContent: function (templateId) {
            const template = $('#promotionBadgeTemplate')[0];
            if (template) {
                const content = $(template.content).find(`#${templateId}`);
                return content.length ? content.html() : '';
            }
            return '';
        },
        appendTemplate: function (templateId, targetElement) {
            const templateContent = KRP0008.getTemplateContent(templateId);
            if (templateContent) {
                $(targetElement).append(templateContent);
            }
        },
        //BTOCSITE-72646 END
        //BTOCSITE-48266 [상품] B2B OBS 구축 end

        //[BTOCSITE-73060] 제품 PDP UI 개선 start
        // fold 영역 가격계산 및 control
        bottomFoldAreaControl : function(empYn){
            /**
             * displayEmployeeArea : 일반 상품정보 로딩시
             * displayDisposalbeEmployeeArea : 소모품 상품정보 로딩시
             * $('#employeePriceTabArea .tabs > li') : 일반 tab 선택시(임직원 /일반)
             * $('#employeeDisposableTab .tabs > li') : 소모품 tab 선택시(임직원 /일반)
             */
            let self = this;
            let foldPriceArea = $('#foldPriceArea');
            let partnerEmpYN = 'N';
            if(self.emp_partner_grp.indexOf(self.memberPartnerGrp) > -1){
                partnerEmpYN = 'Y';
            }

            // 기존 수량 가져오기
            var quantity = parseInt($('.select-quantity .quantity').val()) || 1;

            // foldAreaPrice를 함수 맨 위에서 한 번만 선언
            let foldAreaPrice = 0;

            var $employeeCouponMember;
            var $welfareCouponMember;
            var initialPrice;

            // 번들링 할인이 활성화된 경우 번들 할인가, 세트 수량 사용
            var hasSelectedAdditions = KRP0008.additionModel && KRP0008.additionModel.getSelectedAdditionCount ? KRP0008.additionModel.getSelectedAdditionCount() > 0 : false;
            if (hasSelectedAdditions) {
                var $quantityInput = $('.payment-amount.bundling-set .quantity');
                if ($quantityInput.length) {
                    quantity = parseInt($quantityInput.val()) || 1;
                }

                let isEmployee = KRP0008.additionModel && KRP0008.additionModel.getIsEmployee ? KRP0008.additionModel.getIsEmployee() : false;
                let bundleDiscountPrice = isEmployee
                    ? vcui.number.parse(foldPriceArea.data('employee-bundle-discount-price') || 0)
                    : vcui.number.parse(foldPriceArea.data('bundle-discount-price') || 0);

                foldAreaPrice = bundleDiscountPrice;
            }

            if(foldPriceArea && foldPriceArea.length > 0){
                // 번들링 할인 적용이 아닌 경우 원가로 foldAreaPrice 세팅
                if (!hasSelectedAdditions) {
                    foldAreaPrice = foldPriceArea.data('orgPrice');
                }
                
                // 모든 가격 정보 영역 숨김
                $('#totalFoldPriceEmployeeInfo').hide();
                if($('#totalFoldPriceBusinessInfo') && $('#totalFoldPriceBusinessInfo').length > 0){
                    $('#totalFoldPriceBusinessInfo').hide();
                }
                $('#totalFoldPriceInfo').hide();
                if($('#totalFoldPriceBundleInfo') && $('#totalFoldPriceBundleInfo').length > 0){
                    $('#totalFoldPriceBundleInfo').hide();
                }
                // 번들 해제 시 번들 관련 영역 명시적으로 숨김
                $('#totalPaymentArea').hide();

                if (hasSelectedAdditions) {
                    // 추가품이 선택되었을 때: 총 금액만 표시
                    if($('#totalFoldPriceBundleInfo') && $('#totalFoldPriceBundleInfo').length > 0){
                        $('#totalFoldPriceBundleInfo').show();
                    }
                    $('#totalPaymentArea').show();
                    $('#actionSheetDiscountType').text('');
                    // 번들 선택 시 임직원/복지몰 가격 영역 숨김
                    $('#employeePriceTotalArea').hide();
                    $('#partnerPriceTotalArea').hide();
                    
                    // 번들 선택 전에 쿠폰할인가가 노출되어 있으면 계속 노출
                    $employeeCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-member');
                    $welfareCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-welfare');
                    
                    // 번들 선택 전 쿠폰할인가 노출 여부 확인
                    var wasEmployeeCouponVisible = $employeeCouponMember.is(':visible') && $employeeCouponMember.data('set-coupon-discount-price') == 'Y';
                    var wasWelfareCouponVisible = $welfareCouponMember.is(':visible') && $welfareCouponMember.data('set-coupon-discount-price') == 'Y';
                    
                    if (empYn == 'Y') {
                        // 임직원/복지몰 탭일 때
                        if (partnerEmpYN == "Y") {
                            // 임직원 탭: 번들 선택 전에 노출되어 있으면 계속 노출
                            if (wasEmployeeCouponVisible) {
                                // updatePaymentAmountPrice에서 이미 갱신되므로 여기서는 표시만 유지
                                // 숨기지 않음
                            } else {
                                $employeeCouponMember.hide();
                            }
                            $welfareCouponMember.hide();
                        } else {
                            // 복지몰 탭: 번들 선택 전에 노출되어 있으면 계속 노출
                            if (wasWelfareCouponVisible) {
                                // updatePaymentAmountPrice에서 이미 갱신되므로 여기서는 표시만 유지
                                // 숨기지 않음
                            } else {
                                $welfareCouponMember.hide();
                            }
                            $employeeCouponMember.hide();
                        }
                        // 일반 쿠폰할인가 숨김
                        $('.total-coupon-payment').hide();
                    } else {
                        // 일반 탭일 때는 쿠폰이 없으면 일반 쿠폰할인가 숨김
                        if ($('.total-coupon-payment .payment .price').data('set-coupon-discount-price') != 'Y') {
                            $('.total-coupon-payment').hide();
                        }
                        // 임직원/복지몰 쿠폰할인가 숨김
                        $employeeCouponMember.hide();
                        $welfareCouponMember.hide();
                    }
                } else {
                    // 추가품이 선택되지 않았을 때: 기존 로직대로 동작
                    if(empYn == 'Y'){   //임직원/복지몰 tab
                        if (partnerEmpYN == "Y") {
                            $('#totalFoldPriceEmployeeInfo').show();
                            $('#actionSheetDiscountType').text('임직원 할인');
                            // 임직원 가격 영역 표시
                            $('#employeePriceTotalArea').show();
                            // 임직원 쿠폰할인가는 쿠폰이 있을 때만 표시 (번들 선택 시에는 표시하지 않음)
                            $employeeCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-member');
                            if ($employeeCouponMember.length > 0 && $employeeCouponMember.data('set-coupon-discount-price') == 'Y') {
                                $employeeCouponMember.show();
                                // 초기 쿠폰 가격 저장 (탭별) - 이미 저장된 값이 없는 경우에만 저장
                                if (typeof _KRP0008_COUPON !== 'undefined' && !_KRP0008_COUPON.getInitialCouponPriceByTab('member')) {
                                    initialPrice = $employeeCouponMember.find('.payment .price').data('price');
                                    if (initialPrice) {
                                        _KRP0008_COUPON.setInitialCouponPriceByTab(initialPrice, 'member');
                                    }
                                }
                            } else {
                                $employeeCouponMember.hide();
                            }
                            // 복지몰 가격 영역 숨김
                            $('#partnerPriceTotalArea').hide();
                            $('.is-coupon-price-calc-new.is-popup-cont-welfare').hide();
                            // 번들 해제 시 totalPaymentArea 숨김 (임직원 탭일 때)
                            $('#totalPaymentArea').hide();
                        }else{
                            $('#actionSheetDiscountType').text('복지몰 할인');
                            if($('#totalFoldPriceBusinessInfo') && $('#totalFoldPriceBusinessInfo').length > 0) {
                                $('#totalFoldPriceBusinessInfo').show();
                            }
                            // 복지몰 가격 영역 표시
                            $('#partnerPriceTotalArea').show();
                            // 복지몰 쿠폰할인가는 쿠폰이 있을 때만 표시 (번들 선택 시에는 표시하지 않음)
                            $welfareCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-welfare');
                            if ($welfareCouponMember.length > 0 && $welfareCouponMember.data('set-coupon-discount-price') == 'Y') {
                                $welfareCouponMember.show();
                                // 초기 쿠폰 가격 저장 (탭별) - 이미 저장된 값이 없는 경우에만 저장
                                if (typeof _KRP0008_COUPON !== 'undefined' && !_KRP0008_COUPON.getInitialCouponPriceByTab('welfare')) {
                                    initialPrice = $welfareCouponMember.find('.payment .price').data('price');
                                    if (initialPrice) {
                                        _KRP0008_COUPON.setInitialCouponPriceByTab(initialPrice, 'welfare');
                                    }
                                }
                            } else {
                                $welfareCouponMember.hide();
                            }
                            // 임직원 가격 영역 숨김
                            $('#employeePriceTotalArea').hide();
                            $('.is-coupon-price-calc-new.is-popup-cont-member').hide();
                            
                            // 탭 전환 시 임직원 쿠폰 데이터 초기화 (복지몰 탭으로 전환)
                            if (typeof _KRP0008_COUPON !== 'undefined') {
                                _KRP0008_COUPON.resetTabCouponData('member');
                            }
                            // 번들 해제 시 totalPaymentArea 숨김 (복지몰 탭일 때)
                            $('#totalPaymentArea').hide();
                        }
                        foldAreaPrice = self.partnerPrice;
                    }else{  //일반 tab
                        if (typeof memberDiscountPrice !== 'undefined' && memberDiscountPrice > 0) {
                            foldAreaPrice = memberDiscountPrice;
                        }
                        $('#totalFoldPriceInfo').show();
                        $('#totalPaymentArea').show();
                        $('#actionSheetDiscountType').text('');
                        // 일반회원 탭일 때는 임직원/복지몰 가격 영역 숨김
                        $('#employeePriceTotalArea').hide();
                        $('#partnerPriceTotalArea').hide();
                        $('.is-coupon-price-calc-new.is-popup-cont-member').hide();
                        $('.is-coupon-price-calc-new.is-popup-cont-welfare').hide();
                    }
                }

                var additionTotalPrice = (KRP0008.additionModel && typeof KRP0008.additionModel.getAdditionTotalPrice === 'function')
                    ? KRP0008.additionModel.getAdditionTotalPrice()
                    : 0;

                foldPriceArea.find('#totalFoldPrice').html(
                    vcui.number.addComma((foldAreaPrice * quantity) + additionTotalPrice)
                );
            }
            KRP0008.calcTotalPriceAreaControl(empYn);
        },

        // fold 영역 금액 control
        calcTotalPriceAreaControl : function(empYn){
            /**
             * bottomFoldAreaControl : fold 영역 control
             *
             */
            let $totalCalcPayment = $('#totalCalcPayment');
            if($totalCalcPayment && $totalCalcPayment.length > 0) {
                let $calcNormal = $totalCalcPayment.find('#calcNormalAmt');
                let $calcEmp = $totalCalcPayment.find('#calcEmpAmt');
                if (empYn == 'Y') {   //임직원/복지몰 tab
                    $calcNormal.hide();
                    $calcEmp.show();
                } else {
                    $calcNormal.show();
                    $calcEmp.hide();
                }
            }
        },

        // 바텀 금액 계산
        calcTotalPrice : function(prefix,totalPrice,quantity,totalAdditional){
            /**
             * updatePaymentAmountPrice : 가격계산
             *
             */
            let self = this;
            let $totalCalcPayment = $('#totalCalcPayment');
            if($totalCalcPayment && $totalCalcPayment.length > 0){
                let $calcNormal = $totalCalcPayment.find('#calcNormalAmt');
                let $calcEmp = $totalCalcPayment.find('#calcEmpAmt');
                
                // 추가품이 선택되었는지 확인
                let hasSelectedAdditions = false;
                if (self.additionModel && typeof self.additionModel.getSelectedAdditionCount === 'function') {
                    hasSelectedAdditions = self.additionModel.getSelectedAdditionCount() > 0;
                }
                
                if (hasSelectedAdditions) {
                    // 추가품 선택 시: 번들 할인가 사용 (본품 가격 × 수량 + 추가품 총액)
                    // 일반가와 임직원가를 각각 계산
                    let normalBundleDiscountPrice = vcui.number.parse($('#foldPriceArea').data('bundle-discount-price') || 0);
                    let employeeBundleDiscountPrice = vcui.number.parse($('#foldPriceArea').data('employee-bundle-discount-price') || 0);
                    
                    // 추가품 총액을 일반가/임직원가 각각 계산
                    let normalAdditionTotalPrice = self.additionModel.calculateAdditionTotalPrice(false, quantity);
                    let employeeAdditionTotalPrice = self.additionModel.calculateAdditionTotalPrice(true, quantity);
                    
                    $calcNormal.html('<em>' + prefix + vcui.number.addComma((normalBundleDiscountPrice * quantity) + normalAdditionTotalPrice) + '</em>원');
                    $calcEmp.html('<em>' + prefix + vcui.number.addComma((employeeBundleDiscountPrice * quantity) + employeeAdditionTotalPrice) + '</em>원');
                } else {
                    // 추가품 없을 시: 기존 로직
                    $calcNormal.html('<em>' + prefix + vcui.number.addComma((totalPrice * quantity) + totalAdditional) + '</em>원');
                    $calcEmp.html('<em>' + prefix + vcui.number.addComma((self.partnerPrice * quantity) + totalAdditional) + '</em>원');
                }
            }
        },
        //[BTOCSITE-73060] 제품 PDP UI 개선 end

        //BTOCSITE-71987 LGE.CO.KR B2B제품 견적 문의 시 팝업 추가 요청 start
        onlineLinkMove : function () {
            $('#b2cLayerOnlineCounsel .counsel-link').off('click').on('click',function(e){
                e.preventDefault();
                let b2bUrl = $(e.target).attr('data-b2b-url');
                let popupYn = $(e.target).attr('data-popup-yn');

                if(popupYn === 'Y'){
                    let b2cUrl = $(e.target).attr('data-b2c-url');
                    $('#b2cOnlineCounselModal').vcModal({opener: this}); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 팝업 close 시 포커스 이동
                    $('#personQuestion').off('click').on('click',function(e){
                        window.location.href = b2cUrl;
                    });
                    $('#businessQuestion').off('click').on('click',function(e){
                        window.location.href = b2bUrl;
                    });
                }else{
                    window.location.href = b2bUrl;
                }

            });
        },
        //BTOCSITE-71987 LGE.CO.KR B2B제품 견적 문의 시 팝업 추가 요청 end

        // BTOCSITE-89574 START
        setValueExtraBtnByTimeDeal: function() {
            /* move 로직은 contentLoad가 로드된 후의 지점으로 btn extraBtn의 값을 변경하여 selector jquery가 #extraBtn을 찾지 못하는 비동기 오류를 방지합니다. */
            // [정리] B2C 전용 타임딜 일시품절 처리 제거: b2cYN==='Y'는 이 파일에서 항상 false
          //BTOCSITE-102516
            if(lgkorUI.getHiddenInputData().b2cYN ==='N' && lgkorUI.getHiddenInputData().bsnsType == 'CORP'){
            	$('#extraBtn').addClass("blind");       // 구독신청버튼을 보여주지 않음.
            }
        },
        // BTOCSITE-89574 END

        // BTOCSITE-97545 START
        setQuoteOnlCheck() {
            var modelStatusCodeValue = $('div.pdp-info-area').attr('data-model-status-code')
            if(lgkorUI.getHiddenInputData().defaultCategoryId === 'CT50019019' && modelStatusCodeValue === 'NOT_FOR_SALE') {
                // [정리] B2C 전용 온라인 견적 문의(.reservation.online-counsel) 분기 제거: b2cYN==='Y'는 이 파일에서 항상 false
                if ($('.rental-reservation-call').length !== 0){
                    $('#extraBtn').removeClass().addClass('online-menu btn black').text('견적 문의');
                    $('#extraBtn').show();
                    $('#extraBtn').off('click').on('click', function(e) {
                        e.preventDefault();
                        let url = $('#b2bOnlineCounsel').data("url")+'&qty='+$('#quantity').val();
                        let callBackValue = KRP0008.b2bLoginCheck(e);
                        if(callBackValue){
                            if(isApp()) {
                                if(vcui.detect.isIOS){
                                    window.location.href = url;
                                }else{
                                    let openNewWindow = window.open("about:blank");
                                    openNewWindow.location.href = url;
                                }
                            } else {
                                window.location.href = url;
                            }
                        }
                    });
                }
            }
            //BTOCSITE-113920 [Cutover] CSMS2.0 2차 대응
            if(lgePdpSendData.bizTypeDetail === "CARETAB"){
				let pdpReadOnlyFlag = false;
				// [정리] B2C 전용 subPdpReadonlyYn 분기 제거: b2cYN==='Y'는 이 파일에서 항상 false
				if(subB2bPdpReadonlyYn == "Y"){
					pdpReadOnlyFlag = true;
				}
				if(pdpReadOnlyFlag){
					$("#extraBtn").remove();
				}
            }
        },
        // BTOCSITE-97545 END

        // BTOCSITE-97019 [CSR과제] [상품] 번들링 할인 스킴적용
        additionModel : {
            // ============================================
            // 설정
            // ============================================
            storageHistKey : "additionHistoryBack",
            historyTimeOut : 10, // 분단위
            isSendGA : false,
            // 번들링 영역 표시 플래그
            isAdditionVisible: false,
            // 히스토리 복원 중 플래그
            isRestoringFromHistory: false,
            // API에서 가져온 데이터 저장 ($.data() 대신 사용)
            apiProductData: null, // API 전체 응답 데이터
            additionDisposableList: [], // 추가 소모품 리스트
            additionProductList: [], // 추가 제품 리스트
            // 처음 번들 체크 시 API 호출 플래그
            isFirstBundleCheck: true, // 처음 번들 체크 여부

            // ============================================
            // HTML 템플릿
            // ============================================

            /**
             * 번들링 추가 제품 템플릿 (일반)
             */
            bundlingItemTemplate :
                "<div class=\"bundling-discount-item\" data-model-id=\"{{modelId}}\" data-model-sku=\"{{modelSku}}\" data-model-name=\"{{modelName}}\" data-model-display-name=\"{{modelDisplayName}}\" data-model-url-path=\"{{modelUrlPath}}\"  data-addition-type=\"{{additionType}}\" data-bundle-discount-price=\"{{bundleDiscountPrice}}\" data-employee-bundle-discount-price=\"{{employeeBundleDiscountPrice}}\" data-obs-original-price=\"{{obsOriginalPrice}}\" data-employee-original-price=\"{{employeeOriginalPrice}}\" data-obs-min-qty=\"{{obsMinQty}}\" data-obs-max-qty=\"{{obsMaxQty}}\" data-limit-qty=\"{{limitQty}}\">\n" +
                "    <div class=\"bundling-item-thumb\">\n" +
                "        <div class=\"new-form3\">\n" +
                "            <span class=\"chk-wrap\">\n" +
                "                <input type=\"checkbox\" id=\"{{checkboxId}}\" name=\"{{checkboxName}}\" data-model-id=\"{{modelId}}\">\n" +
                "                <label for=\"{{checkboxId}}\" data-contents=\"{{dataContents}}\"><span class=\"blind\">선택하기</span></label>\n" +
                "            </span>\n" +
                "        </div>\n" +
                "        <img src=\"{{smallImageAddr}}\" alt=\"\" loading=\"lazy\">\n" +
                "    </div>\n" +
                "    <a href=\"#\" class=\"bundling-item-info\" data-contents=\"{{dataContents}}\">\n" +
                "        <p class=\"item-name\">{{modelDisplayName}}</p>\n" +
                "        <span class=\"original-price\"><em class=\"blind\">할인 전 정가</em>{{obsOriginalPriceFormatted}}원</span>\n" +
                "        <p class=\"discount-price\">번들 할인 적용 시<span><em>{{bundleDiscountPriceFormatted}}</em>원</span></p>\n" +
                "    </a>\n" +
                "</div>",

            /**
             * 번들링 추가 제품 템플릿 (품절)
             */
            bundlingItemSoldOutTemplate :
                "<div class=\"bundling-discount-item soldout\" data-model-id=\"{{modelId}}\" data-model-name=\"{{modelName}}\" data-model-url-path=\"{{modelUrlPath}}\">\n" +
                "    <div class=\"bundling-item-thumb\">\n" +
                "        <div class=\"new-form3\">\n" +
                "            <span class=\"chk-wrap\">\n" +
                "                <input type=\"checkbox\" id=\"{{checkboxId}}\" name=\"{{checkboxName}}\" disabled>\n" +
                "                <label for=\"{{checkboxId}}\" data-contents=\"{{dataContents}}\"><span class=\"blind\">선택하기</span></label>\n" +
                "            </span>\n" +
                "        </div>\n" +
                "        <img src=\"{{smallImageAddr}}\" alt=\"\" loading=\"lazy\">\n" +
                "    </div>\n" +
                "    <a href=\"#\" class=\"bundling-item-info\" data-contents=\"{{dataContents}}\">\n" +
                "        <p class=\"item-name\">{{modelDisplayName}}</p>\n" +
                "        <span class=\"original-price\"><em class=\"blind\">할인 전 정가</em>{{obsOriginalPriceFormatted}}원</span>\n" +
                "        <p class=\"discount-price\">번들 할인 적용 시<span><em>{{bundleDiscountPriceFormatted}}</em>원</span></p>\n" +
                "        <span class=\"soldout-badge\">일시품절</span>\n" +
                "    </a>\n" +
                "</div>",

            /**
             * 선택된 번들링 추가 제품 템플릿 (일반/소모품 공통)
             */
            bundlingSelectedItemTemplate :
                "<div class=\"bundling-discount-item\" data-model-id=\"{{modelId}}\" data-model-sku=\"{{modelSku}}\" data-model-name=\"{{modelName}}\" data-model-display-name=\"{{modelDisplayName}}\" data-addition-type=\"{{additionType}}\" data-bundle-discount-price=\"{{bundleDiscountPrice}}\" data-employee-bundle-discount-price=\"{{employeeBundleDiscountPrice}}\" data-obs-original-price=\"{{obsOriginalPrice}}\" data-employee-original-price=\"{{employeeOriginalPrice}}\">\n" +
                "    <div class=\"bundling-item-thumb\">\n" +
                "        <img src=\"{{smallImageAddr}}\" alt=\"\">\n" +
                "    </div>\n" +
                "    <div class=\"bundling-item-info\">\n" +
                "        <p class=\"item-name\">{{modelDisplayName}}</p>\n" +
                "        <span class=\"item-sku\"><em class=\"blind\">모델명</em>{{modelName}}</span>\n" +
                "        <div class=\"item-price\">\n" +
                "            {{#if hasBundleDiscount}}\n" +
                "                <span class=\"discount-price\">\n" +
                "                    <em class=\"blind\">할인가</em>\n" +
                "                    <em>{{bundleDiscountPriceFormatted}}</em>원\n" +
                "                </span>\n" +
                "                <span class=\"original-price\">\n" +
                "                    <em class=\"blind\">할인 전 정가</em>\n" +
                "                    {{obsOriginalPriceFormatted}}원\n" +
                "                </span>\n" +
                "            {{#else}}\n" +
                "                <span class=\"discount-price\">\n" +
                "                    <em class=\"blind\">판매가</em>\n" +
                "                    <em>{{obsOriginalPriceFormatted}}</em>원\n" +
                "                </span>\n" +
                "            {{/if}}\n" +
                "        </div>\n" +
                "    </div>\n" +
                "    <button type=\"button\" class=\"delete-item\"><span class=\"blind\">제품 삭제</span></button>\n" +
                "</div>",

            // ============================================
            // 초기화
            // ============================================

            /**
             * API를 통해 번들링 할인 데이터 가져오기
             * getRewardInfo에서 이미 호출한 API 데이터를 재사용
             */
            fetchAdditionData: function() {
                var deferred = $.Deferred();

                if (KRP0008.rewardInfoData) {
                    deferred.resolve(KRP0008.rewardInfoData);
                } else {
                    deferred.reject();
                }

                return deferred.promise();
            },

            /**
             * 본품 영역 렌더링 (API 데이터로 HTML 생성)
             */
            renderOriginalProductArea: function(productData) {
                var self = this;
                
                if (!productData) return;
                
                // 서버에서 이미 처리된 값을 그대로 사용
                var bundleDiscountPrice = productData.bundleDiscountPrice || 0;
                var obsSellingPrice = productData.obsSellingPrice || 0;
                var employeeBundleDiscountPrice = productData.employeeBundleDiscountPrice || 0;
                var employeeSellingPrice = productData.employeeSellingPrice || 0;
                var disposableEmployeeSellingPrice = productData.disposableEmployeeSellingPrice || 0;
                var disposableBundleDiscountPrice = productData.disposableBundleDiscountPrice || 0;
                var disposableEmployeeBundleDiscountPrice = productData.disposableEmployeeBundleDiscountPrice || 0;
                var smallImageAddr = productData.smallImageAddr || '';
                var modelDisplayName = productData.modelDisplayName || '';
                var modelName = productData.modelName || '';
                var modelSku = productData.sku || '';
                
                // 소모품 리스트가 노출되는지 확인 (공통 함수 사용)
                var validItems = self.getValidBundlingItems();
                var validProduct = validItems.validProduct;
                var validDisposable = validItems.validDisposable;
                
                // 소모품만 노출되는 경우 소모품용 가격 사용
                var isDisposableOnly = validProduct.length === 0 && validDisposable.length > 0;
                
                // 사용할 가격 결정
                var useBundleDiscountPrice = isDisposableOnly ? disposableBundleDiscountPrice : bundleDiscountPrice;
                var useEmployeeBundleDiscountPrice = isDisposableOnly ? disposableEmployeeBundleDiscountPrice : employeeBundleDiscountPrice;
                var useEmployeeSellingPrice = isDisposableOnly ? disposableEmployeeSellingPrice : employeeSellingPrice;
                
                // 일반 본품 영역 렌더링 (PDP)
                var normalOriginalHtml = 
                    '<div class="bundling-item-thumb">' +
                    '    <span class="original-badge">본품</span>' +
                    '    <img src="' + smallImageAddr + '" alt="" loading="lazy">' +
                    '</div>' +
                    '<a href="#" class="bundling-item-info">' +
                    '    <p class="item-name">' + modelDisplayName + '</p>' +
                    '    <span class="original-price" style="' + (useBundleDiscountPrice > 0 && useBundleDiscountPrice < obsSellingPrice ? '' : 'text-decoration: none;') + '">' +
                    '        <em class="blind">할인 전 정가</em>' + vcui.number.addComma(obsSellingPrice) + '원' +
                    '    </span>';
                
                if (useBundleDiscountPrice > 0 && useBundleDiscountPrice < obsSellingPrice) {
                    normalOriginalHtml += 
                        '    <p class="discount-price">번들 할인 적용 시<span><em>' + vcui.number.addComma(useBundleDiscountPrice) + '</em>원</span></p>';
                }
                
                normalOriginalHtml += '</a>';
                
                // data-contents 값 생성: {modelDisplayName/modelSku/번들할인가} / 본품
                var normalDataContents = '{' + modelDisplayName + '/' + modelSku + '/' + useBundleDiscountPrice + '}' + ' / 본품';
                $('#additionOriginalProduct').html(normalOriginalHtml).attr('data-contents', normalDataContents);
                
                // 임직원 본품 영역 렌더링 (PDP)
                var employeeOriginalHtml = 
                    '<div class="bundling-item-thumb">' +
                    '    <span class="original-badge">본품</span>' +
                    '    <img src="' + smallImageAddr + '" alt="" loading="lazy">' +
                    '</div>' +
                    '<a href="#" class="bundling-item-info">' +
                    '    <p class="item-name">' + modelDisplayName + '</p>' +
                    '    <span class="original-price" style="' + (useEmployeeBundleDiscountPrice > 0 && useEmployeeBundleDiscountPrice < useEmployeeSellingPrice ? '' : 'text-decoration: none;') + '">' +
                    '        <em class="blind">할인 전 정가</em>' + vcui.number.addComma(useEmployeeSellingPrice) + '원' +
                    '    </span>';
                
                if (useEmployeeBundleDiscountPrice > 0 && useEmployeeBundleDiscountPrice < useEmployeeSellingPrice) {
                    employeeOriginalHtml += 
                        '    <p class="discount-price">번들 할인 적용 시<span><em>' + vcui.number.addComma(useEmployeeBundleDiscountPrice) + '</em>원</span></p>';
                }
                
                employeeOriginalHtml += '</a>';
                
                // data-contents 값 생성: {modelDisplayName/modelSku/번들할인가} / 본품
                var employeeDataContents = '{' + modelDisplayName + '/' + modelSku + '/' + useEmployeeBundleDiscountPrice + '}' + ' / 본품';
                $('#employeeAdditionOriginalProduct').html(employeeOriginalHtml).attr('data-contents', employeeDataContents);
                
                // ActionSheet 본품 영역 렌더링 (모바일)
                // 현재 임직원 여부에 따라 가격 선택
                var isEmployee = self.getIsEmployee();
                var displayBundlePrice = isEmployee ? useEmployeeBundleDiscountPrice : useBundleDiscountPrice;
                var displaySellingPrice = isEmployee ? useEmployeeSellingPrice : obsSellingPrice;
                
                var actionSheetOriginalHtml = 
                    '<div class="bundling-item-thumb">' +
                    '    <img src="' + smallImageAddr + '" alt="">' +
                    '</div>' +
                    '<div class="bundling-item-info">' +
                    '    <p class="item-name">' + modelDisplayName + '</p>' +
                    '    <span class="item-sku"><em class="blind">모델명</em>' + modelName + '</span>' +
                    '    <div class="item-price">';
                
                if (displayBundlePrice > 0 && displayBundlePrice < displaySellingPrice) {
                    actionSheetOriginalHtml += 
                        '        <span class="discount-price">' +
                        '            <em class="blind">할인가</em>' +
                        '            <em>' + vcui.number.addComma(displayBundlePrice) + '</em>원' +
                        '        </span>' +
                        '        <span class="original-price">' +
                        '            <em class="blind">할인 전 정가</em>' +
                        '            ' + vcui.number.addComma(displaySellingPrice) + '원' +
                        '        </span>';
                } else {
                    actionSheetOriginalHtml += 
                        '        <span class="discount-price">' +
                        '            <em class="blind">판매가</em>' +
                        '            <em>' + vcui.number.addComma(displaySellingPrice) + '</em>원' +
                        '        </span>';
                }
                
                actionSheetOriginalHtml += 
                    '    </div>' +
                    '</div>';
                
                // data-contents 값 생성: {modelDisplayName/modelSku/번들할인가} / 본품
                var actionSheetDataContents = '{' + modelDisplayName + '/' + modelSku + '/' + displayBundlePrice + '}' + ' / 본품';
                $('#actionSheetOriginalProduct').html(actionSheetOriginalHtml).attr('data-contents', actionSheetDataContents);
            },

            /**
             * 추가품 데이터 세팅 (API 응답을 객체 속성에 저장)
             */
            setAdditionProductsData: function(productData) {
                var self = this;
                
                // API 전체 데이터 저장
                self.apiProductData = productData;
                
                if (productData.additionDisposableModelList && productData.additionDisposableModelList.length > 0) {
                    self.additionDisposableList = productData.additionDisposableModelList;
                } else {
                    self.additionDisposableList = [];
                }
                
                if (productData.additionProductModelList && productData.additionProductModelList.length > 0) {
                    self.additionProductList = productData.additionProductModelList;
                } else {
                    self.additionProductList = [];
                }
            },
            
            /**
             * ActionSheet 본품 영역만 업데이트 (탭 전환 시 사용)
             */
            updateActionSheetOriginalProduct: function() {
                var self = this;
                
                if (!self.apiProductData) return;
                
                var productData = self.apiProductData;
                // 서버에서 이미 처리된 값을 그대로 사용
                var bundleDiscountPrice = productData.bundleDiscountPrice || 0;
                var obsSellingPrice = productData.obsSellingPrice || 0;
                var employeeBundleDiscountPrice = productData.employeeBundleDiscountPrice || 0;
                var employeeSellingPrice = productData.employeeSellingPrice || 0;
                var disposableBundleDiscountPrice = productData.disposableBundleDiscountPrice || 0;
                var disposableEmployeeBundleDiscountPrice = productData.disposableEmployeeBundleDiscountPrice || 0;
                var disposableEmployeeSellingPrice = productData.disposableEmployeeSellingPrice || 0;
                var smallImageAddr = productData.smallImageAddr || '';
                var modelDisplayName = productData.modelDisplayName || '';
                var modelName = productData.modelName || '';
                
                // 소모품 리스트가 노출되는지 확인 (공통 함수 사용)
                var validItems = self.getValidBundlingItems();
                var validProduct = validItems.validProduct;
                var validDisposable = validItems.validDisposable;
                
                // 소모품만 노출되는 경우 소모품용 가격 사용
                var isDisposableOnly = validProduct.length === 0 && validDisposable.length > 0;
                
                // 사용할 가격 결정
                var useBundleDiscountPrice = isDisposableOnly ? disposableBundleDiscountPrice : bundleDiscountPrice;
                var useEmployeeBundleDiscountPrice = isDisposableOnly ? disposableEmployeeBundleDiscountPrice : employeeBundleDiscountPrice;
                var useEmployeeSellingPrice = isDisposableOnly ? disposableEmployeeSellingPrice : employeeSellingPrice;
                
                // 현재 임직원 여부에 따라 가격 선택
                var isEmployee = self.getIsEmployee();
                var displayBundlePrice = isEmployee ? useEmployeeBundleDiscountPrice : useBundleDiscountPrice;
                var displaySellingPrice = isEmployee ? useEmployeeSellingPrice : obsSellingPrice;
                
                var actionSheetOriginalHtml = 
                    '<div class="bundling-item-thumb">' +
                    '    <img src="' + smallImageAddr + '" alt="">' +
                    '</div>' +
                    '<div class="bundling-item-info">' +
                    '    <p class="item-name">' + modelDisplayName + '</p>' +
                    '    <span class="item-sku"><em class="blind">모델명</em>' + modelName + '</span>' +
                    '    <div class="item-price">';
                
                if (displayBundlePrice > 0 && displayBundlePrice < displaySellingPrice) {
                    actionSheetOriginalHtml += 
                        '        <span class="discount-price">' +
                        '            <em class="blind">할인가</em>' +
                        '            <em>' + vcui.number.addComma(displayBundlePrice) + '</em>원' +
                        '        </span>' +
                        '        <span class="original-price">' +
                        '            <em class="blind">할인 전 정가</em>' +
                        '            ' + vcui.number.addComma(displaySellingPrice) + '원' +
                        '        </span>';
                } else {
                    actionSheetOriginalHtml += 
                        '        <span class="discount-price">' +
                        '            <em class="blind">판매가</em>' +
                        '            <em>' + vcui.number.addComma(displaySellingPrice) + '</em>원' +
                        '        </span>';
                }
                
                actionSheetOriginalHtml += 
                    '    </div>' +
                    '</div>';
                
                $('#actionSheetOriginalProduct').html(actionSheetOriginalHtml);
            },

            /**
             * 가격 및 수량 관련 data 속성 업데이트 (API 데이터로)
             * #foldPriceArea, #paymentAmountArea, #countCheckArea의 data 속성을 API 데이터로 업데이트
             */
            updatePriceDataAttributes: function() {
                var self = this;
                
                if (!self.apiProductData) return;
                
                var productData = self.apiProductData;
                // 서버에서 이미 처리된 값을 그대로 사용
                var bundleDiscountPrice = productData.bundleDiscountPrice || 0;
                var employeeBundleDiscountPrice = productData.employeeBundleDiscountPrice || 0;
                var disposableBundleDiscountPrice = productData.disposableBundleDiscountPrice || 0;
                var disposableEmployeeBundleDiscountPrice = productData.disposableEmployeeBundleDiscountPrice || 0;
                var obsOriginalPrice = productData.obsOriginalPrice || 0;
                var obsMinQty = productData.obsMinQty || 1;
                var obsMaxQty = productData.obsMaxQty || 24;
                
                // 소모품 리스트가 노출되는지 확인 (공통 함수 사용)
                var validItems = self.getValidBundlingItems();
                var validProduct = validItems.validProduct;
                var validDisposable = validItems.validDisposable;
                
                // 소모품만 노출되는 경우 소모품용 가격 사용
                var isDisposableOnly = validProduct.length === 0 && validDisposable.length > 0;
                
                // 사용할 가격 결정
                var useBundleDiscountPrice = isDisposableOnly ? disposableBundleDiscountPrice : bundleDiscountPrice;
                var useEmployeeBundleDiscountPrice = isDisposableOnly ? disposableEmployeeBundleDiscountPrice : employeeBundleDiscountPrice;
                
                // #foldPriceArea data 속성 업데이트
                var $foldPriceArea = $('#foldPriceArea');
                if ($foldPriceArea.length > 0) {
                    $foldPriceArea.attr('data-org-priced', obsOriginalPrice);
                    $foldPriceArea.attr('data-bundle-discount-price', useBundleDiscountPrice);
                    $foldPriceArea.attr('data-employee-bundle-discount-price', useEmployeeBundleDiscountPrice);
                    
                    $foldPriceArea.data('orgPrice', obsOriginalPrice);
                    $foldPriceArea.data('orgPriced', obsOriginalPrice);
                    $foldPriceArea.data('bundle-discount-price', useBundleDiscountPrice);
                    $foldPriceArea.data('employee-bundle-discount-price', useEmployeeBundleDiscountPrice);
                }
                
                var $paymentAmountArea = $('#paymentAmountArea');
                if ($paymentAmountArea.length > 0) {
                    $paymentAmountArea.attr('data-bundle-discount-price', useBundleDiscountPrice);
                    $paymentAmountArea.attr('data-employee-bundle-discount-price', useEmployeeBundleDiscountPrice);
                    $paymentAmountArea.data('bundle-discount-price', useBundleDiscountPrice);
                    $paymentAmountArea.data('employee-bundle-discount-price', useEmployeeBundleDiscountPrice);
                }
                
                var $countCheckArea = $('#countCheckArea');
                if ($countCheckArea.length > 0) {
                    $countCheckArea.attr('data-obs-min-qty', obsMinQty);
                    $countCheckArea.attr('data-obs-max-qty', obsMaxQty);
                    $countCheckArea.data('obs-min-qty', obsMinQty);
                    $countCheckArea.data('obs-max-qty', obsMaxQty);
                }
                
                // 클래스 선택자로도 접근 가능하도록 업데이트 (레거시 코드 호환성)
                var $countCheckByClass = $('.box.payment-amount.count-check');
                if ($countCheckByClass.length > 0 && $countCheckByClass[0] !== $countCheckArea[0]) {
                    $countCheckByClass.attr('data-obs-min-qty', obsMinQty);
                    $countCheckByClass.attr('data-obs-max-qty', obsMaxQty);
                    
                    $countCheckByClass.data('obs-min-qty', obsMinQty);
                    $countCheckByClass.data('obs-max-qty', obsMaxQty);
                    
                    // purchaseLimitQty는 JSP에서 조건부로 설정되므로 덮어쓰지 않음
                }
            },

            /**
             * 번들링 할인 초기화 (메인 진입점)
             */
            // ============================================
            // 초기화 및 설정
            // ============================================
            init : function() {
                var self = this;

                self.setInitialQuantityInfo();
                self.setElements();
                self.isEmployee = $('#employeePriceTabArea').is(':visible');

                self.fetchAdditionData().done(function(productData) {
                    self.setAdditionProductsData(productData);
                    
                    if (!self.hasBundlingProducts()) {
                        $('#additionSelect').hide();
                        // 추가품이 없어도 수량 관련 이벤트는 바인딩해야 함
                        self.bindEvents();
                        return;
                    }
                    
                    self.renderOriginalProductArea(productData);
                    self.updatePriceDataAttributes();
                    self.bindEvents();
                    self.toggleOriginalProductArea();
                    self.checkVisibility();
                    self.renderInitialItems();
                    self.calculateMaxDiscount();
                    self.setInitialHeight();
                    self.loadFromHistory();
                    $('#additionSelect').show();
                    // 번들 영역 노출 GA 추적 초기화
                    self.initBundleExposureTracking();
                }).fail(function() {
                    $('#additionSelect').hide();
                    // 추가품 데이터 로드 실패 시에도 수량 관련 이벤트는 바인딩해야 함
                    self.bindEvents();
                });
            },

            /**
             * 유효한 번들링 아이템 필터링 (공통 함수)
             * @returns {Object} {validProduct: Array, validDisposable: Array}
             */
            getValidBundlingItems: function() {
                var self = this;
                var disposableData = self.additionDisposableList || [];
                var productData = self.additionProductList || [];

                var validDisposable = disposableData.filter(function(item) {
                    // grp가 'AFC'이면서 Disposable인 추가품은 제외
                    var itemPartnerGrp = item.partnergrp || '';
                    if (itemPartnerGrp.indexOf('AFC') > -1) {
                        return false;
                    }
                    return self.isValidItem(item);
                });
                var validProduct = productData.filter(function(item) {
                    return self.isValidItem(item);
                });

                return {
                    validProduct: validProduct,
                    validDisposable: validDisposable
                };
            },

            hasBundlingProducts: function() {
                var self = this;
                var validItems = self.getValidBundlingItems();
                return validItems.validProduct.length > 0 || validItems.validDisposable.length > 0;
            },

            setElements : function() {
                var self = this;
                // PDP 영역
                self.$bundlingDiscountArea = $('#additionSelect .bundling-discount');
                self.$additionDisposable = $('#additionDisposable');
                self.$additionProduct = $('#additionProduct');
                self.$maxDiscountArea = $('#additionMaxDiscount');
                self.$maxDiscountAmount = $('#additionMaxDiscountAmount');
                self.$benefitBanner = self.$bundlingDiscountArea.find('.bundling-benefit-banner');
                self.$moreButton = self.$bundlingDiscountArea.find('.bundle-btn-more');
                self.$itemSelectWrap = self.$bundlingDiscountArea.find('.item-select-wrap');
                self.$itemSelectInner = self.$bundlingDiscountArea.find('.item-select-inner');

                // ActionSheet 영역
                self.$actionSheet = $('.action-sheet');
                self.$actionSheetDiscount = self.$actionSheet.find('.bundling-discount');
                self.$actionSheetInner = self.$actionSheet.find('.item-select-inner');
            },

            toggleOriginalProductArea: function() {
                var self = this;

                if (self.isEmployee) {
                    $('#additionOriginalProduct').hide();
                    $('#employeeAdditionOriginalProduct').show();
                } else {
                    $('#additionOriginalProduct').show();
                    $('#employeeAdditionOriginalProduct').hide();
                }
            },

            bindEvents : function() {
                var self = this;

                // 품절 상품 체크박스 클릭 방지 (먼저 바인딩)
                // 품절 체크박스 클릭 이벤트 (disabled 속성 제거 후 클릭 이벤트로 처리)

                // 모든 추가품 이미지 영역 클릭 시 페이지 이동
                self.$bundlingDiscountArea.on('click', '.bundling-discount-item .bundling-item-info', function(e) {
                    e.preventDefault();
                    var modelUrlPath = $(this).closest('.bundling-discount-item').data('model-url-path');
                    if (modelUrlPath) {
                        location.href = lgkorUI.DEFAULT_URL + modelUrlPath;
                    }
                });

                // 일반 체크박스 변경 이벤트
                self.$bundlingDiscountArea.on('change', '.bundling-discount-item:not(.soldout) input[type="checkbox"]', function() {
                    self.onCheckboxChange($(this));
                });

                // 삭제 버튼 이벤트
                self.$actionSheetInner.on('click', '.bundling-discount-item .delete-item', function(e) {
                    e.preventDefault();
                    self.onDeleteButtonClick($(this));
                });

                // 더보기 버튼 (중복 방지를 위해 off 후 on)
                self.$moreButton.off('click').on('click', function() {
                    self.toggleExpand();
                });

                // 수량 버튼 이벤트 위임 (중복 방지를 위해 off 후 on)
                // 추가품 선택 시와 본품만 있을 때 모두 동일한 핸들러 사용
                // 소모품 PDP에서는 이 핸들러가 실행되지 않도록 함 (소모품은 3106줄의 핸들러에서 처리)
                $(document).off('click.bundlingQuantity', '.bundling-payment .minus, .payment-amount.bundling-set .minus, .count-check .quantity-payment-wrap .minus')
                    .on('click.bundlingQuantity', '.bundling-payment .minus, .payment-amount.bundling-set .minus, .count-check .quantity-payment-wrap .minus', function(e) {
                        // 소모품(DISPOSABLE)인 경우 여기서 처리하지 않고 구매 수량 선택 핸들러가 처리하도록 함
                        if (lgePdpSendData.bizTypeDetail === "DISPOSABLE" || lgkorUI.getHiddenInputData().b2cYN !=='Y') {
                            return;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        self.handleQuantityChange($(this), -1);
                    });

                $(document).off('click.bundlingQuantity', '.bundling-payment .plus, .payment-amount.bundling-set .plus, .count-check .quantity-payment-wrap .plus')
                    .on('click.bundlingQuantity', '.bundling-payment .plus, .payment-amount.bundling-set .plus, .count-check .quantity-payment-wrap .plus', function(e) {
                        // 소모품(DISPOSABLE)인 경우 여기서 처리하지 않고 구매 수량 선택 핸들러가 처리하도록 함
                        if (lgePdpSendData.bizTypeDetail === "DISPOSABLE" || lgkorUI.getHiddenInputData().b2cYN !=='Y') {
                            return;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        self.handleQuantityChange($(this), 1);
                    });

                // 수량 직접 입력 이벤트 (중복 방지를 위해 off 후 on)
                // 추가품 선택 시와 본품만 있을 때 모두 동일한 핸들러 사용
                // 소모품 PDP에서는 이 핸들러가 실행되지 않도록 함
                $(document).off('input.bundlingQuantity', '.bundling-payment .quantity, .payment-amount.bundling-set .quantity-payment-wrap .quantity, .count-check .quantity-payment-wrap .quantity')
                    .on('input.bundlingQuantity', '.bundling-payment .quantity, .payment-amount.bundling-set .quantity-payment-wrap .quantity, .count-check .quantity-payment-wrap .quantity', function() {
                        // 소모품(DISPOSABLE)인 경우 여기서 처리하지 않고 구매 수량 선택 핸들러가 처리하도록 함
                        if (lgePdpSendData.bizTypeDetail === "DISPOSABLE" || lgkorUI.getHiddenInputData().b2cYN !=='Y') {
                            return;
                        }
                        self.handleQuantityInput($(this));
                    });

                // 수량 입력 필드 blur 이벤트 - 입력 완료 시 검증
                // 추가품 선택 시와 본품만 있을 때 모두 동일한 핸들러 사용
                // 소모품 PDP에서는 이 핸들러가 실행되지 않도록 함
                $(document).off('blur.bundlingQuantity', '.bundling-payment .quantity, .payment-amount.bundling-set .quantity-payment-wrap .quantity, .count-check .quantity-payment-wrap .quantity')
                    .on('blur.bundlingQuantity', '.bundling-payment .quantity, .payment-amount.bundling-set .quantity-payment-wrap .quantity, .count-check .quantity-payment-wrap .quantity', function() {
                        // 소모품(DISPOSABLE)인 경우 여기서 처리하지 않고 구매 수량 선택 핸들러가 처리하도록 함
                        if (lgePdpSendData.bizTypeDetail === "DISPOSABLE" || lgkorUI.getHiddenInputData().b2cYN !=='Y') {
                            return;
                        }
                        self.validateQuantityInput($(this));
                    });

                // 화면 크기 변경 시 높이 재조정 (중복 방지를 위해 off 후 on)
                $(window).off('resize.bundlingHeight').on('resize.bundlingHeight', function() {
                    self.setInitialHeight();
                });
            },

            /**
             * 노출 조건 체크 및 영역 표시/숨김
             */
            checkVisibility : function() {
                var self = this;

                // 본품의 번들할인가와 통제가 비교
                var isEmployee = self.getIsEmployee();
                var mainProductBundleDiscountPrice = isEmployee
                    ? vcui.number.parse($('#foldPriceArea').data('employee-bundle-discount-price') || 0)
                    : vcui.number.parse($('#foldPriceArea').data('bundle-discount-price') || 0);
                var obsControlPrice = 0;
                if (self.apiProductData && self.apiProductData.obsControlPrice) {
                    obsControlPrice = vcui.number.parse(self.apiProductData.obsControlPrice);
                }
                
                // 본품의 번들할인가가 통제가보다 낮으면 번들 영역 숨김
                if (obsControlPrice > 0 && mainProductBundleDiscountPrice < obsControlPrice) {
                    self.$bundlingDiscountArea.hide();
                    self.$moreButton.hide();
                    $('#additionSelect').hide();
                    return;
                }

                // 유효한 아이템 필터링 (공통 함수 사용)
                var validItems = self.getValidBundlingItems();
                var validDisposable = validItems.validDisposable;
                var validProduct = validItems.validProduct;

                // 노출 조건에 따른 처리
                if (validProduct.length > 0) {
                    // 1, 2번 조건: PRODUCT만 노출
                    $('#additionSelect').show();
                    // 본품 영역 표시
                    self.toggleOriginalProductArea();
                    self.$additionProduct.show();
                    self.$additionDisposable.hide();
                    self.$bundlingDiscountArea.show();
                    
                    // 더보기 버튼 표시 여부 (PRODUCT 아이템 개수 기준)
                    if (validProduct.length >= 3) {
                        self.$moreButton.show();
                    } else {
                        self.$moreButton.hide();
                    }
                } else if (validDisposable.length > 0) {
                    // 3번 조건: DISPOSABLE만 노출
                    $('#additionSelect').show();
                    // 본품 영역 표시
                    self.toggleOriginalProductArea();
                    self.$additionDisposable.show();
                    self.$additionProduct.hide();
                    self.$bundlingDiscountArea.show();
                    
                    // 더보기 버튼 표시 여부 (DISPOSABLE 아이템 개수 기준)
                    if (validDisposable.length >= 3) {
                        self.$moreButton.show();
                    } else {
                        self.$moreButton.hide();
                    }
                } else {
                    // 4번 조건: 둘 다 없으면 전체 비노출
                    self.$bundlingDiscountArea.hide();
                    self.$moreButton.hide();
                    // 유효한 아이템이 없을 때는 #additionSelect도 숨김
                    $('#additionSelect').hide();
                }
            },

            /**
             * 초기 아이템 렌더링
             */
            renderInitialItems : function() {
                var self = this;

                // 먼저 노출 조건 체크 및 영역 표시/숨김 처리
                self.checkVisibility();

                // 유효한 아이템 필터링 (공통 함수 사용)
                var validItems = self.getValidBundlingItems();
                var validProduct = validItems.validProduct;
                var validDisposable = validItems.validDisposable;

                // PRODUCT 아이템 렌더링
                self.$additionProduct.empty();
                if (validProduct.length > 0) {
                    self.renderItems(validProduct, self.$additionProduct, 'PRODUCT');
                }

                // DISPOSABLE 아이템 렌더링
                self.$additionDisposable.empty();
                if (validDisposable.length > 0) {
                    self.renderItems(validDisposable, self.$additionDisposable, 'DISPOSABLE');
                }
            },

            /**
             * 아이템 렌더링
             */
            renderItems : function(items, $container, additionType) {
                var self = this;

                // modelStatusCode 기준으로 정렬 (1 먼저, 3 나중)
                var sortedItems = items.slice().sort(function(a, b) {
                    if (a.modelStatusCode === 1 && b.modelStatusCode === 3) return -1;
                    if (a.modelStatusCode === 3 && b.modelStatusCode === 1) return 1;
                    return 0;
                });

                var validItems = [];

                sortedItems.forEach(function(item) {
                    // 템플릿 선택 (품절 여부)
                    var template = item.modelStatusCode === 3
                        ? self.bundlingItemSoldOutTemplate
                        : self.bundlingItemTemplate;

                    // 템플릿 데이터 준비
                    var templateData = self.prepareTemplateData(item, additionType);

                    // 렌더링
                    var html = vcui.template(template, templateData);
                    var $itemElement = $(html);
                    $container.append($itemElement);

                    validItems.push(item);
                });

                // 유효한 아이템이 있으면 영역 표시
                if (validItems.length > 0) {
                    $container.parent().show();
                }
            },

            /**
             * 아이템 유효성 검사
             */
            isValidItem : function(item) {
                var self = this;
                
                var basicCheck = (
                    (item.modelStatusCode == 1 || item.modelStatusCode == 3) &&
                    item.careshipOnlyFlag !== 'Y' &&
                    item.rentalOnlyFlag !== 'Y' &&
                    item.timeDealFlag !== 'Y'
                );
                
                if (!basicCheck) {
                    return false;
                }
                
                var isEmployee = self.getIsEmployee();
                
                // partnerGrp 필터링
                var itemPartnerGrp = item.partnergrp || 'B2C'; // 기본값은 B2C
                if (!isEmployee) {
                    // 일반 회원이면 B2C인 아이템만 표시
                    if (itemPartnerGrp !== 'B2C') {
                        return false;
                    }
                } else {
                    // 임직원이면 B2C가 아닌 아이템들 표시 (회원 타입에 해당하는 것들)
                    if (itemPartnerGrp === 'B2C') {
                        return false;
                    }
                }
                
                var bundleDiscountPrice = isEmployee
                    ? vcui.number.parse(item.employeeBundleDiscountPrice || 0)
                    : vcui.number.parse(item.bundleDiscountPrice || 0);
                var obsOriginalPrice = isEmployee
                    ? vcui.number.parse(item.employeeSellingPrice || 0)
                    : vcui.number.parse(item.obsOriginalPrice || 0);
                
                // bundleDiscountPrice가 obsControlPrice보다 낮으면 유효하지 않음
                var obsControlPrice = vcui.number.parse(item.obsControlPrice || 0);
                if (obsControlPrice > 0 && bundleDiscountPrice < obsControlPrice) {
                    return false;
                }
                
                var hasAdditionDiscount = obsOriginalPrice > 0 && bundleDiscountPrice > 0 && bundleDiscountPrice < obsOriginalPrice;
                
                return hasAdditionDiscount;
            },

            /**
             * 템플릿 데이터 준비
             */
            prepareTemplateData : function(item, additionType) {
                var self = this;
                var isEmployee = self.isEmployee || false;

                // 서버에서 이미 처리된 값을 그대로 사용
                var normalBundleDiscountPrice = vcui.number.parse(item.bundleDiscountPrice || 0);
                var employeeBundleDiscountPrice = vcui.number.parse(item.employeeBundleDiscountPrice || 0);
                var normalOriginalPrice = vcui.number.parse(item.obsOriginalPrice || 0);
                var employeeOriginalPrice = vcui.number.parse(item.employeeSellingPrice || 0);
                
                var bundleDiscountPrice = isEmployee ? employeeBundleDiscountPrice : normalBundleDiscountPrice;
                var obsOriginalPrice = isEmployee ? employeeOriginalPrice : normalOriginalPrice;

                var checkboxId = 'bundling_' + additionType.toLowerCase() + '_' + item.modelId;
                var checkboxName = 'bundling_' + additionType.toLowerCase() + '_' + item.modelName;
                
                // data-contents 값 생성: {modelDisplayName/modelSku/번들할인가}
                var dataContents = '{' + (item.modelDisplayName || '') + '/' + (item.modelSku || '') + '/' + bundleDiscountPrice + '}' + ' / 번들';

                return {
                    modelId: item.modelId,
                    additionType: additionType,
                    smallImageAddr: item.smallImageAddr,
                    modelDisplayName: item.modelDisplayName,
                    modelSku: item.modelSku,
                    modelName: item.modelName,
                    modelUrlPath: item.modelUrlPath,
                    bundleDiscountPrice: normalBundleDiscountPrice,
                    employeeBundleDiscountPrice: employeeBundleDiscountPrice,
                    bundleDiscountPriceFormatted: vcui.number.addComma(bundleDiscountPrice),
                    obsOriginalPrice: normalOriginalPrice,
                    employeeOriginalPrice: employeeOriginalPrice,
                    obsOriginalPriceFormatted: vcui.number.addComma(obsOriginalPrice),
                    hasBundleDiscount: bundleDiscountPrice > 0 && bundleDiscountPrice < obsOriginalPrice,
                    modelStatusCode: item.modelStatusCode,
                    obsMinQty: item.obsMinQty,
                    obsMaxQty: item.obsMaxQty,
                    limitQty: item.limitQty || '',
                    checkboxId: checkboxId,
                    checkboxName: checkboxName,
                    dataContents: dataContents
                };
            },

            /**
             * 체크박스 변경 이벤트
             */
            onCheckboxChange : function($checkbox) {
                var self = this;
                var isChecked = $checkbox.prop('checked');
                var $item = $checkbox.closest('.bundling-discount-item');
                var modelId = $item.data('model-id');
                var isFirstCheck = false; // 처음 번들 체크 여부

                // 본품이 일시품절인 경우 체크 시 알럿 표시
                if (isChecked && self.apiProductData && 
                    (self.apiProductData.modelStatusCode === 3 || self.apiProductData.modelStatusCode === "SOLD_OUT")) {
                    $checkbox.prop('checked', false);
                    
                    lgkorUI.alert("", {
                        title: "일시품절 상태에서는<br/>" +
                            "추가상품 선택이 불가합니다.<br/>" +
                            "상품정보를 선택하시면<br/>" +
                            "해당 제품 페이지에서 구매가 가능합니다.<br/>"
                    });
                    
                    return;
                }

                var $actionSheetItem = self.$actionSheetInner.find('.bundling-discount-item[data-model-id="' + modelId + '"]');

                if (isChecked) {
                    // 처음 번들 체크 여부 확인
                    if (self.isFirstBundleCheck) {
                        isFirstCheck = true;
                        self.isFirstBundleCheck = false; // 다음부터는 false로 설정
                    }
                    
                    if ($actionSheetItem.length === 0) {
                        try {
                            var itemData = self.getItemData($item);
                            var html = vcui.template(self.bundlingSelectedItemTemplate, itemData);
                            self.$actionSheetInner.append(html);
                        } catch(e) {
                            console.error('[에러] 템플릿 생성 실패:', e);
                        }
                    } else {
                        $actionSheetItem.show();
                    }
                    
                    if (isMobile) {
                        self.$actionSheetDiscount.show();
                    }
                } else {
                    $actionSheetItem.remove();
                    var remainingItems = self.$actionSheetInner.find('.bundling-discount-item').length;
                    if (remainingItems === 0) {
                        self.$actionSheetDiscount.hide();
                    }
                }

                self.updateUI(isFirstCheck); // 처음 체크 여부 전달
                self.saveToHistory();
            },

            /**
             * 아이템 데이터 추출
             */
            getItemData : function($item) {
                var self = this;
                var bundleDiscountPrice = vcui.number.parse($item.data('bundle-discount-price') || 0);
                var employeeBundleDiscountPrice = vcui.number.parse($item.data('employee-bundle-discount-price') || 0);
                var obsOriginalPrice = vcui.number.parse($item.data('obs-original-price') || 0);
                var employeeOriginalPrice = vcui.number.parse($item.data('employee-original-price') || obsOriginalPrice);
                
                var isEmployee = self.getIsEmployee();
                var displayPrice = isEmployee ? employeeBundleDiscountPrice : bundleDiscountPrice;

                return {
                    modelId: $item.data('model-id'),
                    modelSku: $item.data('model-sku'),
                    additionType: $item.data('addition-type'),
                    smallImageAddr: $item.find('img').attr('src'),
                    modelDisplayName: $item.data('model-display-name'),
                    modelName: $item.data('model-name'),
                    bundleDiscountPrice: bundleDiscountPrice,
                    employeeBundleDiscountPrice: employeeBundleDiscountPrice,
                    bundleDiscountPriceFormatted: vcui.number.addComma(displayPrice),
                    obsOriginalPrice: obsOriginalPrice,
                    obsOriginalPriceFormatted: vcui.number.addComma(obsOriginalPrice),
                    employeeOriginalPrice: employeeOriginalPrice,
                    hasBundleDiscount: displayPrice > 0 && displayPrice < obsOriginalPrice
                };
            },

            /**
             * 삭제 버튼 클릭
             */
            onDeleteButtonClick : function($button) {
                var self = this;
                var $actionSheetItem = $button.closest('.bundling-discount-item');
                var modelId = $actionSheetItem.data('model-id');

                $('.bundling-discount-item[data-model-id="' + modelId + '"] input[type="checkbox"]')
                    .prop('checked', false);

                $actionSheetItem.remove();
                
                var remainingItems = self.$actionSheetInner.find('.bundling-discount-item').length;
                if (remainingItems === 0) {
                    self.$actionSheetDiscount.hide();
                }

                self.updateUI();
                self.saveToHistory();
            },

            /**
             * UI 업데이트
             */
            updateUI : function(isFirstCheck) {
                var self = this;
                isFirstCheck = isFirstCheck || false; // 처음 체크 여부 (기본값 false)

                var $visibleItems = self.$actionSheetInner.find('.bundling-discount-item');
                var hasItems = $visibleItems.length > 0;

                if (hasItems && isMobile) {
                    self.$actionSheetDiscount.show();
                } else {
                    self.$actionSheetDiscount.hide();
                }

                self.isAdditionVisible = hasItems;

                self.calculatePrices();
                self.setAdditionFoldPrice();
                self.updateQuantityArea();

                var $paymentAmount = $('.payment-amount');
                // 처음 번들 체크할 때만 quantityChange를 true로 전달하여 API 호출
                KRP0008.updatePaymentAmountPrice($paymentAmount, isFirstCheck);
            },

            /**
             * 가격 계산 및 배너 업데이트
             */
            calculatePrices : function() {
                var self = this;
                var totalDiscount = 0;

                var isEmployee = self.getIsEmployee();

                var $visibleOriginal = $('#additionOriginalProduct:visible, #employeeAdditionOriginalProduct:visible');
                if ($visibleOriginal.length > 0) {
                    var originalPriceText = $visibleOriginal.find('.original-price').text();
                    var discountPriceText = $visibleOriginal.find('.discount-price em').text();

                    var originalPrice = vcui.number.parse(originalPriceText || 0);
                    var discountPrice = vcui.number.parse(discountPriceText || 0);

                    if (originalPrice > 0 && discountPrice > 0 && discountPrice < originalPrice) {
                        totalDiscount += (originalPrice - discountPrice);
                    }
                }

                self.$actionSheetInner.find('.bundling-discount-item').each(function() {
                    var $item = $(this);
                    var bundlePrice = isEmployee
                        ? vcui.number.parse($item.data('employee-bundle-discount-price') || 0)
                        : vcui.number.parse($item.data('bundle-discount-price') || 0);
                    var originalPrice = isEmployee
                        ? vcui.number.parse($item.data('employee-original-price') || $item.data('obs-original-price') || 0)
                        : vcui.number.parse($item.data('obs-original-price') || 0);

                    if (bundlePrice > 0 && originalPrice > 0 && bundlePrice < originalPrice) {
                        totalDiscount += (originalPrice - bundlePrice);
                    }
                });

                var hasSelectedAdditions = self.getSelectedAdditionCount() > 0;
                
                if (self.$benefitBanner.length) {
                    if (isMobile) {
                        self.$benefitBanner.hide();
                    } else {
                        if (hasSelectedAdditions && totalDiscount > 0) {
                            $('#additionBenefitAmount').text(vcui.number.addComma(totalDiscount) + '원');
                            self.$benefitBanner.show();
                        } else {
                            self.$benefitBanner.hide();
                        }
                    }
                }

                if (isMobile) {
                    var $actionSheetBanner = self.$actionSheetDiscount.find('.bundling-benefit-banner');
                    if ($actionSheetBanner.length > 0) {
                        if (hasSelectedAdditions && totalDiscount > 0) {
                            $actionSheetBanner.find('span').text(vcui.number.addComma(totalDiscount) + '원');
                            $actionSheetBanner.show();
                        } else {
                            $actionSheetBanner.hide();
                        }
                    }
                    
                    var $bundlingPaymentBanner = $('.bundling-payment.type-fix .bundling-benefit-banner');
                    if ($bundlingPaymentBanner.length > 0) {
                        if (hasSelectedAdditions && totalDiscount > 0) {
                            $bundlingPaymentBanner.find('.text span').text(vcui.number.addComma(totalDiscount) + '원');
                            $bundlingPaymentBanner.show();
                        } else {
                            $bundlingPaymentBanner.hide();
                        }
                    }
                }
            },

            setAdditionFoldPrice : function(){
                const self = this;
                if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                    if($('#employeeTab').hasClass('on')){
                        KRP0008.bottomFoldAreaControl('Y');
                    }else{
                        KRP0008.bottomFoldAreaControl('N');
                    }
                }else{
                    let foldPriceArea = $('#foldPriceArea');
                    let bundleDiscountPrice = self.isEmployee
                        ? vcui.number.parse(foldPriceArea.data('employee-bundle-discount-price') || 0)
                        : vcui.number.parse(foldPriceArea.data('bundle-discount-price') || 0);
                    
                    let currentQuantity = parseInt($('#quantity').val()) || 1;
                    let hasSelectedAdditions = self.getSelectedAdditionCount() > 0;
                    
                    if (hasSelectedAdditions) {
                        let totalSetPrice = (bundleDiscountPrice * currentQuantity) + self.getAdditionTotalPrice();
                        foldPriceArea.find('#totalFoldPrice').html(vcui.number.addComma(totalSetPrice));
                    } else {
                        foldPriceArea.find('#totalFoldPrice').html(vcui.number.addComma(bundleDiscountPrice * currentQuantity));
                    }
                }
            },

            getAdditionTotalPrice: function() {
                var self = this;
                var totalPrice = 0;

                // 소모품 PDP 등 $actionSheetInner가 초기화되지 않은 경우 0 반환
                if (!self.$actionSheetInner) {
                    return 0;
                }

                var $bundlingQuantity = $('.payment-amount.bundling-set .quantity');
                var currentQuantity = $bundlingQuantity.length > 0 
                    ? parseInt($bundlingQuantity.val()) || 1
                    : parseInt($('#quantity').val()) || 1;

                var isEmployee = self.getIsEmployee();

                self.$actionSheetInner.find('.bundling-discount-item').each(function() {
                    var $item = $(this);
                    var bundlePrice = isEmployee
                        ? (vcui.number.parse($item.data('employee-bundle-discount-price')) || 0)
                        : (vcui.number.parse($item.data('bundle-discount-price')) || 0);
                    
                    totalPrice += (bundlePrice * currentQuantity);
                });

                return totalPrice;
            },

            /**
             * 추가품 총 가격 계산 (임직원 여부 지정 가능)
             */
            calculateAdditionTotalPrice: function(isEmployee, quantity) {
                var self = this;
                var totalPrice = 0;

                self.$actionSheetInner.find('.bundling-discount-item').each(function() {
                    var $item = $(this);
                    var bundlePrice = isEmployee
                        ? (vcui.number.parse($item.data('employee-bundle-discount-price')) || 0)
                        : (vcui.number.parse($item.data('bundle-discount-price')) || 0);
                    totalPrice += (bundlePrice * quantity);
                });

                return totalPrice;
            },

            /**
             * 초기 최대 할인가 계산 및 DOM 업데이트
             * calculateMaxDiscountValue를 호출하여 값을 계산하고 DOM에 반영
             */
            calculateMaxDiscount : function() {
                var self = this;
                var maxDiscount = self.calculateMaxDiscountValue();

                if (maxDiscount > 0) {
                    $('#additionMaxDiscountAmount').html('최대 <em>' + vcui.number.addComma(maxDiscount) + '</em>원');
                    $('#additionMaxDiscount').show();
                } else {
                    $('#additionMaxDiscount').hide();
                }
            },

            /**
             * 번들 영역 노출 GA 추적 초기화
             * IntersectionObserver를 사용하여 번들 영역이 화면에 완전히 노출되었을 때 dataLayer 이벤트 전송
             */
            initBundleExposureTracking : function() {
                var self = this;
                
                // 이미 추적된 경우 중복 실행 방지
                if (self.isBundleExposureTracked) {
                    return;
                }
                
                var $targetElement = $('#additionSelect .tit-wrap');
                if ($targetElement.length === 0) {
                    return;
                }
                
                // IntersectionObserver 지원 여부 확인
                if (!('IntersectionObserver' in window)) {
                    return;
                }
                
                var observer = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        // 영역이 완전히 노출되었을 때 (threshold: 1.0)
                        if (entry.isIntersecting && !self.isBundleExposureTracked) {
                            self.isBundleExposureTracked = true;
                            self.sendBundleExposureGA();
                            observer.disconnect();
                        }
                    });
                }, {
                    threshold: 1.0 // 영역이 100% 보일 때 트리거
                });
                
                observer.observe($targetElement[0]);
            },

            /**
             * 번들 노출 GA 이벤트 전송
             */
            sendBundleExposureGA : function() {
                var self = this;
                
                // displayName 목록 생성 (본품 + 모든 추가품)
                var displayNames = [];
                
                // 본품 displayName 추가
                if (self.apiProductData && self.apiProductData.modelDisplayName) {
                    displayNames.push(self.apiProductData.modelDisplayName);
                }
                
                // 추가품 displayName 추가 (유효한 아이템만)
                var validItems = self.getValidBundlingItems();
                
                // PRODUCT 타입 추가품
                if (validItems.validProduct && validItems.validProduct.length > 0) {
                    validItems.validProduct.forEach(function(item) {
                        if (item.modelDisplayName) {
                            displayNames.push(item.modelDisplayName);
                        }
                    });
                }
                
                // DISPOSABLE 타입 추가품
                if (validItems.validDisposable && validItems.validDisposable.length > 0) {
                    validItems.validDisposable.forEach(function(item) {
                        if (item.modelDisplayName) {
                            displayNames.push(item.modelDisplayName);
                        }
                    });
                }
                
                // displayName을 '/'로 구분
                var eventAction = displayNames.join(' / ');
                
                // 할인 총액 계산
                var maxDiscount = self.calculateMaxDiscountValue();
                var eventLabel = vcui.number.addComma(maxDiscount);
                
                // dataLayer push
                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({
                        'event': 'customEvent',
                        'customEventCategory': 'PDP 번들 영역 노출',
                        'customEventAction': eventAction,
                        'customEventLabel': eventLabel
                    });
                }
            },

            /**
             * 최대 할인 총액 계산 (값만 반환)
             * - 본품 + 추가품의 번들 할인 총액을 계산
             * - calculateMaxDiscount, sendBundleExposureGA에서 공통 사용
             */
            calculateMaxDiscountValue : function() {
                var self = this;
                var maxDiscount = 0;
                var isEmployee = self.getIsEmployee();

                if (self.apiProductData) {
                    var productData = self.apiProductData;
                    
                    var validItems = self.getValidBundlingItems();
                    var validProduct = validItems.validProduct;
                    var validDisposable = validItems.validDisposable;
                    
                    var isDisposableOnly = validProduct.length === 0 && validDisposable.length > 0;
                    
                    var bundleDiscountPrice;
                    if (isDisposableOnly) {
                        if (isEmployee) {
                            bundleDiscountPrice = vcui.number.parse(productData.disposableEmployeeBundleDiscountPrice || 0);
                        } else {
                            bundleDiscountPrice = vcui.number.parse(productData.disposableBundleDiscountPrice || 0);
                        }
                    } else {
                        if (isEmployee) {
                            bundleDiscountPrice = vcui.number.parse(productData.employeeBundleDiscountPrice || 0);
                        } else {
                            bundleDiscountPrice = vcui.number.parse(productData.bundleDiscountPrice || 0);
                        }
                    }
                    
                    var sellingPrice;
                    if (isDisposableOnly) {
                        sellingPrice = isEmployee
                            ? vcui.number.parse(productData.disposableEmployeeSellingPrice || 0)
                            : vcui.number.parse(productData.obsSellingPrice || 0);
                    } else {
                        sellingPrice = isEmployee
                            ? vcui.number.parse(productData.employeeSellingPrice || 0)
                            : vcui.number.parse(productData.obsSellingPrice || 0);
                    }

                    if (bundleDiscountPrice > 0 && bundleDiscountPrice < sellingPrice) {
                        var originalDiscount = sellingPrice - bundleDiscountPrice;
                        maxDiscount += originalDiscount;
                    }
                }

                var $visibleContainer = null;
                if (self.$additionProduct && self.$additionProduct.css('display') !== 'none') {
                    $visibleContainer = self.$additionProduct;
                } else if (self.$additionDisposable && self.$additionDisposable.css('display') !== 'none') {
                    $visibleContainer = self.$additionDisposable;
                }

                if ($visibleContainer) {
                    $visibleContainer.find('.bundling-discount-item:not(.original)').each(function() {
                        var $item = $(this);
                        
                        var bundlePrice = isEmployee
                            ? vcui.number.parse($item.data('employee-bundle-discount-price') || 0)
                            : vcui.number.parse($item.data('bundle-discount-price') || 0);
                        var originalPrice = isEmployee
                            ? vcui.number.parse($item.data('employee-original-price') || 0)
                            : vcui.number.parse($item.data('obs-original-price') || 0);

                        if (bundlePrice > 0 && bundlePrice < originalPrice) {
                            var itemDiscount = originalPrice - bundlePrice;
                            maxDiscount += itemDiscount;
                        }
                    });
                }

                return maxDiscount;
            },

            /**
             * 초기 높이 설정 (모바일/PC 구분)
             */
            setInitialHeight : function() {
                var self = this;
                var $itemSelectInner = self.$bundlingDiscountArea.find('.item-select-inner');
                var $itemSelectWrap = self.$bundlingDiscountArea.find('.item-select-wrap');
                
                // 펼쳐진 상태가 아니면 초기 높이 설정
                if (!$itemSelectWrap.hasClass('on')) {
                    var isMobile = window.innerWidth < 768;
                    var maxHeight = isMobile ? '192px' : '260px';
                    $itemSelectInner.css('max-height', maxHeight);
                }
            },

            /**
             * 더보기 토글
             */
            toggleExpand : function() {
                var self = this;
                // 매번 fresh하게 요소를 찾음 (재렌더링 대응)
                var $itemSelectWrap = self.$bundlingDiscountArea.find('.item-select-wrap');
                var isExpanded = $itemSelectWrap.hasClass('on');

                if (isExpanded) {
                    $itemSelectWrap.removeClass('on');
                    self.$moreButton.find('span').text('더보기');
                } else {
                    $itemSelectWrap.addClass('on');
                    self.$moreButton.find('span').text('접기');
                }
            },

            /**
             * qtyNotice와 qtyNoticeMobile을 함께 업데이트하는 헬퍼 함수
             */
            updateQtyNotices: function(displayMaxQty) {
                var $qtyNotice = $('#qtyNotice');
                var $qtyNoticeMobile = $('#qtyNoticeMobile');
                
                if ($qtyNotice.length > 0) {
                    $qtyNotice.find('.count-num').text(displayMaxQty);
                }
                if ($qtyNoticeMobile.length > 0) {
                    $qtyNoticeMobile.find('.count-num').text(displayMaxQty);
                }
            },

            /**
             * qtyNotice와 qtyNoticeMobile을 함께 표시하는 헬퍼 함수
             * purchase-limit-qty가 있을 때만 표시
             * @param {number} effectiveLimitQty - 유효한 구매 제한 수량 (옵션, 전달되지 않으면 본품의 purchase-limit-qty 사용)
             */
            showQtyNotices: function(effectiveLimitQty) {
                var purchaseLimitQty;
                
                if (effectiveLimitQty !== undefined && effectiveLimitQty !== null) {
                    // 파라미터로 전달된 값 사용 (번들 선택 시)
                    purchaseLimitQty = effectiveLimitQty;
                } else {
                    // 본품의 purchase-limit-qty 사용 (번들 미선택 시)
                    var $countCheckArea = $('.box.payment-amount.count-check');
                    purchaseLimitQty = parseInt($countCheckArea.data('purchase-limit-qty'));
                }
                
                // purchase-limit-qty가 없으면 표시하지 않음
                if (!purchaseLimitQty || purchaseLimitQty <= 0) {
                    this.hideQtyNotices();
                    return;
                }
                
                var isMobile = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;
                var $qtyNotice = $('#qtyNotice');
                var $qtyNoticeMobile = $('#qtyNoticeMobile');
                
                if (isMobile) {
                    // 모바일: qtyNoticeMobile만 표시
                    if ($qtyNoticeMobile.length > 0) {
                        $qtyNoticeMobile.css({
                            'display': 'block',
                            'visibility': 'visible',
                            'opacity': '1'
                        }).removeAttr('style').show();
                    }
                    // PC용 qtyNotice는 숨김
                    if ($qtyNotice.length > 0) {
                        $qtyNotice.hide();
                    }
                } else {
                    // PC: qtyNotice만 표시
                    if ($qtyNotice.length > 0) {
                        $qtyNotice.css({
                            'display': 'block',
                            'visibility': 'visible',
                            'opacity': '1'
                        }).removeAttr('style').show();
                    }
                    // 모바일용 qtyNoticeMobile은 숨김
                    if ($qtyNoticeMobile.length > 0) {
                        $qtyNoticeMobile.hide();
                    }
                }
            },

            /**
             * qtyNotice와 qtyNoticeMobile을 함께 숨기는 헬퍼 함수
             */
            hideQtyNotices: function() {
                $('#qtyNotice').hide();
                $('#qtyNoticeMobile').hide();
            },

            /**
             * 초기 구매 가능 수량 정보 설정 (페이지 로드 시)
             */
            setInitialQuantityInfo: function() {
                var $countCheckArea = $('.box.payment-amount.count-check');
                
                // data 속성에서 값 읽기
                var mainMaxQty = parseInt($countCheckArea.data('obs-max-qty')) || 24;
                var purchaseLimitQty = parseInt($countCheckArea.data('purchase-limit-qty'));
                
                // purchaseLimitQty가 있을 때만 표시
                if (purchaseLimitQty && purchaseLimitQty > 0) {
                    var displayMaxQty = Math.min(mainMaxQty, purchaseLimitQty);
                    // JSP의 구매 가능 수량 영역 업데이트 (PC/모바일 모두)
                    this.updateQtyNotices(displayMaxQty);
                    // PC/모바일에 맞게 표시
                    this.showQtyNotices();
                } else {
                    // purchaseLimitQty가 없으면 숨김
                    this.hideQtyNotices();
                }
            },

            // 세트 수량 범위 계산
            calculateSetQuantityRange: function() {
                var self = this;
                var $mainProduct = $('.box.payment-amount.count-check');
                var mainMinQty = parseInt($mainProduct.data('obs-min-qty')) || 1;
                var mainMaxQty = parseInt($mainProduct.data('obs-max-qty')) || 24;
                
                // 회원당 구매 제한 수량이 있으면 적용 (본품)
                var purchaseLimitQty = parseInt($mainProduct.data('purchase-limit-qty'));
                if (purchaseLimitQty && purchaseLimitQty > 0) {
                    mainMaxQty = Math.min(mainMaxQty, purchaseLimitQty);
                }
                
                // purchaseLimitQty 중 최소값을 찾기 위한 배열 (본품 포함)
                var limitQtyList = [];
                if (purchaseLimitQty && purchaseLimitQty > 0) {
                    limitQtyList.push(purchaseLimitQty);
                }

                var selectedAdditions = [];
                self.$bundlingDiscountArea.find('input[type="checkbox"]:checked').each(function() {
                    var $item = $(this).closest('.bundling-discount-item');
                    var minQty = parseInt($item.data('obs-min-qty')) || 1;
                    var maxQty = parseInt($item.data('obs-max-qty')) || 24;
                    
                    // 추가품의 limitQty 확인
                    var additionLimitQty = parseInt($item.data('limit-qty'));
                    if (additionLimitQty && additionLimitQty > 0) {
                        maxQty = Math.min(maxQty, additionLimitQty);
                        limitQtyList.push(additionLimitQty);
                    }
                    
                    selectedAdditions.push({ minQty: minQty, maxQty: maxQty });
                });

                // 겹치는 범위 계산
                var setMinQty = mainMinQty;
                var setMaxQty = mainMaxQty;

                selectedAdditions.forEach(function(addition) {
                    setMinQty = Math.max(setMinQty, addition.minQty);
                    setMaxQty = Math.min(setMaxQty, addition.maxQty);
                });

                // 유효하지 않은 범위일 경우 기본값 반환
                if (setMinQty > setMaxQty) {
                    return { minQty: 1, maxQty: 1, effectiveLimitQty: null };
                }
                
                // 가장 낮은 purchaseLimitQty 계산
                var effectiveLimitQty = null;
                if (limitQtyList.length > 0) {
                    effectiveLimitQty = Math.min.apply(Math, limitQtyList);
                }

                return { minQty: setMinQty, maxQty: setMaxQty, effectiveLimitQty: effectiveLimitQty };
            },

            // 수량 영역 업데이트
            updateQuantityArea: function() {
                var self = this;
                var hasSelectedAdditions = self.getSelectedAdditionCount() > 0;
                var currentQuantity = parseInt($('#quantity').val()) || 1;

                // 기존 count-check 영역
                var $countCheckArea = $('.box.payment-amount.count-check');
                var $countCheckWrap = $countCheckArea.find('.quantity-payment-wrap');

                // 새로운 box payment-amount 영역
                var $boxArea = $('.box.payment-amount');
                var $bundlingPayment = $boxArea.find('.bundling-payment.type-fix');
                
                var $text;
                var $paymentAmount;
                var $qtyNotice;
                var isMobile = window.breakpoint ? window.breakpoint.isMobile : window.innerWidth < 768;
                var empYn;

                if (hasSelectedAdditions) {
                    // 세트 수량 범위 계산
                    var quantityRange = self.calculateSetQuantityRange();
                    var setMinQty = quantityRange.minQty;
                    var setMaxQty = quantityRange.maxQty;
                    var effectiveLimitQty = quantityRange.effectiveLimitQty;
                                        
                    // effectiveLimitQty가 있을 때만 표시하되, maxQty와 비교해서 더 작은 값 사용
                    var displayQty = null;
                    if (effectiveLimitQty && effectiveLimitQty > 0) {
                        displayQty = Math.min(effectiveLimitQty, setMaxQty);
                    }
                    // effectiveLimitQty가 없으면 displayQty는 null로 유지 (표시 안 함)
                    
                    if (!$countCheckArea.hasClass('bundling-set')) {
                        // 처음 추가품을 선택할 때 원래 수량 저장
                        self.originalQuantity = currentQuantity;
                        
                        $countCheckArea.addClass('bundling-set');
                        $countCheckWrap.addClass('bundling-payment');

                        $text = $countCheckWrap.find('.price-info.quantity .text');
                        // qtyNotice를 숨기기만 하고 제거하지 않음 (PC용만, 모바일용은 JSP에 별도로 있음)
                        $qtyNotice = $text.find('#qtyNotice');

                        // displayQty가 있을 때만 "구매 가능 수량" 표시
                        var quantityInfoHtml = '';
                        if (displayQty && displayQty > 0) {
                            quantityInfoHtml = '<p class="info-text">구매 가능 수량 <span class="count-num">' + displayQty + '</span>개</p>';
                        }

                        $text.html(
                            '<p class="text-select">수량선택 (본품 + 추가 제품)</p>' +
                            quantityInfoHtml   
                        );

                        // qtyNotice를 다시 추가 (나중에 복원할 때 사용 - PC용만)
                        if ($qtyNotice.length > 0) {
                            self.originalQtyNotice = $qtyNotice.clone();
                        }
                    } else {
                        // 이미 추가품이 선택된 상태에서 다른 추가품 선택/해제 시
                        var $infoText = $countCheckWrap.find('.info-text');
                        if (displayQty && displayQty > 0) {
                            // displayQty가 있으면 업데이트하거나 새로 추가
                            if ($infoText.length > 0) {
                                $infoText.find('.count-num').text(displayQty);
                            } else {
                                $countCheckWrap.find('.price-info.quantity .text').append(
                                    '<p class="info-text">구매 가능 수량 <span class="count-num">' + displayQty + '</span>개</p>'
                                );
                            }
                        } else {
                            // displayQty가 없으면 제거
                            $infoText.remove();
                        }
                    }

                    // 모바일에서는 count-check 영역 숨기기 (bundling-set 활성화 시)
                    if (isMobile) {
                        $countCheckArea.hide();
                    }
                    
                    // 번들 선택 시: displayQty가 있을 때만 qtyNotice 표시
                    if (displayQty && displayQty > 0) {
                        // qtyNotice의 수량 업데이트
                        self.updateQtyNotices(displayQty);
                        // PC/모바일에 맞게 표시
                        self.showQtyNotices(displayQty);
                    } else {
                        // displayQty가 없으면 숨김
                        self.hideQtyNotices();
                    }

                    // 현재 수량이 범위를 벗어나면 조정
                    if (currentQuantity < setMinQty) {
                        currentQuantity = setMinQty;
                    } else if (currentQuantity > setMaxQty) {
                        currentQuantity = setMaxQty;
                    }

                    // 모든 수량 input 동기화
                    $('#quantity').val(currentQuantity);
                    $('.payment-amount .quantity').val(currentQuantity);
                    $countCheckWrap.find('.quantity').val(currentQuantity).prop('readonly', false);
                    
                    // data 속성도 함께 업데이트
                    $('.payment-amount').data('quantity', currentQuantity);

                    $bundlingPayment.show();

                    // 수량 정보 업데이트 (displayQty가 있을 때만 표시)
                    var $textNum = $bundlingPayment.find('.text-num');
                    if (displayQty && displayQty > 0) {
                        $textNum.find('.count-num').text(displayQty);
                        $textNum.show();
                    } else {
                        $textNum.hide();
                    }
                    $bundlingPayment.find('.quantity').val(currentQuantity).prop('readonly', false);
                    
                    // iOS에서 자동 확대 방지: wrapper에 font-size 설정 (input은 inherit)
                    $bundlingPayment.find('.select-quantity').css('font-size', '16px');

                    // 혜택 배너 가격 동기화
                    // calculatePrices에서 이미 ActionSheet 배너를 업데이트하므로, 
                    // PC 배너의 값을 가져와서 동기화 (모바일일 때는 calculatePrices에서 직접 설정됨)
                    var benefitPrice = '';
                    if (!isMobile && self.$benefitBanner.length > 0) {
                        benefitPrice = self.$benefitBanner.find('span').text();
                    } else {
                        // 모바일일 때는 ActionSheet 배너에서 직접 가져오기
                        var $actionSheetBanner = self.$actionSheetDiscount.find('.bundling-benefit-banner span');
                        if ($actionSheetBanner.length > 0) {
                            benefitPrice = $actionSheetBanner.text();
                        }
                    }
                    if (benefitPrice) {
                        $bundlingPayment.find('.bundling-benefit-banner .text span').text(benefitPrice);
                    }

                    // 버튼 활성화 상태 업데이트
                    self.updateQuantityButtons(currentQuantity, setMinQty, setMaxQty);

                    // 가격 업데이트
                    self.setAdditionFoldPrice();
                    
                    $paymentAmount = $('.payment-amount');
                    KRP0008.updatePaymentAmountPrice($paymentAmount, true);
                    // 임직원으로 로그인했어도 일반회원 탭이 선택되었는지 확인
                    if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                        empYn = $('#employeeTab').hasClass('on') ? 'Y' : 'N';
                    } else {
                        empYn = 'N';
                    }
                    KRP0008.bottomFoldAreaControl(empYn);
                } else {
                    // 추가품이 없을 때 원래 상태로 복원
                    $bundlingPayment.hide();
                    
                    // 본품의 원래 수량 범위 가져오기
                    var mainMinQty = parseInt($countCheckArea.data('obs-min-qty')) || 1;
                    var mainMaxQty = parseInt($countCheckArea.data('obs-max-qty')) || 24;
                    
                    // 회원당 구매 제한 수량이 있으면 적용
                    var purchaseLimitQty = parseInt($countCheckArea.data('purchase-limit-qty'));
                    var displayMaxQty = mainMaxQty;
                    if (purchaseLimitQty && purchaseLimitQty > 0) {
                        displayMaxQty = Math.min(mainMaxQty, purchaseLimitQty);
                    }
                    
                    // 저장된 원래 수량으로 복원 (없으면 현재 수량 또는 최소값 사용)
                    if (self.originalQuantity !== null && self.originalQuantity !== undefined) {
                        currentQuantity = self.originalQuantity;
                    } else if (!currentQuantity || currentQuantity < 1) {
                        // 수량이 비어있거나 유효하지 않으면 최소값으로 설정
                        currentQuantity = mainMinQty;
                    }
                    
                    // 원래 수량이 본품의 범위를 벗어나면 조정
                    if (currentQuantity < mainMinQty) {
                        currentQuantity = mainMinQty;
                    } else if (currentQuantity > displayMaxQty) {
                        currentQuantity = displayMaxQty;
                    }
                    
                    // 모든 수량 input 동기화
                    $('#quantity').val(currentQuantity);
                    $('.payment-amount .quantity').val(currentQuantity);
                    $countCheckWrap.find('.quantity').val(currentQuantity).prop('readonly', false);
                    
                    // data 속성도 함께 업데이트
                    $('.payment-amount').data('quantity', currentQuantity);
                    
                    // count-check 영역 원래 상태로 복원
                    if ($countCheckArea.hasClass('bundling-set')) {
                        $countCheckArea.removeClass('bundling-set');
                        $countCheckWrap.removeClass('bundling-payment');
                        
                        // 텍스트를 원래 상태로 복원 (qtyNotice 포함)
                        $text = $countCheckWrap.find('.price-info.quantity .text');
                        $text.html('<p class="text-select">수량선택</p>');
                        
                        // qtyNotice 복원 (PC용만 복원, 모바일용은 JSP에 이미 있음)
                        if (self.originalQtyNotice && self.originalQtyNotice.length > 0) {
                            $text.append(self.originalQtyNotice);
                            self.originalQtyNotice = null; // 메모리 정리
                        } else {
                            // originalQtyNotice가 없으면 새로 생성 (PC용만)
                            $qtyNotice = $('<div class="info-text" id="qtyNotice"><p>구매 가능 수량 <span class="count-num">' + displayMaxQty + '</span>개</p></div>');
                            $text.append($qtyNotice);
                        }
                        // 모바일용 qtyNoticeMobile은 JSP에 이미 있으므로 업데이트만 수행
                        
                        // readonly 해제 및 수량 동기화
                        $countCheckWrap.find('.quantity').val(currentQuantity).prop('readonly', false);
                    }
                    
                    // iOS에서 자동 확대 방지: wrapper에 font-size 설정 (input은 inherit)
                    // 번들 선택 시와 동일하게 count-check 영역에도 적용
                    $countCheckWrap.find('.select-quantity').css('font-size', '16px');
                    
                    // count-check 영역 다시 보이기 (추가품 해제 시 - PC/모바일 모두)
                    $countCheckArea.show();
                    
                    // JSP의 구매 가능 수량 영역 표시 및 값 업데이트 (PC/모바일 모두)
                    self.updateQtyNotices(displayMaxQty);
                    self.showQtyNotices();
                    
                    // 버튼 활성화 상태 업데이트 (본품 범위 기준)
                    self.updateQuantityButtons(currentQuantity, mainMinQty, displayMaxQty);
                    
                    // 가격 업데이트
                    self.setAdditionFoldPrice();
                    $paymentAmount = $('.payment-amount');
                    KRP0008.updatePaymentAmountPrice($paymentAmount, true);
                    
                    // 일반회원일 때 totalPaymentArea 명시적으로 표시
                    // 임직원으로 로그인했어도 일반회원 탭이 선택되었는지 확인
                    if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                        empYn = $('#employeeTab').hasClass('on') ? 'Y' : 'N';
                    } else {
                        empYn = 'N';
                    }
                    if (empYn === 'N') {
                        $('#totalPaymentArea').show();
                    }
                    
                    KRP0008.bottomFoldAreaControl(empYn);
                }
            },

            // 수량 버튼 활성화 상태 업데이트
            updateQuantityButtons: function(currentQuantity, minQuantity, maxQuantity) {
                // count-check 영역 버튼 (PC)
                var $countCheckMinus = $('.box.payment-amount.count-check .quantity-payment-wrap .minus');
                var $countCheckPlus = $('.box.payment-amount.count-check .quantity-payment-wrap .plus');

                // box 영역 버튼 (MO)
                var $boxMinus = $('.box.payment-amount .bundling-payment .minus');
                var $boxPlus = $('.box.payment-amount .bundling-payment .plus');

                // bundling-set 영역 버튼 (번들링 세트 선택 시)
                var $bundlingSetMinus = $('.payment-amount.bundling-set .minus');
                var $bundlingSetPlus = $('.payment-amount.bundling-set .plus');

                // minus 버튼: 최소수량일 때 disabled 속성 true로 설정 (아예 선택 안되게)
                if (currentQuantity <= minQuantity) {
                    $countCheckMinus.prop('disabled', true).addClass('disabled').attr('aria-disabled', 'true');
                    $boxMinus.prop('disabled', true).addClass('disabled').attr('aria-disabled', 'true');
                    $bundlingSetMinus.prop('disabled', true).addClass('disabled').attr('aria-disabled', 'true');
                } else {
                    $countCheckMinus.prop('disabled', false).removeClass('disabled').attr('aria-disabled', 'false');
                    $boxMinus.prop('disabled', false).removeClass('disabled').attr('aria-disabled', 'false');
                    $bundlingSetMinus.prop('disabled', false).removeClass('disabled').attr('aria-disabled', 'false');
                }

                // plus 버튼: 최대수량일 때도 disabled 속성 false 유지, 클래스도 제거 (시각적으로도 비활성화 안되고 선택 가능하게)
                $countCheckPlus.prop('disabled', false).removeClass('disabled').attr('aria-disabled', 'false');
                $boxPlus.prop('disabled', false).removeClass('disabled').attr('aria-disabled', 'false');
                $bundlingSetPlus.prop('disabled', false).removeClass('disabled').attr('aria-disabled', 'false');
            },

            // 수량 변경 핸들러
            handleQuantityChange: function($btn, delta) {
                var self = this;
                var $quantityInput = $btn.closest('.inner').find('.quantity');
                var currentQuantity = parseInt($quantityInput.val()) || 1;
                var empYn;

                var quantityRange = self.calculateSetQuantityRange();
                var minQuantity = quantityRange.minQty;
                var maxQuantity = quantityRange.maxQty;

                var newQuantity = currentQuantity + delta;

                if (newQuantity >= minQuantity && newQuantity <= maxQuantity) {
                    // 모든 수량 input 동기화
                    $('.payment-amount .quantity').val(newQuantity);
                    $('#quantity').val(newQuantity);
                    
                    // data('quantity') 속성도 동기화 (updatePaymentAmountPrice에서 사용)
                    $('.payment-amount').data('quantity', newQuantity);

                    self.updateQuantityButtons(newQuantity, minQuantity, maxQuantity);

                    // 가격 업데이트
                    self.setAdditionFoldPrice();
                    
                    var $paymentAmount = $('.payment-amount');
                    KRP0008.updatePaymentAmountPrice($paymentAmount, true);
                    // 임직원으로 로그인했어도 일반회원 탭이 선택되었는지 확인
                    if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                        empYn = $('#employeeTab').hasClass('on') ? 'Y' : 'N';
                    } else {
                        empYn = 'N';
                    }
                    KRP0008.bottomFoldAreaControl(empYn);
                    
                    // 수량 변경 시 히스토리 저장
                    self.saveToHistory();
                } else if (newQuantity > maxQuantity) {
                    // 최대 수량 초과 시 토스트 표시
                    self.showQuantityToast('구매 가능 수량을 초과했어요');
                    // 현재 수량 기준으로 버튼 상태 재설정
                    self.updateQuantityButtons(currentQuantity, minQuantity, maxQuantity);
                } else if (newQuantity < minQuantity) {
                    // 최소 수량 미만 시 아무것도 하지 않음 (알럿도 안뜨고)
                    return;
                }
            },

            // 수량 직접 입력 핸들러 (실시간 입력 제한)
            handleQuantityInput: function($input) {
                var value = $input.val();
                
                // 숫자가 아닌 문자 제거 (자연수만 허용)
                value = value.replace(/\D/g, '');
                
                // 0으로 시작하는 경우 제거 (단, 빈 값이 아닐 때만)
                if (value.length > 1 && value.charAt(0) === '0') {
                    value = value.substring(1);
                }
                
                $input.val(value);
            },

            // 수량 입력 검증 (blur 시 호출)
            validateQuantityInput: function($input) {
                var self = this;
                var value = $input.val();
                var quantity = parseInt(value) || 0;

                var quantityRange = self.calculateSetQuantityRange();
                var minQuantity = quantityRange.minQty;
                var maxQuantity = quantityRange.maxQty;

                // 빈 값이거나 0인 경우 최소값으로 설정
                if (!value || quantity === 0 || quantity < minQuantity) {
                    self.showQuantityToast('주문 가능한 최소 수량은 ' + minQuantity + '개 입니다.');
                    quantity = minQuantity;
                    self.syncAllQuantityInputs(quantity, minQuantity, maxQuantity);
                } else if (quantity > maxQuantity) {
                    // 최대 수량 초과 시
                    self.showQuantityToast('구매 가능 수량을 초과했어요');
                    quantity = maxQuantity;
                    self.syncAllQuantityInputs(quantity, minQuantity, maxQuantity);
                } else {
                    // 정상 범위 내의 값
                    self.syncAllQuantityInputs(quantity, minQuantity, maxQuantity);
                }
            },

            // 모든 수량 input 동기화 및 가격 업데이트
            syncAllQuantityInputs: function(quantity, minQuantity, maxQuantity) {
                var self = this;

                // 모든 수량 input 동기화
                $('.payment-amount .quantity').val(quantity);
                $('#quantity').val(quantity);
                
                // data('quantity') 속성도 동기화
                $('.payment-amount').data('quantity', quantity);

                // 버튼 상태 업데이트
                self.updateQuantityButtons(quantity, minQuantity, maxQuantity);

                // 가격 업데이트
                self.setAdditionFoldPrice();
                
                var $paymentAmount = $('.payment-amount');
                KRP0008.updatePaymentAmountPrice($paymentAmount, true);
                // 임직원으로 로그인했어도 일반회원 탭이 선택되었는지 확인
                var empYn;
                if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                    empYn = $('#employeeTab').hasClass('on') ? 'Y' : 'N';
                } else {
                    empYn = 'N';
                }
                KRP0008.bottomFoldAreaControl(empYn);
                
                // 수량 변경 시 히스토리 저장
                self.saveToHistory();
            },

            // 토스트 메시지 표시
            showQuantityToast: function(message) {
                lgkorUI.alert("", {title: message});
            },

            // 선택된 추가품 개수 반환
            getSelectedAdditionCount: function() {
                var self = this;
                // ActionSheet에 있는 아이템 개수를 반환 (ActionSheet에 있다는 것 = 선택되었다는 의미)
                var count = self.$actionSheetInner ? self.$actionSheetInner.find('.bundling-discount-item').length : 0;
                return count;
            },

            /**
             * 케어십 라디오 버튼 클릭 시 추가품 확인 및 처리
             * @param {boolean} isCareship - 케어십 선택 여부
             */
            careshipServiceRadioClick: function(isCareship) {
                var self = this;

                // 유효한 아이템 필터링 (공통 함수 사용)
                var validItems = self.getValidBundlingItems();
                var validDisposable = validItems.validDisposable;
                var validProduct = validItems.validProduct;

                var additionListTotalCnt = validDisposable.length + validProduct.length;

                if (additionListTotalCnt > 0) {
                    if (isCareship) {
                        var confirmMessage = "";
                        var selectedCount = self.getSelectedAdditionCount();

                        if (selectedCount > 0) {
                            confirmMessage = "케어십 서비스 신청시에는</br>" +
                                "추가상품을 함께 구매하지 못하기에</br>" +
                                "선택하신 추가상품은 삭제됩니다.</br>" +
                                "케어십을 신청하시겠습니까?</br>";
                        } else {
                            confirmMessage = "케어십 서비스 신청시에는</br>" +
                                "추가상품을 함께 구매하지 못합니다.</br>" +
                                "케어십을 신청하시겠습니까?</br>";
                        }

                        var saveQuantity = $('#quantity').val();

                        lgkorUI.confirm('', {
                            title: confirmMessage,
                            okBtnName: '예',
                            cancelBtnName: '아니오',
                            ok: function() {
                                self.removeAllSelectedAdditionModel();
                                // 케어십 선택 시 additionSelect 영역 숨김
                                $('#additionSelect').hide();
                            },
                            cancel: function() {
                                $('#quantity').val(saveQuantity);
                                var $paymentAmount = KRP0008.$pdpInfo.find('.payment-amount');
                                $paymentAmount.data('quantity', saveQuantity);
                                KRP0008.$pdpInfoCareshipService.find('input[type=radio][value=N]').trigger('click');
                            }
                        }, document.activeElement);
                    } else {
                        // 케어십 해제 시 additionSelect 영역 다시 보이기
                        $('#additionSelect').show();
                    }
                }
            },

            /**
             * 선택된 모든 추가품 제거
             */
            removeAllSelectedAdditionModel: function() {
                var self = this;

                // 선택된 추가품 체크박스 해제
                self.$additionDisposable.find('input[type=checkbox]:checked').prop('checked', false);
                self.$additionProduct.find('input[type=checkbox]:checked').prop('checked', false);

                // 추가품 목록 초기화
                $('#actionSheetAddition .bundled-payment-list').empty();

                // ActionSheet의 선택된 추가품 제거
                if (self.$actionSheetInner && self.$actionSheetInner.length > 0) {
                    self.$actionSheetInner.find('.bundling-discount-item').remove();
                }

                self.updateUI();

                // 히스토리 저장
                self.saveToHistory();
            },

            /**
             * 탭 클릭 시 가격 정보 업데이트
             * @param {string} tabId - 탭 ID ('employeeTab' 또는 'b2cTab')
             */
            tabClick: function(tabId) {
                var self = this;
                self.isEmployee = (tabId === 'employeeTab');

                // 탭 전환 시 선택된 추가품 모두 해제
                // 체크박스 해제
                self.$additionDisposable.find('input[type=checkbox]:checked').prop('checked', false);
                self.$additionProduct.find('input[type=checkbox]:checked').prop('checked', false);
                
                // 기존 아이템 제거
                self.$additionProduct.empty();
                self.$additionDisposable.empty();
                self.$actionSheetInner.find('.bundling-discount-addition').empty();
                
                // ActionSheet의 선택된 추가품 제거
                if (self.$actionSheetInner && self.$actionSheetInner.length > 0) {
                    self.$actionSheetInner.find('.bundling-discount-item').remove();
                }

                // 본품 영역 업데이트 (PDP + ActionSheet)
                // API 데이터가 있으면 본품 영역을 다시 렌더링
                if (self.apiProductData) {
                    self.renderOriginalProductArea(self.apiProductData);
                }
                self.toggleOriginalProductArea();
                
                // ActionSheet 본품 영역도 업데이트 (API 데이터가 있는 경우)
                if (self.apiProductData) {
                    self.updateActionSheetOriginalProduct();
                }
                
                // 가격 data 속성 업데이트 (탭 전환 시에도 동기화)
                if (self.apiProductData) {
                    self.updatePriceDataAttributes();
                }

                // 아이템 렌더링 먼저 (calculateMaxDiscount가 아이템을 참조하므로)
                self.renderInitialItems();

                // 이벤트 재바인딩 (탭 전환 시 새로 렌더링된 아이템에 이벤트 적용)
                self.bindEvents();

                // 아이템 렌더링 후 할인액 계산
                self.calculateMaxDiscount();

                // 가격 업데이트 (탭 전환 시 추가품이 해제되었으므로)
                var $paymentAmount = $('.payment-amount');
                if ($paymentAmount.length > 0) {
                    KRP0008.updatePaymentAmountPrice($paymentAmount, false);
                    
                    // 탭에 맞는 empYn 설정
                    var empYn = 'N';
                    if($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0){
                        empYn = $('#employeeTab').hasClass('on') ? 'Y' : 'N';
                    }
                    KRP0008.bottomFoldAreaControl(empYn);
                }

                self.updateUI();
            },

            getIsEmployee: function() {
                return this.isEmployee || false;
            },

            /**
             * 히스토리 저장
             */
            saveToHistory : function() {
                var self = this;
                
                // 히스토리 복원 중에는 저장하지 않음 (복원 중 trigger('change')로 인한 덮어쓰기 방지)
                if (self.isRestoringFromHistory) {
                    return;
                }
                
                var selectedItems = [];
                var quantities = {}; // 추가품별 수량 저장
                var $additionalItems;

                // 번들링 추가품 선택 정보 저장
                $('input[type="checkbox"][data-model-id]:checked').each(function() {
                    var modelId = $(this).data('model-id');
                    selectedItems.push(modelId);
                });

                // 본품 수량 저장 (번들링 추가품은 본품 수량과 동일)
                var $bundlingQuantity = $('.payment-amount.bundling-set .quantity');
                var mainQuantity = $bundlingQuantity.length > 0 
                    ? parseInt($bundlingQuantity.val()) || 1
                    : parseInt($('#quantity').val()) || 1;
                quantities._main = mainQuantity;

                // 소모품 추가구매 수량 저장
                $additionalItems = $('.additional-purchase div.additional-payment ul li');
                $additionalItems.each(function() {
                    var $item = $(this);
                    var itemId = $item.data('id');
                    if (itemId) {
                        var itemQuantity = parseInt($item.find('input.quantity').val()) || 1;
                        quantities[itemId] = itemQuantity;
                    }
                });

                // 총금액 저장 (각 플랫폼별 가격 모두 저장)
                var totalPrice = 0;
                var foldPrice = 0;  // AOS 바닥페이지 가격
                var pcPrice = 0;    // PC 가격
                
                // AOS 바텀시트 가격 저장
                var $totalPriceElement = $('.action-sheet .total-payment span.price em');
                if ($totalPriceElement.length > 0) {
                    var totalPriceText = $totalPriceElement.text();
                    // 숫자만 추출 (콤마 제거)
                    totalPriceText = totalPriceText.replace(/\D/g, '');
                    totalPrice = parseInt(totalPriceText) || 0;
                }
                
                // AOS 바닥페이지 가격 저장 (foldPriceArea)
                var $foldPriceElement = $('#foldPriceArea #totalFoldPrice');
                if ($foldPriceElement.length > 0) {
                    var foldPriceText = $foldPriceElement.text();
                    foldPriceText = foldPriceText.replace(/\D/g, '');
                    foldPrice = parseInt(foldPriceText) || 0;
                }
                
                // PC 가격 저장 (totalCalcPayment 또는 totalPaymentArea)
                var $pcPriceElement = $('#totalCalcPayment #calcNormalAmt em');
                if ($pcPriceElement.length === 0) {
                    $pcPriceElement = $('#totalPaymentArea .total-payment .price em');
                }
                if ($pcPriceElement.length > 0) {
                    var pcPriceText = $pcPriceElement.text();
                    pcPriceText = pcPriceText.replace(/\D/g, '');
                    pcPrice = parseInt(pcPriceText) || 0;
                }

                // 현재 상품 ID 저장
                var currentModelId = typeof lgePdpSendData !== 'undefined' && lgePdpSendData.modelId 
                    ? lgePdpSendData.modelId 
                    : null;

                var historyData = {
                    modelId: currentModelId,     // 현재 상품 ID 저장
                    items: selectedItems,
                    quantities: quantities,
                    totalPrice: totalPrice,      // AOS 바텀시트 가격
                    foldPrice: foldPrice,        // AOS 바닥페이지 가격
                    pcPrice: pcPrice,            // PC 가격
                    timestamp: new Date().getTime()
                };

                // 안드로이드 앱 환경에서는 localStorage 사용 (sessionStorage는 페이지 이동 시 초기화될 수 있음)
                var storage = (isApp() && vcui.detect.isAndroid) ? localStorage : sessionStorage;
                storage.setItem(self.storageHistKey, JSON.stringify(historyData));
            },

            /**
             * 히스토리 로드
             */
            loadFromHistory : function() {
                var self = this;
                // 안드로이드 앱 환경에서는 localStorage 사용 (sessionStorage는 페이지 이동 시 초기화될 수 있음)
                var storage = (isApp() && vcui.detect.isAndroid) ? localStorage : sessionStorage;
                var historyData = storage.getItem(self.storageHistKey);
                var $additionalItems;

                if (!historyData) return;

                try {
                    var data = JSON.parse(historyData);
                    var currentTime = new Date().getTime();
                    var timeoutMs = self.historyTimeOut * 60 * 1000;

                    if (currentTime - data.timestamp > timeoutMs) {
                        storage.removeItem(self.storageHistKey);
                        return;
                    }

                    // 현재 상품 ID와 저장된 상품 ID 비교
                    var currentModelId = typeof lgePdpSendData !== 'undefined' && lgePdpSendData.modelId 
                        ? lgePdpSendData.modelId 
                        : null;
                    
                    // 상품 ID가 다르면 히스토리를 로드하지 않음 (다른 상품 페이지)
                    if (currentModelId && data.modelId && currentModelId !== data.modelId) {
                        // 다른 상품의 히스토리는 삭제하지 않고 그냥 무시 (같은 상품으로 돌아올 수 있으므로)
                        return;
                    }

                    // 히스토리 복원 중 플래그 설정
                    self.isRestoringFromHistory = true;

                    self.isFirstBundleCheck = false;
                    
                    // 저장된 수량 정보를 먼저 저장
                    var savedMainQuantity = null;
                    var savedAdditionalQuantities = {};
                    if (data.quantities) {
                        if (data.quantities._main) {
                            savedMainQuantity = parseInt(data.quantities._main) || 1;
                        }
                        
                        // 소모품 추가구매 수량 저장
                        $additionalItems = $('.additional-purchase div.additional-payment ul li');
                        $additionalItems.each(function() {
                            var $item = $(this);
                            var itemId = $item.data('id');
                            if (itemId && data.quantities[itemId]) {
                                savedAdditionalQuantities[itemId] = parseInt(data.quantities[itemId]) || 1;
                            }
                        });
                    }

                    // 번들링 추가품 선택 복원
                    if (data.items && Array.isArray(data.items) && data.items.length > 0) {
                        data.items.forEach(function(modelId) {
                            $('input[data-model-id="' + modelId + '"]')
                                .prop('checked', true)
                                .trigger('change');
                        });
                    }

                    // 수량 복원 (번들링 추가품 선택 복원 후 다시 복원하여 덮어쓰기 방지)
                    if (data.quantities) {
                        // 본품 수량 복원
                        if (savedMainQuantity !== null) {
                            // 약간의 지연을 두어 change 이벤트 처리 후 수량 복원
                            setTimeout(function() {
                                if (data.items.length > 0) {
                                    // 번들링 추가품이 선택된 경우
                                    $('.payment-amount.bundling-set .quantity').val(savedMainQuantity);
                                    $('.payment-amount.bundling-set .quantity').trigger('change');
                                    
                                    // 모바일 번들링 수량 영역도 함께 업데이트
                                    $('.bundling-payment .quantity').val(savedMainQuantity);
                                } else {
                                    // 번들링 추가품이 선택되지 않은 경우
                                    $('#quantity').val(savedMainQuantity);
                                    $('#quantity').trigger('change');
                                }
                                $('.payment-amount').data('quantity', savedMainQuantity);
                                
                                // 수량 버튼 상태 업데이트 (마이너스/플러스 버튼 활성화/비활성화)
                                var quantityRange = self.calculateSetQuantityRange();
                                self.updateQuantityButtons(savedMainQuantity, quantityRange.minQty, quantityRange.maxQty);
                                
                                // 가격 업데이트 함수 호출하여 모든 영역 자동 업데이트
                                var $paymentAmount = $('.pdp-info-area .payment-amount');
                                if ($paymentAmount.length > 0) {
                                    KRP0008.updatePaymentAmountPrice($paymentAmount, true);
                                }
                                
                                // AOS 바닥페이지 가격 업데이트
                                if (KRP0008.additionModel && typeof KRP0008.additionModel.setAdditionFoldPrice === 'function') {
                                    KRP0008.additionModel.setAdditionFoldPrice();
                                }
                                
                                // 히스토리 복원 완료 후 플래그 해제
                                self.isRestoringFromHistory = false;
                            }, 200);
                        } else {
                            self.isRestoringFromHistory = false;
                        }

                        // 소모품 추가구매 수량 복원
                        if (Object.keys(savedAdditionalQuantities).length > 0) {
                            $additionalItems = $('.additional-purchase div.additional-payment ul li');
                            setTimeout(function() {
                                $additionalItems.each(function() {
                                    var $item = $(this);
                                    var itemId = $item.data('id');
                                    
                                    if (itemId && savedAdditionalQuantities[itemId]) {
                                        var savedQty = savedAdditionalQuantities[itemId];
                                        var $input = $item.find('input.quantity');
                                        $input.val(savedQty);
                                        $item.data('quantity', savedQty);
                                        
                                        // 수량이 1보다 크면 minus 버튼 활성화
                                        if (savedQty > 1) {
                                            $item.find('button.minus').removeAttr('disabled');
                                        } else {
                                            $item.find('button.minus').attr('disabled', true);
                                        }
                                    }
                                });

                                // 소모품 추가구매 수량 복원 후 가격 업데이트
                                var $paymentAmount = $('.pdp-info-area .payment-amount');
                                if ($paymentAmount.length > 0) {
                                    KRP0008.updatePaymentAmountPrice($paymentAmount, true);
                                }
                                
                                // AOS 바닥페이지 가격 업데이트
                                if (KRP0008.additionModel && typeof KRP0008.additionModel.setAdditionFoldPrice === 'function') {
                                    KRP0008.additionModel.setAdditionFoldPrice();
                                }
                            }, 200);
                        }
                    } else {
                        self.isRestoringFromHistory = false;
                    }

                    // 총금액 복원 - 현재 활성화된 탭에 맞는 가격으로 업데이트
                    // 저장된 가격을 직접 복원하지 않고, 탭에 맞는 가격으로 다시 계산
                    setTimeout(function() {
                        // 현재 활성화된 탭 확인
                        var empYn = 'N';
                        if ($('#employeePriceTabArea').is(':visible') && $('#employeePriceTabArea .tabs > li').length > 0) {
                            empYn = $('#employeeTab').hasClass('on') ? 'Y' : 'N';
                        }
                        
                        // 번들링이 선택된 경우 totalFoldPriceBundleInfo 영역 표시
                        if (data.items && data.items.length > 0) {
                            var $totalFoldPriceBundleInfo = $('#totalFoldPriceBundleInfo');
                            if ($totalFoldPriceBundleInfo && $totalFoldPriceBundleInfo.length > 0) {
                                $totalFoldPriceBundleInfo.show();
                            }
                        }
                        
                        // 현재 탭에 맞는 가격으로 업데이트 (AOS 바닥페이지)
                        if (KRP0008.additionModel && typeof KRP0008.additionModel.setAdditionFoldPrice === 'function') {
                            KRP0008.additionModel.setAdditionFoldPrice();
                        }
                        
                        // 현재 탭에 맞는 가격 영역 제어 (bottomFoldAreaControl)
                        KRP0008.bottomFoldAreaControl(empYn);
                        
                        // 가격 재계산 (updatePaymentAmountPrice에서 탭에 맞는 가격 계산)
                        var $paymentAmount = $('.pdp-info-area .payment-amount');
                        if ($paymentAmount.length > 0) {
                            KRP0008.updatePaymentAmountPrice($paymentAmount, false);
                        }
                    }, 300);
                } catch (e) {
                    // 히스토리 로드 실패 시 무시
                    console.log('히스토리 로드 실패:', e);
                }
            },

            /**
             * 구매하기 버튼 클릭 시 추가 구성품 제품 목록 파라미터 설정
             * @return {boolean} 번들 상품이 선택되어 있으면 true, 아니면 false
             */
            getAdditionSelectModelBuyParam: function(param) {
                var self = this;

                // additionlist가 없을 때 self.$actionSheetInner가 정의되지 않을 수 있으므로 직접 정의
                if (!self.$actionSheetInner) {
                    self.$actionSheetInner = $('.action-sheet .item-select-inner');
                }

                // ActionSheet에서 선택된 아이템 수집
                var selectedAdditions = [];
                self.$actionSheetInner.find('.bundling-discount-item').each(function() {
                    var $item = $(this);
                    selectedAdditions.push({
                        modelSku: $item.data('model-sku'),
                        modelDisplayName: $item.data('model-display-name'),
                        modelName: $item.data('model-name'),
                        bizType: $item.data('addition-type')
                    });
                });

                if (selectedAdditions.length > 0) {
                    param.isDisposable = 'N';
                    param.isAdditionModel = "Y";
                    param.isBundle = "Y";
                    param.isMultiple = "Y";

                    // 본품 정보 추가
                    param.modelNameList = [{
                        "sku": lgePdpSendData.sku,
                        "modelDisplayName": lgePdpSendData.modelDisplayName,
                        "modelName": lgePdpSendData.modelName
                    }];

                    // 번들링 세트 활성화 시 번들링 수량 input 사용, 아니면 기본 수량 input 사용
                    var $bundlingQuantity = $('.payment-amount.bundling-set .quantity');
                    var quantity = $bundlingQuantity.length > 0 
                        ? parseInt($bundlingQuantity.val()) || 1
                        : parseInt($('#quantity').val()) || 1;

                    // selectedItemList 배열 생성 (본품 + 추가품)
                    var selectedItemList = [];

                    selectedItemList.push({
                        "qty": quantity.toString(),
                        "sku": lgePdpSendData.sku,
                        "bundleSeq": "1"
                    });

                    selectedAdditions.forEach(function(addition, index) {
                        param.cart_items.push({
                            "data": {
                                "sku": addition.modelSku,
                                "quantity": quantity
                            }
                        });

                        param.modelNameList.push({
                            "sku": addition.modelSku,
                            "modelDisplayName": addition.modelDisplayName,
                            "modelName": addition.modelName
                        });

                        selectedItemList.push({
                            "qty": quantity.toString(),
                            "sku": addition.modelSku,
                            "bundleSeq": (index + 2).toString()
                        });

                        // 소모품 여부 확인
                        if (addition.bizType === 'DISPOSABLE') {
                            param.isDisposable = 'Y';
                        }
                    });

                    // selectedItemList를 JSON 문자열로 변환하여 추가
                    param.selectedItemList = JSON.stringify(selectedItemList);
                    param.order_item_qty = param.cart_items.length;
                    
                    return true;
                }
                
                return false;
            },

            /**
             * 장바구니 버튼 클릭 시 추가 구성품 제품 목록 파라미터 설정
             * @return {boolean} 번들 상품이 선택되어 있으면 true, 아니면 false
             */
            getAdditionSelectModelCartParam: function(param) {
                var self = this;

                // additionlist가 없을 때 self.$actionSheetInner가 정의되지 않을 수 있으므로 직접 정의
                if (!self.$actionSheetInner) {
                    self.$actionSheetInner = $('.action-sheet .item-select-inner');
                }

                // ActionSheet에서 선택된 아이템 수집
                var selectedAdditions = [];
                self.$actionSheetInner.find('.bundling-discount-item').each(function() {
                    var $item = $(this);
                    selectedAdditions.push({
                        modelSku: $item.data('model-sku'),
                        modelDisplayName: $item.data('model-display-name'),
                        modelName: $item.data('model-name')
                    });
                });

                if (selectedAdditions.length > 0) {
                    // 번들링 세트 활성화 시 번들링 수량 input 사용, 아니면 기본 수량 input 사용
                    var $bundlingQuantity = $('.payment-amount.bundling-set .quantity');
                    var currentQuantity = $bundlingQuantity.length > 0 
                        ? parseInt($bundlingQuantity.val()) || 1
                        : parseInt($('#quantity').val()) || 1;
                    param.isAdditionModel = "Y";
                    param.isBundle = "Y";
                    param.isMultiple = "Y";

                    // 본품 정보 추가
                    param.modelNameList = [{
                        "sku": lgePdpSendData.sku,
                        "modelDisplayName": lgePdpSendData.modelDisplayName,
                        "modelName": lgePdpSendData.modelName
                    }];

                    // selectedItemList 배열 생성 (본품 + 추가품)
                    var selectedItemList = [];

                    selectedItemList.push({
                        "qty": currentQuantity.toString(),
                        "sku": lgePdpSendData.sku,
                        "bundleSeq": "1"
                    });

                    // 선택된 추가 구성품을 sku 파라미터에 추가
                    selectedAdditions.forEach(function(addition, index) {
                        param.sku = param.sku + "," + addition.modelSku + "|" + currentQuantity;

                        param.modelNameList.push({
                            "sku": addition.modelSku,
                            "modelDisplayName": addition.modelDisplayName,
                            "modelName": addition.modelName
                        });

                        selectedItemList.push({
                            "qty": currentQuantity.toString(),
                            "sku": addition.modelSku,
                            "bundleSeq": (index + 2).toString()
                        });
                    });

                    // selectedItemList를 JSON 문자열로 변환하여 추가
                    param.selectedItemList = JSON.stringify(selectedItemList);
                    
                    return true;
                }
                
                return false;
            }
        },

        // BTOCSITE-76255
        empOnlyModel:function (){
          if(!lgkorUI.getHiddenInputData().partnerGrp.includes('B2C')){
              if(digitalData.userInfo.partnerType == 'AFC'){
                  $('#afcOnlyModelAlert').vcModal();
              }else{
                  $('#empOnlyModelAlert').vcModal();
              }
              return false;
          }else{
              return true;
          }
        },
        //[BTOCSITE-113594]PDP 내 일시불-구독 제안 영역 위치 변경
        buyFullAreaDisplay:function (obj){
            if(!lgkorUI.getHiddenInputData().partnerGrp.includes('B2C')){
                $('#buyFullArea').hide();
            }else{
                //
                if(typeof obj !== 'undefined'){
                    $("#buyFullArea").find(".buyFullPrice strong").html(vcui.number.addComma(obj) + "원");
                }
                $('#buyFullArea').show();
            }
        },

        // BTOCSITE-74162 START
        setUpActionForAwardAfterContentLoaded: function() {
            /* 1. 비동기로 인해 이 변수가 정의되지 않는 것을 방지하기 위해 콘텐츠가 로드된 후에만 이벤트 할당 논리를 pdpMoreInfo 변수로 이동합니다. (BTOCSITE-74162)
               2. 이 함수는 KRP0008-2.0.0 범위 밖에서만 호출되므로 self = this를 사용하는 대신 새로운 selector jquery 를 사용하여 변수를 다시 할당합니다. 왜냐하면 this는 현재 같은 컨텍스트에 없기 때문입니다 */
            var pdpMoreInfo = $('div.pdp-more-info');
            var awardPopup  = $('#awardPopup');

            //수상내역 아이템 클릭
            awardPopup.off('click', 'li a.award-item').on('click', 'li a.award-item', function(e) {
                awardPopup.find('.btn-group button[data-link-url]').trigger('click');
            });

            awardPopup.off('click', 'button[data-link-url]').on('click', 'button[data-link-url]', function(e) {
                var buttonLinkUrl = $(this).attr('data-link-url');
                var isNew = $(this).attr('data-open-new');
                if(buttonLinkUrl) {
                    if(isNew == "Y") {
                        setTimeout(function () {
                            window.open(buttonLinkUrl);
                        },250);
                    } else {
                        setTimeout(function () {
                            location.href = buttonLinkUrl;
                        },250);
                    }
                }
            });

            //팝업 열기
            //PDP 갤러리 더보기(수상내역등)
            pdpMoreInfo.off('click', 'a.btn-link.popup').on('click', 'a.btn-link.popup', function(e) {
                e.preventDefault();
                var arr = [];
                var loaded = awardPopup.data('loaded');
                if (!loaded) {
                    awardPopup.data('loaded', true);
                    if (typeof awards !== 'undefined' && awards.length > 0) {
                        arr = awards instanceof Array ? awards.slice(0,4) : [];
                        var list_ul = awardPopup.find('ul.awards-list');
                        list_ul.empty();

                        var frag = $(document.createDocumentFragment());
                        arr.forEach(function(item) {
                            frag.append(vcui.template(awardPopupItemTemplate, item));
                        });
                        list_ul.append(frag);
                    }
                }

                awardPopup.find('.btn-group button[data-link-url]').trigger('click');
            });

            // [S] BTOCSITE-79476 [웹앱 접근성 개선활동] 상품_PDP>WCMS USP 컴포넌트 // 스와이프 문구 노출 현상 수정
            var $swiper = $('.award-content .swiper-container2');
            $swiper.each(function() {
                var $this = $(this);
                var $wrap = $this.closest('.award-content');
                var _swiper = $this[0].swiper;

                if (!_swiper) return;

                _swiper.destroy();
                $this.addClass('swiper');
                
                var awardSwiper = new Swiper($this[0], {
                    spaceBetween: 20,
                    loopFillGroupWithBlank: true,
                    navigation: {
                        nextEl: $wrap.find(".awards-btn .swiper-button-next")[0],
                        prevEl: $wrap.find(".awards-btn .swiper-button-prev")[0],
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                        }
                    },
                });
                console.log(awardSwiper.initialized);
            });
            // [E] BTOCSITE-79476 [웹앱 접근성 개선활동] 상품_PDP>WCMS USP 컴포넌트 // 스와이프 문구 노출 현상 수정
        },
        // BTOCSITE-74162 END

        // [S] BTOCSITE-83434 [EPIC] 구독 다품목 적용
        setBannerSwiper: function() {
            var self = this;
            var $bannerSwiper = $('.banner-slide-box .swiper-container');
            var $autoControlBtn = $bannerSwiper.find('.wrap-autoplay-control button');

            $bannerSwiper.each(function() {
                var $this = $(this);

                if ($this[0].swiper) {
                    $this[0].swiper.destroy();
                }

                if ($this.find('.banner_item').length < 2) {
                    $this.find('.control').hide();
                    return;
                }

                $this.find('.control').show();

                var _swiper = new Swiper($this[0], {
                    loop: true,
                    spaceBetween: 12,
                    autoplay: {
                        enabled: true,
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: '.control .swiper-pagination',
                        type: 'fraction',
                        clickable: true,
                        //[S] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 페이징 접근성 작업
                        renderFraction: function(currentClass, totalClass) {
                            return '<span class="blind">현재 페이지</span>'+
                                    '<span class="' + currentClass + '"></span>' +
                                    '<span class="blind">총 페이지 수</span>'+
                                    '<span class="' + totalClass + '"></span>';
                        }
                        //[E] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 페이징 접근성 작업
                    },
                    //[S] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 스와이프 버튼 작업
                    navigation: {
                        nextEl: $this.find('.swiper-button-next').get(0),
                        prevEl: $this.find('.swiper-button-prev').get(0)
                    },
                    //[E] BTOCSITE-85182 구독 PDP 퀵윈 CSR(5건) 스와이프 버튼 작업
                    on: {
                        init: function(swiper) {
                            var $swiper = $(swiper.el);

                            if ($swiper.is(':visible')) setAutoPlay(swiper, true);
                        }
                    }
                });
            });

            $autoControlBtn.each(function() {
                var $this = $(this);

                $this.off('click.bannerSwiper').on('click.bannerSwiper', function() {
                    var $this = $(this);
                    var $swiper = $this.closest('.swiper-container');
                    var _swiper = $swiper[0].swiper;
                    var autoStatus = $this.attr('aria-pressed');

                    if (autoStatus === 'true') {
                        setAutoPlay(_swiper, true);
                    } else {
                        setAutoPlay(_swiper, false);
                    }
                });
            });

            function setAutoPlay(swiper, isPlay) {
                var $swiper = $(swiper.el);
                var $autoControlBtn = $swiper.find('.wrap-autoplay-control button');

                if (isPlay) {
                    swiper.autoplay.stop();
                    $autoControlBtn.attr('aria-pressed', 'false');
                    $autoControlBtn.attr('aria-label', '일시정지');
                    swiper.autoplay.start();
                } else {
                    $autoControlBtn.attr('aria-pressed', 'true');
                    $autoControlBtn.attr('aria-label', '자동 재생');
                    swiper.autoplay.stop();
                }
            }

            var oldTabIdx = null;
            $('.product-detail-option .care-sibling-option > .tabs-wrap').off('tabchange.bannerSwiper').on('tabchange.bannerSwiper', function(e, obj) {
                var $this = $(this);
                var selectedIdx = obj.selectedIndex;
                if (oldTabIdx === selectedIdx) return;

                $this.closest('.pdp-info-area').find('.banner-slide-box .swiper-container').each(function() {
                    var $this = $(this);
                    var _swiper = $this[0].swiper;

                    if (_swiper) {
                        _swiper.update();
                        _swiper.slideToLoop(0, 0);
                        if ($this.is(':visible')) {
                            setAutoPlay(_swiper, true);
                        }
                    }
                });

                /* [BTOCSITE-103184] [퍼블]After job 프로모션/혜택 - 구독 추가 혜택 스타일 개선 */
				$('.add-Benefits-list ul').each(function() {
					var $visibleLi = $(this).children('li').filter(function() {
						return $(this).css('display') !== 'none';
					});
					// visible li가 1개 또는 2개일 때 첫번째 visible li의 border-top: 0 적용
					if ($visibleLi.length <= 2) {
						$visibleLi.first().css('border-top', '0');
					}
				});

                oldTabIdx = selectedIdx;
            });
        },

        // BTOCSITE-102082
        setInfoDisclaimer: function() {
            var $dropInfo = $(".drop-info");

            if($dropInfo.length) {
                $dropInfo.each(function() {
                    var $this = $(this);
                    var $openBtn = $this.find(".dropInfo_openBtn");
                    var $closeBtn = $this.find(".dropInfo_closeBtn");
                    var $dropContent = $this.find(".dropContent");

                    $openBtn.on("click", function() {
                        $dropContent.show().attr("aria-hidden", "false");
                        $openBtn.hide();
                        $closeBtn.show().focus();
                        $this.attr("data-scroll", $(window).scrollTop());
                    });

                    $closeBtn.on("click", function() {
                        $dropContent.hide().attr("aria-hidden", "true");
                        $closeBtn.hide();
                        $openBtn.show().focus();

                        var winTop = $(window).scrollTop(),
                            currentTop = Number($this.attr("data-scroll"));
                        if(!isNan(currentTop) && winTop !== currentTop && currentTop < winTop) {
                            $(window).scrollTop(currentTop);
                        }
                    });

                    $dropContent.on('keydown', function(e) {
                        if (e.key === 'Escape') {
                            $closeBtn.click();
                        }
                    });
                });
            }
        },

        // BTOCSITE-88928 3D 공간 (구 미리집 : 3D 홈뷰) 인입페이지 버튼 애니메이션
        setButtonAnimate: function() {
            var $btn = $('.pdp-ar-area .btn-3dSpace');
            var COOKIE_NAME = 'btn3dSpaceAnimated';

            $btn.off('animationend').on('animationend', function(e) {
                var $this = $(this);

                if ($this.hasClass('deactive')) {
                    $this.removeClass('deactive');
                }
            });

            // 모바일에서만 애니메이션 실행
            if (window.innerWidth <= 767) {
                // 쿠키가 없는 경우에만 애니메이션 실행 (하루에 한번)
                if (!lgkorUI.getCookie(COOKIE_NAME)) {
                    $btn.addClass('active');

                    setTimeout(function() {
                        $btn.removeClass('active');
                        $btn.addClass('deactive');

                        // 애니메이션 실행 후 오늘 하루동안 유효한 쿠키 설정
                        lgkorUI.setCookieToday(COOKIE_NAME, 'true');
                    }, 3000);
                }
            }
        }
    };

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'PROD', name: 'KRP0008-2.0.0', isFirstLoad: true, fn: function () {
                if (!document.querySelector('.KRP0008')) return false;
                $('.KRP0008').buildCommonUI();
                // KRP0008.init();
                var vcLoadedEvent = new Event("vcLoaded");
                document.dispatchEvent(vcLoadedEvent);
            }
        });
    }

    // SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if (!document.querySelector('.KRP0008')) return false;
        $('.KRP0008').buildCommonUI();
        //KRP0008.init();

        // 번들링 가능한 상품이 있을 때만 초기화
        // getRewardInfo API 호출 후에 additionModel.init()이 자동으로 호출됨
        // if (KRP0008.additionModel.hasBundlingProducts()) {
        //     KRP0008.additionModel.init();
        // }

        //BTOCSITE-33023 [구매하기]버튼이 키보드에 밀려 올라오는 현상
        if(vcui.detect.isAndroid){
            var prevH = $(window).height();
            $(window).on('resizestart',function(){
                if(prevH - $(window).height() >= 200){
                    //구매버튼 노출하는 로직에 영향도 없게 (키패드 오픈, 구매버튼 비노출)
                    if($('#paymentButtonArea').css('display') == 'block' ){
                        $('#paymentButtonArea').data('open-keypad',true).hide();
                    }
                }else if(prevH - $(window).height() <= -200){
                    //구매버튼 노출하는 로직에 영향도 없게 (키패드 클로즈, 구매버튼 노출)
                    if( $('#paymentButtonArea').data('open-keypad') == true){
                        $('#paymentButtonArea').show();
                    }
                }
                prevH = $(window).height();
            })
        }
    });
    
    
    // BTOCSITE-117193
    function changePlanPromotionInfo(partnerType) {

    	var skuList = [];
    	skuList.push(lgePdpSendData.sku);
    	
    	var params = {'skuList': skuList,'partnerType': partnerType};
    	lgkorUI.requestKongAjax('subscriptionsvc', '/ajax/v1/product/subscription-plan-promotion-info', {
             method: 'POST',
             data: JSON.stringify(params),
             contentType: 'application/json; charset=utf-8',
             success: function (result) {
            	 
                 if (!result.data || !result.data.length || !result.data[0]) {
                	 // [정리] B2C 전용 #rentalApiDataCall 분기 제거: b2cYN==='Y'는 이 파일에서 항상 false
                	 $("#b2bRentalApiDataCall").hide();
                 }else{
                	 // [정리] B2C 전용 #rentalApiDataCall 분기 제거: b2cYN==='Y'는 이 파일에서 항상 false
                	 $("#b2bRentalApiDataCall").show();

                	 var data = result.data[0];
	                 var monthlyAmount = data.monthlyAmount;
	                 var discountType = data.discountType;
	                 var contractPeriodYears = data.contractPeriodYears;
	                 var discountAppliedTerm = data.discountAppliedTerm;
	                 var amountAfterDiscountTerm = data.amountAfterDiscountTerm;
	                 
	                 $("#monthlyAmount").html("월 " + vcui.number.addComma(monthlyAmount) + "원");
	                 
	                 // 3. discountType에 따라 alert
	                 if (discountType === "NONE" || discountType === "FULL") {
	                	 $("#discountType").html("("+contractPeriodYears + "년 계약"+")");
	                 } else if (discountType === "PARTIAL") {
	                	 $("#discountType").html("("+contractPeriodYears + "년계약 · " + (discountAppliedTerm + 1) + "회차부터 월 " + vcui.number.addComma(amountAfterDiscountTerm) + "원"+")");
	                 }
                 }
                
             },
             error: function (error) {
                 console.log('subscription-plan-promotion-info error', error);
             }
         });
    }
    

    $(document).ready(function(){
    	
    	//BTOCSITE-117193
    	// [정리] B2C 전용 partnerType 분기 및 #employeeTab/#b2cTab 클릭 핸들러 제거: b2cYN==='N'는 이 파일에서 항상 true이고, 두 엘리먼트 모두 B2B 화면에 없어 바인딩되어도 실행된 적 없는 코드
    	var paramPartnerType = "ENT";
    	changePlanPromotionInfo(paramPartnerType);
    	
        // [정리] 사업자몰 미사용 탭 클릭 핸들러 제거: #rentalTabs가 항상 비활성화되어 .tabs>li가 DOM에 존재하지 않아 실행된 적 없는 코드

        // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
        $('#employeePriceTabArea .tabs > li').each(function(){
            var $this = $(this);
            $(this).find('a').click(function(){
                var selectedTab = $this.attr('id');
                var tabIdx = $this.index();
                let $buyBenefitInfoPurchase = $('#buyBenefitInfoPurchase');
				let vsPartnerType = digitalData.userInfo.partnerType;
                var initialPrice;

                // 임직원 or 복지몰 가격탭 (첫 번째 탭은 로그인 타입에 관계없이 동일하게 처리)
                if(tabIdx == 0) {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("first").removeClass("last");
                    $('span[id^="b2cBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="b2cBadge"]'));
                    $('#badgeArea').append($('span[id^="employeeBadge"]'));
                    $('span[id^="employeeBadge"]').show();
                    // $('#actionSheetDiscountType').css("display","");
                    $('.emp-price-info.is-price-calc-new').show();

                    $('.total-coupon-payment').hide();
                    
                    // 로그인 타입 확인 (AFC: 복지몰, AFF/LGE: 임직원)
                    var currentPartnerType = vsPartnerType || (typeof digitalData !== 'undefined' && digitalData.userInfo ? digitalData.userInfo.partnerType : '');
                    var isWelfareLogin = currentPartnerType === 'AFC';
                    var isEmployeeLogin = currentPartnerType === 'AFF' || currentPartnerType === 'LGE';
                    
                    // 탭 전환 시 다른 탭의 쿠폰 데이터 초기화
                    if (typeof _KRP0008_COUPON !== 'undefined') {
                        if (isWelfareLogin) {
                            _KRP0008_COUPON.resetTabCouponData('member');
                        } else if (isEmployeeLogin) {
                            _KRP0008_COUPON.resetTabCouponData('welfare');
                        }
                    }
                    
                    // 로그인 타입에 따라 적절한 쿠폰할인가 표시 (임직원 탭과 복지몰 탭은 동일한 로직)
                    var $employeeCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-member');
                    var $welfareCouponMember = $('.is-coupon-price-calc-new.is-popup-cont-welfare');
                    
                    var savedInitialPrice;
                    var $priceEl;
                    
                    // 임직원 로그인 시 임직원 쿠폰 표시
                    if (isEmployeeLogin && $employeeCouponMember.length > 0 && $employeeCouponMember.data('set-coupon-discount-price') == 'Y') {
                        $employeeCouponMember.show();
                        $welfareCouponMember.hide();
                        // 탭 전환 시 초기 가격으로 복원 또는 저장
                        if (typeof _KRP0008_COUPON !== 'undefined') {
                            savedInitialPrice = _KRP0008_COUPON.getInitialCouponPriceByTab('member');
                            if (savedInitialPrice) {
                                // 저장된 초기 가격이 있으면 DOM 복원
                                $priceEl = $employeeCouponMember.find('.payment .price');
                                $priceEl.data('price', savedInitialPrice);
                                $priceEl.find('em').text(vcui.number.addComma(savedInitialPrice));
                            } else {
                                // 저장된 초기 가격이 없으면 현재 값 저장
                                initialPrice = $employeeCouponMember.find('.payment .price').data('price');
                                if (initialPrice) {
                                    _KRP0008_COUPON.setInitialCouponPriceByTab(initialPrice, 'member');
                                }
                            }
                        }
                    } 
                    // 복지몰 로그인 시 복지몰 쿠폰 표시
                    else if (isWelfareLogin && $welfareCouponMember.length > 0 && $welfareCouponMember.data('set-coupon-discount-price') == 'Y') {
                        $welfareCouponMember.show();
                        $employeeCouponMember.hide();
                        // 탭 전환 시 초기 가격으로 복원 또는 저장
                        if (typeof _KRP0008_COUPON !== 'undefined') {
                            savedInitialPrice = _KRP0008_COUPON.getInitialCouponPriceByTab('welfare');
                            if (savedInitialPrice) {
                                // 저장된 초기 가격이 있으면 DOM 복원
                                $priceEl = $welfareCouponMember.find('.payment .price');
                                $priceEl.data('price', savedInitialPrice);
                                $priceEl.find('em').text(vcui.number.addComma(savedInitialPrice));
                            } else {
                                // 저장된 초기 가격이 없으면 현재 값 저장
                                initialPrice = $welfareCouponMember.find('.payment .price').data('price');
                                if (initialPrice) {
                                    _KRP0008_COUPON.setInitialCouponPriceByTab(initialPrice, 'welfare');
                                }
                            }
                        }
                    } 
                    // 쿠폰이 없거나 로그인 타입이 명확하지 않은 경우 둘 다 숨김
                    else {
                        $employeeCouponMember.hide();
                        $welfareCouponMember.hide();
                    }

                    // 렌탈 이동 영역
                    if ($('#rentalDirectinfoListEmployee .text').length > 0) {
                        $('#rentalDirectinfoList').hide();
                        $('#rentalDirectinfoListEmployee').show();
                    }


                    // 구매혜택안내 > 결제일 할인 (임직원가격탭)
                    if ($buyBenefitInfoPurchase.data("employee_purchase_yn") == 'Y') {
                        KRP0008.displayBenefitPurchaseArea(true);
                    } else {
                        KRP0008.displayBenefitPurchaseArea(false);
                    }
                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                    KRP0008.displayBenefitPointArea(digitalData.userInfo.partnerType);

                    //BTOCSITE-73832  제품 번들링 과제
                    KRP0008.additionModel.tabClick('employeeTab');

                    KRP0008.bottomFoldAreaControl('Y');
					
                // 일반 가격탭
                } else {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("last").removeClass("first");
                    $('span[id^="employeeBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="employeeBadge"]'));
                    $('#badgeArea').append($('span[id^="b2cBadge"]'));
                    $('span[id^="b2cBadge"]').show();
                    // $('#actionSheetDiscountType').hide();
                    $('.emp-price-info.is-price-calc-new').hide();

                    if ($('.total-coupon-payment .payment .price').data('set-coupon-discount-price') == 'Y') $('.total-coupon-payment').show();
                    
                    // 탭 전환 시 임직원/복지몰 쿠폰 데이터 초기화 (일반 탭으로 전환)
                    if (typeof _KRP0008_COUPON !== 'undefined') {
                        _KRP0008_COUPON.resetTabCouponData('member');
                        _KRP0008_COUPON.resetTabCouponData('welfare');
                    }
                    
                    // 임직원/복지몰 쿠폰할인가 숨김
                    $('.emp-price-info.is-coupon-price-calc-new').hide();

                    // 렌탈 이동 영역
                    if ($('#rentalDirectinfoListEmployee .text').length > 0) {
                        $('#rentalDirectinfoListEmployee').hide();
                        $('#rentalDirectinfoList').show();
                    }


                    // 구매혜택안내 > 결제일 할인 (일반가격탭)
                    if ($buyBenefitInfoPurchase.data("purchase_yn") == 'Y') {
                        KRP0008.displayBenefitPurchaseArea(true);
                    } else {
                        KRP0008.displayBenefitPurchaseArea(false);
                    }
                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                    KRP0008.displayBenefitPointArea('B2C');

                    //BTOCSITE-73832  제품 번들링 과제
                    KRP0008.additionModel.tabClick('b2cTab');

                    KRP0008.bottomFoldAreaControl('N');
					
                }
            })
        });

        // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰 - 소모품
        $('#employeeDisposableTab .tabs > li').each(function(){
            /*var $this = $(this);
            $(this).find('a').click(function(){
                var selectedTab = $this.attr('id');
                var tabIdx = $this.index();

                // 임직원 or 복지몰 가격탭
                if(tabIdx == 0) {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("first").removeClass("last");
                    $('span[id^="b2cBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="b2cBadge"]'));
                    $('#badgeArea').append($('span[id^="employeeBadge"]'));
                    $('span[id^="employeeBadge"]').show();
                    $('.emp-price-info').show();

                    // 바텀시트 임직원 쿠폰할인가 노출여부
                    var employeeCouponYn = $('.emp-price-info.is-coupon-price-calc-new').data('set-coupon-discount-price');
                    if (employeeCouponYn == undefined || employeeCouponYn !== "Y") {
                        $(".emp-price-info.price-red.is-coupon-price-calc-new.is-popup-cont-member").hide();
                    }

                    $('#actionSheetDiscountType').css("display","");
                    if ($('.total-coupon-payment .payment .price').data('price') != undefined) $('.total-coupon-payment').hide();

                    // 일반 가격탭
                } else {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("last").removeClass("first");
                    $('span[id^="employeeBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="employeeBadge"]'));
                    $('#badgeArea').append($('span[id^="b2cBadge"]'));
                    $('span[id^="b2cBadge"]').show();
                    $('.emp-price-info').hide();
                    $('#actionSheetDiscountType').hide();
                    if ($('.total-coupon-payment .payment .price').data('price') != undefined) $('.total-coupon-payment').show();
                }
            })*/
            var $this = $(this);
            $(this).find('a').click(function(){
                var selectedTab = $this.attr('id');
                var tabIdx = $this.index();

                // 임직원 or 복지몰 가격탭
                if(tabIdx == 0) {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("first").removeClass("last");
                    $('span[id^="b2cBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="b2cBadge"]'));
                    $('#badgeArea').append($('span[id^="employeeBadge"]'));
                    $('span[id^="employeeBadge"]').show();
                    // $('#actionSheetDiscountType').css("display","");
                    $('.emp-price-info.is-price-calc-new').show();
                    $('.total-coupon-payment').hide();
                    if ($('.emp-price-info.is-coupon-price-calc-new').data('set-coupon-discount-price') == 'Y') $('.emp-price-info.is-coupon-price-calc-new').show();


                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                    KRP0008.displayBenefitPointArea(digitalData.userInfo.partnerType);
                    // 일반 가격탭

                    KRP0008.bottomFoldAreaControl('Y');
                } else {
                    $(this).parents('.member-price-tab').find('.detail-option-box').addClass("last").removeClass("first");
                    $('span[id^="employeeBadge"]').hide();
                    $('#badgeArea').prepend($('span[id^="employeeBadge"]'));
                    $('#badgeArea').append($('span[id^="b2cBadge"]'));
                    $('span[id^="b2cBadge"]').show();
                    // $('#actionSheetDiscountType').hide();
                    $('.emp-price-info.is-price-calc-new').hide();

                    if ($('.total-coupon-payment .payment .price').data('set-coupon-discount-price') == 'Y') $('.total-coupon-payment').show();
                    $('.emp-price-info.is-coupon-price-calc-new').hide();

                    //BTOCSITE-72981 [개발] PDP - 멤버십 포인트 캠페인 전송 API 개발 (NewBEST -> OBS -> MKT)
                    KRP0008.displayBenefitPointArea('B2C');

                    KRP0008.bottomFoldAreaControl('N');
                }
            })
        });

        if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab'){
	        //GNB로그인시 선택 옵션값 저장
	        $("a[href='/sso/member/login']").on("click",function(){
	        	let optionValArr = new Array();
	        	$("#tab2").find("input:checked:visible").each(function(){
	        		optionValArr.push($(this).val());
	        	});
	        	sessionStorage.setItem("optionValArr",JSON.stringify(optionValArr));
	        });
        }

        // S : [BTOCSITE-93072] 스펙 기반의 선호도 : 스팩 용어사전 바텀시트
        $('.specTerms-popup-action-sheet').on('click', function () {
            setTimeout (() => {
                $('#specTermsPopup').addClass('active');
            }, 10)
        });

        // 팝업 닫기
        $('.sheet-close').on('click', function () {
            $('.action-sheet').removeClass('active');
            setTimeout(function () {
                $('.action-sheet').removeAttr('style');
            }, 300);
        });

        // BTOCSITE-97545 
        $('#b2cOnlineCounselMobile').on('click', function () {
           $('.counsel-link').click();
        });

        $('#b2bOnlineCounselMobile').on('click', function (e) {
            e.preventDefault();
            let url = $('#b2bOnlineCounsel').data("url")+'&qty='+$('#quantity').val();
            let callBackValue = KRP0008.b2bLoginCheck(e);
            if(callBackValue){
                if(isApp()) {
                    if(vcui.detect.isIOS){
                        window.location.href = url;
                    }else{
                        let openNewWindow = window.open("about:blank");
                        openNewWindow.location.href = url;
                    }
                } else {
                    window.location.href = url;
                }
            }
        });


        // 팝업 닫기 (배경 클릭 시)
        $(document).on('click', '.ui_modal_dim', function (e) {
            // alert나 모달이 표시되어 있으면 actionSheet를 닫지 않음
            if (KRP0008.isModalVisible()) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            $('.action-sheet').find('.sheet-close').trigger('click');
        });

        // 반응형 처리
        if (window.innerWidth <= 767) {
            $('#specTermsPopup').removeClass('popup-wrap');
        }

        $(window).on('resizeend', function () {
            if (window.innerWidth <= 767) {
                $('#specTermsPopup').removeClass('popup-wrap');
            } else {
                $('#specTermsPopup').addClass('popup-wrap');
            }
        }).trigger('resizeend');
        // E : [BTOCSITE-93072] 스펙 기반의 선호도 : 스팩 용어사전 바텀시트

        // S : [BTOCSITE-93072] 스펙 기반의 선호도 : 선호도 판매량 스낵바
        // function snackbarPosition() {
        //     var $snackbar = $(".preference-snackbar");
        //     var btnHeight = $(".payment-amount.action-sheet-call").outerHeight(true) || 50; // 기본값 설정

        //     // PC 환경에서는 bottom: 30px, 모바일 환경에서는 버튼 높이값 + 15px
        //     if (window.innerWidth > 767) {
        //         $snackbar.css('bottom', '30px');
        //     } else {
        //         $snackbar.css('bottom', -btnHeight + 'px'); // 시작 위치를 btnHeight만큼 아래로 설정
        //         document.documentElement.style.setProperty('--btnHeight', btnHeight + 'px'); // CSS 변수 설정
        //     }
        // }

        // function showSnackbar() {
        //     var $snackbar = $(".preference-snackbar");

        //     // 스낵바 초기 상태 설정
        //     $snackbar.css({
        //         bottom: '-50px',
        //         opacity: 0,
        //     });

        //     // 스낵바 표시 (슬라이드 업)
        //     setTimeout(function () {
        //         if (window.innerWidth > 767) {
        //             $snackbar.addClass("show").css({
        //                 bottom: '30px',
        //                 opacity: 0.9,
        //             });
        //         } else {
        //             var btnHeight = $(".payment-amount.action-sheet-call").outerHeight(true) || 50; // 버튼 높이값 계산
        //             $snackbar.addClass("show").css({
        //                 bottom: btnHeight + 15 + 'px',
        //                 opacity: 0.9,
        //             });
        //         }
        //     }, 10);

        //     // 5초 후 스낵바 숨김
        //     setTimeout(function () {
        //         $snackbar.removeClass("show").addClass("hide").css({
        //             opacity: 0, // 서서히 투명해짐
        //         });

        //         setTimeout(function () {
        //             $snackbar.css({
        //                 display: 'none',
        //                 bottom: '-50px',
        //             });
        //         }, 1000);
        //     }, 5000);

        //     // 스크롤 시 스낵바 숨김
        //     // $(window).on("scroll", function () {
        //     //     if ($snackbar.hasClass("show")) {
        //     //         $snackbar.removeClass("show").addClass("hide").css({
        //     //             opacity: 0,
        //     //         });
        //     //     }
        //     // });
        // }

        // // 초기화
        // $(window).on('load', function () {
        //     snackbarPosition();
        //     showSnackbar();

        //     $(window).on('resize', function () {
        //         snackbarPosition();
        //     });
        // });

        // E : [BTOCSITE-93072] 스펙 기반의 선호도 : 선호도 판매량 스낵바


        // S : [BTOCSITE-93072] 스펙 기반의 선호도 : PDP 스펙용어사전
        var specTermsSlideBanner = {
            init: function(){
                var self = this;
                if(isApp()) {
                    $(document).on('click', 'a[data-target="_blank"]', function(e){
                        e.preventDefault();
                        var appUrl = $(this).attr('href');
                        if(vcui.detect.isIOS){
                            var jsonString = JSON.stringify({'url': appUrl, 'command':'sendOutLink'});
                            webkit.messageHandlers.callbackHandler.postMessage(jsonString);
                        } else {
                            android.openLinkOut(appUrl);
                        }
                    })
                }
                self.settings();
                self.bindEvents();
            },
            settings: function(){
                var self = this;
                self.$specTermsSlideBanner = $('.specTermsPopup');
                //상단 히어로배너
                self.$heroSlider = self.$specTermsSlideBanner.find('.specTerms-banner');
                self.$heroSlider.vcCarousel('destroy').vcCarousel({
                    autoplay: false,
                    // autoplaySpped: 5000,
                    infinite: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    swipeToSlide: true,
                    dotsSelector: '.ui_wideslider_dots',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    touchThreshold: 100,
                    cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    speed: 150
                }).on('carouselafterchange', function(e, slide, prev, next){
                    self.brandHeroBanner();
                });
				self.brandHeroBanner();
            },
            bindEvents: function(){
                var self = this;
				$(window).on('addSpecTermsPopup',function(){
					setTimeout(function(){
						self.settings();
					},20);
				})
            },
            brandHeroBanner: function(){
                var self = this;
                var heroList = self.$heroSlider.find('.slide-track > li');
                var heroListAct = heroList.siblings('.ui_carousel_current').index();
                var heroListLens = heroList.length;
                var custom = self.$heroSlider.find('.custom-indi-wrap');
                var slideCurrent = custom.find('.slide-page .current');
                var slideCount = custom.find('.slide-page .count');

                //히어로 배너가 1개 이상일 경우에만 indicator 노출 / 1개인 경우에는 비노출
                if( heroListLens > 1) {
                    custom.show();
                    slideCurrent.text(heroListAct).prepend('<span class="blind">현재 슬라이드</span>');
                    slideCount.text(heroListLens - 2).prepend('<span class="blind">전체 슬라이드 갯수</span>');
                } else {
                    custom.hide();
                    $(".specTerms-banner").css('padding-bottom','0')
                }
            },

        };

        specTermsSlideBanner.init();
        // E : [BTOCSITE-93072] 스펙 기반의 선호도 : PDP 스펙용어사전
    })


    $(window).load(function(){
        var hash = location.hash;
        if(hash) {
            var findEl = $(hash);
            if(findEl.length > 0) {
                var target_top = findEl.offset().top;
                setTimeout(function () {
                    $("html, body").animate({ scrollTop: target_top }, 0);
                }, 30);
            }
        }

        $(this).on('resize', function(){
            KRP0008.resize();
        });

        KRP0008.setInfoDisclaimer(); // BTOCSITE-102082

        // iframe resizer lib 추가
        var script = document.createElement('script');
        script.src = "https://www.lge.co.kr/kr/brands/gram/lib/iframeResizer.contentWindow.min.js";
        document.getElementsByTagName('head')[0].appendChild(script);
    });

    /* BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다. start */
    function resizeEv1() {
        if(document.getElementById('base_detail_target')) {
            if(document.getElementById('pdp_visual_click2')) {
                var size1 = document.getElementById('base_detail_target');
                var size2 = document.getElementById('pdp_visual_click2');
                if ($(size1).is(':hidden')) size1 = $(size2).closest('.pdp-visual-inner')[0]; // BTOCSITE-85964 [PDP 갤러리영역 360 영상] 디스클레이머 추가
                size2.style.width = size1.offsetWidth + 'px';
            }
        }
    }
    /* BTOCSITE-37933 [UI] 다품목 판매 활성화_ PDP start */
    function resizeEv2() {
        if(document.getElementById('actionSheetCart')) {
            if(window.innerWidth > 767) {
                var size0 = document.querySelector('#actionSheetCart .component-wrap');
                var size1 = document.getElementById('actionSheetCart');
                var size2 = document.querySelector('#actionSheetCart .action-sheet-inner');
                if(size0.offsetHeight > 318) {
                    size2.style.height = size1.offsetHeight - 70 + 'px';
                }
                else {
                    size2.style.removeProperty('height');
                }
            }
        }
    }
    // [BTOCSITE-93072] 스펙 기반의 선호도 : 선호도 판매량 스낵바
    function snackbarPosition() {
        var $snackbar = $(".preference-snackbar");
        var btnHeight = $(".payment-amount.action-sheet-call").outerHeight(true) || 50; // 기본값 설정

        // PC 환경에서는 bottom: 30px, 모바일 환경에서는 버튼 높이값 + 15px
        if (window.innerWidth > 767) {
            $snackbar.css('bottom', '30px');
        } else {
            $snackbar.css('bottom', -btnHeight + 'px'); // 시작 위치를 btnHeight만큼 아래로 설정
            document.documentElement.style.setProperty('--btnHeight', btnHeight + 'px'); // CSS 변수 설정
        }
    }
    //[BTOCSITE-93072] 스펙 기반의 선호도 : 선호도 판매량 스낵바
    function showSnackbar() {
        var $snackbar = $(".preference-snackbar");
        // 스낵바 초기 상태 설정
        $snackbar.css({
            bottom: '-50px', // 초기 위치 설정
            opacity: 0, // 투명 상태
        });

        // 스낵바 표시 (슬라이드 업)
        setTimeout(function () {
            if (window.innerWidth > 767) {
                $snackbar.addClass("show").css({
                    bottom: '30px', // PC 환경에서 화면에 나타남
                    opacity: 1, // 불투명 상태
                });
            } else {
                var btnHeight = $(".payment-amount.action-sheet-call").outerHeight(true) || 50; // 버튼 높이값 계산
                $snackbar.addClass("show").css({
                    bottom: btnHeight + 15 + 'px', // 모바일 환경에서 화면에 나타남
                    opacity: 1, // 불투명 상태
                });
            }
        }, 10); // 약간의 지연을 추가하여 transition 트리거

        // 5초 후 스낵바 숨김
        setTimeout(function () {
            $snackbar.removeClass("show").addClass("hide").css({
                opacity: 0, // 서서히 투명해짐
            });

            setTimeout(function () {
                $snackbar.css({
                    display: 'none', // 완전히 숨김
                    bottom: '-50px',
                });
            }, 1000); // transition 시간과 동일하게 설정
        }, 5000);
    }

    /* BTOCSITE-85293 START */
    function resizeActionSheetConsent() {
        var isModal = $('#actionSheetConsent').closest('.ui_modal_wrap');
        var isMobile = window.outerWidth < 768 ;
        var isClass = $('#actionSheetConsent').hasClass('active');
        if(isModal.length && isMobile){ // 모달 에서 모바일 전환
            $('#actionSheetConsent').removeClass('active');
        }else if(!isModal.length && !isMobile && isClass){  //엑션시트 에서 PC 전환
            $('#actionSheetConsent').vcModal('show');
        }
    }
    /* BTOCSITE-85293 END */

    window.onresize = function(){
        resizeEv1();
        resizeEv2();
        resizeActionSheetConsent(); /* BTOCSITE-85293 */
    }
    window.onload = function(){
        resizeEv1();
        resizeEv2();
        resizeActionSheetConsent(); /* BTOCSITE-85293 */
        
        
      //BTOCSITE-90937
      // [정리] B2C 전용 #beneAdd 다품목 캐시백 배너 표시 제거: b2cYN==='Y'는 이 파일에서 항상 false
    }
    /* BTOCSITE-43175 [인테리어컷] 영역 디스클레이머 일괄 적용 요청드립니다. end */
    
    /* [BTOCSITE-103184] [퍼블]After job 프로모션/혜택 - 구독 추가 혜택 스타일 개선 */
    // $(function() {
    //     $('.add-Benefits-list ul').each(function() {
    //         var $visibleLi = $(this).children('li').filter(function() {
    //             return $(this).css('display') !== 'none';
    //         });
    //         // visible li가 1개 또는 2개일 때 첫번째 visible li의 border-top: 0 적용
    //         if ($visibleLi.length <= 2) {
    //             $visibleLi.first().css('border-bottom', '0');
    //         }
    //     });
    // });

    //BTOCSITE-90937
    function chgTabEvent(){
    	// [정리] val=="A"(임직원 탭) 분기 제거: 유일하게 "A"로 호출하던 탭 클릭 핸들러가 삭제되어(#rentalTabs가 항상 DOM에 없어 dead) 이 분기는 도달 불가능했음
    	// [정리] #badgeOth, #selOth, li[name='beneListOth'], #beneAdd/#subMultiItemBenefit, #empBanner/#b2cBanner는
    	// B2B 화면(infoCaretabAreaB2b.jsp)에 마크업 자체가 없어 항상 no-op이었음
    	// 단 span[name='bdgOth']는 예외: galleryArea.jsp(모든 biz type에 조건 없이 include)에서 model.badgeOth(서버가 b2cYN 무관하게 생성)로 실제 렌더링되므로 계속 숨김 처리 필요
    	$("span[name='bdgCom']").hide();
    	$("span[name='bdgOth']").hide();
    	$("#badgeCom").hide();
    	$("#selCom").hide();
    	$("li[name='beneListCom']").hide();

    	if(lgkorUI.getHiddenInputData().b2cYN == "N" && $("#sessPg").val() != "ENT"){
        	$("span[name='bdgCom']").hide();
        }

    	if($("#sessPg").val() == "ENT"){
			$("span[name='bdgCom']").show();
    		$("#badgeCom").show();
    		$("#selCom").show();
    		$("li[name='beneListCom']").show();
    	}
    }
    

    /*BTOCSITE-85182*/
    function subMultiItemBenefit(partnerYn){
    	let tgtYn = "N";
    	let benefitAmt = 0;
    	var t1 = 0;
    	if(partnerYn == "Y"){
    		//임직원
    		tgtYn = $("#partnerMultItemDscntTgtYn").val();
    		t1 =  Number($("#partnerMultItemDscntAmt").val());
    		benefitAmt = t1/10000;
    	}else{
    		//일반
    		tgtYn = $("#multItemDscntTgtYn").val();
    		t1 =  Number($("#multItemDscntAmt").val());
    		benefitAmt = t1/10000;
    	}
    	if(tgtYn == "Y"){
    		$("#subMultiItemBenefitTxt").html('당월 내, 이 다품목 제품을 구독하면<br class="mo-only"> '+benefitAmt+'만원 캐시백이 추가 적용 됩니다.');
    		$("#subMultiItemBenefit").removeClass("blind");
    		$("#subMultiItemBenefit").show();
    	}else{
    		$("#subMultiItemBenefit").addClass("blind");
    		$("#subMultiItemBenefit").hide();
    	}
    }
    
    function getOptItemData(){
    	let subOpt;
    	$(".subOpt").each(function(e){
    		if($(this).css("display") == "block"){
    			subOpt=$(this).find("dd > ul > li > input:checked").last().data("item");
    		}
    	});
    	return subOpt;
    }
    
    function getVisitPerText(visitPer){
    	if (visitPer == 0) {               		
    		return "(방문없음/자가관리)";
    	} else {                		
    		return "(" + visitPer + "개월/1회방문)";
    	}
    }
    
	//[BTOCSITE-98681] 선납할인 조회
    function retrievePrepayDscnt(itemData, tabIdx){
    	//일반회원의 경우만 선납할인, 총구독료 조회
    	const $prepayDscntAmt = $("#subPrepay span.discount-amount em");
        if(tabIdx == 1 && !vcui.isEmpty(itemData)){
        	let param = {};
        	param.rtModelSeq = itemData.rtModelSeq;
        	param.dutyTerm = itemData.dutyTerm;
        	param.b2cYN = lgkorUI.getHiddenInputData().b2cYN;
        	lgkorUI.requestAjaxDataPost("/mkt/ajax/product/retrievePrepayDscnt"
        			, param
        			, function(result){
        				const prepayYn = result.data.prepayYn; 
        				const prepayDscntAmt = result.data.prepayDscntAmt; 
        				const totAmt = result.data.totAmt;
        				if(prepayYn == "Y" && result.status == "success" && !vcui.isEmpty(prepayDscntAmt) && prepayDscntAmt > 0){
        					$prepayDscntAmt.text(vcui.number.addComma(prepayDscntAmt*-1)+"원 추가 할인");
        					$("#subPrepay").show();
        				}else{
        					$prepayDscntAmt.text("");
        					$("#subPrepay").hide();
        				}
        			}
        	);
        }else{
        	$prepayDscntAmt.text("");
        	$("#subPrepay").hide();
        }
    }
    
    // [정리] B2C 전용 retrieveHalfPeriod() 함수 제거: 전체가 b2cYN=='Y' 단일 조건으로만 이루어져 이 파일(b2cYN 항상 'N')에서는 항상 no-op

    //BTOCSITE-109874 NetFunnel
    //BTOCSITE-109874 NetFunnel
    function updateNfStartSection(fnCallback) {
	    // fnCallback을 전역 변수에 저장
	    globalFnCallback = fnCallback;

	    if(typeof nfStartSection === 'function') {
            // S : BTOCSITE-109002 이벤트PDP개발 - 일반 PDP 넷퍼넬 적용
            const profileEnv = getProfileEnv();
        	let segmentKey = "";
            $(modelInfoJson).each(function(i, item) {
                if (item.modelId  === lgePdpSendData.modelId) {
                    segmentKey = 'pr-order';
                }
            });

            if(segmentKey.length === 0 && segmentKey === ''){
                if (lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab') {
                    segmentKey = 'sub-order';
                }else{
                    segmentKey = 'order';
                }
            }
            // E : BTOCSITE-109002 이벤트PDP개발 - 일반 PDP 넷퍼넬 적용

	        if(profileEnv == "LOCAL" || profileEnv == "DEV"){
	            segmentKey = segmentKey+"-dev"
	        }else if(profileEnv == "STG"){
	            segmentKey = segmentKey+"-stg"
	        }

	        lgkorUI.setCookie('LGEKR_NF_segment_key', segmentKey);

			if (typeof nfStartSection === 'function') {
				nfStartSection({ projectKey: 'service_244', segmentKey: segmentKey }, function (res) {
					nfCallback(res, segmentKey, fnCallback);
				});
			} else {
				notNfCallback(fnCallback);
			}

	    }else if(fnCallback && typeof fnCallback === 'function'){
	        fnCallback();
	    }
	}

    function nfCallback(response, segmentKey, fnCallback) {
	    const { status } = response;
	    switch (status) {
	        case 'Success':
	        case 'Error':
	            notNfCallback(fnCallback);
	            break;
	        case 'NetworkError':
	            if (typeof nfStartSection === 'function') {
	                nfStartSection(
	                    {
	                        projectKey: 'service_244',
	                        segmentKey: segmentKey,
	                    },
	                    function(res) {
	                        nfCallback(res, segmentKey, fnCallback);
	                    }
	                );
	            }
	            break;
	    }
	}


    function getProfileEnv(){
		const subDomain = window.location.href.replace('https://', '').split('.')[0];
		let profileEnv = '';
		if (subDomain.startsWith('test') || subDomain.endsWith('test')) {
			profileEnv = 'LOCAL';
		}else if (subDomain.startsWith('dev') || subDomain.endsWith('dev50')) {
			profileEnv = 'DEV';
	    } else if (subDomain.startsWith('stg') || subDomain.endsWith('stg')) {
	    	profileEnv = 'STG';
	    }else{
	    	profileEnv = 'PROD';
	    }
		return profileEnv;
    }

    function notNfCallback(fnCallback) {
        window.onbeforeunload = null;
        clearTimeout(timeId);
        timeId = setTimeout(function () {
            if (sessionStorage.getItem('redirect') === 'move') {
                window.location.href = path;
            } else if (fnCallback && typeof fnCallback === 'function') {
                fnCallback();
            }
        }, 0);
    }
    /* BTOCSITE-121070  [구독] 구독 광고 스크립트 개선 개발 S */
    // ====================================================================================/
    // ======================================= 네이버 WCS =================================/
    // ====================================================================================/
    var wcsEventQueue = [];
    // wcs.js 로드 여부 체크
    function isWcsReady() {
        return typeof window.wcs === 'object' && typeof window.wcs_do === 'function';
    }

    // wcs 이벤트 실행 함수
    function sendWcsEvent(eventFunc) {
        if (isWcsReady()) {
            eventFunc();
        } else {
            wcsEventQueue.push(eventFunc);
        }
    }

    // 큐 처리 함수
    function processWcsQueue() {
        while (wcsEventQueue.length > 0) {
            var eventFunc = wcsEventQueue.shift();
            eventFunc();
        }
    }

    // wcs 준비 상태 감시
    function waitForWcsReady() {
        var interval = setInterval(function() {
            if (isWcsReady()) {
                processWcsQueue();
                clearInterval(interval);
            }
        }, 200);
    }

    // 이벤트 트리거 함수
    function wcsTraceEvent(eventType) {
        waitForWcsReady();
        sendWcsEvent(function() {
            if (window.wcs) {
                window.wcs_add = {}; // 항상 전역에 새로 할당
                window.wcs_add["wa"] = "s_10f2ff8ac82";
                wcs.inflow("lge.co.kr");
                wcs_do();
                var _conv = { type: eventType };
                if (eventType === 'view_product' || eventType === 'add_to_cart') {
                    _conv.items = [{id: lgePdpSendData.modelId}];
                }
                wcs.trans(_conv);
            }
        });
    }

    // ====================================================================================/
    // ======================================= 카카오  =================================/
    // ====================================================================================/
    // LGE.COM 카카오 스크립트
    var kakaoEventQueue = [];

    // 카카오 픽셀 로드 여부 체크
    function isKakaoReady() {
        return typeof window.kakaoPixel === 'function';
    }

    // 카카오 이벤트 실행 함수
    function sendKakaoEvent(eventFunc) {
        if (isKakaoReady()) {
            eventFunc();
        } else {
            kakaoEventQueue.push(eventFunc);
        }
    }

    // 큐 처리 함수
    function processKakaoQueue() {
        while (kakaoEventQueue.length > 0) {
            var eventFunc = kakaoEventQueue.shift();
            eventFunc();
        }
    }

    // 카카오 픽셀 준비 상태 감시
    function waitForKakaoReady() {
        var interval = setInterval(function() {
            if (isKakaoReady()) {
                processKakaoQueue();
                clearInterval(interval);
            }
        }, 100);
    }

    // 이벤트 트리거 함수
    function kakaoTraceEvent(eventType) {
        sendKakaoEvent(function() {
            var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
            kakaoPixel('975360282649280347').pageView();
            if(eventType === 'page_load'){
                if(productInfo) {
                    kakaoPixel('975360282649280347').viewContent({
                        currency: "KRW",
                        products: [
                            {
                                id: productInfo.model_id,
                                name: productInfo.model_name,
                                quantity: 1,
                                price: productInfo.base_price
                            }]
                    });
                }
            } else if (eventType === 'add_to_cart'){
                kakaoPixel('975360282649280347').participation('장바구니추가');
            } else if  (eventType === 'consult_reservation'){
                kakaoPixel('975360282649280347').participation('구독상담예약');
            } else if  (eventType === 'subscribe'){
                kakaoPixel('975360282649280347').participation('구독하기');
            }
        });
        waitForKakaoReady();
    }
    // ====================================================================================/
    // ======================================= Karrot  =================================/
    // ====================================================================================/
    // Karrot Pixel 이벤트 큐
    var karrotEventQueue = [];

    // Karrot Pixel 로드 여부 체크
    function isKarrotReady() {
        return typeof window.karrotPixel === 'object' && typeof window.karrotPixel.track === 'function';
    }

    // Karrot 이벤트 실행 함수
    function sendKarrotEvent(eventFunc) {
        if (isKarrotReady()) {
            eventFunc();
        } else {
            karrotEventQueue.push(eventFunc);
        }
    }

    // 큐 처리 함수
    function processKarrotQueue() {
        while (karrotEventQueue.length > 0) {
            var eventFunc = karrotEventQueue.shift();
            eventFunc();
        }
    }

    // karrot 준비 상태 감시
    function waitForKarrotReady() {
        var interval = setInterval(function() {
            if (isKarrotReady()) {
                processKarrotQueue();
                clearInterval(interval);
            }
        }, 200);
    }

    // 이벤트 트리거 함수
    function karrotTraceEvent(eventType) {
        sendKarrotEvent(function() {
            window.karrotPixel.init('1730775359252900001');
            if (eventType === 'page_load') {
                window.karrotPixel.track('ViewContent', { 'id': lgePdpSendData.modelId });
            } else {
                window.karrotPixel.track('Lead');
            }
        });
        waitForKarrotReady();
    }

    // ====================================================================================/
    // ======================================= gtag  =================================/
    // ====================================================================================/
    // gtag 이벤트 큐
    var gtagEventQueue = [];


    //gtag.js 로드 여부 체크
    function isGtagReady() {
        return document.querySelector('script[src*="googletagmanager.com/gtag/js"]') && typeof window.gtag === 'function';
    }

    // gtag 이벤트 실행 함수
    function sendGtagEvent(eventName, eventParams) {
        if (typeof window.gtag === 'function') {
            window.gtag('event', eventName, eventParams);
        }
    }

    // 큐 처리 함수
    function processGtagQueue() {
        while (gtagEventQueue.length > 0) {
            var event = gtagEventQueue.shift();
            console.log('>>> [gtag] 큐에서 이벤트 꺼냄:', event);
            sendGtagEvent(event.name, event.params);
        }
    }

    // gtag 이벤트 추가 함수
    function addGtagEvent(eventName, eventParams) {
        if (isGtagReady()) {
            sendGtagEvent(eventName, eventParams);
        } else {
            gtagEventQueue.push({ name: eventName, params: eventParams });
        }
    }

    // gtag.js 준비 상태 감시
    function waitForGtagReady() {
        var interval = setInterval(function() {
            if (isGtagReady()) {
                processGtagQueue();
                clearInterval(interval);
            }
        }, 100);
    }

    function gtagTraceEvent(eventType, url) {
        if(eventType === 'page_load') {
            addGtagEvent('conversion', { 'send_to': 'AW-362582935/yK2GCJuSxPgZEJen8qwB' });
            waitForGtagReady();
        } else {
            var callback = function () {
                if (typeof(url) !== 'undefined') {
                    window.location = url;
                }
            };
            if (eventType === 'add_to_cart') {
                addGtagEvent('conversion', {
                    'send_to': 'AW-362582935/27pYCJ6SxPgZEJen8qwB',
                    'value': 1.0,
                    'currency': 'KRW',
                    'event_callback': callback
                });
            }  else if (eventType === 'consult_reservation') {
                addGtagEvent('conversion', {
                    'send_to': 'AW-362582935/uIgLCKSSxPgZEJen8qwB',
                    'event_callback': callback
                });
            } else if  (eventType === 'subscribe'){
                addGtagEvent('conversion', {
                    'send_to': 'AW-362582935/zhb7CKGSxPgZEJen8qwB',
                    'event_callback': callback
                });
                return false;
            }
            waitForGtagReady();
            return false;
        }
    }
    // ====================================================================================/
    // ======================================= 크레테오  =================================/
    // ====================================================================================/
    // criteo 이벤트 큐
    var criteoEventQueue = [];

    // criteo.js(ld.js) 로드 여부 체크
    function isCriteoReady() {
        var isResult = typeof window.criteo_q === 'object' && typeof window.criteo_q.push === 'function';
        return isResult;
    }

    // criteo 이벤트 실행 함수
    function sendCriteoEvent(eventObj) {
        if (typeof window.criteo_q === 'object' && typeof window.criteo_q.push === 'function') {
            window.criteo_q.push(eventObj);
        }
    }

    // 큐 처리 함수
    function processCriteoQueue() {
        while (criteoEventQueue.length > 0) {
            var event = criteoEventQueue.shift();
            sendCriteoEvent(event);
        }
    }

    // criteo 이벤트 추가 함수
    function addCriteoEvent(eventObj) {
        if (isCriteoReady()) {
            sendCriteoEvent(eventObj);
        } else {
            criteoEventQueue.push(eventObj);
        }
    }

    // criteo.js 준비 상태 감시
    function waitForCriteoReady() {
        var interval = setInterval(function() {
            if (isCriteoReady()) {
                processCriteoQueue();
                clearInterval(interval);
            }
        }, 100);
    }

    // 이벤트 트리거 함수
    function criteoTraceEvent(eventType, params) {
        if(params === 'undefined') {
            params = [];
        }
        var deviceType;
        if (/iPad/.test(navigator.userAgent)) {
            deviceType = "t";
        } else if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)) {
            deviceType = "m";
        } else {
            deviceType = "d";
        }
        var events = [
            { event: "setAccount", account: "114760" },
            { event: "setSiteType", type: deviceType }
        ];
        var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
        var carePrice = KRP0008.$pdpInfo.find('.payment-amount').data('carePrice');
        var modelId = lgePdpSendData.modelId;
        if(!carePrice){
            carePrice = productInfo.rental_price;
        }
        var criteoParam = [];
        if(productInfo != null){
            criteoParam = [{id: modelId, price: carePrice, quantity: 1}];
        }

        if (eventType === 'page_load') {
            events.push(
                { event: "setZipcode", zipcode: "" },
                { event: "viewItem", item: modelId }
            );
        }else if (eventType === 'add_to_cart' || eventType === 'consult_reservation' || eventType === 'subscribe') {
            events.push(
                { event: "addToCart" , currency: "KRW", item: criteoParam }
            );
        }

        addCriteoEvent(events);
        waitForCriteoReady();
    }

    // 메타 트리거 함수
    function metaTraceEvent(eventType) {
        var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
        var carePrice = KRP0008.$pdpInfo.find('.payment-amount').data('carePrice');
        var modelId = lgePdpSendData.modelId;
        if (!carePrice && productInfo) {
            carePrice = productInfo.rental_price;
        }
        var quantity = 1;
        fbq('trackCustom', eventType ,{
            value: carePrice,
            currency: 'KRW',
            contents: [{
                id: modelId,
                quantity: quantity
            }],
            content_type: 'product'
        });
        if (window.LgeMetaCapi) {
            LgeMetaCapi.trackCustom(eventType, {
                value: carePrice,
                currency: 'KRW',
                contents: [{
                    id: modelId,
                    quantity: quantity
                }],
                content_type: 'product'
            }, {});
        }
    }

    // ====================================================================================/
    // ======================================= 토스  =======================================/
    // ====================================================================================/
    // CSR-9453: [구독/청약] 토스 광고 스크립트 설치 요청
    var tossEventQueue = [];
    var TOSS_PIXEL_ID = '6195919662078243568';

    // Toss Pixel(lex/v1.js) 로드 여부 체크
    function isTossReady() {
        return typeof window.TossPixel === 'function';
    }

    // 토스 이벤트 실행 함수
    function sendTossEvent(eventFunc) {
        if (isTossReady()) {
            eventFunc();
        } else {
            tossEventQueue.push(eventFunc);
        }
    }

    // 큐 처리 함수
    function processTossQueue() {
        while (tossEventQueue.length > 0) {
            var eventFunc = tossEventQueue.shift();
            eventFunc();
        }
    }

    // Toss Pixel 준비 상태 감시
    function waitForTossReady() {
        var interval = setInterval(function() {
            if (isTossReady()) {
                processTossQueue();
                clearInterval(interval);
            }
        }, 100);
    }

    // 이벤트 트리거 함수
    function tossTraceEvent(eventType) {
        sendTossEvent(function() {
            var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
            var carePrice = KRP0008.$pdpInfo.find('.payment-amount').data('carePrice');
            var modelId = lgePdpSendData.modelId;
            if (!carePrice && productInfo) {
                carePrice = productInfo.rental_price;
            }

            if (eventType === 'page_load') {
                TossPixel(TOSS_PIXEL_ID).productView({
                    product_id: modelId,
                    product_name: productInfo ? productInfo.model_name : lgePdpSendData.productName,
                    category_id: lgePdpSendData.categoryId,
                    category_name: productInfo ? productInfo.category : '',
                    price: carePrice || 0,
                    currency: 'KRW'
                });
            } else {
                // addtocart, consultation, subscribe
                TossPixel(TOSS_PIXEL_ID).lead({
                    lead_type: eventType
                });
            }
        });
        waitForTossReady();
    }

    return {
		// BTOCSITE-45339, cookie name 설정 방법은 임시로 하드코딩...
		setTail: function(_value, _days) {
			var _name = "f_area";	// cookie name
			KRP0008.setCookie(_name, _value, _days);
		}
        ,
        // BTOCSITE-54289 // UP가전 2.0 PDP
        init: function(up20Flag) {
            KRP0008.init(up20Flag);
        }
        ,
        // BTOCSITE-78355 [S]
        refresh: function() {
            KRP0008.refresh();
        }
        // BTOCSITE-78355 [E]
        // BTOCSITE-89574 START
        , setValueExtraBtnByTimeDeal: function() {
            KRP0008.setValueExtraBtnByTimeDeal();
        }
        // BTOCSITE-89574 END
        ,
        addCartAjaxCall: function(ajaxUrl, param, isToast) {
            KRP0008.addCartAjaxCall(ajaxUrl, param, isToast);
        }
        // BTOCSITE-70412 START
        ,
        updatePaymentAmountPrice: function($paymentAmount, quantityChange) {
            KRP0008.updatePaymentAmountPrice($paymentAmount, quantityChange)
        },
        // BTOCSITE-70412 END

        // BTOCSITE-97545 START
        setQuoteOnlCheck: function() {
            KRP0008.setQuoteOnlCheck();
        },
        // BTOCSITE-97545 END

        additionInit : function(){
            KRP0008.additionModel.init();
        },
        addRentalCartTag: function(modelId, price, quantity) {
            KRP0008.addRentalCartTag(modelId, price, quantity);
        },
        csSubscribeClickRecordEvent: function() {
            KRP0008.csSubscribeClickRecordEvent();
        }
        // BTOCSITE-74162 START
        , setUpActionForAwardAfterContentLoaded: function() {
            KRP0008.setUpActionForAwardAfterContentLoaded();
        }
        // BTOCSITE-74162 END
        /* BTOCSITE-121070  [구독] 구독 광고 스크립트 개선 개발 */
        , wcsTraceEvent: wcsTraceEvent
        , kakaoTraceEvent : kakaoTraceEvent
        , karrotTraceEvent : karrotTraceEvent
        , gtagTraceEvent : gtagTraceEvent
        , criteoTraceEvent : criteoTraceEvent
        , metaTraceEvent : metaTraceEvent
        , tossTraceEvent : tossTraceEvent
	};

})();
// S : [BTOCSITE-93072] 스펙 기반의 선호도 : 선호도 판매량 스낵바
document.addEventListener("DOMContentLoaded", function () {
    //스낵바 이동
});
// E : [BTOCSITE-93072] 스펙 기반의 선호도 : 선호도 판매량 스낵바
/*BTOCSITE-102603 S*/
document.addEventListener('DOMContentLoaded', function() {
    var $membershipBox = $('.membership-point-box');
    var $membershipBtn = $('.membership-point-more');
    var $membershipBlindText = $membershipBtn.find('.blind');

    $membershipBtn.on('click', function() {
        $membershipBox.toggleClass('open');
        if ($membershipBox.hasClass('open')) {
            $membershipBlindText.text('내용 닫기');
        } else {
            $membershipBlindText.text('내용 더보기');
        }
    });
});
/*BTOCSITE-102603 E*/
/*
window.addEventListener("pageshow", function (event) {
    if (event.persisted || (window.performance && window.performance.navigation.type == 2 )) {
        console.log("yongho => start step 1");
        _KRP0008.additionInit();
        if($('#quantity').val() > 1){
            $('.payment-amount .quantity-payment-wrap .minus').prop('disabled',false);
        }
    }
});*/

// $(function(){
//     Promise.resolve(_KRP0008.init()).then(_KRP0008_COUPON.KRP0008_COUPON_INIT());
// });

// BTOCSITE-113740 [Afterjob][구독] LGE.COM 가전구독 PLP/PDP 內 물동정보(내일배송 뱃지) 노출 (사업자몰)
document.addEventListener('DOMContentLoaded', function() {
    var $detailBusiness = $('.details-box-business');
    var $headerBusiness = $('.details-header-business');
    var $businessBtn = $('.details-more-business');
    // CSR-4632 [WA][모니터링]1차 심사결과_구독
    $businessBtn.on('click', function() {
        $detailBusiness.toggleClass('open');
        if ($detailBusiness.hasClass('open')) {
            $(this).attr("aria-expanded", "true");
        } else {
            $(this).attr("aria-expanded", "false");
        }
    });
});